<template>
  <div class="app-container procurement-page">
    <div class="procurement-shell">
      <main v-if="!isDetailPage" class="procurement-workspace">
        <div v-if="activeTab === 'dashboard' || activeTab === 'report'" class="workbench-scope-heading">
          <div><strong>{{ activeTab === 'dashboard' ? '我的采购工作台' : (workbench.allApplicationsVisible ? '公司采购概览' : '相关采购概览') }}</strong>
            <span>{{ activeTab === 'dashboard' ? '申请统计按本人发起，待办按本人办理' : '按当前账号可查看的范围汇总' }}</span></div>
          <el-button v-if="activeTab === 'dashboard' && workbench.allApplicationsVisible" size="small" @click="pushProcurementRoute('/procurement/report')">公司采购概览</el-button>
          <el-button v-if="activeTab === 'report'" size="small" @click="pushProcurementRoute('/procurement/workbench')">我的采购工作台</el-button>
        </div>
        <div v-if="activeTab === 'dashboard' || activeTab === 'report'" class="procurement-stats">
          <button v-for="card in workbenchCards" :key="card.key" class="stat-tile" type="button" @click="filterMetric(card)">
            <span>{{ card.label }}</span>
            <strong>{{ card.value }}</strong>
          </button>
        </div>

        <div class="procurement-board">
            <section v-if="activeTab === 'dashboard'" class="board-pane">
              <div class="workspace-grid">
                <section class="workbench-panel workbench-panel--primary">
                  <div class="panel-heading">
                    <div>
                      <strong>待我处理</strong>
                      <span>{{ dashboardQuickHint }}</span>
                    </div>
                    <div class="panel-heading__actions">
                      <el-button v-if="canCreateDirectOrder" type="primary" size="mini" icon="el-icon-plus" @click="openDirectOrderDialog">新增零星采购</el-button>
                    </div>
                  </div>
                  <div v-if="dashboardTasks.length" class="todo-list todo-list--featured">
                    <button v-for="task in dashboardTasks" :key="task.key" :class="{ 'is-role-task': task.roleMatched }" type="button" @click="filterMetric(task)">
                      <span>{{ task.label }}</span>
                      <strong>{{ task.value }}</strong>
                      <em>{{ task.desc }}</em>
                    </button>
                  </div>
                  <div v-else class="dashboard-empty">暂无需要当前账号处理的采购事项</div>
                </section>
                <section class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>流程概览</strong>
                    </div>
                  </div>
                  <div class="process-overview-list">
                    <div v-for="step in dashboardProcessSteps" :key="step.key">
                      <i :class="step.icon"></i>
                      <span>{{ step.label }}</span>
                    </div>
                  </div>
                </section>
              </div>

              <div class="dashboard-grid">
                <section class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>我发起的申请进度</strong>
                    </div>
                  </div>
                  <div class="status-report-list">
                    <button v-for="row in statusReportRows" :key="row.queue || row.status" type="button" @click="filterMetric(row)">
                      <span>{{ row.label }}</span>
                      <strong>{{ row.count }}</strong>
                      <em>{{ workbenchMoney(row.amount) }}</em>
                    </button>
                  </div>
                  <div v-if="!statusReportRows.length" class="dashboard-empty">暂无本人发起的采购申请</div>
                </section>
                <section class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>我发起的近期申请</strong>
                    </div>
                  </div>
                  <el-table :data="recentApplyList" height="252" size="mini" @row-click="handleRecentApplyRowClick" @row-dblclick="handleEditApply">
                    <el-table-column label="编号" min-width="190" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click.stop="handleEditApply(scope.row)">{{ scope.row.applyNo || '-' }}</el-link>
                        <div class="sub-text">{{ scope.row.applyTitle || '-' }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" width="90" align="center">
                      <template slot-scope="scope"><el-tag :type="businessStatusTag(scope.row)" size="mini">{{ businessStatusText(scope.row) }}</el-tag></template>
                    </el-table-column>
                    <el-table-column label="金额" width="112" align="right">
                      <template slot-scope="scope">{{ workbenchMoney(scope.row.applyAmount) }}</template>
                    </el-table-column>
                  </el-table>
                </section>
                <section v-if="canAccessPurchaseSensitive" class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>供应商已完成采购额</strong>
                    </div>
                  </div>
                  <div v-if="!supplierReportRows.length" class="dashboard-empty">暂无已完成的供应商采购</div>
                  <div class="supplier-rank-list">
                    <div v-for="row in supplierReportRows.slice(0, 6)" :key="row.id || row.supplierName">
                      <span>{{ row.supplierName || '-' }}</span>
                      <strong>{{ money(row.cumulativePurchaseAmount) }}</strong>
                    </div>
                  </div>
                </section>
              </div>
            </section>

            <section v-if="activeTab === 'report'" class="board-pane">
              <div class="report-layout">
                <section class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>关键指标</strong>
                    </div>
                  </div>
                  <div class="report-metrics">
                    <button type="button" @click="filterMetric({ tab: 'apply' })">
                      <span>采购申请数</span>
                      <strong>{{ workbench.totalCount == null ? '—' : workbench.totalCount }}</strong>
                    </button>
                    <button type="button" @click="filterMetric({ tab: 'apply' })">
                      <span>申请金额</span>
                      <strong>{{ workbenchMoney(workbench.applyAmount) }}</strong>
                    </button>
                    <button type="button" @click="pushProcurementRoute('/procurement/order', { queue: 'paid' })">
                      <span>已付金额</span>
                      <strong>{{ workbenchMoney(workbench.paidAmount) }}</strong>
                    </button>
                    <button type="button" @click="pushProcurementRoute('/procurement/order', { queue: 'unpaid' })">
                      <span>未付金额</span>
                      <strong>{{ workbenchMoney(workbench.unpaidAmount) }}</strong>
                    </button>
                  </div>
                </section>
                <section class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>状态金额分布</strong>
                    </div>
                  </div>
                  <el-table :data="statusReportRows" height="300" size="mini" class="clickable-table" @row-click="filterMetric">
                    <el-table-column label="状态" prop="label" min-width="120" />
                    <el-table-column label="单数" prop="count" width="90" align="center" />
                    <el-table-column label="金额" width="140" align="right"><template slot-scope="scope">{{ workbenchMoney(scope.row.amount) }}</template></el-table-column>
                  </el-table>
                </section>
                <section v-if="canAccessPurchaseSensitive" class="workbench-panel">
                  <div class="panel-heading">
                    <div>
                      <strong>供应商已完成采购排行</strong>
                    </div>
                  </div>
                  <el-table :data="supplierReportRows" height="300" size="mini" class="clickable-table" @row-click="row => pushProcurementRoute('/procurement/supplier', { keyword: row.supplierName })">
                    <el-table-column label="供应商" prop="supplierName" min-width="180" show-overflow-tooltip />
                    <el-table-column label="采购次数" prop="purchaseCount" width="90" align="center" />
                    <el-table-column label="已完成采购额" width="130" align="right"><template slot-scope="scope">{{ money(scope.row.cumulativePurchaseAmount) }}</template></el-table-column>
                    <el-table-column label="未付余额" width="130" align="right"><template slot-scope="scope">{{ money(scope.row.unpaidBalance) }}</template></el-table-column>
                  </el-table>
                </section>
              </div>
            </section>

            <section v-if="activeTab === 'apply' || activeTab === 'order' || activeTab === 'todo'" class="board-pane">
              <el-form ref="queryForm" :model="queryParams" class="multipleSelectScroll" v-show="showSearch" label-width="85px">
                  <el-row :gutter="10" class="mb8">
                    <el-col :xs="24" :md="9" :lg="8">
                      <el-form-item label="关键词">
                        <el-input v-model="queryParams.keyword" placeholder="编号、主题、项目、合同" clearable @keyup.enter.native="handleQuery" />
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="5" :lg="4">
                      <el-form-item label="类型">
                        <el-select v-model="queryParams.purchaseType" clearable placeholder="全部" style="width:100%">
                          <el-option-group v-for="group in purchaseTypeOptionGroups" :key="group.label" :label="group.label">
                            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
                          </el-option-group>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="5" :lg="4">
                      <el-form-item label="状态">
                        <el-select v-model="queryParams.status" clearable placeholder="全部" style="width:100%">
                          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="5" :lg="8" align="right">
                      <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

              <el-row :gutter="10" class="mb8 table-toolbar table-toolbar--system">
                <el-col :span="1.5" v-if="activeTab === 'apply'">
                  <el-button v-hasPermi="['crm:procurement:save']" type="primary" icon="el-icon-plus" @click="handleAddApply('ai')">新增采购申请</el-button>
                </el-col>
                <el-col :span="1.5" v-if="['apply', 'order'].includes(activeTab) && canCreateDirectOrder">
                  <el-button type="primary" icon="el-icon-plus" @click="openDirectOrderDialog">新增零星采购</el-button>
                </el-col>
                <el-col :span="1.5">
                  <el-button icon="el-icon-refresh" @click="refreshWorkspace">刷新</el-button>
                </el-col>
                <el-col :span="1.5">
                  <el-tag v-if="activeQueueLabel" type="primary" size="small" closable @close="clearApplyQueue">{{ activeQueueLabel }}</el-tag>
                </el-col>
                <right-toolbar :showSearch.sync="showSearch" @queryTable="refreshWorkspace"></right-toolbar>
              </el-row>
              <el-row class="totalCount">
                <div style="font-size: 14px; margin: 5px 0">
                  <span>{{ activeApplyListTitle }}：{{ applyListSummaryText }}</span>
                </div>
              </el-row>
              <el-alert
                v-if="activeQueueHint"
                class="queue-hint"
                :title="activeQueueHint"
                type="info"
                show-icon
                :closable="false"
              />

              <el-table v-loading="loading.apply" :data="pagedApplyList" class="standard-apply-table" @row-dblclick="handleViewApply">
                <el-table-column :label="activeApplyNoLabel" width="150" fixed="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click.stop="handleViewApply(scope.row)">{{ scope.row.applyNo || '-' }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column :label="activeApplyTitleLabel" prop="applyTitle" min-width="210" show-overflow-tooltip />
                <el-table-column label="申请人" prop="applicantName" width="120" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.applicantName || '-' }}</template>
                </el-table-column>
                <el-table-column label="类型/状态" min-width="180" align="center">
                  <template slot-scope="scope">
                    <div class="compact-cell center purchase-type-status">
                      <strong class="purchase-type-status__name" :title="purchaseTypeText(scope.row.purchaseType)">{{ purchaseTypeText(scope.row.purchaseType) }}</strong>
                      <el-tag :type="businessStatusTag(scope.row)" size="mini">{{ businessStatusText(scope.row) }}</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="项目/合同" min-width="180" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="compact-cell">
                      <strong>{{ scope.row.projectCode || scope.row.projectName || '-' }}</strong>
                      <em v-if="scope.row.contractNum">{{ scope.row.contractNum }}</em>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="activeTab === 'order' || activeTab === 'todo'" label="执行信息" min-width="190" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="compact-cell">
                      <strong>{{ purchaseOwnerDisplayText(scope.row) }}</strong>
                      <em v-if="(activeTab === 'order' || activeTab === 'todo') && canViewRowSensitive(scope.row)">{{ scope.row.supplierName || '-' }}</em>
                      <em v-else-if="activeTab === 'order' || activeTab === 'todo'">{{ supplierOrderProgressText(scope.row) }}</em>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="activeAmountColumnLabel" width="150" align="right">
                  <template slot-scope="scope">
                    <div class="amount-cell">
                      <strong v-if="Number(scope.row.documentType || 1) !== 2 || canViewRowSensitive(scope.row)">{{ applicationAmountText(scope.row) }}</strong>
                      <strong v-else>---</strong>
                      <template v-if="shouldShowRowPaymentProgress(scope.row) && canViewRowSensitive(scope.row)">
                        <em>已付 {{ money(scope.row.paidAmount) }}</em>
                        <em>未付 {{ money(scope.row.unpaidAmount) }}</em>
                      </template>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="申请时间" prop="submitTime" width="160" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.submitTime || '-' }}</template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center" fixed="right" class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <div class="row-inline-actions">
                      <el-button v-if="canEditApplyRow(scope.row)" type="text" @click.stop="handleEditApply(scope.row, 'basic')">编辑</el-button>
                      <el-button
                        v-if="rowPrimaryAction(scope.row)"
                        type="text"
                        :loading="applySubmitLoadingId === scope.row.id"
                        :disabled="Boolean(applySubmitLoadingId)"
                        @click.stop="handleRowPrimaryAction(scope.row)"
                      >{{ rowPrimaryAction(scope.row).label }}</el-button>
                      <el-button v-if="canCancelRow(scope.row)" type="text" class="danger" @click.stop="handleCancelApply(scope.row)">作废</el-button>
                      <el-button v-if="canDeleteWithdrawnRow(scope.row)" type="text" class="danger" @click.stop="handleDeleteWithdrawnApply(scope.row)">删除</el-button>
                      <el-button v-if="canDeleteDraftRow(scope.row)" type="text" class="danger" @click.stop="handleDeleteDraftApply(scope.row)">删除</el-button>
                      <span v-if="!canEditApplyRow(scope.row) && !rowPrimaryAction(scope.row) && !canCancelRow(scope.row) && !canDeleteWithdrawnRow(scope.row) && !canDeleteDraftRow(scope.row)" class="table-empty-action">-</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <pagination
                v-show="applyTotal > 0"
                :total="applyTotal"
                :page.sync="applyPage.pageNum"
                :limit.sync="applyPage.pageSize"
                :page-sizes="[10]"
                @pagination="handleApplyPagination"
              />
            </section>

            <section v-if="activeTab === 'supplier'" class="board-pane">
              <el-form :model="supplierQuery" class="multipleSelectScroll" v-show="showSearch" label-width="85px">
                  <el-row :gutter="10" class="mb8">
                    <el-col :xs="24" :md="10" :lg="8">
                      <el-form-item label="关键词">
                        <el-input v-model="supplierQuery.keyword" placeholder="供应商、别名、采购内容" clearable @keyup.enter.native="handleSupplierQuery" />
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="14" :lg="16" align="right">
                      <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="handleSupplierQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" @click="resetSupplierQuery">清空</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

              <el-row :gutter="10" class="mb8 table-toolbar table-toolbar--system">
                <el-col :span="1.5">
                  <el-button v-hasPermi="['crm:procurement:supplier']" type="primary" icon="el-icon-plus" @click="handleAddSupplier">新增</el-button>
                </el-col>
                <el-col :span="1.5">
                  <el-button icon="el-icon-refresh" @click="refreshWorkspace">刷新</el-button>
                </el-col>
                <right-toolbar :showSearch.sync="showSearch" @queryTable="refreshWorkspace"></right-toolbar>
              </el-row>
              <el-row class="totalCount">
                <div style="font-size: 14px; margin: 5px 0">供应商库：{{ supplierTotal }} 条</div>
              </el-row>

              <el-table v-loading="loading.supplier" :data="supplierList" class="standard-list-table">
                <el-table-column label="供应商名称" min-width="210" fixed="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="handleEditSupplier(scope.row)">{{ scope.row.supplierName }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="简称/别名" width="132" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.shortName || '-' }}</div>
                    <em class="sub-text">{{ scope.row.aliases || '' }}</em>
                  </template>
                </el-table-column>
                <el-table-column label="类型" prop="supplierType" width="108" align="center" show-overflow-tooltip />
                <el-table-column label="主要采购内容" prop="mainPurchaseContent" min-width="220" show-overflow-tooltip />
                <el-table-column label="采购金额" width="116" align="right">
                  <template slot-scope="scope">{{ money(scope.row.cumulativePurchaseAmount) }}</template>
                </el-table-column>
                <el-table-column label="次数/合同" width="96" align="center">
                  <template slot-scope="scope">{{ numberText(scope.row.purchaseCount) }} / {{ numberText(scope.row.contractCount) }}</template>
                </el-table-column>
                <el-table-column label="未付余额" width="112" align="right">
                  <template slot-scope="scope">{{ money(scope.row.unpaidBalance) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="76" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'" size="mini">
                      {{ Number(scope.row.status) === 1 ? '启用' : '禁用' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="96" align="center" fixed="right" class-name="small-padding fixed-width">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleEditSupplier(scope.row)">编辑</el-button>
                    <el-button v-hasPermi="['crm:procurement:supplier']" type="text" class="danger" @click="handleRemoveSupplier(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <pagination
                v-show="supplierTotal > 0"
                :total="supplierTotal"
                :page.sync="supplierQuery.pageNum"
                :limit.sync="supplierQuery.pageSize"
                :page-sizes="[20, 50, 100]"
                @pagination="getSupplierList"
              />
            </section>

            <section v-if="activeTab === 'price' && canAccessPurchasePrice" class="board-pane">
              <el-form :model="priceQuery" class="multipleSelectScroll" v-show="showSearch" label-width="85px">
                  <el-row :gutter="10" class="mb8">
                    <el-col :xs="24" :md="6">
                      <el-form-item label="物料">
                        <el-autocomplete
                          v-model="priceQuery.materialName"
                          :fetch-suggestions="queryPriceMaterialSuggestions"
                          value-key="materialName"
                          placeholder="输入或选择物料"
                          clearable
                          :trigger-on-focus="true"
                          :highlight-first-item="true"
                          popper-class="material-reference-popper"
                          style="width:100%"
                          @select="handlePriceMaterialSelect"
                          @keyup.enter.native="handlePriceQuery"
                        >
                          <template slot-scope="{ item }">
                            <div class="reference-option reference-option--material-name">
                              <strong>{{ item.materialName }}</strong>
                              <div v-if="materialSuggestionOptionDetails(item).length" class="reference-option__details">
                                <span v-for="detail in materialSuggestionOptionDetails(item)" :key="detail">{{ detail }}</span>
                              </div>
                            </div>
                          </template>
                        </el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="5">
                      <el-form-item label="规格">
                        <el-autocomplete
                          v-model="priceQuery.specification"
                          :fetch-suggestions="queryPriceSpecificationSuggestions"
                          value-key="value"
                          placeholder="输入或选择规格"
                          clearable
                          :trigger-on-focus="true"
                          :highlight-first-item="true"
                          popper-class="spec-reference-popper"
                          style="width:100%"
                          @select="handlePriceSpecificationSelect"
                          @keyup.enter.native="handlePriceQuery"
                        >
                          <template slot-scope="{ item }">
                            <div class="spec-reference-option" :title="item.value">
                              <strong>{{ item.value }}</strong>
                              <span v-if="item.detail">{{ item.detail }}</span>
                            </div>
                          </template>
                        </el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="5">
                      <el-form-item label="供应商">
                        <el-autocomplete
                          v-model="priceQuery.supplierName"
                          :fetch-suggestions="queryPriceSupplierSuggestions"
                          value-key="supplierName"
                          placeholder="输入或选择供应商"
                          clearable
                          :trigger-on-focus="true"
                          :highlight-first-item="true"
                          popper-class="supplier-reference-popper"
                          style="width:100%"
                          @select="handlePriceSupplierSelect"
                          @keyup.enter.native="handlePriceQuery"
                        >
                          <template slot-scope="{ item }">
                            <div class="reference-option">
                              <div class="reference-option__title">
                                <strong>{{ item.supplierName }}</strong>
                                <em v-if="item.shortName">{{ item.shortName }}</em>
                              </div>
                              <div v-if="priceSupplierOptionDetails(item).length" class="reference-option__details">
                                <span v-for="detail in priceSupplierOptionDetails(item)" :key="detail.label + detail.value">{{ detail.label }}：{{ detail.value }}</span>
                              </div>
                            </div>
                          </template>
                        </el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="4">
                      <el-form-item label="类型">
                        <el-select v-model="priceQuery.purchaseType" clearable placeholder="采购类型" style="width:100%">
                          <el-option-group v-for="group in purchaseTypeOptionGroups" :key="group.label" :label="group.label">
                            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
                          </el-option-group>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="24" align="right">
                      <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="handlePriceQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" @click="resetPriceQuery">清空</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

              <el-row :gutter="10" class="mb8 table-toolbar table-toolbar--system">
                <el-col :span="1.5">
                  <el-button type="primary" plain icon="el-icon-search" @click="openPriceLookup">物料价格查询</el-button>
                </el-col>
                <el-col :span="1.5">
                  <el-button icon="el-icon-refresh" @click="refreshWorkspace">刷新</el-button>
                </el-col>
                <right-toolbar :showSearch.sync="showSearch" @queryTable="refreshWorkspace"></right-toolbar>
              </el-row>
              <el-row class="totalCount">
                <div style="font-size: 14px; margin: 5px 0">已定商价格：{{ priceTotal }} 条</div>
              </el-row>

              <el-table v-loading="loading.price" :data="priceList" class="standard-list-table">
                <el-table-column label="物料名称" prop="materialName" min-width="180" fixed="left" show-overflow-tooltip />
                <el-table-column label="规格型号" prop="specification" min-width="160" show-overflow-tooltip />
                <el-table-column label="材质/品牌" prop="materialQualityBrand" min-width="130" show-overflow-tooltip />
                <el-table-column label="供应商" prop="supplierName" min-width="180" show-overflow-tooltip />
                <el-table-column label="最终单价" width="110" align="right">
                  <template slot-scope="scope">{{ unitPriceText(scope.row.purchaseUnitPrice) }}</template>
                </el-table-column>
                <el-table-column label="数量" width="90" align="right">
                  <template slot-scope="scope">{{ numberText(scope.row.quantity) }}</template>
                </el-table-column>
                <el-table-column label="单位" prop="unit" width="70" align="center" />
                <el-table-column label="金额" width="120" align="right">
                  <template slot-scope="scope">{{ money(scope.row.amount) }}</template>
                </el-table-column>
                <el-table-column label="来源采购单" min-width="210" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tag v-if="isHistoricalPrice(scope.row)" size="mini" type="info">参考价</el-tag>
                    {{ scope.row.applyNo }} {{ scope.row.applyTitle }}
                  </template>
                </el-table-column>
                <el-table-column label="定商时间" prop="decisionTime" width="160" align="center" />
              </el-table>
              <pagination
                v-show="priceTotal > 0"
                :total="priceTotal"
                :page.sync="priceQuery.pageNum"
                :limit.sync="priceQuery.pageSize"
                :page-sizes="[20, 50, 100]"
                @pagination="getPriceList"
              />
            </section>
        </div>
      </main>
    </div>

    <section v-if="isDetailPage" class="procurement-detail-page crm-detail">
      <el-card v-if="applyForm.id" class="crm-detail-base purchase-detail-base" shadow="never">
        <el-row>
          <el-col :span="12" class="purchase-detail-base__title">
            <span class="base-name">{{ applyForm.id ? (applyForm.applyNo || '暂无采购编号') : '新增采购申请' }}</span>
          </el-col>
          <el-col :span="12" align="right">
            <el-button v-if="isApplicationDetail && ![115, 120].includes(Number(applyForm.status))" type="primary" size="mini" @click="openPurchaseContractApplication()">发起采购合同审批</el-button>
            <el-button v-if="canWithdrawApproval" v-hasPermi="['crm:procurement:submit']" type="warning" plain size="mini" icon="el-icon-refresh-left" @click="handleWithdrawApply">撤回修改</el-button>
            <el-button v-if="canDeleteCurrentWithdrawnApply" type="danger" plain size="mini" icon="el-icon-delete" @click="handleDeleteWithdrawnApply(applyForm)">删除申请</el-button>
            <el-button v-if="canDeleteCurrentDraftApply" type="danger" plain size="mini" icon="el-icon-delete" @click="handleDeleteDraftApply(applyForm)">删除草稿</el-button>
            <el-button v-if="canRecallSupplierDecision" v-hasPermi="['crm:procurement:quote']" type="warning" plain size="mini" icon="el-icon-refresh-left" @click="handleRecallSupplierDecision">撤回修改报价</el-button>
            <el-button v-if="shouldShowApprovalFlowButton" type="primary" plain size="mini" icon="el-icon-finished" @click="openApprovalFlowDialog">审批流程</el-button>
            <el-button v-if="contractSealWorkOrderAvailable" type="success" plain size="mini" icon="el-icon-s-check" @click="openContractSealApprovalDialog">{{ contractSealApprovalButtonText }}</el-button>
            <el-button v-if="applyForm.id" type="text" @click="backToApplyList">返回列表</el-button>
            <el-button type="text" :disabled="!applyForm.id" @click="refreshCurrentDetail">刷新</el-button>
          </el-col>
        </el-row>
        <div v-if="applyForm.id">
          <div class="base-item purchase-title-item">
            <div class="title label">{{ isSupplierOrderDetail ? '来源采购申请' : '采购主题' }}</div>
            <div class="value">
              <el-link
                v-if="isSupplierOrderDetail && applyForm.parentApplyId"
                type="primary"
                :underline="false"
                @click="openSourcePurchaseApply"
              >{{ applyForm.applyTitle || '-' }}</el-link>
              <span v-else>{{ applyForm.applyTitle || (applyForm.id ? '-' : '新采购申请') }}</span>
            </div>
          </div>
          <div v-if="isApplicationDetail" class="base-item">
            <div class="title label">采购类型</div>
            <div class="value">{{ purchaseTypeText(applyForm.purchaseType) }}</div>
          </div>
          <div class="base-item">
            <div class="title label">业务状态</div>
            <div class="value">{{ businessStatusText(applyForm) }}</div>
          </div>
          <div v-if="isApplicationDetail || applyForm.contractNum" class="base-item">
            <div class="title label">关联合同</div>
            <div class="value">
              <el-link
                v-if="applyForm.contractId"
                type="primary"
                :underline="false"
                @click="openRelatedContract"
              >{{ applyForm.contractNum || '查看合同' }}</el-link>
              <span v-else>{{ applyForm.contractNum || '-' }}</span>
            </div>
          </div>
          <div v-if="isApplicationDetail" class="base-item">
            <div class="title label">项目/用途</div>
            <div class="value">{{ applyForm.projectCode || applyForm.projectName || '-' }}</div>
          </div>
          <div v-if="isApplicationDetail" class="base-item">
            <div class="title label">申请人</div>
            <div class="value">{{ applyForm.applicantName || '-' }}</div>
          </div>
          <div v-if="isApplicationDetail" class="base-item">
            <div class="title label">{{ purchaseOwnerFieldLabel(applyForm) }}</div>
            <div class="value">{{ purchaseOwnerDisplayText(applyForm) }}</div>
          </div>
          <div v-if="isSupplierOrderDetail && canViewPurchaseSensitive" class="base-item">
            <div class="title label">供应商</div>
            <div class="value">{{ applyForm.supplierName || contractForm.supplierName || '-' }}</div>
          </div>
          <div v-if="isApplicationDetail || (isSupplierOrderDetail && canViewPurchaseSensitive)" class="base-item">
            <div class="title label">{{ isApplicationDetail ? '申请总价' : '采购金额' }}</div>
            <div class="value">{{ money(applyForm.applyAmount || totalApplyAmount) }}</div>
          </div>
          <div v-if="isSupplierOrderDetail && canViewPurchaseSensitive" class="base-item">
            <div class="title label">已付/未付</div>
            <div class="value">{{ money(detailPaidAmount) }} / {{ money(detailUnpaidAmount) }}</div>
          </div>
          <div class="base-item">
            <div class="title label">期望到货</div>
            <div class="value">{{ applyForm.expectedArrivalDate || '-' }}</div>
          </div>
        </div>
      </el-card>

      <el-row :gutter="12" class="purchase-detail-layout" :class="{ 'is-single-column': !applyForm.id || sidebarCollapsed }">
        <div v-if="applyForm.id" class="sidebar-toggle">
          <el-button type="text" @click="sidebarCollapsed = !sidebarCollapsed">
            {{ sidebarCollapsed ? '展开' : '收起' }}
          </el-button>
        </div>
        <el-col :span="!applyForm.id || sidebarCollapsed ? 24 : 18">
          <el-card class="crm-detail-main purchase-detail-main" shadow="never">
      <el-tabs v-model="detailTab" class="detail-tabs">
        <el-tab-pane name="basic">
          <span slot="label"><i class="el-icon-document"></i> {{ isSupplierOrderDetail ? '采购清单' : detailDocumentTitle }}</span>
          <el-form ref="applyForm" :model="applyForm" :rules="applyRules" label-width="108px" class="purchase-form">
            <template v-if="isApplicationDetail">
              <div class="section-title section-title--first">
                <span>采购基本信息</span>
                <div class="section-title__actions">
                  <el-button v-if="canEditProcurementBase" v-hasPermi="['crm:procurement:save']" type="primary" plain icon="el-icon-magic-stick" size="mini" :loading="recognizingContract" @click="handleRecognizeContract">AI录入</el-button>
                  <el-button
                    v-if="canEditProcurementBase"
                    v-hasPermi="['crm:procurement:save']"
                    type="primary"
                    plain
                    size="mini"
                    :loading="applySaving && applySavingAction === 'save'"
                    :disabled="applySaving"
                    @click="saveApply(false)"
                  >{{ procurementSaveActionText }}</el-button>
                  <el-button
                    v-if="canEditProcurementBase && !isApplicationPendingSplit"
                    v-hasPermi="['crm:procurement:submit']"
                    type="primary"
                    size="mini"
                    :loading="applySaving && applySavingAction === 'submit'"
                    :disabled="applySaving"
                    @click="saveApply(true)"
                  >保存并提交</el-button>
                </div>
              </div>
              <el-row :gutter="12">
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="采购主题" prop="applyTitle">
                    <el-input v-model="applyForm.applyTitle" :disabled="!canEditProcurementBase" placeholder="请输入采购主题" />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="采购类型" prop="purchaseType">
                    <el-select v-model="applyForm.purchaseType" :disabled="!canEditProcurementBase" placeholder="请选择" style="width:100%" @change="handlePurchaseTypeChange">
                      <el-option-group v-for="group in purchaseTypeOptionGroups" :key="group.label" :label="group.label">
                        <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="期望到货">
                    <el-date-picker v-model="applyForm.expectedArrivalDate" :disabled="!canEditProcurementBase" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期" style="width:100%" />
                  </el-form-item>
                </el-col>
                <el-col v-if="isProjectPurchase" :xs="24" :md="12" :lg="8">
                  <el-form-item label="关联合同" prop="contractId" :required="isProjectPurchase">
                    <el-select
                      v-model="applyForm.contractId"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      :disabled="!canEditProcurementBase"
                      :remote-method="searchContracts"
                      :loading="loading.contract"
                      placeholder="搜索并选择系统已有合同"
                      style="width:100%"
                      @focus="searchContracts(contractQueryKeyword)"
                      @change="handleContractChange"
                    >
                      <el-option
                        v-for="item in contractOptions"
                        :key="item.id"
                        :label="contractOptionLabel(item)"
                        :value="item.id"
                      >
                        <span>{{ item.contractNum || '-' }}</span>
                        <span class="option-sub-text">{{ item.contractName || item.customerName || '' }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="isAttachmentOnlyApplication" :xs="24" :md="12" :lg="8">
                  <el-form-item label="预估总价" required>
                    <el-input-number
                      v-model="applyForm.applyAmount"
                      :disabled="!canEditProcurementBase"
                      :precision="3"
                      :min="0"
                      :step="0.001" :controls="false"
                      placeholder="请输入预估总价"
                      style="width:100%"
                      @change="normalizeApplyAmounts"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="申请单备注" prop="remark">
                <el-input
                  v-if="canEditProcurementBase"
                  v-model="applyForm.remark"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 8 }"
                  maxlength="1000"
                  show-word-limit
                  placeholder="请输入整张采购申请单的补充说明（选填）"
                />
                <div v-else style="white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.6; padding-top: 8px;">{{ applyForm.remark || '-' }}</div>
              </el-form-item>
            </template>

            <div class="section-title" :class="{ 'section-title--first': isSupplierOrderDetail }">
              <span>{{ isSupplierOrderDetail ? '真实采购清单' : '采购需求明细' }}</span>
              <div class="section-title__actions">
                <el-switch
                  v-if="isApplicationDetail && canEditProcurementBase"
                  :value="isAttachmentOnlyApplication"
                  active-text="复杂清单，仅上传附件"
                  @change="handleAttachmentOnlyModeChange"
                />
                <el-tag v-else-if="isAttachmentOnlyApplication" size="mini" type="info">仅附件申请</el-tag>
                <el-button v-if="canEditProcurementBase && !isAttachmentOnlyApplication" type="primary" plain icon="el-icon-plus" size="mini" @click="addApplyItem">新增明细</el-button>
              </div>
            </div>
            <el-alert
              v-if="isAttachmentOnlyApplication"
              class="attachment-only-tip"
              title="本申请以原始附件作为需求依据"
              description="适用于格式复杂、暂时无法结构化录入的采购清单。提交时必须上传附件并填写预估总价；预估总价用于审批分级，采购员完成询价前仍需整理真实采购项和供应商报价。"
              type="info"
              show-icon
              :closable="false"
            />
            <el-table
              v-else
              :key="isApplicationDetail ? 'application-items' : 'supplier-order-items'"
              :data="applyForm.itemList"
              border
              class="edit-table"
            >
              <el-table-column v-if="showApplicationItemExpand" type="expand" width="42">
                <template slot-scope="scope">
                  <div class="requirement-detail-grid">
                    <el-form-item label="工艺分区">
                      <el-input v-model="scope.row.processSection" :disabled="!canEditProcurementBase" maxlength="200" placeholder="如：MBR膜池" />
                    </el-form-item>
                    <el-form-item label="系统/分组">
                      <el-input v-model="scope.row.itemGroupName" :disabled="!canEditProcurementBase" maxlength="200" placeholder="如：膜清洗加药系统" />
                    </el-form-item>
                    <el-form-item label="技术参数">
                      <el-input v-model="scope.row.technicalParameter" :disabled="!canEditProcurementBase" type="textarea" :rows="2" maxlength="10000" show-word-limit placeholder="流量、扬程、功率、控制方式等" />
                    </el-form-item>
                    <el-form-item label="材质要求">
                      <el-input v-model="scope.row.materialRequirement" :disabled="!canEditProcurementBase" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="与供应商品牌分开，仅填写技术材质要求" />
                    </el-form-item>
                    <el-form-item label="需求备注" class="requirement-detail-grid__wide">
                      <el-input v-model="scope.row.remark" :disabled="!canEditProcurementBase" type="textarea" :rows="2" maxlength="1000" show-word-limit placeholder="品牌/厂家只能作为技术建议，不会自动绑定供应商" />
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="物料名称" min-width="220">
                <template slot-scope="scope">
                  <el-input
                    v-if="isApplicationDetail"
                    v-model="scope.row.materialName"
                    :disabled="!canEditProcurementBase"
                    placeholder="请输入物料名称"
                  />
                  <el-autocomplete
                    v-else
                    v-model="scope.row.materialName"
                    :disabled="!canEditProcurementBase"
                    :fetch-suggestions="(query, cb) => queryMaterialSuggestions(query, scope.row, cb)"
                    :title="scope.row.materialName || ''"
                    value-key="materialName"
                    :trigger-on-focus="true"
                    :highlight-first-item="true"
                    placeholder="优先选择物料，找不到可输入"
                    popper-class="material-reference-popper"
                    style="width:100%"
                    @input="handleItemMaterialInput(scope.row)"
                    @select="item => handleMaterialSuggestionSelect(scope.row, item)"
                    @blur="handleItemMaterialBlur(scope.row)"
                  >
                    <template slot-scope="{ item }">
                      <div class="reference-option reference-option--material-name">
                        <strong>{{ item.materialName }}</strong>
                        <div v-if="materialSuggestionOptionDetails(item).length" class="reference-option__details">
                          <span v-for="detail in materialSuggestionOptionDetails(item)" :key="detail">{{ detail }}</span>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                </template>
              </el-table-column>
              <el-table-column :label="isApplicationDetail ? '型号/规格' : '规格型号'" min-width="260">
                <template slot-scope="scope">
                  <el-input
                    v-if="isApplicationDetail"
                    v-model="scope.row.specification"
                    :disabled="!canEditProcurementBase"
                    placeholder="请输入规格型号"
                    @input="value => syncApplicationModel(scope.row, value)"
                  />
                  <el-autocomplete
                    v-else
                    v-model="scope.row.specification"
                    :disabled="!canEditProcurementBase"
                    :fetch-suggestions="(query, cb) => queryItemSpecificationSuggestions(query, scope.row, cb)"
                    :title="scope.row.specification || ''"
                    value-key="value"
                    clearable
                    :trigger-on-focus="true"
                    :highlight-first-item="true"
                    placeholder="优先选择规格，找不到可输入"
                    popper-class="spec-reference-popper"
                    style="width:100%"
                    @input="handleItemSpecificationInput(scope.row)"
                    @select="item => handleSpecificationSuggestionSelect(scope.row, item)"
                    @blur="handleItemSpecificationBlur(scope.row)"
                  >
                    <template slot-scope="{ item }">
                      <div class="spec-reference-option" :title="item.value">
                        <strong>{{ item.value }}</strong>
                        <span v-if="item.detail">{{ item.detail }}</span>
                      </div>
                    </template>
                  </el-autocomplete>
                </template>
              </el-table-column>
              <el-table-column v-if="shouldShowSupplierInputColumn" :label="isEcommercePurchase ? '平台 / 店铺' : '供应商'" min-width="280">
                <template slot-scope="scope">
                  <div v-if="isEcommercePurchase" class="ecommerce-store-cell">
                    <el-tag v-if="scope.row.purchasePlatform" size="mini" type="warning">{{ scope.row.purchasePlatform }}</el-tag>
                    <el-input
                      v-model="scope.row.supplierName"
                      :disabled="!canEditProcurementBase"
                      maxlength="200"
                      placeholder="请输入实际店铺名"
                    />
                  </div>
                  <el-autocomplete
                    v-else
                    v-model="scope.row.supplierName"
                    :disabled="!canEditProcurementBase"
                    :fetch-suggestions="(query, cb) => queryItemSupplierSuggestions(query, scope.row, cb)"
                    :title="scope.row.supplierName || ''"
                    value-key="supplierName"
                    placeholder="优先选择供应商，找不到可输入"
                    popper-class="supplier-reference-popper"
                    style="width:100%"
                    @input="handleItemSupplierInput(scope.row)"
                    @select="item => handleItemSupplierSelect(scope.row, item)"
                    @blur="handleItemSupplierBlur(scope.row)"
                  >
                    <template slot-scope="{ item }">
                      <div class="reference-option">
                        <div class="reference-option__title">
                          <strong>{{ item.supplierName }}</strong>
                          <em v-if="item.shortName">{{ item.shortName }}</em>
                        </div>
                        <div v-if="itemSupplierOptionDetails(item).length" class="reference-option__details">
                          <span v-for="detail in itemSupplierOptionDetails(item)" :key="detail.label + detail.value">{{ detail.label }}：{{ detail.value }}</span>
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                  <div v-if="!isEcommercePurchase" class="reference-row-tags">
                    <el-tag v-if="scope.row.supplierName && !scope.row.supplierId" size="mini" type="info">新供应商</el-tag>
                    <el-tag v-if="scope.row.historyPriceMatched" size="mini" type="success">已匹配历史价格</el-tag>
                    <el-button v-if="canAccessPurchasePrice && scope.row.materialName" type="text" class="price-reference-link" @click="openItemPriceLookup(scope.row)">查看供应商价格</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="isSupplierOrderDetail" label="编码" min-width="110">
                <template slot-scope="scope"><el-input v-model="scope.row.materialCode" :disabled="!canEditProcurementBase" /></template>
              </el-table-column>
              <el-table-column v-if="isSupplierOrderDetail" label="材质/品牌" min-width="130">
                <template slot-scope="scope"><el-input v-model="scope.row.materialQualityBrand" :disabled="!canEditProcurementBase" /></template>
              </el-table-column>
              <el-table-column label="数量" width="120">
                <template slot-scope="scope"><el-input v-model.number="scope.row.quantity" :disabled="!canEditProcurementBase" type="number" min="0" style="width:100%" @input="recalculateRow(scope.row)" /></template>
              </el-table-column>
              <el-table-column label="单位" width="90">
                <template slot-scope="scope"><el-input v-model="scope.row.unit" :disabled="!canEditProcurementBase" /></template>
              </el-table-column>
              <el-table-column v-if="isApplicationDetail || (isSupplierOrderDetail && canViewPurchaseSensitive)" :label="isApplicationDetail ? '单价（选填）' : '采购单价'" width="130">
                <template slot-scope="scope">
                  <el-input-number v-if="canEditProcurementBase" v-model="scope.row.purchaseUnitPrice" :precision="3" :step="0.001" :min="0" :controls="false" placeholder="选填" style="width:100%" @change="recalculateRow(scope.row)" />
                  <span v-else>{{ unitPriceText(scope.row.purchaseUnitPrice) }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="isApplicationDetail || (isSupplierOrderDetail && canViewPurchaseSensitive)" :label="isApplicationDetail ? '总价' : '金额'" width="130">
                <template slot-scope="scope"><el-input :value="money(scope.row.amount)" disabled style="width:100%" /></template>
              </el-table-column>
              <el-table-column v-if="isSupplierOrderDetail" label="交期" width="140">
                <template slot-scope="scope"><el-date-picker v-model="scope.row.expectedArrivalDate" :disabled="!canEditProcurementBase" type="date" value-format="yyyy-MM-dd" placeholder="日期" style="width:100%" /></template>
              </el-table-column>
              <el-table-column label="操作" width="70" align="center">
                <template slot-scope="scope"><el-button v-if="canEditProcurementBase" type="text" class="danger" @click="removeApplyItem(scope.$index)">删除</el-button><span v-else>-</span></template>
              </el-table-column>
            </el-table>

            <div v-if="isApplicationDetail" class="section-title">
              <span>附件 <el-tag v-if="isAttachmentOnlyApplication" size="mini" type="danger">必传</el-tag></span>
            </div>
            <div v-if="isApplicationDetail" class="single-attachment-panel">
              <file-upload :key="'apply-attachment-single-' + uploadRenderKey" v-model="applicationAttachmentFileObjs" :limit="8" :multiple="true" :readOnly="!canEditProcurementBase"></file-upload>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('decision')" name="decision">
          <span slot="label"><i class="el-icon-s-order"></i> 最终定商清单</span>
          <div class="final-decision-card__header final-decision-tab__header">
            <div>
              <strong>最终定商清单</strong>
              <span>总经理定商结果 · {{ finalDecisionSupplierGroups.length }} 家供应商 / 店铺</span>
            </div>
            <div class="final-decision-card__total">
              <span>定商总价</span>
              <strong>{{ money(finalDecisionTotalAmount) }}</strong>
              <el-button v-if="shouldShowDetailTab('quote')" type="text" size="mini" @click="detailTab = 'quote'">查看全部报价</el-button>
            </div>
          </div>
          <section v-for="group in finalDecisionSupplierGroups" :key="group.key" class="final-decision-supplier">
            <div class="final-decision-supplier__head">
              <div>
                <el-tag v-if="group.purchasePlatform" size="mini" type="warning">{{ group.purchasePlatform }}</el-tag>
                <strong>{{ group.supplierName }}</strong>
                <span>{{ group.groupName }} · {{ group.lines.length }} 项</span>
              </div>
              <strong>{{ money(group.subtotal) }}</strong>
            </div>
            <el-table :data="group.lines" border size="mini" empty-text="暂无定商明细">
              <el-table-column label="采购内容" min-width="220">
                <template slot-scope="scope">
                  <strong>{{ scope.row.materialName }}</strong>
                  <span v-if="scope.row.specification" class="sub-text"> · {{ scope.row.specification }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" width="120" align="right">
                <template slot-scope="scope">{{ numberText(scope.row.quantity) }} {{ scope.row.unit }}</template>
              </el-table-column>
              <el-table-column label="定商单价" width="140" align="right">
                <template slot-scope="scope">{{ unitPriceText(scope.row.unitPrice) }}</template>
              </el-table-column>
              <el-table-column label="金额" width="150" align="right">
                <template slot-scope="scope"><strong>{{ money(scope.row.amount) }}</strong></template>
              </el-table-column>
            </el-table>
          </section>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('contract')" name="contract">
          <span slot="label"><i class="el-icon-document-checked"></i> 采购合同</span>
          <el-form :model="contractForm" label-width="108px" class="purchase-form">
            <div class="section-title section-title--first">
              <span>合同信息</span>
              <div class="section-title__actions">
                <el-button v-if="canManageContractSection && !contractEditing" v-hasPermi="['crm:procurement:contract']" type="primary" plain icon="el-icon-edit" size="mini" @click="startContractEdit">编辑合同信息</el-button>
                <el-button v-if="canEditContractSection && !isContractNotRequired" v-hasPermi="['crm:procurement:contract']" type="primary" plain icon="el-icon-magic-stick" size="mini" :loading="recognizingContract" @click="handleRecognizeContractInfoOnly">AI填合同</el-button>
                <el-button v-if="canEditContractSection" size="mini" @click="cancelContractEdit">取消</el-button>
                <el-button v-if="canEditContractSection" v-hasPermi="['crm:procurement:contract']" type="primary" size="mini" :loading="contractModeSaving" @click="saveSupplierContract">保存合同信息</el-button>
              </div>
            </div>
            <el-alert
              v-if="isBatchManagedSupplierOrder"
              title="合同资料由采购申请主单统一批量维护；再次维护会替换原合同，用印通过后锁定。用印状态不影响本采购执行单的付款、到货状态。"
              type="info"
              show-icon
              :closable="false"
            />
            <div class="contract-choice-row">
              <span class="contract-choice-row__label">合同情况</span>
              <el-radio-group v-model="contractModeDraft" :disabled="!contractEditing">
                <el-radio :label="1">有合同信息</el-radio>
                <el-radio :label="2">无合同信息</el-radio>
              </el-radio-group>
            </div>
            <div v-if="!isContractNotRequired" class="contract-inline-panel" :class="{ 'is-readonly-section': !canEditContractSection }">
              <el-row :gutter="12">
                <el-col :xs="24" :md="12" :lg="8"><el-form-item label="采购合同号"><el-input v-model="contractForm.contractNo" :disabled="!canEditContractSection" /></el-form-item></el-col>
                <el-col :xs="24" :md="12" :lg="8"><el-form-item label="合同名称"><el-input v-model="contractForm.contractName" :disabled="!canEditContractSection" /></el-form-item></el-col>
                <el-col :xs="24" :md="12" :lg="8"><el-form-item label="签约日期"><el-date-picker v-model="contractForm.signDate" :disabled="!canEditContractSection" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="甲方">
                    <el-autocomplete
                      v-model="contractForm.partyA"
                      :disabled="!canEditContractSection"
                      :fetch-suggestions="queryTenantPartySuggestions"
                      value-key="fullName"
                      placeholder="默认当前租户"
                      popper-class="party-reference-popper"
                      style="width:100%"
                      @select="handleContractPartyASelect"
                      @blur="handleContractPartyABlur"
                    >
                      <template slot-scope="{ item }">
                        <div class="reference-option">
                          <div class="reference-option__title">
                            <strong>{{ item.fullName }}</strong>
                            <em v-if="item.shortName">{{ item.shortName }}</em>
                          </div>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="乙方">
                    <el-autocomplete
                      v-model="contractForm.partyB"
                      :disabled="!canEditContractSection"
                      :fetch-suggestions="querySupplierSuggestions"
                      value-key="supplierName"
                      placeholder="默认供应商"
                      popper-class="supplier-reference-popper"
                      style="width:100%"
                      @input="handleContractPartyBInput"
                      @select="handleContractPartyBSelect"
                      @blur="handleContractPartyBBlur"
                    >
                      <template slot-scope="{ item }">
                        <div class="reference-option">
                          <div class="reference-option__title">
                            <strong>{{ item.supplierName }}</strong>
                            <em v-if="item.shortName">{{ item.shortName }}</em>
                          </div>
                          <div v-if="supplierOptionDetails(item).length" class="reference-option__details">
                            <span v-for="detail in supplierOptionDetails(item)" :key="detail.label + detail.value">{{ detail.label }}：{{ detail.value }}</span>
                          </div>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :lg="8">
                  <el-form-item label="供应商">
                    <el-autocomplete
                      v-model="contractForm.supplierName"
                      :disabled="!canEditContractSection"
                      :fetch-suggestions="querySupplierSuggestions"
                      value-key="supplierName"
                      placeholder="输入或选择供应商"
                      popper-class="supplier-reference-popper"
                      style="width:100%"
                      @input="handleContractSupplierInput"
                      @select="handleContractSupplierSelect"
                      @blur="handleContractSupplierBlur"
                    >
                      <template slot-scope="{ item }">
                        <div class="reference-option">
                          <div class="reference-option__title">
                            <strong>{{ item.supplierName }}</strong>
                            <em v-if="item.shortName">{{ item.shortName }}</em>
                          </div>
                          <div v-if="supplierOptionDetails(item).length" class="reference-option__details">
                            <span v-for="detail in supplierOptionDetails(item)" :key="detail.label + detail.value">{{ detail.label }}：{{ detail.value }}</span>
                          </div>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :lg="8"><el-form-item label="合同金额"><el-input-number v-model="contractForm.contractAmount" :disabled="!canEditContractSection" :precision="2" :min="0" :controls="false" style="width:100%" /></el-form-item></el-col>
                <el-col :xs="24" :md="12" :lg="8"><el-form-item label="税率%"><el-input-number v-model="contractForm.taxRate" :disabled="!canEditContractSection" :precision="2" :min="0" :controls="false" style="width:100%" /></el-form-item></el-col>
                <el-col :xs="24" :md="12" :lg="16"><el-form-item label="交付约定"><el-input v-model="contractForm.deliveryPeriod" :disabled="!canEditContractSection" /></el-form-item></el-col>
                <el-col :span="24"><el-form-item label="付款条款"><el-input v-model="contractForm.paymentTerms" :disabled="!canEditContractSection" type="textarea" :rows="2" /></el-form-item></el-col>
                <el-col :span="24"><el-form-item label="附件清单"><el-input v-model="contractForm.attachmentListText" :disabled="!canEditContractSection" type="textarea" :rows="2" /></el-form-item></el-col>
                <el-col :span="24">
                  <el-form-item label="合同附件">
                    <file-upload :key="'contract-upload-' + uploadRenderKey" v-model="contractForm.fileInfoList" :limit="8" :multiple="true" :readOnly="!canEditContractSection"></file-upload>
                    <div v-if="canEditContractSection || contractReadonlyTip" class="field-tip">{{ canEditContractSection ? '可上传供应商采购合同或扫描件；付款由采购在付款页登记实际付款金额。' : contractReadonlyTip }}</div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('shipment')" name="shipment">
          <span slot="label"><i class="el-icon-truck"></i> 发货物流</span>
          <div class="section-title section-title--first">
            <span>发货物流</span>
            <div class="section-title__actions">
              <el-button v-if="canManageShipment && !shipmentEditing" v-hasPermi="['crm:procurement:quote']" type="primary" size="mini" icon="el-icon-plus" @click="openShipmentEditor()">添加物流记录</el-button>
            </div>
          </div>
          <el-alert type="info" :closable="false" show-icon title="采购员登记供应商发货信息，仓管和财务可直接查看；快递或物流发货时必须填写物流单号。" />
          <el-table :data="detail.shipmentList || []" border class="shipment-table" empty-text="暂无发货物流记录">
            <el-table-column label="发货日期" prop="shipmentDate" width="120" />
            <el-table-column label="发货方式" width="126"><template slot-scope="scope">{{ shipmentMethodText(scope.row.shipmentMethod) }}</template></el-table-column>
            <el-table-column label="承运单位" prop="logisticsCompanyName" min-width="150" show-overflow-tooltip />
            <el-table-column label="物流单号" prop="trackingNo" min-width="170" show-overflow-tooltip />
            <el-table-column label="状态" width="100" align="center"><template slot-scope="scope"><el-tag size="mini" :type="Number(scope.row.completeFlag) === 1 ? 'success' : 'warning'">{{ Number(scope.row.completeFlag) === 1 ? '全部发货' : '部分发货' }}</el-tag></template></el-table-column>
            <el-table-column label="备注" prop="remark" min-width="160" show-overflow-tooltip />
            <el-table-column label="附件" width="110" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.fileInfoList && scope.row.fileInfoList.length" type="text" @click="openShipmentAttachments(scope.row)">{{ scope.row.fileInfoList.length }}个附件</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column v-if="canManageShipment" label="操作" width="130" align="center">
              <template slot-scope="scope">
                <div class="table-action-group">
                  <el-button type="text" @click="openShipmentEditor(scope.row)">编辑</el-button>
                  <el-button type="text" class="danger" @click="handleRemoveShipment(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-form v-if="shipmentEditing" :model="shipmentForm" label-width="96px" class="shipment-editor">
            <el-row :gutter="12">
              <el-col :xs="24" :md="12" :lg="8"><el-form-item label="发货方式" required><el-select v-model="shipmentForm.shipmentMethod" style="width:100%"><el-option label="快递/物流" :value="1" /><el-option label="供应商送货" :value="2" /><el-option label="采购自提" :value="3" /><el-option label="其他" :value="4" /></el-select></el-form-item></el-col>
              <el-col :xs="24" :md="12" :lg="8"><el-form-item label="发货日期" required><el-date-picker v-model="shipmentForm.shipmentDate" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
              <el-col :xs="24" :md="12" :lg="8"><el-form-item label="发货状态"><el-switch v-model="shipmentForm.completeFlag" :active-value="1" :inactive-value="0" active-text="全部发货" inactive-text="部分发货" /></el-form-item></el-col>
              <el-col :xs="24" :md="12"><el-form-item label="承运单位"><el-input v-model="shipmentForm.logisticsCompanyName" maxlength="100" placeholder="快递公司、物流公司或送货单位" /></el-form-item></el-col>
              <el-col :xs="24" :md="12"><el-form-item label="物流单号" :required="Number(shipmentForm.shipmentMethod) === 1"><el-input v-model="shipmentForm.trackingNo" maxlength="100" placeholder="快递/物流发货时必填" /></el-form-item></el-col>
              <el-col :span="24"><el-form-item label="备注"><el-input v-model="shipmentForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit /></el-form-item></el-col>
              <el-col :span="24"><el-form-item label="附件（选填）"><file-upload :key="'shipment-upload-' + uploadRenderKey" v-model="shipmentForm.fileInfoList" :limit="8" :multiple="true"></file-upload></el-form-item></el-col>
            </el-row>
            <div class="shipment-editor__actions">
              <el-button @click="cancelShipmentEdit">取消</el-button>
              <el-button v-hasPermi="['crm:procurement:quote']" type="primary" :loading="shipmentSaving" @click="handleSaveShipment">保存物流记录</el-button>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('quote')" name="quote">
          <span slot="label"><i class="el-icon-s-check"></i> 供应商报价</span>
          <section v-if="canShowPurchaserDecisionEntry" class="purchaser-decision-entry">
            <div class="purchaser-decision-entry__icon"><i class="el-icon-data-analysis"></i></div>
            <div class="purchaser-decision-entry__main">
              <div class="purchaser-decision-entry__title">
                <strong>智能定商分析</strong>
                <el-tag
                  size="mini"
                  :type="purchaserDecisionAnalysis && purchaserDecisionAnalysis.analysisStatus === 'READY' ? 'success' : (purchaserDecisionAnalysis && purchaserDecisionAnalysis.analysisStatus === 'GENERATING' ? 'warning' : 'info')"
                >{{ purchaserDecisionAnalysis && purchaserDecisionAnalysis.analysisStatus === 'READY' ? '分析完成' : (purchaserDecisionAnalysis && purchaserDecisionAnalysis.analysisStatus === 'GENERATING' ? '生成中' : '待生成') }}</el-tag>
              </div>
              <p v-if="purchaserDecisionAnalysis && purchaserDecisionAnalysis.analysisStatus === 'READY'">
                {{ purchaserDecisionAnalysis.executiveSummary || purchaserDecisionAnalysis.overallConclusion || '分析已生成，可查看完整建议和风险。' }}
              </p>
              <p v-else>在这里提前核对给总经理看的推荐结论和风险提示；完成询价时系统仍会自动更新分析。</p>
            </div>
            <div class="purchaser-decision-entry__actions">
              <el-button
                v-if="quoteDisplayGroups.length"
                type="primary"
                plain
                size="mini"
                :loading="decisionAnalysisGenerating"
                @click="handleGenerateDecisionAnalysis"
              >{{ purchaserDecisionAnalysis ? '刷新分析' : '生成分析' }}</el-button>
              <el-button v-if="purchaserDecisionAnalysis" type="text" size="mini" @click="scrollToPurchaserDecisionAnalysis">查看完整分析</el-button>
            </div>
          </section>
          <section class="quote-requirement-panel">
            <button type="button" class="quote-requirement-toggle" @click="quoteRequirementsExpanded = !quoteRequirementsExpanded">
              <span><strong>采购需求明细</strong><em>{{ (applyForm.itemList || []).length }}项</em></span>
              <i :class="quoteRequirementsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
            </button>
            <el-collapse-transition>
              <el-table v-show="quoteRequirementsExpanded" :data="applyForm.itemList || []" border class="quote-requirement-table">
                <el-table-column label="物料名称" prop="materialName" min-width="200" show-overflow-tooltip />
                <el-table-column label="规格型号" prop="specification" min-width="220" show-overflow-tooltip />
                <el-table-column label="数量" width="120" align="right">
                  <template slot-scope="scope">{{ numberText(scope.row.quantity) }} {{ scope.row.unit || '' }}</template>
                </el-table-column>
                <el-table-column label="需求单价" width="130" align="right">
                  <template slot-scope="scope">{{ unitPriceText(scope.row.purchaseUnitPrice || scope.row.budgetUnitPrice) }}</template>
                </el-table-column>
                <el-table-column label="小计" width="140" align="right">
                  <template slot-scope="scope">{{ money(scope.row.amount) }}</template>
                </el-table-column>
              </el-table>
            </el-collapse-transition>
          </section>

          <section class="purchase-mode-panel">
            <div>
              <strong>报价组类型</strong>
              <span>每个报价组可独立选择普通供应商或电商店铺；审批通过后按实际类型分别生成执行单。</span>
            </div>
            <div class="purchase-mode-panel__types">
              <el-tag size="small" type="info">普通供应商报价组</el-tag>
              <el-tag size="small" type="warning">电商平台店铺报价组</el-tag>
            </div>
          </section>

          <div class="section-title quote-list-title">
            <span>供应商 / 电商店铺报价组</span>
            <div class="section-title__actions">
              <el-upload
                v-if="canEditQuote"
                action=""
                accept=".xls,.xlsx"
                :show-file-list="false"
                :http-request="handleQuoteWorkbookUpload"
              >
                <el-button size="mini" :loading="quoteImportLoading" icon="el-icon-upload2">导入报价表</el-button>
              </el-upload>
              <el-button v-if="canEditQuote" type="primary" size="mini" icon="el-icon-plus" @click="openQuoteDialog()">新增报价组</el-button>
            </div>
          </div>
          <el-empty v-if="!quoteDisplayGroups.length" description="暂无报价组" />
          <template v-else>
          <section v-for="(group, groupIndex) in quoteDisplayGroups" :key="group.key" class="quote-group-card quote-comparison-card">
            <div
              class="quote-group-card__head quote-group-card__toggle"
              role="button"
              tabindex="0"
              @click="toggleQuoteGroup(group, groupIndex)"
              @keydown.enter.prevent="toggleQuoteGroup(group, groupIndex)"
              @keydown.space.prevent="toggleQuoteGroup(group, groupIndex)"
            >
              <div class="quote-group-card__identity">
                <div>
                  <strong>{{ group.comparisonGroupName }}</strong>
                  <el-tag size="mini" :type="quoteGroupIsEcommerce(group) ? 'warning' : 'info'">{{ quoteGroupModeLabel(group) }}</el-tag>
                  <span>{{ group.itemCount }}项 · {{ group.supplierCount }}家{{ quoteGroupPartyName(group) }}</span>
                </div>
                <span class="quote-amount-inline">实采金额 {{ money(group.actualPurchaseAmount) }} · 使用库存 {{ money(group.inventoryUseAmount) }}<template v-if="positiveAmount(group.freightAmount)"> · 运费 {{ money(group.freightAmount) }}</template> · 总金额 {{ money(group.totalDemandAmount) }}</span>
                <span v-if="group.recommendedItemCount">
                  采购员已推荐 {{ group.recommendedItemCount }}/{{ group.decisionItemCount }} 项
                  <template v-if="group.recommendedSupplierName"> · {{ group.recommendedSupplierName }}</template>
                </span>
                <span v-if="group.recommendationReason">推荐理由：{{ group.recommendationReason }}</span>
                <span v-if="group.selectedSupplierName">{{ quoteGroupIsEcommerce(group) ? '已选店铺' : '已定商' }}：{{ group.selectedSupplierName }}</span>
              </div>
              <div class="quote-group-card__summary">
                <el-radio-group
                  size="mini"
                  class="quote-group-layout-switch"
                  :value="quoteGroupDisplayLayout(group)"
                  @input="layout => setQuoteGroupDisplayLayout(group, layout)"
                  @click.native.stop
                  @keydown.native.stop
                >
                  <el-radio-button label="supplier">按报价方</el-radio-button>
                  <el-radio-button label="item">按产品</el-radio-button>
                </el-radio-group>
                <div v-if="canEditQuote" class="quote-group-card__actions">
                  <el-button type="text" @click.stop="editQuoteGroup(group)">编辑</el-button>
                  <el-button type="text" class="danger" @click.stop="removeQuoteGroup(group)">删除</el-button>
                </div>
                <i :class="quoteGroupExpanded(group, groupIndex) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="quoteGroupExpanded(group, groupIndex)" class="quote-comparison-card__body">
                <div v-if="quoteGroupDisplayLayout(group) === 'item'" class="quote-display-item-list">
                  <section
                    v-for="(item, itemIndex) in group.items"
                    :key="item.key"
                    class="quote-display-item-card"
                  >
                    <div class="quote-display-item-card__head">
                      <div>
                        <strong>{{ item.materialName || `采购项 ${itemIndex + 1}` }}</strong>
                        <span>{{ item.specification || '无规格' }}<template v-if="item.parameterValue"> · {{ item.parameterValue }}</template><template v-if="item.materialQualityBrand"> · {{ item.materialQualityBrand }}</template></span>
                      </div>
                      <div>
                        <el-tag size="mini" type="info">需求 {{ numberText(item.demandQuantity) }}</el-tag>
                        <el-tag size="mini" type="info">库存 {{ numberText(item.inventoryQuantity) }}</el-tag>
                        <el-tag size="mini" type="success">实采 {{ numberText(item.quantity) }}{{ item.unit || '' }}</el-tag>
                        <el-tag v-if="item.historyMinPrice !== undefined && item.historyMinPrice !== null" size="mini" type="warning">历史价 {{ unitPriceText(item.historyMinPrice) }}</el-tag>
                        <el-tag size="mini">{{ quoteDisplayItemOffers(group, item).length }}家{{ quoteGroupPartyName(group) }}</el-tag>
                        <el-tag v-if="item.recommendedOffer" size="mini" type="warning">
                          推荐 {{ quoteSupplierDisplayName(item.recommendedOffer, item.recommendedOffer.supplierName) }}
                        </el-tag>
                        <el-tag v-else-if="quoteItemRequiresDecision(item)" size="mini" type="info">未推荐</el-tag>
                      </div>
                    </div>
                    <div v-if="!quoteDisplayItemOffers(group, item).length" class="quote-display-item-offer-empty">暂无{{ quoteGroupPartyName(group) }}报价</div>
                    <div v-else class="quote-display-item-offer-list">
                      <div
                        v-for="(offer, offerIndex) in quoteDisplayItemOffers(group, item)"
                        :key="offer.id || `${item.key}-${offer.key || offer.quoteGroupNo || offerIndex}`"
                        class="quote-display-item-offer-row"
                        :class="{ 'is-selected': offer.selected, 'is-recommended': offer.recommended && !offer.selected }"
                      >
                        <span class="quote-display-item-offer-row__index">{{ offerIndex + 1 }}</span>
                        <div class="quote-display-item-offer-row__supplier">
                          <el-tag v-if="offer.purchasePlatform" size="mini" type="warning">{{ offer.purchasePlatform }}</el-tag>
                          <strong>{{ offer.supplierName || '未标供应商' }}</strong>
                          <el-button
                            v-if="canEditQuote && offer.id"
                            size="mini"
                            :type="offer.recommended ? 'warning' : 'primary'"
                            :plain="!offer.recommended"
                            class="quote-recommend-inline-button"
                            @click.stop="recommendQuoteItem(group, item, offer)"
                          >{{ offer.recommended ? '取消推荐' : '设为推荐' }}</el-button>
                          <el-tag v-if="offer.recommended" size="mini" type="warning">采购员推荐</el-tag>
                          <el-tag v-if="offer.selected" size="mini" type="success">{{ quoteGroupIsEcommerce(group) ? '已选店铺' : '已定商' }}</el-tag>
                        </div>
                        <div class="quote-display-item-offer-row__price">
                          <span>单价</span>
                          <strong>{{ unitPriceText(offer.quoteAmount) }}</strong>
                        </div>
                        <div class="quote-display-item-offer-row__amount">
                          <span>实采</span>
                          <strong>{{ money(quoteActualPurchaseAmount(item, offer.quoteAmount)) }}</strong>
                        </div>
                        <div class="quote-display-item-offer-row__amount">
                          <span>库存</span>
                          <strong>{{ money(quoteInventoryUseAmount(item)) }}</strong>
                        </div>
                        <div class="quote-display-item-offer-row__amount">
                          <span>总</span>
                          <strong>{{ money(quoteTotalDemandAmount(item, offer.quoteAmount)) }}</strong>
                        </div>
                        <div class="quote-display-item-offer-row__note">
                          <span v-if="offer.recommended && offer.recommendationReason">推荐理由：{{ offer.recommendationReason }}</span>
                          <span v-else-if="meaningfulOptionalText(offer.selectionReason)">报价说明：{{ offer.selectionReason }}</span>
                          <span v-else class="muted">无补充说明</span>
                        </div>
                        <div class="quote-display-item-offer-row__actions">
                          <el-button v-for="file in offer.fileInfoList" :key="quoteFileIdentity(file)" type="text" @click.stop="openQuoteFile(file)">
                            <i class="el-icon-paperclip"></i>{{ quoteFileName(file) }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <template v-else>
                <div class="quote-supplier-summary-list">
                  <div
                    v-for="supplier in group.suppliers"
                    :key="supplier.key"
                    class="quote-supplier-summary"
                    :class="{ 'is-selected': supplier.selected, 'is-recommended': supplier.recommended && !supplier.selected }"
                  >
                    <div class="quote-supplier-summary__identity">
                      <span class="quote-supplier-summary__kind">{{ quoteGroupPartyName(group) }}</span>
                      <div class="quote-supplier-summary__name">
                        <el-tag v-if="supplier.purchasePlatform" size="mini" type="warning">{{ supplier.purchasePlatform }}</el-tag>
                        <strong>{{ supplier.supplierName }}</strong>
                        <el-button
                          v-if="canEditQuote && quoteGroupSupplierCoversAllItems(group, supplier)"
                          size="mini"
                          :type="supplier.fullyRecommended ? 'warning' : 'primary'"
                          :plain="!supplier.fullyRecommended"
                          class="quote-recommend-inline-button"
                          @click="recommendQuoteGroup(group, supplier)"
                        >{{ supplier.fullyRecommended ? '取消整组推荐' : '设为整组推荐' }}</el-button>
                      </div>
                      <div class="quote-supplier-summary__status">
                        <el-tag v-if="supplier.recommended" size="mini" type="warning">采购员推荐</el-tag>
                        <el-tag v-if="supplier.selected" size="mini" type="success">{{ quoteGroupIsEcommerce(group) ? '已选店铺' : '已定商' }}</el-tag>
                      </div>
                    </div>
                    <div class="quote-supplier-summary__price">
                      <div>
                        <span>实采金额</span>
                        <strong>{{ money(supplier.actualPurchaseAmount) }}</strong>
                      </div>
                      <div>
                        <span>使用库存</span>
                        <strong>{{ money(supplier.inventoryUseAmount) }}</strong>
                      </div>
                      <div v-if="positiveAmount(supplier.freightAmount)">
                        <span>运费</span>
                        <strong>{{ money(supplier.freightAmount) }}</strong>
                      </div>
                      <div class="quote-supplier-summary__final">
                        <span>合计</span>
                        <strong>{{ money(supplier.actualPurchaseTotalAmount) }}</strong>
                      </div>
                      <div class="quote-supplier-summary__final">
                        <span>最终价</span>
                        <strong>{{ money(supplier.totalAmount) }}</strong>
                      </div>
                      <p>
                        <span>税率 {{ supplier.taxRate === undefined || supplier.taxRate === null ? '-' : numberText(supplier.taxRate) + '%' }}</span>
                        <span>交期 {{ supplier.deliveryDays ? supplier.deliveryDays + '天' : '-' }}</span>
                      </p>
                    </div>
                    <div class="quote-supplier-summary__evidence">
                      <div v-if="meaningfulOptionalText(supplier.selectionReason)">
                        <span>报价说明</span>
                        <p>{{ supplier.selectionReason }}</p>
                      </div>
                      <div v-if="supplier.recommended && supplier.recommendationReason" class="quote-recommendation-reason">
                        <span>推荐理由</span>
                        <p>{{ supplier.recommendationReason }}</p>
                      </div>
                      <div v-if="(supplier.fileInfoList && supplier.fileInfoList.length) || canEditQuote" class="quote-supplier-summary__actions">
                        <el-button v-for="file in supplier.fileInfoList" :key="quoteFileIdentity(file)" type="text" @click="openQuoteFile(file)">
                          <i class="el-icon-paperclip"></i>{{ quoteFileName(file) }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="quote-matrix-scroll">
                  <el-table :data="group.items" border size="mini" class="quote-comparison-matrix" max-height="520">
                    <el-table-column label="采购项" fixed min-width="240">
                      <template slot-scope="scope">
                        <strong>{{ scope.row.materialName }}</strong>
                        <div class="muted">{{ scope.row.specification || '无规格' }} · 实购 {{ numberText(scope.row.quantity) }} {{ scope.row.unit || '' }}</div>
                        <div v-if="scope.row.parameterValue" class="muted">参数 {{ scope.row.parameterValue }}</div>
                        <div v-if="scope.row.demandQuantity !== undefined || scope.row.inventoryQuantity !== undefined" class="muted">
                          需求 {{ numberText(scope.row.demandQuantity) }} · 库存 {{ numberText(scope.row.inventoryQuantity) }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="最近采购价" width="120" align="right">
                      <template slot-scope="scope">{{ scope.row.historyMinPrice === undefined || scope.row.historyMinPrice === null ? '-' : unitPriceText(scope.row.historyMinPrice) }}</template>
                    </el-table-column>
                    <el-table-column v-for="supplier in group.suppliers" :key="supplier.key" :label="supplier.purchasePlatform ? supplier.purchasePlatform + ' · ' + supplier.supplierName : supplier.supplierName" min-width="150" align="right">
                      <template slot-scope="scope">
                        <template v-if="scope.row.offerMap[supplier.key]">
                          <strong>{{ unitPriceText(scope.row.offerMap[supplier.key].quoteAmount) }}</strong>
                          <div class="muted">实采 {{ money(quoteActualPurchaseAmount(scope.row, scope.row.offerMap[supplier.key].quoteAmount)) }}</div>
                          <div class="muted">库存 {{ money(quoteInventoryUseAmount(scope.row, scope.row.offerMap[supplier.key].quoteAmount)) }} · 总 {{ money(quoteTotalDemandAmount(scope.row, scope.row.offerMap[supplier.key].quoteAmount)) }}</div>
                          <div class="quote-matrix-recommendation">
                            <el-tag v-if="scope.row.offerMap[supplier.key].recommended" size="mini" type="warning">采购员推荐</el-tag>
                            <el-button
                              v-if="canEditQuote && scope.row.offerMap[supplier.key].id"
                              type="text"
                              @click.stop="recommendQuoteItem(group, scope.row, scope.row.offerMap[supplier.key])"
                            >{{ scope.row.offerMap[supplier.key].recommended ? '取消推荐' : '设为推荐' }}</el-button>
                          </div>
                        </template>
                        <span v-else class="muted">未报价</span>
                    </template>
                  </el-table-column>
                </el-table>
                </div>
                </template>
              </div>
            </el-collapse-transition>
          </section>
          </template>

          <section id="purchaser-decision-analysis" v-if="canShowPurchaserDecisionPreview" class="purchaser-decision-preview">
            <div class="purchaser-decision-preview__head">
              <div>
                <span class="purchaser-decision-preview__eyebrow">采购决策辅助</span>
                <strong>智能定商分析</strong>
                <p>汇总报价、推荐依据和风险信息，采购专员可在完成询价前核对并优化推荐结论。</p>
              </div>
              <el-tag
                v-if="purchaserDecisionAnalysis"
                size="small"
                :type="purchaserDecisionAnalysis.analysisStatus === 'READY' ? 'success' : (purchaserDecisionAnalysis.analysisStatus === 'GENERATING' ? 'warning' : 'danger')"
              >{{ purchaserDecisionAnalysis.analysisStatus === 'READY' ? '分析完成' : (purchaserDecisionAnalysis.analysisStatus === 'GENERATING' ? '分析生成中' : '分析需重试') }}</el-tag>
            </div>

            <el-alert
              v-if="!purchaserDecisionAnalysis || purchaserDecisionAnalysis.analysisStatus === 'GENERATING'"
              type="info"
              :closable="false"
              show-icon
              title="定商分析正在生成"
              description="生成完成后刷新本页即可查看；完成询价时系统还会根据最新报价自动更新。"
            />
            <el-alert
              v-else-if="purchaserDecisionAnalysis.analysisStatus !== 'READY'"
              type="warning"
              :closable="false"
              show-icon
              title="本次分析暂未生成有效结果"
              :description="purchaserDecisionAnalysis.statusMessage || '总经理端重新分析完成后，此处会同步更新。'"
            />
            <template v-else>
              <div class="purchaser-decision-preview__summary">
                <span>综合结论</span>
                <p>{{ purchaserDecisionAnalysis.executiveSummary || purchaserDecisionAnalysis.overallConclusion || '暂无综合结论' }}</p>
                <em v-if="purchaserDecisionAnalysis.generatedAt">生成时间 {{ purchaserDecisionAnalysis.generatedAt }} · 可信度{{ purchaserDecisionAnalysis.confidence || '-' }}</em>
              </div>
              <div v-if="purchaserDecisionAnalysis.recommendedPlan && purchaserDecisionAnalysis.recommendedPlan.length" class="purchaser-decision-preview__plans">
                <article v-for="(plan, planIndex) in purchaserDecisionAnalysis.recommendedPlan" :key="`${plan.comparisonGroupNo || planIndex}-${plan.supplierName || ''}`">
                  <div class="purchaser-decision-preview__plan-title">
                    <span>{{ planIndex + 1 }}</span>
                    <div>
                      <strong>{{ plan.comparisonGroupName || `报价组${planIndex + 1}` }}</strong>
                      <em>建议 {{ plan.supplierName || '人工判断' }}</em>
                    </div>
                  </div>
                  <p v-if="plan.conclusion">{{ plan.conclusion }}</p>
                  <div v-if="plan.itemRecommendations && plan.itemRecommendations.length" class="purchaser-decision-preview__item-plans">
                    <div v-for="itemPlan in plan.itemRecommendations" :key="itemPlan.itemGroupNo || `${itemPlan.materialName}-${itemPlan.supplierName}`">
                      <span>{{ itemPlan.materialName || '采购项' }}</span>
                      <strong>建议 {{ itemPlan.purchasePlatform ? itemPlan.purchasePlatform + ' · ' : '' }}{{ itemPlan.supplierName }}</strong>
                      <em v-if="itemPlan.conclusion">{{ itemPlan.conclusion }}</em>
                    </div>
                  </div>
                  <ul v-if="plan.reasons && plan.reasons.length" class="purchaser-decision-preview__reason-list">
                    <li v-for="(reason, reasonIndex) in plan.reasons" :key="`reason-${reasonIndex}`">{{ reason }}</li>
                  </ul>
                  <ul v-if="plan.risks && plan.risks.length" class="purchaser-decision-preview__risk-list">
                    <li v-for="(risk, riskIndex) in plan.risks" :key="`risk-${riskIndex}`">{{ risk }}</li>
                  </ul>
                </article>
              </div>
              <div
                v-if="(purchaserDecisionAnalysis.focusWarnings && purchaserDecisionAnalysis.focusWarnings.length) || (purchaserDecisionAnalysis.purchaseSuggestions && purchaserDecisionAnalysis.purchaseSuggestions.length)"
                class="purchaser-decision-preview__followup"
              >
                <div v-if="purchaserDecisionAnalysis.focusWarnings && purchaserDecisionAnalysis.focusWarnings.length">
                  <strong>需补强的信息</strong>
                  <p v-for="(warning, warningIndex) in purchaserDecisionAnalysis.focusWarnings" :key="`warning-${warningIndex}`">{{ warning }}</p>
                </div>
                <div v-if="purchaserDecisionAnalysis.purchaseSuggestions && purchaserDecisionAnalysis.purchaseSuggestions.length">
                  <strong>采购执行建议</strong>
                  <p v-for="(suggestion, suggestionIndex) in purchaserDecisionAnalysis.purchaseSuggestions" :key="`suggestion-${suggestionIndex}`">{{ suggestion.suggestion || suggestion }}</p>
                </div>
              </div>
            </template>
          </section>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('order')" name="order">
          <span slot="label"><i class="el-icon-document-checked"></i> {{ supplierOrderSectionTitle }}</span>
          <div class="section-title section-title--first">
            <span>{{ supplierOrderSectionTitle }}</span>
            <el-tag v-if="supplierOrderCount" size="mini" type="success">{{ supplierOrderCount }}张</el-tag>
          </div>
          <el-alert
            v-if="isApplicationPendingSplit"
            class="pending-split-alert"
            type="info"
            :title="`${supplierOrderSectionTitle}待生成`"
            :description="supplierOrderPendingDescription"
            show-icon
            :closable="false"
          />
          <section v-if="isApplicationDetail && supplierOrderCount" class="contract-seal-package">
            <div class="contract-seal-package__header">
              <div>
                <strong>合同用章包</strong>
                <p>在当前采购申请里一次上传全部供应商合同，整包只发起一次审批和用章。</p>
              </div>
              <div class="contract-seal-package__actions">
                <el-tag :type="contractSealBatchStatusTag" size="small">{{ contractSealBatchStatusText }}</el-tag>
                <el-button
                  v-if="contractSealWorkOrderAvailable"
                  type="success"
                  plain
                  size="mini"
                  icon="el-icon-s-check"
                  @click="openContractSealApprovalDialog"
                >{{ contractSealApprovalButtonText }}</el-button>
                <el-button
                  v-if="canBatchUploadContracts"
                  v-hasPermi="['crm:procurement:contract']"
                  type="primary"
                  plain
                  size="mini"
                  icon="el-icon-upload2"
                  @click="openContractBatchUpload"
                >批量上传合同</el-button>
                <el-button
                  v-if="canManageContractSealPackage"
                  v-hasPermi="['crm:procurement:contract']"
                  type="primary"
                  size="mini"
                  icon="el-icon-s-check"
                  :disabled="!contractSealPackageReady"
                  :loading="contractSealSubmitting"
                  @click="submitCurrentContractSealPackage"
                >发起采购合同审批</el-button>
              </div>
            </div>
            <el-alert
              v-if="contractSealPackageHint"
              :title="contractSealPackageHint"
              :type="contractSealApproving ? 'warning' : 'info'"
              :closable="false"
              show-icon
            />
            <el-table :data="contractSealRows" border size="mini" class="contract-seal-package__table">
              <el-table-column label="供应商采购单" width="140" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.applyNo || '-' }}</template>
              </el-table-column>
              <el-table-column label="供应商" prop="supplierName" min-width="150" show-overflow-tooltip />
              <el-table-column label="合同" min-width="210" show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="Number(scope.row.contractMode || 1) === 2" class="compact-cell">
                    <strong>无需合同</strong>
                    <em>{{ scope.row.noContractReason || '未填写原因' }}</em>
                  </div>
                  <div v-else class="compact-cell">
                    <strong>{{ (scope.row.contractInfo && scope.row.contractInfo.contractNo) || (contractFileCount(scope.row) ? '合同编号AI识别中' : '待上传') }}</strong>
                    <em>{{ (scope.row.contractInfo && scope.row.contractInfo.contractName) || '采购合同' }} · {{ contractFileCount(scope.row) }}个文件</em>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合同金额" width="112" align="right">
                <template slot-scope="scope">{{ Number(scope.row.contractMode || 1) === 2 ? '-' : money(scope.row.contractInfo && scope.row.contractInfo.contractAmount) }}</template>
              </el-table-column>
            </el-table>
            <section v-if="contractSealAllFiles.length" class="contract-seal-files">
              <div class="contract-seal-files__header">
                <div>
                  <strong>全部合同附件</strong>
                  <span>共 {{ contractSealAllFiles.length }} 个文件，按供应商集中展示</span>
                </div>
                <el-button type="primary" plain size="mini" icon="el-icon-download" :loading="contractSealDownloading" @click="downloadAllContractSealFiles">全部下载（ZIP）</el-button>
              </div>
              <div v-for="group in contractSealFileGroups" :key="group.key" class="contract-seal-files__group">
                <div class="contract-seal-files__supplier">
                  <strong>{{ group.supplierName }}</strong>
                  <span>{{ group.files.length }} 个文件</span>
                </div>
                <div class="contract-seal-files__list">
                  <div v-for="file in group.files" :key="file.key" class="contract-seal-file-card">
                    <i :class="quoteFileIconClass(file)"></i>
                    <div>
                      <strong>{{ quoteFileName(file) }}</strong>
                      <span>{{ quoteFileMeta(file) }}</span>
                    </div>
                    <el-button type="text" @click="openQuoteFile(file)">查看</el-button>
                    <el-button type="text" @click="downloadSingleContractSealFile(file)">下载</el-button>
                  </div>
                </div>
              </div>
            </section>
          </section>
          <el-table :data="detail.supplierOrderList || []" border class="edit-table supplier-order-list-table" :empty-text="`生成${supplierOrderSectionTitle}后，可点击单号进入详情`">
            <el-table-column label="采购单号" width="132" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click.stop="handleEditApply(scope.row, 'basic')">{{ scope.row.applyNo || '-' }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="供应商" prop="supplierName" min-width="145" show-overflow-tooltip />
            <el-table-column label="当前事项" min-width="145">
              <template slot-scope="scope">
                <div class="compact-cell">
                  <strong>{{ businessStatusText(scope.row) }}</strong>
                  <em>{{ supplierOrderProgressText(scope.row) }}</em>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="金额" width="96" align="right">
              <template slot-scope="scope">{{ money(scope.row.applyAmount) }}</template>
            </el-table-column>
            <el-table-column label="合同/付款" width="142">
              <template slot-scope="scope">
                <div class="compact-cell">
                  <span>{{ contractStatusText(scope.row.contractStatus) }}</span>
                  <em>{{ paymentStatusText(scope.row.paymentStatus) }}</em>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="到货" width="94" align="center">
              <template slot-scope="scope">{{ arrivalStatusText(scope.row.arrivalStatus) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="116" align="center">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="handleEditApply(scope.row, 'basic')">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('payment')" name="payment">
          <span slot="label"><i class="el-icon-bank-card"></i> 付款记录</span>
          <div class="section-title">
            <span>付款记录</span>
            <div class="section-title__actions">
              <el-button v-if="canRegisterPayment" v-hasPermi="['crm:procurement:finance']" type="primary" plain size="mini" @click="openRegisterPayment()">添加付款记录</el-button>
            </div>
          </div>
          <el-table :data="detail.paymentPlanList" border empty-text="暂无付款记录">
            <el-table-column label="付款金额" width="140" align="right"><template slot-scope="scope">{{ scope.row.paidAmount === null || scope.row.paidAmount === undefined ? '-' : money(scope.row.paidAmount) }}</template></el-table-column>
            <el-table-column label="付款时间" prop="paymentTime" width="160" align="center" />
            <el-table-column label="收款账户" prop="supplierAccountInfo" min-width="180" show-overflow-tooltip />
            <el-table-column label="备注" min-width="210" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.duplicateCheckRemark || scope.row.remark || '-' }}</template>
            </el-table-column>
            <el-table-column label="操作" width="190" align="center">
              <template slot-scope="scope">
                <div class="inline-row-action payment-record-actions">
                  <el-button type="text" @click="openPaymentDetail(scope.row)">查看</el-button>
                  <el-button v-if="canRegisterPayment" v-hasPermi="['crm:procurement:finance']" type="text" @click="editPaymentRecord(scope.row)">编辑</el-button>
                  <el-button v-if="canRegisterPayment" v-hasPermi="['crm:procurement:finance']" type="text" class="danger" @click="deletePaymentRecord(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('arrival')" name="arrival">
          <span slot="label"><i class="el-icon-truck"></i> 到货验收</span>
          <div class="arrival-workbench">
            <div class="arrival-toolbar">
              <div>
                <strong>按采购明细登记到货</strong>
                <span>所有物料已展开，逐项录入到货数量、验收结果和异常说明；附件可按需上传。</span>
              </div>
              <el-button v-if="canEditArrival" v-hasPermi="['crm:procurement:arrival']" type="primary" plain icon="el-icon-position" @click="prefillArrivalFromFirstPending">登记下一项</el-button>
            </div>

            <el-table :data="arrivalItemProgressRows" border class="arrival-progress-table arrival-progress-table--detail" empty-text="暂无采购明细">
              <el-table-column label="物料/供应商" min-width="310">
                <template slot-scope="scope">
                  <div class="arrival-material-cell">
                    <strong>{{ scope.row.item.materialName || '-' }}</strong>
                    <div class="arrival-material-meta">
                      <span v-if="scope.row.item.materialCode">编码：{{ scope.row.item.materialCode }}</span>
                      <span v-if="scope.row.item.specification">规格：{{ scope.row.item.specification }}</span>
                      <span v-if="scope.row.item.materialQualityBrand">材质/品牌：{{ scope.row.item.materialQualityBrand }}</span>
                      <span v-if="scope.row.item.unit">单位：{{ scope.row.item.unit }}</span>
                    </div>
                    <div class="arrival-material-sub">
                      <span>{{ scope.row.item.supplierName || selectedQuoteSupplierName || '-' }}</span>
                      <span>期望到货：{{ scope.row.item.expectedArrivalDate || applyForm.expectedArrivalDate || '-' }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="数量/进度" min-width="230">
                <template slot-scope="scope">
                  <div class="arrival-progress-cell">
                    <strong>采购 {{ quantityWithUnit(scope.row.totalQuantity, scope.row.item.unit) }}</strong>
                    <div>
                      <span>已到 {{ quantityWithUnit(scope.row.arrivedQuantity, scope.row.item.unit) }}</span>
                      <em>未到 {{ quantityWithUnit(scope.row.remainingQuantity, scope.row.item.unit) }}</em>
                    </div>
                    <el-progress :percentage="scope.row.progressPercent" :stroke-width="8" :show-text="false" :status="arrivalProgressStatus(scope.row)" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="状态" width="108" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.statusTagType" size="small">{{ scope.row.statusText }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="最近记录" min-width="190">
                <template slot-scope="scope">
                  <div v-if="scope.row.latestRecord" class="arrival-secondary-cell">
                    <strong>{{ scope.row.latestRecord.acceptorName || '-' }}</strong>
                    <span>{{ scope.row.latestRecord.arrivalDate || '-' }}</span>
                    <span>质量 {{ numberText(scope.row.latestRecord.qualityScore) }}</span>
                    <span>附件 {{ scope.row.fileCount }} 个</span>
                    <div class="inline-row-action arrival-record-actions">
                      <el-button type="text" class="tiny-link-button" @click="openArrivalDetail(arrivalRecordForDetail(scope.row))">查看记录</el-button>
                    </div>
                  </div>
                  <span v-else class="muted-text">暂无记录</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <div class="inline-row-action arrival-record-actions">
                    <el-button v-if="scope.row.latestRecord" type="text" @click="openArrivalDetail(arrivalRecordForDetail(scope.row))">查看</el-button>
                    <button v-if="scope.row.latestRecord && canEditExistingArrival" type="button" class="arrival-edit-text-button" @click="startArrivalRecordEdit(arrivalRecordForDetail(scope.row))">编辑</button>
                    <el-button v-if="canEditArrival" v-hasPermi="['crm:procurement:arrival']" type="primary" size="mini" plain @click="openArrivalForItem(scope.row)">{{ scope.row.remainingQuantity > 0 ? '登记到货' : '补充验收' }}</el-button>
                    <span v-if="!canEditArrival && !canEditExistingArrival" class="readonly-action-text">-</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div v-if="canEditArrivalForm" ref="arrivalEditor" class="arrival-editor-card" :class="{ 'is-empty': !arrivalForm.itemId && !arrivalForm.materialName }">
              <template v-if="arrivalForm.itemId || arrivalForm.materialName">
                <div class="arrival-editor-head">
                  <div>
                    <strong>{{ arrivalForm.id ? '编辑到货记录' : '登记本次到货' }}</strong>
                    <span>{{ arrivalForm.materialName || '-' }}<template v-if="arrivalForm.specification"> ｜ {{ arrivalForm.specification }}</template></span>
                  </div>
                  <el-button type="text" @click="cancelArrivalEditing">取消登记</el-button>
                </div>
                <el-form :model="arrivalForm" :disabled="!canEditArrivalForm" label-width="96px">
                  <el-row :gutter="12">
                    <el-col :xs="24" :md="8"><el-form-item label="本次应到"><el-input :value="quantityWithUnit(arrivalForm.quantity, selectedArrivalUnit)" disabled /></el-form-item></el-col>
                    <el-col :xs="24" :md="8"><el-form-item label="到货数量"><el-input-number v-model="arrivalForm.arrivedQuantity" :precision="2" :min="0" :controls="false" style="width:100%" /></el-form-item></el-col>
                    <el-col :xs="24" :md="8"><el-form-item label="到货状态"><el-input :value="predictedArrivalStatusText" disabled /></el-form-item></el-col>
                    <el-col :xs="24" :md="8"><el-form-item label="日期"><el-date-picker v-model="arrivalForm.arrivalDate" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
                    <el-col :xs="24" :md="8"><el-form-item label="质量评分"><el-input-number v-model="arrivalForm.qualityScore" :precision="1" :min="0" :max="100" :controls="false" style="width:100%" /></el-form-item></el-col>
                    <el-col :xs="24" :md="8"><el-form-item label="剩余数量"><el-input :value="quantityWithUnit(predictedArrivalRemaining, selectedArrivalUnit)" disabled /></el-form-item></el-col>
                    <el-col :span="24"><el-form-item label="附件（选填）"><file-upload :key="'arrival-upload-' + uploadRenderKey" v-model="arrivalForm.fileInfoList" :limit="8" :multiple="true" :readOnly="!canEditArrivalForm"></file-upload></el-form-item></el-col>
                    <el-col :span="24"><el-form-item label="问题说明"><el-input v-model="arrivalForm.issueDescription" type="textarea" :rows="2" placeholder="异常、少发、破损或需要补充说明时填写" /></el-form-item></el-col>
                    <el-col :span="24">
                      <div class="arrival-editor-actions">
                        <el-button v-hasPermi="['crm:procurement:arrival']" type="primary" icon="el-icon-check" @click="saveArrival">保存验收</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </template>
              <div v-else class="arrival-editor-empty">
                <i class="el-icon-truck"></i>
                <span>从上方物料列表选择一项登记到货</span>
              </div>
            </div>

            <div v-if="detail.arrivalList && detail.arrivalList.length" class="arrival-history-card">
              <div class="section-title"><span>历史到货记录</span></div>
              <el-table :data="detail.arrivalList" border size="small">
                <el-table-column label="物料" min-width="210">
                  <template slot-scope="scope">
                    <div class="arrival-material-cell arrival-material-cell--compact">
                      <strong>{{ scope.row.materialName || '-' }}</strong>
                      <div class="arrival-material-meta"><span v-if="scope.row.specification">规格：{{ scope.row.specification }}</span></div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="应到/已到/未到" width="170" align="right"><template slot-scope="scope">{{ numberText(scope.row.quantity) }} / {{ numberText(scope.row.arrivedQuantity) }} / {{ numberText(scope.row.unarrivedQuantity) }}</template></el-table-column>
                <el-table-column label="状态" width="110" align="center"><template slot-scope="scope">{{ arrivalRecordStatusText(scope.row) }}</template></el-table-column>
                <el-table-column label="验收人" prop="acceptorName" width="120" />
                <el-table-column label="质量" width="90" align="right"><template slot-scope="scope">{{ numberText(scope.row.qualityScore) }}</template></el-table-column>
                <el-table-column label="日期" prop="arrivalDate" width="110" align="center" />
                <el-table-column label="问题说明" prop="issueDescription" min-width="180" show-overflow-tooltip />
                <el-table-column label="操作" width="130" align="center">
                  <template slot-scope="scope">
                    <div class="inline-row-action arrival-record-actions">
                      <el-button type="text" @click="openArrivalDetail(scope.row)">查看</el-button>
                      <button v-if="canEditExistingArrival" type="button" class="arrival-edit-text-button" @click="startArrivalRecordEdit(scope.row)">编辑</button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="shouldShowDetailTab('log')" name="log">
          <span slot="label"><i class="el-icon-time"></i> 操作日志</span>
          <div class="purchase-log-pane">
            <div ref="purchaseOperateLog" class="purchase-operate-log">
              <OperateLogList ref="operateLogListRef" :targetId="applyForm.id" targetType="purchaseApply" />
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
          </el-card>
        </el-col>
        <el-col v-if="applyForm.id" :span="sidebarCollapsed ? 0 : 6" v-show="!sidebarCollapsed">
        <aside ref="purchaseDetailSide" class="purchase-detail-side">
          <el-card class="crm-detail-follow purchase-detail-follow" shadow="never">
            <div class="label">申请人</div>
            <div class="crm-manager">
              <UserAvatar class="avatar" :name="applyForm.applicantName || '-'" />
              <div class="name">
                <span class="value">{{ applyForm.applicantName || '-' }}</span>
              </div>
            </div>
            <div class="label">{{ purchaseOwnerFieldLabel(applyForm) }}</div>
            <div class="crm-manager">
              <UserAvatar class="avatar" :name="purchaseOwnerDisplayText(applyForm)" />
              <div class="name">
                <span class="value">{{ purchaseOwnerDisplayText(applyForm) }}</span>
              </div>
            </div>
            <GroupMember
              :groupName="'采购团队'"
              :targetId="applyForm.id"
              :targetType="'purchaseApply'"
              :canAddGroupMemberFlag="canAddPurchaseGroupMember"
              @success="handleGroupMemberSuccess"
            />
          </el-card>
        </aside>
        </el-col>
      </el-row>
      </section>

    <el-dialog title="审批流程" :visible.sync="approvalDialogOpen" width="920px" append-to-body custom-class="approval-flow-dialog">
      <section v-if="detail.approvalWorkOrder" class="approval-workorder-panel approval-workorder-panel--dialog">
        <div class="approval-workorder-status">
          <span>审批单</span>
          <strong>{{ detail.approvalWorkOrder.approvalTypeDesc || '采购审批流' }}</strong>
          <el-tag size="mini" :type="workOrderStatusTag(detail.approvalWorkOrder.status)">{{ detail.approvalWorkOrder.statusStr || workOrderStatusText(detail.approvalWorkOrder.status) }}</el-tag>
        </div>
        <div class="approval-workorder-status">
          <span>当前处理</span>
          <strong>{{ currentApprovalNodeText(detail.approvalWorkOrder) }}</strong>
          <em>{{ approvalWorkOrderHint(detail.approvalWorkOrder) }}</em>
        </div>
        <div v-if="currentPurchaseApprovalInstruction(detail.approvalWorkOrder)" class="approval-stage-task">
          <span>本阶段任务</span>
          <strong>{{ currentPurchaseApprovalInstruction(detail.approvalWorkOrder) }}</strong>
        </div>
      </section>
      <section v-if="isPurchaseInquiryApprovalNode" class="approval-business-panel">
          <div class="approval-business-title">采购员询价</div>
          <p v-if="Number(applyForm.purchaseType) === 7">研发项目可由两名候选人协同维护报价；谁实际点击“完成询价”，定商后的完成采购节点就回到谁。</p>
          <p v-else>本单由对应采购团队协同询价；实际点击“完成询价”的人负责后续采购执行。</p>
        <el-button v-if="canEditQuote" type="primary" plain size="mini" @click="openInquiryQuoteTab">维护报价组</el-button>
        <el-button v-if="canOfflineComplete" type="warning" plain size="mini" icon="el-icon-circle-check" @click="openOfflineCompleteDialog">线下已完成</el-button>
      </section>
      <section v-if="isPurchaseCompletionApprovalNode" class="approval-business-panel">
        <div class="approval-business-title">采购员完成采购</div>
        <p>本节点只流转给实际点击“完成询价”的人。可根据实际采购进度灵活确认完成采购，未完成的执行单仍可继续办理。</p>
        <el-button type="primary" plain size="mini" @click="detailTab = 'order'; approvalDialogOpen = false">查看采购执行单</el-button>
      </section>
      <section v-if="canShowSupplierDecisionApproval" class="approval-business-panel">
        <div class="approval-business-title approval-business-title--decision">
          <span>总经理逐报价组定商（电商按采购项选店铺）</span>
          <div>
            <em>已选 {{ approvalSelectedGroupCount }}/{{ approvalQuoteGroups.length }}</em>
            <el-button size="mini" type="primary" plain @click="adoptAllRecommendedQuotes">采用全部推荐</el-button>
          </div>
        </div>
        <el-alert v-if="!approvalQuoteGroups.length" title="采购员尚未提交报价组，暂不能确认供应商或店铺" type="warning" :closable="false" show-icon />
        <div v-for="(group, groupIndex) in approvalQuoteGroups" :key="group.key" class="approval-quote-group">
          <div class="approval-quote-group__title approval-quote-group__toggle" @click="toggleQuoteGroup(group, groupIndex)">
            <div>
              <strong>{{ group.comparisonGroupName }}</strong>
              <span>{{ quoteGroupModeLabel(group) }} · {{ group.itemCount }}项 · {{ group.supplierCount }}家{{ quoteGroupPartyName(group) }}<span v-if="group.recommendedSupplierName"> · 推荐 {{ group.recommendedSupplierName }}</span></span>
              <span class="approval-group-recommendation-reason">金额参考{{ group.amountSummarySupplierName ? '（' + group.amountSummarySupplierName + '）' : '' }}：实采 {{ money(group.actualPurchaseAmount) }} · 库存 {{ money(group.inventoryUseAmount) }} · 总 {{ money(group.totalDemandAmount) }}</span>
              <span v-if="quoteGroupIsEcommerce(group)" class="approval-group-recommendation-reason">本采购项必须且只能选择1家店铺，不同采购项可选择不同店铺</span>
              <span v-if="group.recommendationReason" class="approval-group-recommendation-reason">推荐理由：{{ group.recommendationReason }}</span>
            </div>
            <i :class="quoteGroupExpanded(group, groupIndex) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div v-show="quoteGroupExpanded(group, groupIndex)" class="approval-item-offer-list">
            <div
              v-for="offer in group.offers"
              :key="offer.key"
              class="approval-item-offer"
              :class="{ selected: approvalOfferSelected(group, offer) }"
              @click="selectApprovalQuote(group, offer)"
            >
              <span class="approval-item-offer__radio"></span>
              <span class="approval-item-offer__main">
                <span class="approval-item-offer__supplier">
                  <el-tag v-if="offer.purchasePlatform" size="mini" type="warning">{{ offer.purchasePlatform }}</el-tag>
                  <strong>{{ offer.supplierName }}</strong>
                  <el-tag v-if="offer.recommended" size="mini" type="warning">采购员推荐</el-tag>
                </span>
                <span class="approval-item-offer__meta">{{ offer.lineList.length }}/{{ group.itemCount }}项有报价 · 税率 {{ offer.taxRate === undefined || offer.taxRate === null ? '-' : numberText(offer.taxRate) + '%' }} · 交期 {{ offer.deliveryDays ? offer.deliveryDays + '天' : '-' }}</span>
                <span class="approval-item-offer__meta">需求 {{ numberText(offer.demandQuantity) }} · 使用库存 {{ numberText(offer.inventoryUseQuantity) }} · 实采 {{ numberText(offer.actualPurchaseQuantity) }}</span>
                <span class="approval-item-offer__meta">实采金额 {{ money(offer.actualPurchaseAmount) }} · 库存金额 {{ money(offer.inventoryUseAmount) }} · 总金额 {{ money(offer.totalDemandAmount) }}</span>
                <span v-if="meaningfulOptionalText(offer.selectionReason)" class="approval-item-offer__reason">{{ offer.selectionReason }}</span>
                <span v-if="offer.recommended && offer.recommendationReason" class="approval-item-offer__recommendation">推荐理由：{{ offer.recommendationReason }}</span>
                <span v-if="offer.fileInfoList && offer.fileInfoList.length" class="approval-item-offer__files">
                  <el-button v-for="file in offer.fileInfoList" :key="quoteFileIdentity(file)" type="text" @click.stop="openQuoteFile(file)"><i class="el-icon-paperclip"></i>{{ quoteFileName(file) }}</el-button>
                </span>
              </span>
              <span class="approval-item-offer__price">
                <strong>{{ money(offer.actualPurchaseAmount) }}</strong>
                <small>实际采购</small>
              </span>
            </div>
            <div class="approval-quote-matrix">
              <el-table :data="group.items" border size="mini" max-height="360">
                <el-table-column label="采购项" min-width="240">
                  <template slot-scope="scope">
                    <strong>{{ scope.row.materialName }}</strong>
                    <div class="muted">{{ scope.row.specification || '-' }} · 需求 {{ numberText(scope.row.demandQuantity) }} · 库存 {{ numberText(scope.row.inventoryQuantity) }} · 实采 {{ numberText(scope.row.quantity) }} {{ scope.row.unit || '' }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="最近采购价" width="116" align="right">
                  <template slot-scope="scope">{{ scope.row.historyMinPrice === undefined || scope.row.historyMinPrice === null ? '-' : unitPriceText(scope.row.historyMinPrice) }}</template>
                </el-table-column>
                <el-table-column v-for="supplier in group.suppliers" :key="supplier.key" :label="supplier.supplierName" min-width="130" align="right">
                  <template slot-scope="scope">
                    <template v-if="scope.row.offerMap[supplier.key]">
                      <span>{{ unitPriceText(scope.row.offerMap[supplier.key].quoteAmount) }}</span>
                      <div class="muted">总 {{ money(quoteTotalDemandAmount(scope.row, scope.row.offerMap[supplier.key].quoteAmount)) }}</div>
                    </template>
                    <span v-else class="muted">未报价</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </section>
      <approve-info
        ref="purchaseApprovalInfo"
        v-if="detail.approvalWorkOrder && detail.approvalWorkOrder.workOrderId"
        :targetId="detail.approvalWorkOrder.workOrderId"
        targetType="purchaseApply"
        :show-form-info="false"
        :approval-handler="handlePurchaseApprovalAction"
        :pass-button-text="approvalPassButtonText"
        :allow-transfer="!isPurchaseCompletionApprovalNode"
        :allow-reject="!isPurchaseInquiryApprovalNode && !isPurchaseCompletionApprovalNode"
        @success="handlePurchaseApprovalSuccess"
        @update="handlePurchaseApprovalUpdate">
      </approve-info>
      <el-empty v-else description="审批单未生成，请重新提交采购单" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalDialogOpen = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="线下已完成" :visible.sync="offlineCompleteDialogOpen" width="520px" append-to-body :close-on-click-modal="false">
      <el-alert
        title="确认后将直接结束当前采购流程，不再进入总经理定商，也不会生成采购执行单。"
        type="warning"
        :closable="false"
        show-icon
      />
      <el-form label-width="88px" class="offline-complete-form">
        <el-form-item label="结束备注" required>
          <el-input
            v-model="offlineCompleteRemark"
            type="textarea"
            :rows="4"
            maxlength="200"
            show-word-limit
            placeholder="请输入5至200字，例如：该采购已在线下完成，并已与总经理沟通确认，现结束线上流程。"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="offlineCompleteDialogOpen = false">取消</el-button>
        <el-button type="warning" :loading="offlineCompleteSubmitting" @click="submitOfflineComplete">确认结束</el-button>
      </div>
    </el-dialog>

    <el-dialog title="采购合同用章审批" :visible.sync="contractSealApprovalDialogOpen" width="920px" append-to-body custom-class="approval-flow-dialog contract-seal-approval-dialog">
      <template v-if="detail.contractSealWorkOrder && detail.contractSealWorkOrder.workOrderId">
        <section class="approval-workorder-panel approval-workorder-panel--dialog">
          <div class="approval-workorder-status">
            <span>用章审批</span>
            <strong>{{ (detail.contractSealBatch && detail.contractSealBatch.batchNo) || applyForm.applyNo || '-' }}</strong>
            <el-tag size="mini" :type="workOrderStatusTag(detail.contractSealWorkOrder.status)">{{ detail.contractSealWorkOrder.statusStr || workOrderStatusText(detail.contractSealWorkOrder.status) }}</el-tag>
          </div>
          <div class="approval-workorder-status">
            <span>当前处理</span>
            <strong>{{ currentApprovalNodeText(detail.contractSealWorkOrder) }}</strong>
            <em>{{ approvalWorkOrderHint(detail.contractSealWorkOrder) }}</em>
          </div>
        </section>
        <section v-if="contractSealAllFiles.length" class="contract-seal-dialog-files">
          <div class="contract-seal-files__header">
            <div>
              <strong>本次审批全部附件</strong>
              <span>{{ contractSealFileGroups.length }} 家供应商 · {{ contractSealAllFiles.length }} 个文件</span>
            </div>
            <el-button type="primary" plain size="mini" icon="el-icon-download" :loading="contractSealDownloading" @click="downloadAllContractSealFiles">全部下载（ZIP）</el-button>
          </div>
          <div v-for="group in contractSealFileGroups" :key="`dialog-${group.key}`" class="contract-seal-files__group">
            <div class="contract-seal-files__supplier"><strong>{{ group.supplierName }}</strong><span>{{ group.files.length }} 个文件</span></div>
            <div class="contract-seal-files__list">
              <div v-for="file in group.files" :key="`dialog-${file.key}`" class="contract-seal-file-card">
                <i :class="quoteFileIconClass(file)"></i>
                <div><strong>{{ quoteFileName(file) }}</strong><span>{{ quoteFileMeta(file) }}</span></div>
                <el-button type="text" @click="openQuoteFile(file)">查看</el-button>
                <el-button type="text" @click="downloadSingleContractSealFile(file)">下载</el-button>
              </div>
            </div>
          </div>
        </section>
        <approve-info
          :targetId="detail.contractSealWorkOrder.workOrderId"
          targetType="purchaseApply"
          :show-form-info="false"
          pass-button-text="通过并流转"
          :allow-transfer="true"
          :allow-reject="true"
          @success="handleContractSealApprovalSuccess"
          @update="handleContractSealApprovalUpdate"
        />
      </template>
      <el-empty v-else description="当前采购申请尚未生成用章审批单" />
      <div slot="footer" class="dialog-footer"><el-button @click="contractSealApprovalDialogOpen = false">关闭</el-button></div>
    </el-dialog>

    <el-dialog :title="paymentActionForm.paymentPlanId ? '编辑付款记录' : '添加付款记录'" :visible.sync="paymentActionOpen" width="720px" append-to-body :close-on-click-modal="false">
      <el-form :model="paymentActionForm" label-width="108px">
        <el-form-item label="供应商"><el-input :value="contractForm.supplierName || contractForm.partyB || selectedQuoteSupplierName || '-'" disabled /></el-form-item>
        <el-form-item label="采购合同"><el-input :value="contractForm.contractNo || applyForm.contractNum || '-'" disabled /></el-form-item>
        <el-form-item label="付款金额"><el-input-number v-model="paymentActionForm.paidAmount" :precision="2" :min="0" :controls="false" style="width:100%" /></el-form-item>
        <el-form-item label="付款时间"><el-date-picker v-model="paymentActionForm.paymentTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" /></el-form-item>
        <el-form-item label="收款账户"><el-input v-model="paymentActionForm.supplierAccountInfo" placeholder="可填写供应商收款账户" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="paymentActionForm.duplicateCheckRemark" type="textarea" :rows="2" placeholder="可填写付款批次、用途或核对说明" /></el-form-item>
        <el-form-item label="付款凭证"><file-upload :key="'payment-voucher-upload-' + uploadRenderKey" v-model="paymentActionForm.paymentVoucherFileList" :limit="8" :multiple="true" :readOnly="false"></file-upload><div class="field-tip">可选，不上传也可登记付款金额。</div></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentActionOpen = false">取消</el-button>
        <el-button v-hasPermi="['crm:procurement:finance']" type="primary" @click="registerPayment">保存付款记录</el-button>
      </div>
    </el-dialog>

    <el-dialog title="付款记录详情" :visible.sync="paymentDetailOpen" width="720px" append-to-body>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="供应商">{{ paymentDetailPlan.supplierName || contractForm.supplierName || contractForm.partyB || applyForm.supplierName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="采购合同">{{ paymentDetailPlan.contractNo || contractForm.contractNo || applyForm.contractNum || '-' }}</el-descriptions-item>
        <el-descriptions-item label="付款金额">{{ paymentDetailPlan.paidAmount === null || paymentDetailPlan.paidAmount === undefined ? '-' : money(paymentDetailPlan.paidAmount) }}</el-descriptions-item>
        <el-descriptions-item label="付款时间">{{ paymentDetailPlan.paymentTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收款账户" :span="2">{{ paymentDetailPlan.supplierAccountInfo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ paymentDetailPlan.duplicateCheckRemark || paymentDetailPlan.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="detail-dialog-files">
        <div>
          <strong>付款凭证</strong>
          <file-upload :key="'payment-detail-voucher-' + uploadRenderKey" v-model="paymentDetailPlan.paymentVoucherFileList" :limit="8" :multiple="true" :readOnly="true"></file-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="paymentDetailOpen = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="到货验收详情" :visible.sync="arrivalDetailOpen" width="720px" append-to-body>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="物料">{{ arrivalDetailRecord.materialName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="规格型号">{{ arrivalDetailRecord.specification || '-' }}</el-descriptions-item>
        <el-descriptions-item label="应到/已到/未到">{{ numberText(arrivalDetailRecord.quantity) }} / {{ numberText(arrivalDetailRecord.arrivedQuantity) }} / {{ numberText(arrivalDetailRecord.unarrivedQuantity) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ arrivalRecordStatusText(arrivalDetailRecord) }}</el-descriptions-item>
        <el-descriptions-item label="验收人">{{ arrivalDetailRecord.acceptorName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="验收日期">{{ arrivalDetailRecord.arrivalDate || '-' }}</el-descriptions-item>
        <el-descriptions-item label="质量评分">{{ numberText(arrivalDetailRecord.qualityScore) }}</el-descriptions-item>
        <el-descriptions-item label="问题说明" :span="2">{{ arrivalDetailRecord.issueDescription || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div class="detail-dialog-files">
        <div>
          <strong>验收附件</strong>
          <file-upload :key="'arrival-detail-files-' + uploadRenderKey" v-model="arrivalDetailRecord.fileInfoList" :limit="8" :multiple="true" :readOnly="true"></file-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="canEditExistingArrival" type="primary" plain @click.native="startArrivalRecordEdit(arrivalDetailRecord)">编辑验收记录</el-button>
        <el-button @click="arrivalDetailOpen = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="aiDialogTitle"
      :visible.sync="aiEntryOpen"
      width="1120px"
      append-to-body
      custom-class="ai-recognition-dialog"
      :close-on-click-modal="false"
    >
      <div class="ai-dialog-grid">
        <section class="ai-dialog-source">
          <div class="dialog-section-heading">
            <strong>识别资料</strong>
            <span>仅用于识别预览，确认填入前不会保存到采购单。</span>
          </div>
          <div class="source-file-zone source-file-zone--dialog">
            <file-upload
              :key="'ai-contract-upload-' + uploadRenderKey"
              v-model="aiRecognitionForm.fileInfoList"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.png,.jpg,.jpeg,.webp,image/*"
              :limit="8"
              :multiple="true"
              :readOnly="recognizingContract"
              @on-change="handleAiRecognitionFileListChange"
              @raw-file-uploaded="handleAiRawFileUploaded"
            ></file-upload>
          </div>
          <el-alert
            v-if="recognitionFillMode === 'apply' && aiRecognitionForm.fileInfoList && aiRecognitionForm.fileInfoList.length > 1"
            class="ai-source-tip"
            type="info"
            :title="aiMultiFileTip"
            :closable="false"
            show-icon
          />
          <el-input
            v-model="aiRecognitionForm.contractText"
            class="contract-text-input"
            type="textarea"
            :rows="5"
            maxlength="120000"
            show-word-limit
            :disabled="recognizingContract"
            :placeholder="aiSourceTextPlaceholder"
          />
          <div class="source-action-row">
            <el-button v-hasPermi="['crm:procurement:save', 'crm:procurement:contract']" type="primary" icon="el-icon-magic-stick" :loading="recognizingContract" @click="runAiRecognition">开始识别</el-button>
            <el-button :disabled="recognizingContract" @click="aiEntryOpen = false">取消</el-button>
          </div>
        </section>

        <section class="ai-processing-panel ai-processing-panel--dialog">
          <div class="ai-processing-panel__top">
            <div class="ai-visualizer" :class="{ active: recognizingContract, done: recognitionStage === 'DONE', error: recognitionStage === 'ERROR' }">
              <span class="ai-ring ai-ring--outer"></span>
              <span class="ai-ring ai-ring--middle"></span>
              <span class="ai-core"><i class="el-icon-magic-stick"></i></span>
              <span class="ai-scan-line"></span>
              <span class="ai-dot ai-dot--one"></span>
              <span class="ai-dot ai-dot--two"></span>
              <span class="ai-dot ai-dot--three"></span>
            </div>
            <div>
              <strong>{{ recognitionStageText }}</strong>
              <span>{{ recognitionDisplayMessage }}</span>
              <em v-if="recognizingContract">已处理 {{ recognitionElapsedSeconds }} 秒</em>
            </div>
            <el-tag size="mini" :type="recognitionStage === 'ERROR' ? 'danger' : (recognitionProgress === 100 ? 'success' : 'warning')">{{ recognitionProgress + '%' }}</el-tag>
          </div>
          <div class="ai-progress-bar">
            <span :style="{ width: recognitionProgress + '%' }"></span>
          </div>
          <div class="ai-step-track">
            <div v-for="(step, index) in recognitionProcessSteps" :key="step.key" :class="{ active: recognitionActiveStep === index, done: recognitionActiveStep > index }">
              <i :class="recognitionActiveStep > index ? 'el-icon-check' : step.icon"></i>
              <span>{{ step.title }}</span>
            </div>
          </div>
          <div v-if="recognitionActiveStep === 2 || recognitionStage === 'PARSE_RESULT' || recognitionStage === 'VALIDATE_RESULT'" class="ai-model-substeps">
            <span v-for="step in recognitionModelSubSteps" :key="step.key" :class="{ active: step.state === 'active', done: step.state === 'done' }">
              <i :class="step.state === 'done' ? 'el-icon-check' : 'el-icon-loading'"></i>
              {{ step.title }}
            </span>
          </div>
          <div class="ai-summary-strip">
            <span v-for="card in aiSummaryCards" :key="card.key" :title="card.title || card.value">
              {{ card.label }} <strong>{{ card.value }}</strong>
            </span>
          </div>
          <div v-if="aiRecognitionReviewItems.length" class="ai-review-list">
            <span v-for="item in aiRecognitionReviewItems" :key="item">{{ item }}</span>
          </div>
          <div v-else-if="aiRecognizedResult" class="ai-review-list is-ok">
            <span>识别结果可填入</span>
          </div>
        </section>
      </div>

      <section v-if="aiRecognizedResult" class="ai-result-panel">
        <div class="ai-result-panel__head">
          <div>
            <strong>识别结果预览</strong>
            <span>勾选需要填入的区域；未勾选的内容不会改动当前采购单。</span>
          </div>
          <div class="ai-result-panel__controls">
            <el-checkbox v-model="aiOverwriteExisting">覆盖已有内容</el-checkbox>
            <el-checkbox-group v-model="aiApplyScopes" class="ai-fill-scope-group">
              <el-checkbox v-for="item in aiScopeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <el-tabs v-model="aiResultTab" class="ai-result-tabs">
          <el-tab-pane v-if="aiScopeVisible('contract')" label="合同信息" name="contract">
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="合同号">{{ aiRecognizedResult.contractNo || '-' }}</el-descriptions-item>
              <el-descriptions-item label="合同名称">{{ aiRecognizedResult.contractName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="签约日期">{{ aiRecognizedResult.signDate || '-' }}</el-descriptions-item>
              <el-descriptions-item label="甲方">{{ aiRecognizedResult.partyA || currentTenantName() || '-' }}</el-descriptions-item>
              <el-descriptions-item label="乙方">{{ aiRecognizedResult.partyB || '-' }}</el-descriptions-item>
              <el-descriptions-item label="供应商">{{ aiRecognizedResult.supplierName || aiRecognizedResult.partyB || '-' }}</el-descriptions-item>
              <el-descriptions-item label="合同金额">{{ money(aiRecognizedResult.contractAmount) }}</el-descriptions-item>
              <el-descriptions-item label="税率">{{ aiRecognizedResult.taxRate === undefined || aiRecognizedResult.taxRate === null ? '-' : aiRecognizedResult.taxRate + '%' }}</el-descriptions-item>
              <el-descriptions-item label="交付约定">{{ aiRecognizedResult.deliveryPeriod || '-' }}</el-descriptions-item>
              <el-descriptions-item label="付款条款" :span="3">{{ aiRecognizedResult.paymentTerms || '-' }}</el-descriptions-item>
              <el-descriptions-item label="附件清单" :span="3">{{ aiRecognizedResult.attachmentListText || '-' }}</el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
          <el-tab-pane v-if="aiScopeVisible('items')" :label="'采购清单 ' + aiRecognizedItemRows.length" name="items">
            <el-table :data="aiRecognizedItemRows" border size="small" max-height="260">
              <el-table-column label="物料名称" prop="materialName" min-width="180" show-overflow-tooltip />
              <el-table-column label="编码" prop="materialCode" width="120" show-overflow-tooltip />
              <el-table-column label="规格型号" prop="specification" width="150" show-overflow-tooltip />
              <el-table-column label="材质/品牌" prop="materialQualityBrand" width="120" show-overflow-tooltip />
              <el-table-column label="数量" prop="quantity" width="90" align="right" />
              <el-table-column label="单位" prop="unit" width="80" />
              <el-table-column v-if="isSupplierOrderDetail && canViewPurchaseSensitive" label="单价" width="110" align="right"><template slot-scope="scope">{{ unitPriceText(scope.row.purchaseUnitPrice) }}</template></el-table-column>
              <el-table-column v-if="isSupplierOrderDetail && canViewPurchaseSensitive" label="金额" width="120" align="right"><template slot-scope="scope">{{ money(scope.row.amount) }}</template></el-table-column>
              <el-table-column v-if="aiRecognizedItemHasSource" label="来源文件" prop="_sourceFileName" min-width="130" show-overflow-tooltip />
              <el-table-column v-if="isSupplierOrderDetail && canViewPurchaseSensitive" label="供应商" min-width="170" show-overflow-tooltip>
                <template slot-scope="scope">{{ supplierCandidateText(scope.row) }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="aiScopeVisible('payment')" :label="'付款条款 ' + aiRecognizedPaymentRows.length" name="payment">
            <el-table :data="aiRecognizedPaymentRows" border size="small" max-height="240">
              <el-table-column label="付款节点" prop="nodeName" min-width="150" show-overflow-tooltip />
              <el-table-column label="比例%" prop="paymentRate" width="90" align="right" />
              <el-table-column label="应付金额" width="120" align="right"><template slot-scope="scope">{{ money(scope.row.payableAmount) }}</template></el-table-column>
              <el-table-column label="应付日期" prop="payableDate" width="120" />
              <el-table-column label="付款条件" prop="paymentCondition" min-width="220" show-overflow-tooltip />
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </section>

      <div slot="footer" class="dialog-footer">
        <el-button @click="aiEntryOpen = false">不填入</el-button>
        <el-button v-if="aiRecognizedResult && aiScopeVisible('basic')" :disabled="recognizingContract" @click="applyAiRecognition(['basic'])">只填基本信息</el-button>
        <el-button v-if="aiRecognizedResult && aiScopeVisible('contract')" :disabled="recognizingContract" @click="applyAiRecognition(['contract'])">只填合同信息</el-button>
        <el-button v-if="aiRecognizedResult && aiScopeVisible('items') && aiRecognizedItemRows.length" :disabled="recognizingContract" @click="applyAiRecognition(['items'])">只填采购清单</el-button>
        <el-button v-if="aiRecognizedResult && aiScopeVisible('payment') && aiRecognizedPaymentRows.length" :disabled="recognizingContract" @click="applyAiRecognition(['payment'])">只填付款条款</el-button>
        <el-button v-if="aiRecognizedResult" :disabled="recognizingContract || !aiApplyScopes.length" type="primary" @click="applyAiRecognition()">按勾选填入</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="quoteDialogTitle"
      :visible.sync="quoteDialogOpen"
      width="92vw"
      append-to-body
      custom-class="quote-editor-dialog"
      :close-on-click-modal="false"
      @closed="handleQuoteDialogClosed"
    >
      <div v-if="quoteImportQueueIndex >= 0" class="quote-import-group-switcher">
        <div class="quote-import-group-switcher__status">
          <i class="el-icon-circle-check"></i>
          <span>已解析 {{ quoteImportSheetList.length }} 个Sheet / {{ quoteImportDraftList.length }} 个报价组</span>
        </div>
        <div class="quote-import-group-switcher__tabs" role="tablist">
          <button
            v-for="(sheet, sheetIndex) in quoteImportSheetList"
            :key="sheet.key"
            type="button"
            class="quote-import-group-switcher__tab"
            :class="{
              'is-active': quoteImportActiveSheetKey === sheet.key,
              'is-saved': sheet.saved,
              'is-ecommerce': sheet.ecommerce
            }"
            :disabled="sheet.saved"
            :title="quoteImportSheetTitle(sheet, sheetIndex)"
            role="tab"
            :aria-selected="quoteImportActiveSheetKey === sheet.key"
            @click="activateQuoteImportSheet(sheet)"
          >
            <span class="quote-import-group-switcher__tab-index">{{ sheetIndex + 1 }}</span>
            <span class="quote-import-group-switcher__tab-name">{{ sheet.label }}</span>
            <span v-if="sheet.ecommerce" class="quote-import-group-switcher__tab-mode">电商</span>
            <span v-if="sheet.draftIndexes.length > 1" class="quote-import-group-switcher__tab-count">{{ sheet.draftIndexes.length }}项</span>
            <em v-if="sheet.saved" class="quote-import-group-switcher__tab-saved">已保存</em>
          </button>
        </div>
      </div>
      <div
        v-if="activeQuoteImportSheet && activeQuoteImportSheet.draftIndexes && activeQuoteImportSheet.draftIndexes.length > 1"
        class="quote-import-subgroup-switcher"
      >
        <span class="quote-import-subgroup-switcher__label">子报价组</span>
        <div class="quote-import-subgroup-switcher__tabs">
          <button
            v-for="draftIndex in activeQuoteImportSheet.draftIndexes"
            :key="quoteImportDraftList[draftIndex].key"
            type="button"
            class="quote-import-subgroup-switcher__tab"
            :class="{
              'is-active': quoteImportQueueIndex === draftIndex,
              'is-saved': quoteImportDraftList[draftIndex].saved
            }"
            :disabled="quoteImportDraftList[draftIndex].saved"
            :title="quoteImportDraftTitle(quoteImportDraftList[draftIndex], draftIndex)"
            @click="activateQuoteImportDraft(draftIndex)"
          >
            <span class="quote-import-subgroup-switcher__tab-name">{{ quoteImportDraftList[draftIndex].label }}</span>
            <em v-if="quoteImportDraftList[draftIndex].saved">已保存</em>
          </button>
        </div>
      </div>
      <el-form :model="quoteForm" :disabled="!canEditQuote" label-width="96px" class="quote-dialog-form">
        <el-form-item label="报价组类型" required>
          <el-radio-group v-model="quoteForm.purchaseMode" size="small" @change="handleQuoteFormPurchaseModeChange">
            <el-radio-button :label="1">普通供应商</el-radio-button>
            <el-radio-button :label="2">电商平台店铺</el-radio-button>
            <el-radio-button :label="3">混合报价</el-radio-button>
          </el-radio-group>
          <span class="quote-mode-hint">{{ quoteFormModeHint }}</span>
        </el-form-item>
        <el-form-item label="报价组名称" required><el-input v-model="quoteForm.comparisonGroupName" maxlength="200" placeholder="如：车间维修电气材料询价" /></el-form-item>
      </el-form>
      <div v-if="quoteForm.itemList && quoteForm.itemList.length" class="quote-form-amount-summary">
        <span>本报价组金额参考{{ quoteFormAmountSummary.supplierName ? '（' + quoteFormAmountSummary.supplierName + '）' : '' }}</span>
        <strong>实采 {{ money(quoteFormAmountSummary.actualPurchaseAmount) }}</strong>
        <strong>库存 {{ money(quoteFormAmountSummary.inventoryUseAmount) }}</strong>
        <strong v-if="positiveAmount(quoteFormAmountSummary.freightAmount)">运费 {{ money(quoteFormAmountSummary.freightAmount) }}</strong>
        <strong>总 {{ money(quoteFormAmountSummary.totalDemandAmount) }}</strong>
        <em>需求 {{ numberText(quoteFormAmountSummary.demandQuantity) }} · 使用库存 {{ numberText(quoteFormAmountSummary.inventoryUseQuantity) }} · 实采 {{ numberText(quoteFormAmountSummary.actualPurchaseQuantity) }}</em>
      </div>
      <div class="quote-editor-layout-bar">
        <span>编辑布局</span>
        <el-radio-group v-model="quoteForm.editorLayoutMode" size="mini">
          <el-radio-button label="supplier">按报价方</el-radio-button>
          <el-radio-button label="item">按产品平铺</el-radio-button>
        </el-radio-group>
      </div>
      <template v-if="!quoteFormUseItemLayout">
        <div class="section-title quote-line-title quote-editor-section-title">
          <span>{{ quoteFormPartyName }}（{{ quoteForm.supplierList.length }}家）</span>
          <el-button v-if="canEditQuote" type="primary" size="mini" plain icon="el-icon-plus" @click="addComparisonSupplier">新增{{ quoteFormPartyName }}</el-button>
        </div>
        <div v-if="!quoteForm.supplierList.length" class="quote-offer-empty">请至少新增一家{{ quoteFormPartyName }}</div>
        <div v-else class="quote-supplier-card-grid">
          <section
            v-for="(offer, offerIndex) in quoteForm.supplierList"
            :key="offer._rowKey"
            class="quote-offer-editor quote-supplier-compact-card"
            :class="{
              'is-expanded': offer._detailsExpanded,
              'is-recommended': quoteForm.recommendedSupplierKey === offer._rowKey
            }"
          >
            <div class="quote-offer-editor__head">
              <div class="quote-supplier-card__identity">
                <span>{{ offerIndex + 1 }}</span>
                <div>
                  <strong>{{ offer.supplierName || `${quoteFormPartyName} ${offerIndex + 1}` }}</strong>
                  <small>{{ quoteForm.recommendedSupplierKey === offer._rowKey ? '采购员推荐' : `填写${quoteFormPartyName}后，在下方表格录入单价` }}</small>
                </div>
              </div>
              <div class="quote-supplier-card__actions">
                <el-radio v-model="quoteForm.recommendedSupplierKey" :label="offer._rowKey" @change="handleQuoteGroupRecommendedSupplierChange">设为推荐</el-radio>
                <el-button v-if="quoteForm.recommendedSupplierKey === offer._rowKey" type="text" @click="clearQuoteRecommendation">取消</el-button>
                <el-button v-if="canEditQuote" type="text" class="danger" @click="removeComparisonSupplier(offerIndex)">删除</el-button>
              </div>
            </div>
            <el-form :model="offer" :disabled="!canEditQuote" label-width="70px" class="quote-supplier-card__form">
              <el-form-item v-if="quoteFormIsEcommerce || quoteFormIsMixed" label="平台" :required="quoteFormIsEcommerce" class="quote-supplier-card__primary">
                <el-select v-model="offer.purchasePlatform" filterable allow-create default-first-option placeholder="淘宝、天猫、京东等；线下供应商可留空" style="width:100%" @change="handleQuoteOfferPlatformChange(offer)">
                  <el-option v-for="platform in ecommercePlatformOptions" :key="platform" :label="platform" :value="platform" />
                </el-select>
              </el-form-item>
              <el-form-item :label="quoteFormIsEcommerce ? '店铺名' : (quoteFormIsMixed ? '报价方' : '供应商')" required class="quote-supplier-card__primary">
                <el-autocomplete
                  v-model="offer.supplierName"
                  :fetch-suggestions="querySupplierSuggestions"
                  value-key="supplierName"
                  :placeholder="quoteFormIsEcommerce ? '输入完整店铺名，保存时自动关联' : (quoteFormIsMixed ? '输入店铺名或供应商简称，系统会自动匹配' : '可输入工商全称、简称或别名')"
                  style="width:100%"
                  @input="handleQuoteOfferSupplierInput(offer)"
                  @select="handleQuoteOfferSupplierSelect(offer, $event)"
                  @blur="handleQuoteOfferSupplierBlur(offer)"
                />
              </el-form-item>
              <div
                v-if="offer.supplierName"
                class="quote-supplier-link-state"
                :class="`is-${quoteSupplierLinkState(offer).status}`"
              >
                <i :class="quoteSupplierLinkState(offer).icon"></i>
                <span>{{ quoteSupplierLinkState(offer).message }}</span>
                <el-button
                  v-if="quoteSupplierCanMaintain(offer)"
                  type="text"
                  @mousedown.native.prevent
                  @click="openSupplierMaintenanceForOffer(offer)"
                >{{ quoteSupplierMaintainLabel(offer, false) }}</el-button>
              </div>
              <div class="quote-supplier-card__total">
                <div class="quote-supplier-card__detail-total">
                  <span>实采金额</span>
                  <strong>{{ money(comparisonSupplierActualPurchaseAmount(offer)) }}</strong>
                </div>
                <div class="quote-supplier-card__detail-total">
                  <span>库存金额</span>
                  <strong>{{ money(comparisonSupplierInventoryUseAmount(offer)) }}</strong>
                </div>
                <div class="quote-supplier-card__freight-total">
                  <span>运费</span>
                  <el-input-number
                    v-model="offer.freightAmount"
                    :precision="3"
                    :min="0"
                    :step="10" :controls="false"
                    @change="syncComparisonSupplierAutoFinalTotal(offer)"
                  />
                </div>
                <div class="quote-supplier-card__detail-total">
                  <span>合计</span>
                  <strong>{{ money(comparisonSupplierActualPurchaseTotalAmount(offer)) }}</strong>
                </div>
                <div class="quote-supplier-card__final-total">
                  <span>最终价</span>
                  <el-input-number
                    v-model="offer.finalTotalAmount"
                    :precision="3"
                    :min="0"
                    :step="100"
                    :controls="false"
                    @change="setComparisonSupplierFinalTotal(offer, $event)"
                  />
                  <el-button v-if="offer._finalTotalManual" type="text" @click="resetComparisonSupplierFinalTotal(offer)">恢复自动</el-button>
                </div>
                <small>最终价：表格有最终价取最终价，没有则默认等于合计；库存金额仅用于总经理查看，不生成执行采购单</small>
              </div>
              <el-form-item v-if="quoteForm.recommendedSupplierKey === offer._rowKey" label="推荐理由" class="quote-supplier-card__recommendation">
                <el-input
                  v-model="quoteForm.recommendationReason"
                  maxlength="500"
                  show-word-limit
                  placeholder="可不填；如需说明价格、质量、交期或服务优势，总经理定商时可见"
                  @input="markQuoteRecommendationTouched"
                />
              </el-form-item>
              <div class="quote-supplier-card__optional-bar">
                <div class="quote-supplier-card__summary">
                  <el-tag v-if="offer.taxRate !== undefined && offer.taxRate !== null" size="mini" type="info">税率 {{ numberText(offer.taxRate) }}%</el-tag>
                  <el-tag v-if="offer.deliveryDays !== undefined && offer.deliveryDays !== null" size="mini" type="info">交期 {{ numberText(offer.deliveryDays) }}天</el-tag>
                  <el-tag v-if="positiveAmount(offer.freightAmount)" size="mini" type="info">运费 {{ money(offer.freightAmount) }}</el-tag>
                  <el-tag v-if="offer.paymentCondition" size="mini" type="info">已填付款条件</el-tag>
                  <el-tag v-if="meaningfulOptionalText(offer.selectionReason)" size="mini" type="info">已有报价说明</el-tag>
                  <el-tag v-if="offer.fileInfoList && offer.fileInfoList.length" size="mini" type="info">{{ offer.fileInfoList.length }}个附件</el-tag>
                  <span v-if="!comparisonSupplierOptionalCount(offer)" class="muted">选填信息未填写</span>
                </div>
                <el-button type="text" class="quote-supplier-card__toggle" @click="toggleComparisonSupplierDetails(offer)">
                  {{ offer._detailsExpanded ? '收起选填信息' : '展开选填信息' }}
                  <i :class="offer._detailsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </el-button>
              </div>
              <el-collapse-transition>
                <div v-show="offer._detailsExpanded" class="quote-supplier-card__optional">
                  <el-row :gutter="12">
                    <el-col :xs="24" :md="6"><el-form-item label="税率%"><el-input-number v-model="offer.taxRate" :precision="2" :min="0" :controls="false" style="width:100%" /></el-form-item></el-col>
                    <el-col :xs="24" :md="6"><el-form-item label="交期"><el-input-number v-model="offer.deliveryDays" :min="0" :controls="false" style="width:100%" /></el-form-item></el-col>
                    <el-col :xs="24" :md="12"><el-form-item label="付款条件"><el-input v-model="offer.paymentCondition" maxlength="500" placeholder="选填" /></el-form-item></el-col>
                    <el-col :span="24"><el-form-item label="报价说明"><el-input v-model="offer.selectionReason" maxlength="500" placeholder="选填：报价来源、优惠条件或其他说明" /></el-form-item></el-col>
                    <el-col :span="24"><el-form-item label="报价附件"><file-upload :key="'item-offer-upload-' + uploadRenderKey + '-' + offer._rowKey" v-model="offer.fileInfoList" :limit="8" :multiple="true" :readOnly="!canEditQuote"></file-upload></el-form-item></el-col>
                  </el-row>
                </div>
              </el-collapse-transition>
            </el-form>
          </section>
        </div>
      </template>
      <div class="section-title quote-line-title quote-editor-section-title">
        <span>采购项与供应商报价（{{ quoteForm.itemList.length }}项 · {{ quoteForm.supplierList.length }}家）</span>
        <div class="section-title__actions">
          <el-button v-if="canEditQuote" size="mini" plain @click="appendQuoteLinesFromApplyItems">从采购需求带入</el-button>
          <el-button v-if="canEditQuote" type="primary" size="mini" plain icon="el-icon-plus" @click="addComparisonItem">新增采购项</el-button>
        </div>
      </div>
      <el-alert
        v-if="quoteFormDuplicateItemGroups.length"
        :title="`发现${quoteFormDuplicateItemGroups.length}组同名同规格采购项，请核对是否需要合并`"
        description="物料名称和规格型号都相同即视为重复；确因数量、用途等原因需要拆分时，可在保存时确认后保留。"
        type="warning"
        :closable="false"
        show-icon
        class="quote-duplicate-alert"
      />
      <div v-if="quoteFormUseItemLayout" class="quote-item-flat-list">
        <section
          v-for="(item, itemIndex) in quoteForm.itemList"
          :key="item._rowKey"
          class="quote-item-flat-card"
          :class="{ 'is-duplicate': isDuplicateComparisonItem(item) }"
        >
          <div class="quote-item-flat-card__head">
            <div>
              <strong>{{ item.materialName || `采购项 ${itemIndex + 1}` }}</strong>
              <span>{{ item.specification || '无规格' }}<template v-if="item.parameterValue"> · {{ item.parameterValue }}</template></span>
            </div>
            <div class="quote-item-flat-card__actions">
              <el-tag v-if="isDuplicateComparisonItem(item)" size="mini" type="warning">重复项</el-tag>
              <el-button v-if="canEditQuote" type="text" class="danger" @click="removeComparisonItem(itemIndex)">删除产品</el-button>
            </div>
          </div>
          <div class="quote-item-flat-card__form">
            <label class="quote-item-flat-field quote-item-flat-field--name">
              <span>产品</span>
              <el-input v-model="item.materialName" :disabled="!canEditQuote" placeholder="物料或服务名称" @blur="loadLatestQuoteHistoryPrice(item)" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--spec">
              <span>规格</span>
              <el-input v-model="item.specification" :disabled="!canEditQuote" placeholder="选填" @blur="loadLatestQuoteHistoryPrice(item)" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--param">
              <span>参数</span>
              <el-input v-model="item.parameterValue" :disabled="!canEditQuote" placeholder="选填" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--brand">
              <span>品牌</span>
              <el-input v-model="item.materialQualityBrand" :disabled="!canEditQuote" placeholder="选填" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--qty">
              <span>需求</span>
              <el-input-number v-model="item.demandQuantity" :disabled="!canEditQuote" :precision="2" :min="0" :controls="false" @change="handleQuoteDemandInventoryChange(item)" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--qty">
              <span>库存</span>
              <el-input-number v-model="item.inventoryQuantity" :disabled="!canEditQuote" :precision="2" :min="0" :controls="false" @change="handleQuoteDemandInventoryChange(item)" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--qty">
              <span>实采</span>
              <el-input-number v-model="item.quantity" :disabled="!canEditQuote" :precision="2" :min="0" :controls="false" @change="syncAllComparisonSupplierAutoFinalTotal" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--unit">
              <span>单位</span>
              <el-input v-model="item.unit" :disabled="!canEditQuote" />
            </label>
            <label class="quote-item-flat-field quote-item-flat-field--history">
              <span>历史价</span>
              <div class="quote-history-price-field">
                <el-input-number v-model="item.historyMinPrice" :disabled="!canEditQuote" :precision="3" :step="0.001" :min="0" :controls="false" @change="markQuoteHistoryPriceManual(item)" />
                <small v-if="item._historyLoading">查询中</small>
                <small v-else-if="item._historySourceText">{{ item._historySourceText }}</small>
                <small v-else>暂无同规格历史价</small>
              </div>
            </label>
          </div>
          <div class="quote-item-offer-list">
            <div class="quote-item-offer-list__head">
              <span>{{ quoteFormPartyName }}报价（{{ quoteItemSupplierRows(item).length }}家）</span>
              <el-button v-if="canEditQuote" type="primary" plain size="mini" icon="el-icon-plus" @click="addComparisonSupplierForItem(item)">新增{{ quoteFormPartyName }}</el-button>
            </div>
            <div v-if="!quoteItemSupplierRows(item).length" class="quote-offer-empty">请给该产品新增至少一家{{ quoteFormPartyName }}</div>
            <div
              v-for="(supplier, supplierIndex) in quoteItemSupplierRows(item)"
              :key="`${item._rowKey}-${supplier._rowKey}`"
              class="quote-item-offer-row"
              :class="{
                'is-recommended': quoteItemRecommendedSupplierKey(item) === supplier._rowKey,
                'has-platform': quoteFormIsEcommerce || quoteFormIsMixed
              }"
            >
              <span class="quote-item-offer-row__index">{{ supplierIndex + 1 }}</span>
              <el-select
                v-if="quoteFormIsEcommerce || quoteFormIsMixed"
                v-model="supplier.purchasePlatform"
                filterable
                allow-create
                default-first-option
                placeholder="平台"
                class="quote-item-offer-row__platform"
                @change="handleQuoteOfferPlatformChange(supplier)"
              >
                <el-option v-for="platform in ecommercePlatformOptions" :key="platform" :label="platform" :value="platform" />
              </el-select>
              <el-autocomplete
                v-model="supplier.supplierName"
                :fetch-suggestions="querySupplierSuggestions"
                value-key="supplierName"
                :placeholder="quoteFormIsEcommerce ? '店铺名' : (quoteFormIsMixed ? '报价方' : '供应商')"
                class="quote-item-offer-row__supplier"
                @input="handleQuoteOfferSupplierInput(supplier)"
                @select="handleQuoteOfferSupplierSelect(supplier, $event)"
                @blur="handleQuoteOfferSupplierBlur(supplier)"
              />
              <div class="quote-item-offer-row__maintain">
                <div
                  v-if="supplier.supplierName"
                  class="quote-item-offer-row__link-state"
                  :class="`is-${quoteSupplierLinkState(supplier).status}`"
                >
                  <i :class="quoteSupplierLinkState(supplier).icon"></i>
                  <span :title="quoteSupplierLinkState(supplier).message">{{ quoteSupplierCompactLinkMessage(supplier) }}</span>
                </div>
                <el-button
                  v-if="quoteSupplierCanMaintain(supplier)"
                  type="text"
                  @mousedown.native.prevent
                  @click="openSupplierMaintenanceForOffer(supplier)"
                >{{ quoteSupplierMaintainLabel(supplier, true) }}</el-button>
              </div>
              <el-input-number
                v-model="supplier.priceMap[item._rowKey]"
                :precision="3"
                :step="0.001"
                :min="0"
                :controls="false"
                class="quote-item-offer-row__price"
                @change="syncComparisonSupplierAutoFinalTotal(supplier)"
              />
              <span class="quote-item-offer-row__amount">合计 {{ money(quoteActualPurchaseAmount(item, supplier.priceMap[item._rowKey])) }}</span>
              <el-radio
                :value="quoteItemRecommendedSupplierKey(item)"
                :label="supplier._rowKey"
                class="quote-item-offer-row__recommend"
                @input="setQuoteItemRecommendedSupplier(item, supplier)"
              >推荐</el-radio>
              <el-input
                v-if="quoteItemRecommendedSupplierKey(item) === supplier._rowKey"
                :value="quoteItemRecommendationReason(item)"
                maxlength="200"
                clearable
                placeholder="推荐理由"
                class="quote-item-offer-row__reason"
                @input="setQuoteItemRecommendationReason(item, $event)"
              />
              <el-button v-if="quoteItemRecommendedSupplierKey(item) === supplier._rowKey" type="text" class="quote-item-offer-row__cancel" @click="clearQuoteItemRecommendation(item)">取消</el-button>
              <el-button v-if="canEditQuote" type="text" class="quote-item-offer-row__remove danger" @click="removeComparisonSupplierFromItem(item, supplier)">移除</el-button>
            </div>
          </div>
        </section>
      </div>
      <el-table v-else :data="quoteForm.itemList" :row-class-name="quoteEditorItemRowClass" border size="mini" max-height="520" class="quote-editor-item-table">
        <el-table-column label="采购项" fixed min-width="190">
          <template slot-scope="scope">
            <div class="quote-editor-item-name">
              <el-input v-model="scope.row.materialName" placeholder="物料或服务名称" @blur="loadLatestQuoteHistoryPrice(scope.row)" />
              <span v-if="isDuplicateComparisonItem(scope.row)"><i class="el-icon-warning-outline"></i>同名同规格重复</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="规格型号" min-width="180"><template slot-scope="scope"><el-input v-model="scope.row.specification" placeholder="选填" @blur="loadLatestQuoteHistoryPrice(scope.row)" /></template></el-table-column>
        <el-table-column label="参数" min-width="180"><template slot-scope="scope"><el-input v-model="scope.row.parameterValue" placeholder="选填" /></template></el-table-column>
        <el-table-column label="品牌/材质" min-width="145"><template slot-scope="scope"><el-input v-model="scope.row.materialQualityBrand" placeholder="选填" /></template></el-table-column>
        <el-table-column label="需求数量" width="125"><template slot-scope="scope"><el-input-number v-model="scope.row.demandQuantity" :precision="2" :min="0" :controls="false" style="width:100%" @change="handleQuoteDemandInventoryChange(scope.row)" /></template></el-table-column>
        <el-table-column label="库存" width="115"><template slot-scope="scope"><el-input-number v-model="scope.row.inventoryQuantity" :precision="2" :min="0" :controls="false" style="width:100%" @change="handleQuoteDemandInventoryChange(scope.row)" /></template></el-table-column>
        <el-table-column label="实际采购量" width="135"><template slot-scope="scope"><el-input-number v-model="scope.row.quantity" :precision="2" :min="0" :controls="false" style="width:100%" @change="syncAllComparisonSupplierAutoFinalTotal" /></template></el-table-column>
        <el-table-column label="单位" width="90"><template slot-scope="scope"><el-input v-model="scope.row.unit" /></template></el-table-column>
        <el-table-column label="最近采购价" width="165">
          <template slot-scope="scope">
            <div class="quote-history-price-field">
              <el-input-number v-model="scope.row.historyMinPrice" :precision="3" :step="0.001" :min="0" :controls="false" style="width:100%" @change="markQuoteHistoryPriceManual(scope.row)" />
              <small v-if="scope.row._historyLoading">正在查询历史采购…</small>
              <small v-else-if="scope.row._historySourceText">{{ scope.row._historySourceText }}</small>
              <small v-else>暂无同物料同规格历史价</small>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(supplier, supplierIndex) in quoteForm.supplierList"
          :key="`${supplier._rowKey}-${supplier.supplierName || supplierIndex}`"
          :label="supplier.supplierName || `供应商 ${supplierIndex + 1}`"
          min-width="165"
        >
          <template slot="header">
            <div class="quote-editor-supplier-column-header">
              <strong :title="supplier.supplierName">{{ supplier.supplierName || `供应商 ${supplierIndex + 1}` }}</strong>
              <span>单价</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="quote-editor-price-field" :class="{ 'is-lowest': isLowestComparisonPrice(scope.row, supplier) }">
              <el-input-number v-model="supplier.priceMap[scope.row._rowKey]" :precision="3" :step="0.001" :min="0" :controls="false" style="width:100%" @change="syncComparisonSupplierAutoFinalTotal(supplier)" />
              <span v-if="isLowestComparisonPrice(scope.row, supplier)">当前最低</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="canEditQuote" label="操作" fixed="right" width="70" align="center"><template slot-scope="scope"><el-button type="text" class="danger" @click="removeComparisonItem(scope.$index)">删除</el-button></template></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelQuoteEditing">取消</el-button>
        <el-button v-if="quoteImportQueueIndex >= 0" type="primary" plain :loading="quoteImportSaving" @click="confirmAllQuoteImports">确认全部导入</el-button>
        <el-button type="primary" @click="saveQuote">{{ quoteImportQueueIndex >= 0 ? '保存当前报价组' : '保存报价组' }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="物料价格查询"
      :visible.sync="priceLookupOpen"
      width="86vw"
      append-to-body
      custom-class="price-lookup-dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="priceLookupQuery" class="multipleSelectScroll price-lookup-form" label-width="85px">
        <el-row :gutter="10">
          <el-col :xs="24" :md="8">
            <el-form-item label="物料">
              <el-autocomplete
                v-model="priceLookupQuery.materialName"
                :fetch-suggestions="queryPriceLookupMaterialSuggestions"
                value-key="materialName"
                placeholder="输入或选择物料"
                clearable
                :trigger-on-focus="true"
                :highlight-first-item="true"
                popper-class="material-reference-popper"
                style="width:100%"
                @select="handlePriceLookupMaterialSelect"
                @keyup.enter.native="queryPriceLookup"
              >
                <template slot-scope="{ item }">
                  <div class="reference-option reference-option--material-name">
                    <strong>{{ item.materialName }}</strong>
                    <div v-if="materialSuggestionOptionDetails(item).length" class="reference-option__details">
                      <span v-for="detail in materialSuggestionOptionDetails(item)" :key="detail">{{ detail }}</span>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="规格">
              <el-autocomplete
                v-model="priceLookupQuery.specification"
                :fetch-suggestions="queryPriceLookupSpecificationSuggestions"
                value-key="value"
                placeholder="输入或选择规格"
                clearable
                :trigger-on-focus="true"
                :highlight-first-item="true"
                popper-class="spec-reference-popper"
                style="width:100%"
                @select="handlePriceLookupSpecificationSelect"
                @keyup.enter.native="queryPriceLookup"
              >
                <template slot-scope="{ item }">
                  <div class="spec-reference-option" :title="item.value">
                    <strong>{{ item.value }}</strong>
                    <span v-if="item.detail">{{ item.detail }}</span>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="6">
            <el-form-item label="供应商">
              <el-autocomplete
                v-model="priceLookupQuery.supplierName"
                :fetch-suggestions="queryPriceLookupSupplierSuggestions"
                value-key="supplierName"
                placeholder="输入或选择供应商"
                clearable
                :trigger-on-focus="true"
                :highlight-first-item="true"
                popper-class="supplier-reference-popper"
                style="width:100%"
                @select="handlePriceLookupSupplierSelect"
                @keyup.enter.native="queryPriceLookup"
              >
                <template slot-scope="{ item }">
                  <div class="reference-option">
                    <div class="reference-option__title">
                      <strong>{{ item.supplierName }}</strong>
                      <em v-if="item.shortName">{{ item.shortName }}</em>
                    </div>
                    <div v-if="priceSupplierOptionDetails(item).length" class="reference-option__details">
                      <span v-for="detail in priceSupplierOptionDetails(item)" :key="detail.label + detail.value">{{ detail.label }}：{{ detail.value }}</span>
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="4" align="right">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="queryPriceLookup">查询</el-button>
              <el-button icon="el-icon-refresh" @click="resetPriceLookup">清空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table v-loading="priceLookupLoading" :data="priceLookupRows" border max-height="420" empty-text="请输入物料、规格或供应商查询历史价格">
        <el-table-column label="物料名称" prop="materialName" min-width="170" show-overflow-tooltip />
        <el-table-column label="规格型号" prop="specification" min-width="150" show-overflow-tooltip />
        <el-table-column label="材质/品牌" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row._materialQualityBrandSummary || scope.row.materialQualityBrand || '-' }}</template>
        </el-table-column>
        <el-table-column label="供应商" prop="supplierName" min-width="170" show-overflow-tooltip />
        <el-table-column label="价格参考" min-width="170" align="right">
          <template slot-scope="scope">
            <div class="price-lookup-price">
              <strong>{{ priceLookupRangeText(scope.row) }}</strong>
              <span v-if="scope.row._latestPurchaseUnitPrice !== undefined">最近 {{ money(scope.row._latestPurchaseUnitPrice) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单位" prop="unit" width="72" align="center" />
        <el-table-column label="历史数量" width="120" align="right">
          <template slot-scope="scope">{{ priceLookupQuantityText(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="历史记录" min-width="190" show-overflow-tooltip>
          <template slot-scope="scope">{{ priceLookupSourceText(scope.row) }}</template>
        </el-table-column>
        <el-table-column v-if="priceLookupTargetRow" label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="adoptLookupPrice(scope.row)">采用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="priceLookupOpen = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="物流附件" :visible.sync="shipmentAttachmentDialogOpen" width="720px" append-to-body>
      <file-upload :key="'shipment-files-' + uploadRenderKey" v-model="shipmentAttachmentFiles" :limit="8" :multiple="true" :readOnly="true"></file-upload>
      <div slot="footer" class="dialog-footer"><el-button @click="shipmentAttachmentDialogOpen = false">关闭</el-button></div>
    </el-dialog>

    <el-dialog title="新增零星采购" :visible.sync="directOrderDialogOpen" width="92vw" append-to-body :close-on-click-modal="false" custom-class="direct-order-dialog">
      <el-alert type="info" :closable="false" show-icon title="仅采购员可使用。保存后直接生成采购执行单，不进入采购审批；金额不设上限，但必须填写完整供应商和真实采购清单。" />
      <el-form :model="directOrderForm" label-width="98px" class="direct-order-form">
        <div class="section-title section-title--first"><span>采购信息</span><strong class="direct-order-total">合计 {{ money(directOrderAmount) }}</strong></div>
        <el-row :gutter="12">
          <el-col :xs="24" :md="12" :lg="8"><el-form-item label="采购主题" required><el-input v-model="directOrderForm.applyTitle" maxlength="100" placeholder="如：车间临时维修耗材采购" /></el-form-item></el-col>
          <el-col :xs="24" :md="12" :lg="8"><el-form-item label="采购类型" required><el-select v-model="directOrderForm.purchaseType" style="width:100%"><el-option-group v-for="group in purchaseTypeOptionGroups" :key="group.label" :label="group.label"><el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" /></el-option-group></el-select></el-form-item></el-col>
          <el-col :xs="24" :md="12" :lg="8"><el-form-item label="期望到货" required><el-date-picker v-model="directOrderForm.expectedArrivalDate" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="供应商" required>
            <el-autocomplete v-model="directOrderForm.supplierName" :fetch-suggestions="querySupplierSuggestions" value-key="supplierName" placeholder="输入完整工商名称或从供应商库选择" popper-class="supplier-reference-popper" style="width:100%" @input="handleDirectSupplierInput" @select="handleDirectSupplierSelect">
              <template slot-scope="{ item }"><div class="reference-option"><div class="reference-option__title"><strong>{{ item.supplierName }}</strong><em v-if="item.shortName">{{ item.shortName }}</em></div></div></template>
            </el-autocomplete>
          </el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="合同方式" required><el-radio-group v-model="directOrderForm.contractMode"><el-radio :label="1">需要合同</el-radio><el-radio :label="2">无需合同</el-radio></el-radio-group></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="采购原因" required><el-input v-model="directOrderForm.purchaseReason" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="说明临时采购的用途和原因" /></el-form-item></el-col>
          <el-col v-if="Number(directOrderForm.contractMode) === 2" :span="24"><el-form-item label="无合同原因" required><el-input v-model="directOrderForm.noContractReason" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="说明本次采购为什么无需签订合同" /></el-form-item></el-col>
        </el-row>
        <div class="section-title"><span>真实采购清单</span><el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addDirectOrderItem">新增一行</el-button></div>
        <el-table :data="directOrderForm.itemList" border class="direct-order-item-table">
          <el-table-column label="采购项" min-width="190"><template slot-scope="scope"><el-input v-model="scope.row.materialName" placeholder="物料或服务名称" /></template></el-table-column>
          <el-table-column label="规格型号" min-width="180"><template slot-scope="scope"><el-input v-model="scope.row.specification" placeholder="可填写规格型号" /></template></el-table-column>
          <el-table-column label="品牌/材质" min-width="140"><template slot-scope="scope"><el-input v-model="scope.row.materialQualityBrand" placeholder="选填" /></template></el-table-column>
          <el-table-column label="数量" width="125"><template slot-scope="scope"><el-input-number v-model="scope.row.quantity" :precision="2" :min="0" :controls="false" style="width:100%" @change="recalculateDirectOrder" /></template></el-table-column>
          <el-table-column label="单位" width="90"><template slot-scope="scope"><el-input v-model="scope.row.unit" placeholder="单位" /></template></el-table-column>
          <el-table-column label="单价" width="135"><template slot-scope="scope"><el-input-number v-model="scope.row.purchaseUnitPrice" :precision="2" :step="0.01" :min="0" :controls="false" style="width:100%" @change="recalculateDirectOrder" /></template></el-table-column>
          <el-table-column label="小计" width="120" align="right"><template slot-scope="scope">{{ money(directOrderItemAmount(scope.row)) }}</template></el-table-column>
          <el-table-column label="操作" width="70" align="center"><template slot-scope="scope"><el-button type="text" class="danger" @click="removeDirectOrderItem(scope.$index)">删除</el-button></template></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="directOrderDialogOpen = false">取消</el-button>
        <el-button v-hasPermi="['crm:procurement:quote']" type="primary" :loading="directOrderSaving" @click="submitDirectOrder">保存并生成采购单</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="AI识别采购需求清单"
      :visible.sync="applyWorkbookDialogOpen"
      width="94vw"
      append-to-body
      :close-on-click-modal="false"
      custom-class="requirement-workbook-dialog"
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        title="AI会适配不同表格格式并还原栏目、系统分组和明细。结果尚未保存，请人工预览修改；确认后才填入采购申请草稿，原Excel同时作为附件保留。"
      />
      <div class="requirement-preview-summary">
        <span>工作表：{{ applyWorkbookPreview.sheetName || '-' }}</span>
        <span>需求项：{{ applyWorkbookPreview.itemCount || 0 }} 条</span>
        <span>栏目/大项：{{ applyWorkbookPreview.sectionCount || 0 }} 个</span>
        <span>系统/分组：{{ applyWorkbookPreview.itemGroupCount || 0 }} 个</span>
        <el-tag :type="applyWorkbookPreview.aiRecognized ? 'success' : 'warning'" size="small">
          {{ applyWorkbookPreview.aiRecognized ? 'AI增强完成' : '快速解析完成' }}
        </el-tag>
        <span v-if="applyWorkbookPreview.aiConfidence !== null && applyWorkbookPreview.aiConfidence !== undefined">
          AI置信度：{{ applyWorkbookPreview.aiConfidence }}%
        </span>
      </div>
      <el-alert
        v-if="applyWorkbookPreview.aiMessage"
        :type="applyWorkbookPreview.aiRecognized ? 'success' : 'warning'"
        :closable="false"
        show-icon
        :title="applyWorkbookPreview.aiMessage"
      />
      <el-alert
        v-if="(applyWorkbookPreview.warningList || []).length"
        type="warning"
        :closable="false"
        show-icon
        :title="applyWorkbookPreview.warningList.join('；')"
      />
      <el-tabs v-model="applyWorkbookPreviewTab" class="requirement-preview-tabs">
        <el-tab-pane label="AI结构化结果" name="structured">
          <div class="requirement-ai-preview">
            <section
              v-for="(group, groupIndex) in applyWorkbookCategoryGroups"
              :key="`${group.key}-${groupIndex}`"
              class="requirement-category"
            >
              <div v-if="applyWorkbookShowCategoryHeaders" class="requirement-category__title">
                <span>{{ group.sheetName ? `${group.sheetName} · 栏目/大项` : '栏目/大项' }}</span>
                <el-input
                  :value="group.name"
                  maxlength="200"
                  placeholder="未分组"
                  @input="value => updateApplyWorkbookSection(group, value)"
                />
                <em>{{ group.items.length }} 条</em>
              </div>
              <el-table
                :data="group.items"
                border
                class="requirement-preview-table"
                :span-method="applyWorkbookGroupSpanMethod"
              >
                <el-table-column label="系统/分组" min-width="150">
                  <template slot-scope="scope">
                    <el-input
                      :value="scope.row.itemGroupName"
                      type="textarea"
                      :rows="2"
                      maxlength="200"
                      placeholder="无分组"
                      @input="value => updateApplyWorkbookItemGroup(group.items, scope.$index, value)"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="设备/物料名称" min-width="180"><template slot-scope="scope"><el-input v-model="scope.row.materialName" maxlength="200" /></template></el-table-column>
                <el-table-column label="型号" min-width="150"><template slot-scope="scope"><el-input v-model="scope.row.modelNo" maxlength="200" @input="value => syncPreviewModel(scope.row, value)" /></template></el-table-column>
                <el-table-column label="技术参数" min-width="260"><template slot-scope="scope"><el-input v-model="scope.row.technicalParameter" type="textarea" :rows="2" maxlength="10000" /></template></el-table-column>
                <el-table-column label="材质要求" min-width="150"><template slot-scope="scope"><el-input v-model="scope.row.materialRequirement" maxlength="500" /></template></el-table-column>
                <el-table-column label="数量" width="110"><template slot-scope="scope"><el-input-number v-model="scope.row.quantity" :precision="2" :min="0" :controls="false" style="width:100%" /></template></el-table-column>
                <el-table-column label="单位" width="90"><template slot-scope="scope"><el-input v-model="scope.row.unit" /></template></el-table-column>
                <el-table-column label="备注" min-width="220"><template slot-scope="scope"><el-input v-model="scope.row.remark" type="textarea" :rows="2" maxlength="1000" /></template></el-table-column>
                <el-table-column label="来源位置" width="130" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.sourceSheetName ? `${scope.row.sourceSheetName} / ${scope.row.sourceRowNo || '-'}` : (scope.row.sourceRowNo || '-') }}
                  </template>
                </el-table-column>
              </el-table>
            </section>
          </div>
        </el-tab-pane>
        <el-tab-pane label="原表对照" name="source">
          <div
            v-for="(sheet, sheetIndex) in (applyWorkbookPreview.layoutSheetList || [])"
            :key="`${sheet.sheetName}-${sheetIndex}`"
            class="requirement-source-sheet"
          >
            <div class="requirement-source-sheet__name">{{ sheet.sheetName }}</div>
            <div class="requirement-source-sheet__scroll">
              <table>
                <colgroup>
                  <col
                    v-for="column in (sheet.columnList || [])"
                    :key="column.columnIndex"
                    :style="{ width: `${column.widthPx || 80}px` }"
                  >
                </colgroup>
                <tbody>
                  <tr
                    v-for="row in (sheet.rowList || [])"
                    :key="row.sourceRowNo"
                    :style="{ height: `${row.heightPx || 24}px` }"
                  >
                    <td
                      v-for="cell in (row.cellList || [])"
                      :key="`${cell.rowIndex}-${cell.columnIndex}`"
                      :rowspan="cell.rowSpan || 1"
                      :colspan="cell.columnSpan || 1"
                      :style="applyWorkbookSourceCellStyle(cell)"
                    >{{ cell.text || '' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-checkbox v-model="applyWorkbookOverwrite">覆盖当前已有明细</el-checkbox>
        <el-button @click="applyWorkbookDialogOpen = false">取消</el-button>
        <el-button type="primary" :loading="applyWorkbookConfirming" @click="confirmApplyWorkbookPreview">确认填入草稿</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量上传供应商合同"
      :visible.sync="contractBatchDialogOpen"
      width="1080px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-alert
        title="一次可选择多份普通供应商合同并自动匹配；无需填写合同编号，保存后由后台AI从合同首页或第二页自动识别并回填。再次保存会替换原合同附件，用印通过后不可替换。"
        type="info"
        show-icon
        :closable="false"
      />
      <div class="contract-batch-upload-zone">
        <file-upload
          :key="'contract-batch-upload-' + contractBatchUploadKey"
          v-model="contractBatchFiles"
          accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.webp"
          :limit="50"
          :multiple="true"
          :readOnly="false"
          @on-change="handleContractBatchFileChange"
          @raw-file-uploaded="handleContractBatchRawUploaded"
        />
      </div>
      <el-table :data="contractBatchMappingRows" border size="mini" max-height="430" empty-text="请一次选择需要上传的全部合同文件">
        <el-table-column type="index" label="#" width="48" align="center" />
        <el-table-column label="文件" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.fileInfo && scope.row.fileInfo.name || '-' }}</template>
        </el-table-column>
        <el-table-column label="匹配供应商采购单" min-width="255">
          <template slot-scope="scope">
            <el-select v-model="scope.row.applyId" filterable placeholder="选择供应商采购单" style="width:100%" @change="value => handleContractBatchOrderChange(scope.row, value)">
              <el-option
                v-for="order in contractBatchTargetRows"
                :key="order.id"
                :label="`${order.applyNo || ''} · ${order.supplierName || '未命名供应商'}`"
                :value="order.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="合同金额" width="150">
          <template slot-scope="scope"><el-input-number v-model="scope.row.contractAmount" :precision="2" :min="0" :controls="false" style="width:100%" /></template>
        </el-table-column>
        <el-table-column label="匹配结果" width="98" align="center">
          <template slot-scope="scope"><el-tag :type="scope.row.applyId ? 'success' : 'danger'" size="mini">{{ scope.row.applyId ? (scope.row.autoMatched ? '自动匹配' : '已选择') : '待匹配' }}</el-tag></template>
        </el-table-column>
      </el-table>
      <el-form label-width="92px" class="contract-batch-remark">
        <el-form-item label="用章说明"><el-input v-model="contractBatchRemark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="选填，将随整包合同提交给审批人" /></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span class="contract-batch-footer-tip">已选{{ contractBatchMappingRows.length }}个文件，{{ contractBatchUnmatchedCount }}个待匹配</span>
        <el-button @click="contractBatchDialogOpen = false">取消</el-button>
        <el-button type="primary" plain :loading="contractBatchSaving" :disabled="!contractBatchCanSave" @click="saveContractBatch(false)">批量保存</el-button>
        <el-button type="primary" :loading="contractBatchSubmitting" :disabled="!contractBatchCanSave" @click="saveContractBatch(true)">保存并发起采购合同审批</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="supplierDialogTitle" :visible.sync="supplierDialogOpen" width="760px" append-to-body :close-on-click-modal="false">
      <el-form ref="supplierForm" :model="supplierForm" :rules="supplierRules" label-width="108px">
        <el-row :gutter="12">
          <el-col :xs="24" :md="12"><el-form-item label="供应商名称" prop="supplierName"><el-input v-model="supplierForm.supplierName" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="信用代码"><el-input v-model="supplierForm.creditCode" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="简称"><el-input v-model="supplierForm.shortName" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="供应商类型"><el-input v-model="supplierForm.supplierType" placeholder="如原材料、加工件、工程服务" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="联系人"><el-input v-model="supplierForm.contactName" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="联系方式"><el-input v-model="supplierForm.contactPhone" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="别名"><el-input v-model="supplierForm.aliases" placeholder="多个名称用逗号分隔" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="采购内容"><el-input v-model="supplierForm.mainPurchaseContent" type="textarea" :rows="2" /></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="开户信息"><el-input v-model="supplierForm.bankInfo" type="textarea" :rows="2" /></el-form-item></el-col>
          <el-col :xs="24" :md="12"><el-form-item label="状态"><el-radio-group v-model="supplierForm.status"><el-radio :label="1">启用</el-radio><el-radio :label="2">禁用</el-radio></el-radio-group></el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="supplierDialogOpen = false">取消</el-button>
        <el-button type="primary" @click="saveSupplier">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/views/crm/components/fileUpload'
import approveInfo from '@/views/crm/components/approveInfo'
import OperateLogList from '@/views/crm/components/operateLogList'
import UserAvatar from '@/views/system/user/userAvatar'
import GroupMember from '@/views/crm/groupMember'
import { handleWorkOrder } from '@/api/crm/contract'
import { saveAs } from 'file-saver'
import { blobValidate } from '@/utils/ruoyi'
import {
  batchSavePurchaseContracts,
  cancelPurchaseApply,
  deleteDraftPurchaseApply,
  deleteWithdrawnPurchaseApply,
  confirmPurchaseContract,
  downloadPurchaseContractSealFiles,
  generatePurchaseSupplierDecisionAnalysis,
  getPurchaseApplyDetail,
  getPurchaseWorkbench,
  listPurchaseApply,
  listPurchaseContractOptions,
  listPurchasePrice,
  listPurchaseSupplier,
  parsePurchaseApplyWorkbook,
  parsePurchaseQuoteWorkbook,
  recognizePurchaseContractDraftStream,
  recallPurchaseSupplierDecision,
  recommendPurchaseComparisonSupplier,
  recommendPurchaseItemQuote,
  registerPurchasePayment,
  removePurchasePayment,
  removePurchaseComparisonGroup,
  removePurchaseShipment,
  removePurchaseSupplier,
  saveDirectPurchaseOrder,
  savePurchaseApply,
  savePurchaseArrival,
  savePurchaseComparisonGroup,
  savePurchaseQuoteWorkbook,
  savePurchaseQuote,
  savePurchaseShipment,
  savePurchaseSupplier,
  submitPurchaseApply,
  uploadPurchaseApplySourceFile,
  withdrawPurchaseApply,
  updatePurchaseContractMode
} from '@/api/crm/procurement'

import { hasPurchasePriceAccess } from '@/utils/purchase-price-access'

import { roundPurchaseMoney } from '@/utils/procurementMoney'

export default {
  name: 'ProcurementIndex',
  components: { FileUpload, approveInfo, OperateLogList, UserAvatar, GroupMember },
  data() {
    return {
      activeTab: 'dashboard',
      activeWorkflowKey: 'dashboard',
      detailTab: 'basic',
      sidebarCollapsed: false,
      showSearch: true,
      loading: { apply: false, supplier: false, price: false, contract: false },
      queryParams: { keyword: '', purchaseType: null, status: null, queue: '' },
      applyPage: { pageNum: 1, pageSize: 10 },
      supplierQuery: { keyword: '', status: null, pageNum: 1, pageSize: 20 },
      priceQuery: { materialName: '', specification: '', supplierName: '', purchaseType: null, internalPurchaseOnly: true, pageNum: 1, pageSize: 20 },
      priceRefreshTimer: null,
      workbench: {},
      applyList: [],
      supplierList: [],
      priceList: [],
      supplierReferenceList: [],
      priceReferenceList: [],
      materialSupplementList: [],
      contractOptions: [],
      contractQueryKeyword: '',
      contractSearchRequestSeq: 0,
      supplierTotal: 0,
      priceTotal: 0,
      applyTotal: 0,
      applyDialogOpen: false,
      applyDialogTitle: '新增采购申请',
      applySaving: false,
      applySavingAction: '',
      applySubmitLoadingId: null,
      directOrderDialogOpen: false,
      directOrderSaving: false,
      directOrderForm: this.emptyDirectOrderForm(),
      uploadRenderKey: 0,
      aiEntryOpen: false,
      aiRecognitionForm: this.emptyAiRecognitionForm(),
      aiRecognizedResult: null,
      aiApplyScopes: ['basic', 'items'],
      aiAllowedScopeValues: ['basic', 'items'],
      aiResultTab: 'contract',
      aiOverwriteExisting: false,
      recognizingContract: false,
      recognitionFillMode: 'apply',
      recognitionProgress: 0,
      recognitionMessage: '等待识别',
      recognitionStage: '',
      recognitionElapsedSeconds: 0,
      recognitionTicker: null,
      aiBatchProgressList: [],
      aiRecognitionRawFiles: [],
      applyForm: this.emptyApplyForm(),
      pendingSplitSupplierFeeMap: {},
      detail: this.emptyDetail(),
      contractForm: this.emptyContractForm(),
      contractEditing: false,
      contractEditSnapshot: null,
      contractModeDraft: 1,
      noContractReasonDraft: '',
      contractModeSaving: false,
      contractPaymentPlanList: [],
      contractBatchDialogOpen: false,
      contractBatchFiles: [],
      contractBatchMappingRows: [],
      contractBatchRemark: '',
      contractBatchUploadKey: 0,
      contractBatchSaving: false,
      contractBatchSubmitting: false,
      contractSealSubmitting: false,
      contractSealApprovalDialogOpen: false,
      contractSealDownloading: false,
      quoteForm: this.emptyQuoteForm(),
      quoteDialogOpen: false,
      quoteDialogTitle: '新增采购项报价组',
      quoteDialogRow: null,
      quoteImportLoading: false,
      quoteImportQueue: [],
      quoteImportQueueIndex: -1,
      quoteImportDraftList: [],
      quoteImportSheetList: [],
      quoteImportActiveSheetKey: '',
      quoteImportActiveKey: '0',
      quoteImportSourceFileInfo: null,
      quoteImportSaving: false,
      applyWorkbookLoading: false,
      applyWorkbookConfirming: false,
      applyWorkbookDialogOpen: false,
      applyWorkbookOverwrite: true,
      applyWorkbookPreviewTab: 'structured',
      applyWorkbookPreview: { itemList: [], warningList: [] },
      applyWorkbookSourceFile: null,
      applyWorkbookSourceFileInfo: null,
      approvalDialogOpen: false,
      offlineCompleteDialogOpen: false,
      offlineCompleteRemark: '',
      offlineCompleteSubmitting: false,
      approvalSelectionMap: {},
      expandedQuoteGroupMap: {},
      quoteGroupDisplayLayoutMap: {},
      quoteRequirementsExpanded: false,
      decisionAnalysisGenerating: false,
      decisionAnalysisPollTimer: null,
      paymentActionOpen: false,
      paymentDetailOpen: false,
      arrivalDetailOpen: false,
      priceLookupOpen: false,
      priceLookupLoading: false,
      priceLookupQuery: { materialName: '', specification: '', supplierName: '' },
      priceLookupRows: [],
      priceLookupTargetRow: null,
      currentPaymentPlan: {},
      paymentDetailPlan: {},
      arrivalDetailRecord: {},
      paymentActionForm: this.emptyPaymentActionForm(),
      arrivalForm: this.emptyArrivalForm(),
      arrivalEditingExisting: false,
      shipmentForm: this.emptyShipmentForm(),
      shipmentEditing: false,
      shipmentSaving: false,
      shipmentAttachmentDialogOpen: false,
      shipmentAttachmentFiles: [],
      inlineOrder: this.emptyInlineOrder(),
      supplierDialogOpen: false,
      supplierDialogTitle: '新增供应商',
      supplierForm: this.emptySupplierForm(),
      supplierMaintenanceOfferKey: '',
      ecommercePlatformOptions: ['淘宝', '天猫', '京东', '1688', '拼多多', '苏宁', '抖音', '电商'],
      purchaseTypeOptions: [
        { label: '核心原材料', value: 1, group: '非项目采购' },
        { label: '项目采购', value: 2, group: '项目采购' },
        { label: '生产原材料（药剂）', value: 3, group: '非项目采购' },
        { label: '膜元件材料（辅材）', value: 4, group: '非项目采购' },
        { label: '其他（办公用品、耗材等）', value: 5, group: '非项目采购' },
        { label: '租赁车辆（吸粪车/吊车/拖车）', value: 6, group: '非项目采购' },
        { label: '研发项目', value: 7, group: '项目/非项目采购均可' }
      ],
      statusOptions: [
        { label: '草稿待提交', value: 10 },
        { label: '审批中', value: 20 },
        { label: '退回待修改', value: 30 },
        { label: '审批已通过', value: 40 },
        { label: '待付款', value: 50 },
        { label: '待付款', value: 60 },
        { label: '部分付款待补齐', value: 70 },
        { label: '待到货验收', value: 80 },
        { label: '到货验收中', value: 90 },
        { label: '部分到货待补齐', value: 100 },
        { label: '已完成', value: 110 },
        { label: '已作废', value: 120 },
        { label: '线下已结束', value: 115 }
      ],
      attachmentTypeOptions: [
        { label: '采购合同', value: 1 },
        { label: '合同附件清单', value: 2 },
        { label: '报价单', value: 3 },
        { label: '付款凭证', value: 4 },
        { label: '发票', value: 5 },
        { label: '到货清单', value: 6 },
        { label: '验收附件', value: 7 },
        { label: '采购申请资料', value: 8 }
      ],
      arrivalStatusOptions: [
        { label: '未到货', value: 10 },
        { label: '部分到货', value: 20 },
        { label: '全部到货', value: 30 },
        { label: '到货异常', value: 40 },
        { label: '已验收', value: 50 }
      ],
      applyRules: {
        applyTitle: [{ required: true, message: '采购主题不能为空', trigger: 'blur' }],
        purchaseType: [{ required: true, message: '请选择采购类型', trigger: 'change' }],
        contractId: [{
          validator: (rule, value, callback) => {
            if (this.isProjectPurchase && !value) {
              callback(new Error('工程项目采购必须选择系统已有合同'))
              return
            }
            callback()
          },
          trigger: 'change'
        }]
      },
      supplierRules: {
        supplierName: [{ required: true, message: '供应商名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    activeQuoteImportSheet() {
      const sheets = this.quoteImportSheetList || []
      return sheets.find(sheet => sheet.key === this.quoteImportActiveSheetKey) || null
    },
    applyWorkbookCategoryGroups() {
      const rows = (this.applyWorkbookPreview && this.applyWorkbookPreview.itemList) || []
      const groups = []
      rows.forEach((row, index) => {
        const sectionName = String(row && row.processSection || '').trim()
        const sheetName = String(row && row.sourceSheetName || '').trim()
        const previous = groups[groups.length - 1]
        if (!previous || previous.name !== sectionName || previous.sheetName !== sheetName) {
          groups.push({
            key: `${sheetName || 'sheet'}-${sectionName || 'ungrouped'}-${index}`,
            name: sectionName,
            sheetName,
            items: [row]
          })
        } else {
          previous.items.push(row)
        }
      })
      return groups
    },
    applyWorkbookShowCategoryHeaders() {
      return this.applyWorkbookCategoryGroups.length > 1
    },
    isDetailPage() {
      const path = (this.$route && this.$route.path ? this.$route.path : '').replace(/\/$/, '')
      return path.endsWith('/procurement/apply/new') || /\/procurement\/apply\/detail\/[^/]+$/.test(path)
    },
    activeDocumentType() {
      if (this.activeTab === 'apply') return 1
      if (this.activeTab === 'order') return 2
      return null
    },
    activeApplyListTitle() {
      if (this.activeTab === 'todo') return '我的待处理事项'
      if (this.queryParams.myApplications) return '我发起的采购申请'
      if (this.shouldUsePersonalWorkbenchScope) {
        return this.activeTab === 'order' ? '我的采购执行单' : '我的相关采购申请'
      }
      return this.activeTab === 'order' ? '采购执行单列表' : '采购申请列表'
    },
    activeApplyNoLabel() {
      if (this.activeTab === 'todo') return '单据编号'
      return this.activeTab === 'order' ? '采购单号' : '申请编号'
    },
    activeApplyTitleLabel() {
      if (this.activeTab === 'todo') return '事项名称'
      return this.activeTab === 'order' ? '采购内容' : '申请主题'
    },
    activeAmountColumnLabel() {
      if (this.activeTab === 'order') return '金额/执行进度'
      if (this.activeTab === 'todo') return '金额'
      return '金额'
    },
    activeQueueHint() {
      const queue = this.queryParams && this.queryParams.queue
      if (queue === 'payment') return '采购待处理：点击列表中的“登记付款”即可补录付款金额、付款时间和凭证。'
      if (queue === 'arrival') return '仓管待处理：点击列表中的“到货验收”即可按物料登记到货数量和验收结果，附件可选。'
      if (queue === 'approval') return '审批待处理：只有当前节点审批人会看到“审批”操作，点击申请编号可查看完整依据。'
      if (queue === 'supplierConfirmation') return '审批已通过，请确认供应商并生成采购执行单。'
      if (queue === 'contract') return '合同资料已改为采购申请主单整包批量维护，不再作为采购执行待办。'
      if (queue === 'draft') return '草稿待处理：填写采购需求明细，或选择“复杂清单，仅上传附件”并上传原始清单后提交审批。'
      return ''
    },
    shouldUsePersonalWorkbenchScope() {
      const flag = this.queryParams && this.queryParams.myRelated
      return this.activeTab === 'apply' ||
        this.activeTab === 'dashboard' ||
        this.activeTab === 'todo' ||
        flag === true ||
        flag === 1 ||
        flag === '1' ||
        flag === 'true'
    },
    isApplicationDetail() {
      return Number(this.applyForm && this.applyForm.documentType || 1) === 1
    },
    contractSealRows() {
      return (this.detail && this.detail.contractSealItemList) || []
    },
    contractBatchTargetRows() {
      return this.contractSealRows.filter(row => Number(row && row.purchaseMode || 1) !== 2 &&
        Number(row && row.contractSealStatus || 10) !== 40)
    },
    contractSealWorkOrderAvailable() {
      return !!(this.detail && this.detail.contractSealWorkOrder && this.detail.contractSealWorkOrder.workOrderId)
    },
    contractSealApprovalButtonText() {
      const workOrder = this.detail && this.detail.contractSealWorkOrder
      return workOrder && Number(workOrder.hasAuth) === 1 ? '办理用章审批' : '查看用章审批'
    },
    contractSealFileGroups() {
      return this.contractSealRows.map((row, rowIndex) => {
        const supplierName = row && row.supplierName || `供应商${rowIndex + 1}`
        const files = row && row.contractInfo && Array.isArray(row.contractInfo.fileInfoList)
          ? row.contractInfo.fileInfoList : []
        return {
          key: String(row && (row.id || row.applyId || row.applyNo) || rowIndex),
          supplierName,
          files: files.map((file, fileIndex) => Object.assign({}, file, {
            key: `${this.quoteFileIdentity(file) || fileIndex}-${rowIndex}`,
            supplierName,
            applyNo: row && row.applyNo
          }))
        }
      }).filter(group => group.files.length)
    },
    contractSealAllFiles() {
      return this.contractSealFileGroups.reduce((files, group) => files.concat(group.files), [])
    },
    contractSealApproving() {
      return Number(this.detail && this.detail.contractSealBatch && this.detail.contractSealBatch.status) === 20 ||
        this.contractSealRows.some(row => Number(row && row.contractSealStatus || 10) === 20)
    },
    contractSealPackageReady() {
      if (!this.contractSealRows.length || this.contractSealApproving) return false
      if (this.contractSealPackageComplete) return false
      return this.contractSealRows.every(row => {
        if (Number(row && row.contractMode || 1) === 2) {
          return !!String(row && row.noContractReason || '').trim()
        }
        const contract = row && row.contractInfo
        return Number(row && row.contractStatus || 10) === 40 &&
          !!(contract && Array.isArray(contract.fileInfoList) && contract.fileInfoList.length)
      })
    },
    canManageContractSealPackage() {
      return this.isApplicationDetail && this.contractSealRows.length > 0 &&
        !this.contractSealApproving &&
        !this.contractSealRows.every(row => Number(row && row.contractSealStatus || 10) === 40) &&
        this.hasProcurementPermi('crm:procurement:contract')
    },
    canBatchUploadContracts() {
      return this.canManageContractSealPackage && this.contractBatchTargetRows.length > 0
    },
    contractSealPackageComplete() {
      return this.contractSealRows.length > 0 && this.contractSealRows.every(row => this.isContractSealComplete(row))
    },
    contractSealBatchStatusText() {
      if (this.contractSealApproving) return '整包审批中'
      if (this.contractSealPackageComplete) {
        return this.contractSealRows.every(row => Number(row.contractSealStatus || 10) === 40)
          ? '全部已用印' : '历史合同已录入'
      }
      const status = Number(this.detail && this.detail.contractSealBatch && this.detail.contractSealBatch.status || 0)
      if (status === 30) return '整包已退回'
      if (status === 50) return '整包已撤回'
      return this.contractSealPackageReady ? '待一次提交' : '用印资料待维护'
    },
    contractSealBatchStatusTag() {
      if (this.contractSealApproving) return 'warning'
      if (this.contractSealPackageComplete) return 'success'
      const status = Number(this.detail && this.detail.contractSealBatch && this.detail.contractSealBatch.status || 0)
      return [30, 50].includes(status) ? 'danger' : 'info'
    },
    contractSealPackageHint() {
      if (this.contractSealApproving) {
        const workOrder = this.detail && this.detail.contractSealWorkOrder
        return `全部合同正在同一张审批单中处理${workOrder && workOrder.currentTaskName ? `，当前节点：${workOrder.currentTaskName}` : ''}`
      }
      if (this.contractSealPackageComplete) {
        return this.contractSealRows.every(row => Number(row.contractSealStatus || 10) === 40)
          ? '本申请的供应商合同已完成用印，合同资料已锁定。'
          : '本申请属于用印流程上线前生成的历史采购，已录入合同默认按完成处理。'
      }
      if (this.contractSealPackageReady) return '全部用印资料已经齐备，可按需一次性提交整包用印；未提交不影响采购执行。'
      const missing = this.contractSealRows.filter(row => {
        if (Number(row && row.contractMode || 1) === 2) return !String(row && row.noContractReason || '').trim()
        return Number(row && row.contractStatus || 10) !== 40 || !this.contractFileCount(row)
      }).length
      return `如需发起整包用印，还有${missing}张普通供应商采购单需批量维护合同资料。`
    },
    contractBatchUnmatchedCount() {
      return this.contractBatchMappingRows.filter(row => !row.applyId).length
    },
    contractBatchCanSave() {
      return this.contractBatchMappingRows.length > 0 && this.contractBatchUnmatchedCount === 0 &&
        !this.contractBatchSaving && !this.contractBatchSubmitting
    },
    showApplicationItemExpand() {
      if (!this.isApplicationDetail) return false
      if (this.canEditProcurementBase) return true
      return (this.applyForm.itemList || []).some(item => {
        return ['processSection', 'itemGroupName', 'technicalParameter', 'materialRequirement', 'remark']
          .some(field => String(item && item[field] || '').trim())
      })
    },
    isAttachmentOnlyApplication() {
      return this.isApplicationDetail && Number(this.applyForm && this.applyForm.sourceMode) === 6
    },
    isSupplierOrderDetail() {
      return Number(this.applyForm && this.applyForm.documentType || 1) === 2
    },
    isEcommercePurchase() {
      return Number(this.applyForm && this.applyForm.purchaseMode || 1) === 2
    },
    quoteFormIsEcommerce() {
      return Number(this.quoteForm && this.quoteForm.purchaseMode || 1) === 2
    },
    quoteFormIsMixed() {
      return Number(this.quoteForm && this.quoteForm.purchaseMode || 1) === 3
    },
    quoteFormUseItemLayout() {
      return String(this.quoteForm && this.quoteForm.editorLayoutMode || 'supplier') === 'item'
    },
    quoteFormPartyName() {
      if (this.quoteFormIsEcommerce) return '店铺'
      if (this.quoteFormIsMixed) return '报价方'
      return '供应商'
    },
    quoteFormModeHint() {
      if (this.quoteFormIsEcommerce) return '店铺必须填写平台，后续生成电商采购执行单'
      if (this.quoteFormIsMixed) return '有平台的电商店铺自动关联；无平台的线下供应商必须关联供应商库'
      return '供应商需关联供应商库，审批通过后按报价组和供应商生成采购单'
    },
    quoteFormRequiresSupplierLink() {
      return !this.quoteFormIsEcommerce && !this.quoteFormIsMixed
    },
    hasEcommerceQuoteGroups() {
      return (this.quoteDisplayGroups || []).some(group => [2, 3].includes(Number(group.purchaseMode || 1)))
    },
    hasStandardQuoteGroups() {
      return (this.quoteDisplayGroups || []).some(group => [1, 3].includes(Number(group.purchaseMode || 1)))
    },
    hasMixedQuoteGroups() {
      return (this.quoteDisplayGroups || []).some(group => Number(group.purchaseMode || 1) === 3) ||
        (this.hasEcommerceQuoteGroups && this.hasStandardQuoteGroups)
    },
    detailDocumentTitle() {
      if (this.isSupplierOrderDetail && this.isEcommercePurchase) return '电商采购执行单'
      return this.isSupplierOrderDetail ? '采购执行单' : '采购申请'
    },
    supplierOrderSectionTitle() {
      if (this.isSupplierOrderDetail) return this.isEcommercePurchase ? '电商采购执行单' : '采购执行单'
      if (this.hasMixedQuoteGroups) return '采购执行单'
      if (this.hasEcommerceQuoteGroups || (!this.quoteDisplayGroups.length && this.isEcommercePurchase)) {
        return '电商采购执行单'
      }
      return '采购执行单'
    },
    supplierOrderPendingDescription() {
      if (this.hasMixedQuoteGroups) {
        return '普通供应商按报价组和供应商生成采购单；电商店铺按报价组生成电商采购包，平台和店铺保留在采购明细中。'
      }
      if (this.hasEcommerceQuoteGroups || (!this.quoteDisplayGroups.length && this.isEcommercePurchase)) {
        return '完成定商后，电商采购会按报价组聚合成执行包；平台和店铺保留在采购明细中。'
      }
      return '审批通过后按报价组和供应商分别生成采购单；点击采购单号可继续维护合同、付款和到货。'
    },
    supplierOrderCount() {
      return ((this.detail && this.detail.supplierOrderList) || []).length
    },
    applicationSupplierOrdersComplete() {
      const rows = ((this.detail && this.detail.supplierOrderList) || []).filter(row => Number(row.documentType || 2) === 2)
      return this.isApplicationDetail && rows.length > 0 && rows.every(row => this.isSupplierOrderLogicallyComplete(row))
    },
    isApplicationPendingSplit() {
      return this.isApplicationDetail && Number(this.applyForm.status || 10) === 40 && this.supplierOrderCount === 0
    },
    shouldShowSupplierInputColumn() {
      return this.isSupplierOrderDetail
    },
    shouldPersistItemSupplier() {
      return this.isSupplierOrderDetail
    },
    pendingSplitMaterialRows() {
      if (!this.isApplicationPendingSplit) return []
      return (this.applyForm.itemList || []).filter(item => item && item.materialName && this.isActualPurchaseRow(item))
    },
    pendingSplitMissingSupplierCount() {
      return this.pendingSplitMaterialRows.filter(item => !item.supplierId && !String(item.supplierName || '').trim()).length
    },
    isPendingSplitReady() {
      return this.isApplicationPendingSplit && this.pendingSplitMaterialRows.length > 0 && this.pendingSplitMissingSupplierCount === 0
    },
    pendingSplitSupplierGroups() {
      if (!this.isApplicationPendingSplit) return []
      const map = new Map()
      this.pendingSplitMaterialRows.forEach(item => {
        const supplierName = String(item.supplierName || '').trim()
        if (!supplierName) return
        const key = item.supplierId ? `id:${item.supplierId}` : `name:${this.normalizeReferenceName(supplierName)}`
        if (!map.has(key)) {
          map.set(key, {
            key,
            supplierId: item.supplierId || null,
            supplierName,
            amount: 0,
            items: []
          })
        }
        const group = map.get(key)
        group.items.push(item)
        group.amount += Number(item.amount || 0)
      })
      return Array.from(map.values()).map(group => {
        const fee = this.pendingSplitSupplierFeeForKey(group.key)
        const freightAmount = this.positiveAmount(fee.freightAmount)
        const otherFeeAmount = this.positiveAmount(fee.otherFeeAmount)
        return Object.assign({}, group, {
          freightAmount,
          otherFeeAmount,
          feeRemark: fee.feeRemark || '',
          totalAmount: roundPurchaseMoney(Number(group.amount || 0) + freightAmount + otherFeeAmount)
        })
      })
    },
    pendingSplitSummaryCards() {
      return [
        { key: 'item', label: '采购明细', value: this.pendingSplitMaterialRows.length },
        { key: 'confirmed', label: '已确认供应商', value: this.pendingSplitMaterialRows.length - this.pendingSplitMissingSupplierCount },
        { key: 'order', label: '将生成采购单', value: this.pendingSplitSupplierGroups.length },
        { key: 'missing', label: '待补供应商', value: this.pendingSplitMissingSupplierCount }
      ]
    },
    procurementSaveActionText() {
      if (!this.isApplicationPendingSplit) return '保存草稿'
      return this.isPendingSplitReady ? '保存并生成采购单' : '保存补充信息'
    },
    pendingSplitAlertTitle() {
      if (!this.pendingSplitMaterialRows.length) return '审批已通过，请先补充采购需求明细'
      if (this.pendingSplitMissingSupplierCount) return `审批已通过，还需为 ${this.pendingSplitMissingSupplierCount} 条明细选择供应商`
      return '供应商已补齐，保存后会按供应商自动生成采购执行单'
    },
    pendingSplitAlertDescription() {
      if (this.pendingSplitMissingSupplierCount) return '采购执行单会按供应商拆分生成；请在真实采购清单中逐行选择最终供应商。'
      return '一个供应商生成一张执行单，后续登记付款和到货；普通供应商合同在采购申请主单整包批量维护。'
    },
    isProjectPurchase() {
      return Number(this.applyForm && this.applyForm.purchaseType) === 2
    },
    applyStatusValue() {
      return Number(this.applyForm && this.applyForm.status ? this.applyForm.status : 10)
    },
    isApplyDraftEditable() {
      return !this.applyForm || !this.applyForm.id || [10, 30].includes(this.applyStatusValue)
    },
    canEditProcurementBase() {
      return this.isApplyDraftEditable && this.hasProcurementPermi('crm:procurement:save') &&
        (!this.isFinanceProcurementRestrictedUser || this.isOwnPurchaseApplication(this.applyForm))
    },
    canWithdrawApproval() {
      return this.detail && this.detail.canWithdrawApproval === true &&
        this.hasProcurementPermi('crm:procurement:submit')
    },
    canDeleteCurrentWithdrawnApply() {
      const order = this.detail && this.detail.approvalWorkOrder
      return this.hasProcurementPermi('crm:procurement:save', 'crm:procurement:submit') &&
        Number(this.applyForm.status) === 30 && order && Number(order.status) === 4 &&
        String(order.applicantId) === String(this.currentUserId()) &&
        !(this.detail.supplierOrderList || []).length
    },
    canDeleteCurrentDraftApply() {
      return this.hasProcurementPermi('crm:procurement:save') &&
        Number(this.applyForm.documentType || 1) === 1 && Number(this.applyForm.status) === 10 &&
        String(this.applyForm.createBy) === String(this.currentUserId()) &&
        !this.applyForm.approvalWorkOrderId && !(this.detail.supplierOrderList || []).length
    },
    canRecallSupplierDecision() {
      return this.detail && this.detail.canRecallSupplierDecision === true &&
        this.hasProcurementPermi('crm:procurement:quote')
    },
    canConfirmApplicationSupplier() {
      const canHandle = this.requiresPurchaseOwnerClaim(this.applyForm)
        ? this.isCurrentPurchaseOwner
        : this.isCurrentUserPurchaseHandler
      return this.isApplicationPendingSplit && canHandle &&
        this.hasProcurementPermi('crm:procurement:save')
    },
    canViewPurchaseSensitive() {
      return this.detail && this.detail.sensitiveDataVisible === true
    },
    canAccessPurchasePrice() {
      return hasPurchasePriceAccess(this.currentRoleKeys)
    },
    canAccessPurchaseSensitive() {
      if (typeof this.workbench.sensitiveDataVisible === 'boolean') return this.workbench.sensitiveDataVisible
      return this.currentRoleKeys.some(roleKey => ['gly', 'yygly', 'cg', 'xmcgy', 'fxmcgy', 'zjl', 'cwzj', 'cwzy', 'cwgd', 'cwyy'].includes(roleKey))
    },
    currentRoleKeys() {
      const roles = (this.$store && this.$store.getters && this.$store.getters.roles) || []
      return roles.map(role => {
        const roleKey = role && typeof role === 'object' ? role.roleKey : role
        return String(roleKey || '').toLowerCase()
      }).filter(Boolean)
    },
    isFinanceProcurementRestrictedUser() {
      const hasFinanceRole = this.currentRoleKeys.some(roleKey => ['cwzj', 'cwzy', 'cwgd', 'cwyy'].includes(roleKey))
      const hasPurchaserRole = this.currentRoleKeys.some(roleKey => ['cg', 'xmcgy', 'fxmcgy'].includes(roleKey))
      return hasFinanceRole && !hasPurchaserRole && !this.currentRoleKeys.includes('gly')
    },
    isCurrentUserPurchaser() {
      return this.currentRoleKeys.some(roleKey => ['cg', 'xmcgy', 'fxmcgy'].includes(roleKey))
    },
    canReceivePurchasePaymentTodo() {
      return (this.isCurrentUserPurchaser || this.currentRoleKeys.includes('gly')) &&
        this.hasProcurementPermi('crm:procurement:finance')
    },
    isCurrentUserPurchaseHandler() {
      const type = Number(this.applyForm && this.applyForm.purchaseType)
      if (this.currentRoleKeys.includes('cg')) return true
      if (type === 2) return this.currentRoleKeys.includes('xmcgy')
      if (type === 7) return this.currentRoleKeys.some(roleKey => ['xmcgy', 'fxmcgy'].includes(roleKey))
      return this.currentRoleKeys.includes('fxmcgy')
    },
    isCurrentPurchaseOwner() {
      const ownerId = this.applyForm && this.applyForm.purchaseOwnerId
      return ownerId !== undefined && ownerId !== null &&
        String(ownerId) === String(this.currentUserId())
    },
    canCreateDirectOrder() {
      return this.isCurrentUserPurchaser && this.hasProcurementPermi('crm:procurement:quote')
    },
    currentPurchaseApprovalTaskName() {
      const name = (this.detail.approvalWorkOrder && this.detail.approvalWorkOrder.currentTaskName) || ''
      return name === '采购员修改询价' ? '采购员询价' : name
    },
    isPurchaseInquiryApprovalNode() {
      return this.currentPurchaseApprovalTaskName === '采购员询价' ||
        this.currentPurchaseApprovalTaskName === '采购员修改询价'
    },
    isPurchaseInquiryRevisionNode() {
      return false
    },
    isSupplierDecisionApprovalNode() {
      return this.currentPurchaseApprovalTaskName === '总经理定商'
    },
    isPurchaseCompletionApprovalNode() {
      return this.currentPurchaseApprovalTaskName === '采购员完成采购'
    },
    isFinanceDirectorApprovalNode() {
      return this.currentPurchaseApprovalTaskName === '财务总监审批'
    },
    isCurrentUserGeneralManager() {
      const roles = (this.$store && this.$store.getters && this.$store.getters.roles) || []
      return roles.some(role => {
        const roleKey = role && typeof role === 'object' ? role.roleKey : role
        return String(roleKey || '').toLowerCase() === 'zjl'
      })
    },
    canShowSupplierDecisionApproval() {
      const workOrder = this.detail && this.detail.approvalWorkOrder
      return this.isSupplierDecisionApprovalNode && Number(workOrder && workOrder.hasAuth || 0) === 1
    },
    purchaserDecisionAnalysis() {
      return this.detail && this.detail.supplierDecisionAnalysis
        ? this.detail.supplierDecisionAnalysis
        : null
    },
    canShowPurchaserDecisionPreview() {
      return !!(this.applyForm && this.applyForm.id) &&
        this.canViewPurchaseSensitive &&
        (!!this.purchaserDecisionAnalysis || this.isSupplierDecisionApprovalNode || this.isPurchaseInquiryApprovalNode)
    },
    canShowPurchaserDecisionEntry() {
      return !!(this.applyForm && this.applyForm.id) &&
        this.canViewPurchaseSensitive &&
        this.isCurrentUserPurchaser
    },
    canEditQuote() {
      if (this.isFinanceProcurementRestrictedUser) return false
      const workOrder = this.detail && this.detail.approvalWorkOrder
      const ownerId = this.applyForm && this.applyForm.purchaseOwnerId
      const canClaimOrContinue = !this.requiresPurchaseOwnerClaim(this.applyForm) ||
        ownerId === undefined || ownerId === null ||
        String(ownerId) === String(this.currentUserId())
      return !!(this.applyForm && this.applyForm.id) && this.isApplicationDetail && this.canViewPurchaseSensitive &&
        Number(this.applyStatusValue) === 20 && this.isPurchaseInquiryApprovalNode &&
        Number(workOrder && workOrder.hasAuth || 0) === 1 && canClaimOrContinue
    },
    canOfflineComplete() {
      const workOrder = this.detail && this.detail.approvalWorkOrder
      return this.isApplicationDetail && Number(this.applyStatusValue) === 20 &&
        this.isPurchaseInquiryApprovalNode && Number(workOrder && workOrder.hasAuth || 0) === 1
    },
    quoteFormDuplicateItemGroups() {
      const groups = {}
      ;(this.quoteForm.itemList || []).forEach((item, index) => {
        const materialName = String(item && item.materialName || '').trim().replace(/\s+/g, ' ')
        if (!materialName) return
        const specification = String(item && item.specification || '').trim().replace(/\s+/g, ' ')
        const parameterValue = String(item && item.parameterValue || '').trim().replace(/\s+/g, ' ')
        const key = `${materialName.toLowerCase()}\u0000${specification.toLowerCase()}\u0000${parameterValue.toLowerCase()}`
        if (!groups[key]) {
          groups[key] = {
            key,
            materialName,
            specification,
            parameterValue,
            indexes: []
          }
        }
        groups[key].indexes.push(index)
      })
      return Object.keys(groups).map(key => groups[key]).filter(group => group.indexes.length > 1)
    },
    quoteFormAmountSummary() {
      const suppliers = this.quoteForm && this.quoteForm.supplierList || []
      if (!suppliers.length) {
        return this.emptyQuoteAmountSummary()
      }
      if (this.quoteFormUseItemLayout) {
        return this.quoteItemLayoutAmountSummary()
      }
      const summaries = suppliers.map(supplier => this.quoteSupplierCostSummary(supplier, this.quoteForm.itemList || []))
      const recommendedIndex = suppliers.findIndex(supplier => supplier && supplier._rowKey === this.quoteForm.recommendedSupplierKey)
      let summary = recommendedIndex >= 0 ? summaries[recommendedIndex] : null
      if (!summary) {
        summary = summaries.slice().sort((left, right) => {
          if (left.actualPurchaseAmount !== right.actualPurchaseAmount) {
            return left.actualPurchaseAmount - right.actualPurchaseAmount
          }
          return left.totalDemandAmount - right.totalDemandAmount
        })[0]
      }
      return summary || this.emptyQuoteAmountSummary()
    },
    quoteDisplayGroups() {
      const groups = {}
      ;((this.detail && this.detail.quoteList) || []).forEach((quote, index) => {
        const rawItemKey = quote.itemId || [
          quote.materialName,
          quote.specification,
          quote.materialQualityBrand,
          quote.quantity,
          quote.unit
        ].map(value => String(value || '').trim().toLowerCase()).join('|')
        const itemKey = quote.itemGroupNo || `legacy-item-${rawItemKey || index}`
        const key = quote.comparisonGroupNo || quote.itemGroupNo || `legacy-group-${rawItemKey || index}`
        if (!groups[key]) {
          groups[key] = {
            key,
            orderIndex: index,
            comparisonGroupNo: quote.comparisonGroupNo || '',
            comparisonGroupName: quote.comparisonGroupName || quote.itemGroupName || `报价组${Object.keys(groups).length + 1}`,
            sourceLayoutType: quote.sourceLayoutType || quote.layoutType || '',
            purchaseMode: 1,
            _hasStandardQuote: false,
            _hasEcommerceQuote: false,
            itemMap: {},
            supplierMap: {}
          }
        }
        const group = groups[key]
        if (!group.sourceLayoutType && (quote.sourceLayoutType || quote.layoutType)) {
          group.sourceLayoutType = quote.sourceLayoutType || quote.layoutType || ''
        }
        if (String(quote.purchasePlatform || '').trim()) {
          group._hasEcommerceQuote = true
        } else {
          group._hasStandardQuote = true
        }
        group.purchaseMode = group._hasEcommerceQuote && group._hasStandardQuote
          ? 3
          : (group._hasEcommerceQuote ? 2 : 1)
        if (!group.itemMap[itemKey]) {
          group.itemMap[itemKey] = {
            key: itemKey,
            orderIndex: index,
            itemGroupNo: quote.itemGroupNo || '',
            itemGroupName: quote.itemGroupName || this.quoteMaterialName(quote),
            itemId: quote.itemId || null,
            materialCode: quote.materialCode || '',
            materialName: quote.materialName || '真实采购项',
            specification: quote.specification || '',
            parameterValue: quote.parameterValue || '',
            materialQualityBrand: quote.materialQualityBrand || '',
            demandQuantity: quote.demandQuantity,
            inventoryQuantity: quote.inventoryQuantity,
            quantity: quote.quantity,
            unit: quote.unit || '',
            historyMinPrice: quote.historyMinPrice,
            historyMaxPrice: quote.historyMaxPrice,
            remark: quote.remark || '',
            offerMap: {}
          }
        }
        const supplierKey = quote.supplierId
          ? `id-${quote.supplierId}`
          : `name-${String(quote.purchasePlatform || '').trim().toLowerCase()}-${String(quote.supplierName || '').trim().toLowerCase()}`
        const offer = Object.assign({}, quote, {
          supplierName: quote.supplierName || '未标供应商',
          recommended: Number(quote.recommendedFlag) === 1,
          selected: Number(quote.selectedFlag) === 1,
          fileInfoList: quote.fileInfoList || []
        })
        group.itemMap[itemKey].offerMap[supplierKey] = offer
        if (!group.supplierMap[supplierKey]) {
          group.supplierMap[supplierKey] = {
            key: supplierKey,
            orderIndex: index,
            id: quote.id,
            quoteGroupNo: quote.quoteGroupNo || '',
            supplierId: quote.supplierId || null,
            supplierName: quote.supplierName || '未标供应商',
            purchasePlatform: quote.purchasePlatform || '',
            taxRate: quote.taxRate,
            deliveryDays: quote.deliveryDays,
            paymentCondition: quote.paymentCondition || '',
            selectionReason: quote.selectionReason || '',
            recommendationReason: quote.recommendationReason || '',
            fileInfoList: quote.fileInfoList || [],
            recommended: false,
            selected: false,
            finalTotalAmount: this.referenceMoneyValue(quote.finalTotalAmount),
            freightAmount: 0,
            detailTotalAmount: 0,
            demandQuantity: 0,
            actualPurchaseQuantity: 0,
            inventoryUseQuantity: 0,
            actualPurchaseAmount: 0,
            inventoryUseAmount: 0,
            totalDemandAmount: 0,
            actualPurchaseTotalAmount: 0,
            totalAmount: 0,
            lineList: []
          }
        }
        const supplier = group.supplierMap[supplierKey]
        supplier.recommended = supplier.recommended || offer.recommended
        supplier.selected = supplier.selected || offer.selected
        supplier.demandQuantity += this.positiveNumber(quote.demandQuantity)
        supplier.actualPurchaseQuantity += this.positiveNumber(quote.quantity)
        supplier.inventoryUseQuantity += this.quoteInventoryUseQuantity(quote)
        supplier.actualPurchaseAmount += this.quoteActualPurchaseAmount(quote, quote.quoteAmount)
        supplier.inventoryUseAmount += this.quoteInventoryUseAmount(quote)
        supplier.totalDemandAmount += this.quoteTotalDemandAmount(quote, quote.quoteAmount)
        supplier.detailTotalAmount += this.quoteActualPurchaseAmount(quote, quote.quoteAmount)
        supplier.freightAmount = Math.max(this.positiveAmount(supplier.freightAmount), this.positiveAmount(quote.freightAmount))
        if ((supplier.finalTotalAmount === undefined || supplier.finalTotalAmount === null) &&
            quote.finalTotalAmount !== undefined && quote.finalTotalAmount !== null) {
          supplier.finalTotalAmount = Number(quote.finalTotalAmount)
        }
        supplier.lineList.push(offer)
        if (!supplier.fileInfoList.length && offer.fileInfoList.length) supplier.fileInfoList = offer.fileInfoList
        if (!supplier.selectionReason && offer.selectionReason) supplier.selectionReason = offer.selectionReason
        if (!supplier.recommendationReason && offer.recommendationReason) supplier.recommendationReason = offer.recommendationReason
        if (!supplier.paymentCondition && offer.paymentCondition) supplier.paymentCondition = offer.paymentCondition
      })
      return Object.keys(groups).map(key => {
        const group = groups[key]
        group.items = Object.keys(group.itemMap)
          .map(itemKey => group.itemMap[itemKey])
          .sort((left, right) => Number(left.orderIndex || 0) - Number(right.orderIndex || 0))
        group.suppliers = Object.keys(group.supplierMap).map(supplierKey => {
          const supplier = group.supplierMap[supplierKey]
          supplier.detailTotalAmount = roundPurchaseMoney(Number(supplier.detailTotalAmount || 0))
          supplier.demandQuantity = Number(Number(supplier.demandQuantity || 0).toFixed(2))
          supplier.actualPurchaseQuantity = Number(Number(supplier.actualPurchaseQuantity || 0).toFixed(2))
          supplier.inventoryUseQuantity = Number(Number(supplier.inventoryUseQuantity || 0).toFixed(2))
          supplier.actualPurchaseAmount = roundPurchaseMoney(Number(supplier.actualPurchaseAmount || 0))
          supplier.inventoryUseAmount = roundPurchaseMoney(Number(supplier.inventoryUseAmount || 0))
          supplier.freightAmount = roundPurchaseMoney(Number(supplier.freightAmount || 0))
          supplier.actualPurchaseTotalAmount = roundPurchaseMoney(supplier.actualPurchaseAmount + supplier.freightAmount)
          supplier.detailTotalAmount = supplier.actualPurchaseTotalAmount
          supplier.totalDemandAmount = roundPurchaseMoney(Number(supplier.totalDemandAmount || 0) + supplier.freightAmount)
          const finalTotalAmount = this.referenceMoneyValue(supplier.finalTotalAmount)
          if (finalTotalAmount !== null && finalTotalAmount > 0) {
            supplier.totalAmount = roundPurchaseMoney(finalTotalAmount)
          } else {
            supplier.totalAmount = supplier.actualPurchaseTotalAmount
          }
          return supplier
        }).sort((left, right) => Number(left.orderIndex || 0) - Number(right.orderIndex || 0))
        group.offers = group.suppliers
        group.itemCount = group.items.length
        group.supplierCount = group.suppliers.length
        const decisionItems = group.items.filter(item => this.quoteItemRequiresDecision(item))
        decisionItems.forEach(item => {
          item.recommendedOffer = this.quoteDisplayItemOffers(group, item)
            .find(offer => offer.recommended) || null
        })
        group.decisionItemCount = decisionItems.length
        group.recommendedItemCount = decisionItems.filter(item => item.recommendedOffer).length
        group.suppliers.forEach(supplier => {
          supplier.recommendedItemCount = decisionItems.filter(item => {
            const offer = item.offerMap && item.offerMap[supplier.key]
            return offer && offer.recommended
          }).length
          supplier.recommended = supplier.recommendedItemCount > 0
          supplier.fullyRecommended = decisionItems.length > 0 &&
            supplier.recommendedItemCount === decisionItems.length
        })
        const fullyRecommendedSupplier = group.suppliers.find(supplier => supplier.fullyRecommended)
        const recommended = fullyRecommendedSupplier ||
          (group.recommendedItemCount === group.decisionItemCount && group.recommendedItemCount > 0
            ? { supplierName: '按采购项分别推荐', recommendationReason: '' }
            : null)
        const selected = group.suppliers.find(supplier => supplier.selected)
        group.recommendedSupplierName = recommended ? recommended.supplierName : ''
        group.recommendationReason = recommended ? recommended.recommendationReason : ''
        group.selectedSupplierName = selected ? selected.supplierName : ''
        const amountSupplier = selected || recommended || group.suppliers.slice().sort((left, right) => {
          if (left.actualPurchaseAmount !== right.actualPurchaseAmount) {
            return left.actualPurchaseAmount - right.actualPurchaseAmount
          }
          return left.totalDemandAmount - right.totalDemandAmount
        })[0] || null
        group.amountSummarySupplierName = amountSupplier ? amountSupplier.supplierName : ''
        group.demandQuantity = amountSupplier ? amountSupplier.demandQuantity : 0
        group.actualPurchaseQuantity = amountSupplier ? amountSupplier.actualPurchaseQuantity : 0
        group.inventoryUseQuantity = amountSupplier ? amountSupplier.inventoryUseQuantity : 0
        group.actualPurchaseAmount = amountSupplier ? amountSupplier.actualPurchaseAmount : 0
        group.inventoryUseAmount = amountSupplier ? amountSupplier.inventoryUseAmount : 0
        group.freightAmount = amountSupplier ? amountSupplier.freightAmount : 0
        group.totalDemandAmount = amountSupplier ? amountSupplier.totalDemandAmount : 0
        return group
      }).sort((left, right) => Number(left.orderIndex || 0) - Number(right.orderIndex || 0))
    },
    finalDecisionSupplierGroups() {
      return this.quoteDisplayGroups.reduce((result, group) => {
        ;(group.suppliers || []).forEach(supplier => {
          const selectedLines = (supplier.lineList || []).filter(line => line && line.selected)
          if (!selectedLines.length) return
          const allLinesSelected = selectedLines.length === (supplier.lineList || []).length
          const subtotal = allLinesSelected
            ? Number(supplier.totalAmount || supplier.actualPurchaseTotalAmount || 0)
            : selectedLines.reduce((sum, line) => sum + this.quoteActualPurchaseAmount(line, line.quoteAmount), 0)
          result.push({
            key: `${group.key}-${supplier.key}`,
            groupName: group.comparisonGroupName,
            supplierName: supplier.supplierName || '未标供应商',
            purchasePlatform: supplier.purchasePlatform || '',
            subtotal: roundPurchaseMoney(Number(subtotal || 0)),
            lines: selectedLines.map(line => ({
              id: line.id,
              materialName: line.materialName || '采购项',
              specification: line.specification || line.materialQualityBrand || '',
              quantity: line.quantity,
              unit: line.unit || '',
              unitPrice: line.quoteAmount,
              amount: this.quoteActualPurchaseAmount(line, line.quoteAmount)
            }))
          })
        })
        return result
      }, [])
    },
    finalDecisionTotalAmount() {
      const snapshot = Number(this.applyForm && this.applyForm.decisionAmount || 0)
      if (snapshot > 0) return snapshot
      return roundPurchaseMoney(this.finalDecisionSupplierGroups.reduce((sum, group) => sum + Number(group.subtotal || 0), 0))
    },
    approvalQuoteGroups() {
      return this.quoteDisplayGroups
    },
    approvalSelectedQuoteIds() {
      const seen = new Set()
      return this.approvalQuoteGroups.reduce((result, group) => {
        this.approvalQuoteIdsForGroup(group).forEach(quoteId => {
          const key = String(quoteId)
          if (!key || seen.has(key)) return
          seen.add(key)
          result.push(quoteId)
        })
        return result
      }, [])
    },
    approvalSelectedGroupCount() {
      return this.approvalQuoteGroups.filter(group => this.approvalGroupSelectionComplete(group)).length
    },
    approvalPassButtonText() {
      if (this.isPurchaseInquiryApprovalNode) return '完成询价'
      if (this.isSupplierDecisionApprovalNode) return '确认定商'
      if (this.isPurchaseCompletionApprovalNode) return '完成采购'
      return '通过'
    },
    applicationAttachmentFileObjs: {
      get() {
        const rows = ((this.applyForm && this.applyForm.attachmentList) || []).filter(item => {
          return Number(item.relationType || 1) === 1 && Number(item.attachmentType || 8) === 8
        })
        return rows.reduce((files, item) => files.concat(item.attachmentFileObjs || []), [])
      },
      set(files) {
        const keepRows = ((this.applyForm && this.applyForm.attachmentList) || []).filter(item => {
          return Number(item.relationType || 1) !== 1 || Number(item.attachmentType || 8) !== 8
        })
        const attachmentRow = {
          attachmentType: 8,
          relationType: 1,
          attachmentFileObjs: files || [],
          remark: ''
        }
        this.$set(this.applyForm, 'attachmentList', keepRows.concat([attachmentRow]))
      }
    },
    shouldShowApprovalFlowButton() {
      if (!this.isApplicationDetail || !this.applyForm || !this.applyForm.id) return false
      const status = Number(this.applyForm.status || 10)
      return (this.detail.approvalWorkOrder && this.detail.approvalWorkOrder.workOrderId) ||
        (this.detail.approvalRecordList || []).length > 0 ||
        status >= 20
    },
    canManageContractSection() {
      if (this.isFinanceProcurementRestrictedUser) return false
      if (!this.hasProcurementPermi('crm:procurement:contract')) return false
      if (!this.applyForm || !this.applyForm.id) return false
      if (!this.isSupplierOrderDetail) return false
      if (this.applyForm.parentApplyId) return false
      if (![50, 60].includes(this.applyStatusValue)) return false
      if (Number(this.applyForm.contractSealStatus || 10) === 20) return false
      if (Number(this.detailPaidAmount || 0) > 0) return false
      if ((this.detail.arrivalList || []).length > 0) return false
      return !this.hasPaymentExecutionRecord
    },
    isContractNotRequired() {
      const mode = this.contractEditing ? this.contractModeDraft : (this.applyForm && this.applyForm.contractMode)
      return Number(mode || 1) === 2
    },
    isBatchManagedSupplierOrder() {
      return this.isSupplierOrderDetail && !!(this.applyForm && this.applyForm.parentApplyId)
    },
    canEditContractSection() {
      return this.canManageContractSection && this.contractEditing
    },
    canManageShipment() {
      if (this.isFinanceProcurementRestrictedUser) return false
      return !!(this.applyForm && this.applyForm.id) &&
        this.isSupplierOrderDetail &&
        this.isCurrentUserPurchaser &&
        ![110, 120].includes(this.applyStatusValue) &&
        this.hasProcurementPermi('crm:procurement:quote')
    },
    hasPaymentExecutionRecord() {
      return (this.paymentPlanList || []).some(row => {
        const status = Number(row.status || 10)
        return [50, 60].includes(status) ||
          Number(row.paidAmount || 0) > 0 ||
          !!row.paymentTime ||
          !!row.paymentVoucherFileObjs ||
          !!row.invoiceFileObjs
      })
    },
    contractReadonlyTip() {
      if (!this.hasProcurementPermi('crm:procurement:contract')) return ''
      if (!this.isSupplierOrderDetail) return '合同信息仅在采购执行单中维护。'
      if (this.applyForm.parentApplyId) return '合同资料由采购申请主单整包批量维护，无需在执行单中手工编辑。'
      if ([110, 115, 120].includes(this.applyStatusValue)) return '采购单已完成、作废或线下结束，合同信息仅可查看。'
      if (Number(this.applyForm.contractSealStatus || 10) === 20) return '全部合同正在整包用章审批，当前合同不能修改。'
      if (Number(this.detailPaidAmount || 0) > 0 || this.hasPaymentExecutionRecord) return '已登记付款后，合同信息不能再修改。'
      if ((this.detail.arrivalList || []).length > 0) return '已登记到货后，合同信息不能再修改。'
      if (this.canManageContractSection && !this.contractEditing) return '合同信息当前为只读，点击“编辑合同信息”后可修改。'
      return '当前状态不能修改合同信息。'
    },
    canRegisterPayment() {
      return !!(this.applyForm && this.applyForm.id) &&
        this.isSupplierOrderDetail &&
        ![10, 20, 30, 120].includes(this.applyStatusValue) &&
        this.isContractStepComplete(this.applyForm) &&
        this.hasProcurementPermi('crm:procurement:finance')
    },
    canEditArrival() {
      if (this.isFinanceProcurementRestrictedUser) return false
      return !!(this.applyForm && this.applyForm.id) &&
        this.isSupplierOrderDetail &&
        ![10, 20, 30, 110, 120].includes(this.applyStatusValue) &&
        this.hasProcurementPermi('crm:procurement:arrival')
    },
    canEditExistingArrival() {
      if (this.isFinanceProcurementRestrictedUser) return false
      return !!(this.applyForm && this.applyForm.id) &&
        this.isSupplierOrderDetail &&
        ![10, 20, 30, 120].includes(this.applyStatusValue) &&
        this.hasProcurementPermi('crm:procurement:arrival')
    },
    canEditArrivalForm() {
      return this.canEditArrival || (this.arrivalEditingExisting && this.canEditExistingArrival)
    },
    inlineOrderTitle() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      if (!this.inlineOrder || !this.inlineOrder.open) return ''
      return `${form.applyNo || '采购执行单'}${form.supplierName ? ' · ' + form.supplierName : ''}`
    },
    inlineOrderStatusCards() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      return [
        { key: 'payment', label: '付款', value: this.paymentStatusText(form.paymentStatus) },
        { key: 'arrival', label: '到货', value: this.arrivalStatusText(form.arrivalStatus) },
        { key: 'amount', label: '金额', value: this.money(form.applyAmount) }
      ]
    },
    inlineOrderPaymentContext() {
      const order = this.inlineOrder || {}
      const form = order.applyForm || {}
      const contract = order.contractForm || {}
      const plans = order.paymentPlanList || []
      const payableAmount = plans.reduce((sum, row) => sum + Number(row.payableAmount || 0), 0)
      const paidAmount = plans.reduce((sum, row) => sum + Number(row.paidAmount || 0), 0)
      return [
        { key: 'order', label: '采购单号', value: form.applyNo },
        { key: 'supplier', label: '供应商', value: form.supplierName || contract.supplierName || contract.partyB },
        { key: 'contractNo', label: '采购合同号', value: contract.contractNo || form.contractNum },
        { key: 'contractName', label: '合同名称', value: contract.contractName || form.applyTitle },
        { key: 'amount', label: '合同金额', value: this.money(contract.contractAmount || form.applyAmount) },
        { key: 'paid', label: '已付/应付', value: `${this.money(paidAmount)} / ${this.money(payableAmount || form.applyAmount)}` }
      ]
    },
    inlineOrderPaymentRiskTip() {
      const order = this.inlineOrder || {}
      const form = order.applyForm || {}
      const contract = order.contractForm || {}
      if (!form.supplierName && !contract.supplierName && !contract.partyB) return '供应商为空，请先补齐合同供应商后再登记付款。'
      if (!contract.contractNo && !form.contractNum && !form.parentApplyId) return '采购合同号为空，建议补齐后再登记付款，便于财务核对。'
      return ''
    },
    inlinePaymentNodeContext() {
      const order = this.inlineOrder || {}
      const form = order.applyForm || {}
      const contract = order.contractForm || {}
      const plan = order.paymentPlan || {}
      return [
        { key: 'supplier', label: '供应商', value: form.supplierName || contract.supplierName || contract.partyB },
        { key: 'contractNo', label: '合同号', value: contract.contractNo || form.contractNum },
        { key: 'node', label: '付款方式', value: plan.nodeName || '直接付款登记' },
        { key: 'payable', label: '应付', value: this.money(plan.payableAmount || form.applyAmount) },
        { key: 'unpaid', label: '未付', value: this.money(plan.unpaidAmount || form.unpaidAmount || plan.payableAmount || form.applyAmount) }
      ]
    },
    inlineOrderHasPaymentExecutionRecord() {
      return ((this.inlineOrder && this.inlineOrder.paymentPlanList) || []).some(row => {
        const status = Number(row.status || 10)
        return [50, 60].includes(status) ||
          Number(row.paidAmount || 0) > 0 ||
          !!row.paymentTime ||
          !!row.paymentVoucherFileObjs ||
          !!row.invoiceFileObjs
      })
    },
    inlineOrderContractEditable() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      const detail = (this.inlineOrder && this.inlineOrder.detail) || {}
      if (!this.inlineOrder || !this.inlineOrder.open) return false
      if (!this.hasProcurementPermi('crm:procurement:contract')) return false
      if (!form.id || Number(form.documentType || 2) !== 2) return false
      if (form.parentApplyId) return false
      if (![50, 60].includes(Number(form.status || 10))) return false
      if (Number(form.contractSealStatus || 10) === 20) return false
      if (Number(detail.paidAmount || form.paidAmount || 0) > 0) return false
      if ((detail.arrivalList || []).length > 0) return false
      return !this.inlineOrderHasPaymentExecutionRecord
    },
    inlineOrderCanRegisterPayment() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      if (!this.inlineOrder || !this.inlineOrder.open) return false
      return !!form.id &&
        Number(form.documentType || 2) === 2 &&
        ![10, 20, 30, 110, 120].includes(Number(form.status || 10)) &&
        this.isContractStepComplete(form) &&
        this.hasProcurementPermi('crm:procurement:finance')
    },
    inlineOrderCanEditArrival() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      if (!this.inlineOrder || !this.inlineOrder.open) return false
      return !!form.id &&
        Number(form.documentType || 2) === 2 &&
        ![10, 20, 30, 110, 120].includes(Number(form.status || 10)) &&
        this.hasProcurementPermi('crm:procurement:arrival')
    },
    inlineOrderArrivalRows() {
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      const detail = (this.inlineOrder && this.inlineOrder.detail) || {}
      return this.buildArrivalProgressRows(form, detail)
    },
    inlineOrderSelectedArrivalProgress() {
      const form = (this.inlineOrder && this.inlineOrder.arrivalForm) || {}
      return this.inlineOrderArrivalRows.find(row => {
        if (form.itemId && row.itemId && String(form.itemId) === String(row.itemId)) return true
        return this.arrivalRecordMatchesItem(row.item, form)
      }) || null
    },
    inlineOrderSelectedArrivalUnit() {
      return this.inlineOrderSelectedArrivalProgress && this.inlineOrderSelectedArrivalProgress.item ? this.inlineOrderSelectedArrivalProgress.item.unit : ''
    },
    inlineOrderPredictedArrivalRemaining() {
      const form = (this.inlineOrder && this.inlineOrder.arrivalForm) || {}
      return Math.max(Number(form.quantity || 0) - Number(form.arrivedQuantity || 0), 0)
    },
    inlineOrderPredictedArrivalStatusText() {
      const form = (this.inlineOrder && this.inlineOrder.arrivalForm) || {}
      return this.arrivalStatusText(this.inferArrivalStatusCode(form))
    },
    arrivalItemProgressRows() {
      return this.buildArrivalProgressRows(this.applyForm, this.detail)
    },
    selectedArrivalProgress() {
      const form = this.arrivalForm || {}
      return this.arrivalItemProgressRows.find(row => {
        if (form.itemId && row.itemId && String(form.itemId) === String(row.itemId)) return true
        return this.arrivalRecordMatchesItem(row.item, form)
      }) || null
    },
    selectedArrivalUnit() {
      return this.selectedArrivalProgress && this.selectedArrivalProgress.item ? this.selectedArrivalProgress.item.unit : ''
    },
    predictedArrivalRemaining() {
      const form = this.arrivalForm || {}
      return Math.max(Number(form.quantity || 0) - Number(form.arrivedQuantity || 0), 0)
    },
    predictedArrivalStatusText() {
      const form = this.arrivalForm || {}
      return this.arrivalStatusText(this.inferArrivalStatusCode(form))
    },
    canAddPurchaseGroupMember() {
      return Boolean(this.applyForm && this.applyForm.id && this.detail && this.detail.canAddGroupMemberFlag)
    },
    totalApplyAmount() {
        const itemAmount = (this.applyForm.itemList || []).reduce((total, item) => total + Number(item.amount || 0), 0)
        const feeAmount = this.isSupplierOrderDetail
          ? this.positiveAmount(this.applyForm.freightAmount) + this.positiveAmount(this.applyForm.otherFeeAmount)
          : 0
      return roundPurchaseMoney(itemAmount + feeAmount)
    },
    recognizedItemCount() {
      return (this.applyForm.itemList || []).filter(item => item.materialName).length
    },
    recognizedPaymentPlanCount() {
      return (this.contractPaymentPlanList || []).filter(item => item.nodeName).length
    },
    aiScopeOptions() {
      const allowed = this.aiAllowedScopeValues && this.aiAllowedScopeValues.length
        ? this.aiAllowedScopeValues
        : this.defaultAiScopeValues()
      return [
        { label: '基本信息', value: 'basic' },
        { label: '合同信息', value: 'contract' },
        { label: '采购清单', value: 'items' },
        { label: '付款条款', value: 'payment' }
      ].filter(item => allowed.includes(item.value))
    },
    aiDialogTitle() {
      if (this.isSupplierOrderDetail || this.recognitionFillMode === 'contract') return 'AI录入采购执行单'
      return 'AI录入采购申请'
    },
    aiSourceTextPlaceholder() {
      if (this.recognitionFillMode === 'apply') {
        return '也可以粘贴采购需求、物料清单或技术要求'
      }
      return '也可以粘贴合同正文、报价清单或付款条款'
    },
    aiMultiFileTip() {
      if (this.recognitionFillMode === 'apply') {
        return `已选择 ${this.aiRecognitionForm.fileInfoList.length} 个文件，将按文件识别后合并采购需求；供应商和实际价格不会填入采购申请。`
      }
      return `已选择 ${this.aiRecognitionForm.fileInfoList.length} 个文件，将按文件并发识别后合并合同资料。`
    },
    recognitionProcessSteps() {
      if (this.recognitionFillMode === 'apply') {
        return [
          { key: 'file', title: '读取需求资料', icon: 'el-icon-folder-opened' },
          { key: 'structure', title: '理解表格结构', icon: 'el-icon-s-grid' },
          { key: 'items', title: '提取需求明细', icon: 'el-icon-magic-stick' },
          { key: 'validate', title: '校验并合并', icon: 'el-icon-finished' },
          { key: 'preview', title: '生成预览', icon: 'el-icon-view' }
        ]
      }
      return [
        { key: 'file', title: '读取合同资料', icon: 'el-icon-folder-opened' },
        { key: 'render', title: '解析合同页面', icon: 'el-icon-picture-outline' },
        { key: 'model', title: '提取合同信息', icon: 'el-icon-magic-stick' },
        { key: 'validate', title: '校验识别结果', icon: 'el-icon-finished' },
        { key: 'preview', title: '生成预览', icon: 'el-icon-view' }
      ]
    },
    aiRecognizedSummary() {
      const result = this.aiRecognizedResult || {}
      return {
        supplierName: this.recognizedSupplierCandidates(result).join('、'),
        contractAmount: result.contractAmount
      }
    },
    aiSummaryCards() {
      const cards = []
      const supplierCandidates = this.recognizedSupplierCandidates(this.aiRecognizedResult || {})
      if (this.aiScopeVisible('contract') && this.isSupplierOrderDetail) {
        cards.push({
          key: 'supplier',
          label: this.shouldShowSupplierInputColumn ? '供应商' : '候选供应商',
          value: supplierCandidates.length > 1 ? `${supplierCandidates.length}家` : (supplierCandidates[0] || '-'),
          title: supplierCandidates.join('、')
        })
        cards.push({ key: 'amount', label: '合同金额', value: this.money(this.aiRecognizedSummary.contractAmount) })
      } else if (supplierCandidates.length && this.isSupplierOrderDetail) {
        cards.push({
          key: 'supplierCandidates',
          label: '候选供应商',
          value: supplierCandidates.length > 1 ? `${supplierCandidates.length}家` : supplierCandidates[0],
          title: supplierCandidates.join('、')
        })
      }
      if (this.aiScopeVisible('items')) cards.push({ key: 'items', label: '明细', value: String(this.aiRecognizedItemRows.length) })
      if (this.aiScopeVisible('payment')) cards.push({ key: 'payment', label: '付款', value: String(this.aiRecognizedPaymentRows.length) })
      if (!cards.length) cards.push({ key: 'empty', label: '结果', value: '-' })
      return cards
    },
    aiRecognizedItemRows() {
      return this.aiRecognizedResult ? this.toObjectArray(this.aiRecognizedResult.itemList) : []
    },
    aiRecognizedItemHasSource() {
      return this.aiRecognizedItemRows.some(row => row && row._sourceFileName)
    },
    aiRecognizedPaymentRows() {
      return this.aiRecognizedResult ? this.toObjectArray(this.aiRecognizedResult.paymentPlanList) : []
    },
    aiRecognitionReviewItems() {
      if (!this.aiRecognizedResult) return []
      return this.buildRecognitionReviewItems(this.aiRecognizedResult)
    },
    recognitionReviewItems() {
      if (!this.contractForm || !this.contractForm.recognitionJson) return []
      return this.buildRecognitionReviewItems({
        supplierName: this.contractForm.supplierName,
        partyB: this.contractForm.partyB,
        contractAmount: this.contractForm.contractAmount,
        itemList: this.applyForm.itemList || [],
        paymentPlanList: this.contractPaymentPlanList || []
      })
    },
    applyQueueOptions() {
      return [
        { key: 'draft', label: '申请待提交', desc: '草稿采购申请' },
        { key: 'approval', label: '待我审批', desc: '当前账号需要审批的采购申请' },
        { key: 'payment', label: '待付款', desc: '采购登记付款和凭证' },
        { key: 'arrival', label: '待到货验收', desc: '仓管登记到货和验收资料' },
        { key: 'todo', label: '待处理事项', desc: '存在待办动作的采购事项' },
        { key: 'paid', label: '已付款执行单', desc: '已有付款记录的采购执行单' },
        { key: 'unpaid', label: '未付款执行单', desc: '仍有未付余额的采购执行单' },
        { key: 'supplierConfirmation', label: '待确认供应商', desc: '审批通过后确认供应商并生成执行单' },
        { key: 'sourcing', label: '待补价格依据', desc: '草稿或退回状态可补充历史价、报价或说明' }
      ]
    },
    activeQueueLabel() {
      const queue = this.applyQueueOptions.find(item => item.key === this.queryParams.queue)
      return queue ? queue.label : ''
    },
    workbenchQueueStats() {
      const rows = this.applyList || []
      const workbench = this.workbench || {}
      const hasServerStats = ['totalCount', 'draftCount', 'pendingApprovalCount', 'missingContractCount', 'paymentPendingCount', 'arrivalPendingCount', 'todoCount'].some(key => typeof workbench[key] !== 'undefined' && workbench[key] !== null)
      if (hasServerStats) {
        return {
          totalCount: Number(workbench.totalCount || 0),
          draftCount: Number(workbench.draftCount || 0),
          pendingApprovalCount: Number(workbench.pendingApprovalCount || 0),
          supplierTodoCount: Number(workbench.supplierTodoCount || 0),
          contractPendingCount: Number(workbench.missingContractCount || 0),
          paymentPendingCount: Number(workbench.paymentPendingCount || 0),
          arrivalPendingCount: Number(workbench.arrivalPendingCount || 0),
          todoCount: Number(workbench.todoCount || 0)
        }
      }
      const pick = queue => rows.filter(row => this.applyMatchesQueue(row, queue))
      const uniqueTodoIds = new Set([].concat(
        pick('draft'),
        pick('approval'),
        pick('contract'),
        pick('payment'),
        pick('arrival')
      ).map(row => row.id))
      return {
        totalCount: rows.length,
        draftCount: pick('draft').length,
        pendingApprovalCount: pick('approval').length,
        contractPendingCount: pick('contract').length,
        paymentPendingCount: pick('payment').length,
        arrivalPendingCount: pick('arrival').length,
        todoCount: uniqueTodoIds.size
      }
    },
    dashboardTasks() {
      const stats = this.workbenchQueueStats
      return [
        { key: 'draftCount', label: '申请待提交', value: stats.draftCount, queue: 'draft', tab: 'apply', desc: '补齐资料后提交审批' },
        { key: 'pendingApprovalCount', label: '待我审批', value: stats.pendingApprovalCount, queue: 'approval', tab: 'apply', desc: '当前节点需要你审批' },
        { key: 'supplierTodoCount', label: '待确认供应商', value: stats.supplierTodoCount, queue: 'supplierConfirmation', tab: 'apply', desc: '确认供应商并生成采购执行单' },
        { key: 'paymentPendingCount', label: '待付款', value: stats.paymentPendingCount, queue: 'payment', tab: 'order', desc: '采购登记付款金额' },
        { key: 'arrivalPendingCount', label: '待到货验收', value: stats.arrivalPendingCount, queue: 'arrival', tab: 'order', desc: '仓管登记到货和验收' }
      ].filter(item => Number(item.value || 0) > 0 && (item.queue !== 'payment' || this.canReceivePurchasePaymentTodo))
    },
    visibleTodoCount() {
      if (this.workbench && this.workbench.todoCount !== undefined && this.workbench.todoCount !== null) {
        return Number(this.workbench.todoCount || 0)
      }
      return this.dashboardTasks.reduce((sum, item) => sum + Number(item.value || 0), 0)
    },
    dashboardQuickHint() {
      const canFinance = this.canReceivePurchasePaymentTodo
      const canArrival = this.hasProcurementPermi('crm:procurement:arrival')
      const canApprove = this.hasProcurementPermi('crm:procurement:approve')
      if (canFinance && canArrival) return '付款和到货会优先显示，点卡片进入自己的待办。'
      if (canFinance) return '采购优先处理待付款执行单，点卡片进入付款队列。'
      if (canArrival) return '仓管优先处理待到货验收，点卡片进入到货队列。'
      if (canApprove) return '审批人优先处理待我审批，点卡片查看需要决策的申请。'
      return '与当前账号相关的待办会优先显示。'
    },
    dashboardProcessSteps() {
      return [
        { key: 'apply', label: '采购申请', desc: '需求、预算、历史价格参考', icon: 'el-icon-document' },
        { key: 'approval', label: '审批流', desc: '部门负责人、仓管员、项目技术负责人、大额总经理', icon: 'el-icon-finished' },
        { key: 'order', label: '采购执行单', desc: '审批后按供应商或电商店铺生成', icon: 'el-icon-s-order' },
        { key: 'fulfillment', label: '付款到货', desc: '采购登记付款，仓管逐项登记到货', icon: 'el-icon-box' }
      ]
    },
    workbenchCards() {
      const personal = this.activeTab === 'dashboard'
      const cards = [
        { key: 'totalCount', label: personal ? '我的采购申请' : '采购申请总数', value: this.workbench.totalCount == null ? '—' : this.workbench.totalCount, tab: 'apply' },
        { key: 'todoCount', label: '我的待处理', value: this.workbench.todoCount == null ? '—' : this.visibleTodoCount, queue: 'todo', tab: 'todo' },
        { key: 'applyAmount', label: personal ? '我的申请金额' : '申请金额', value: this.workbenchMoney(this.workbench.applyAmount), tab: 'apply' }
      ]
      if (this.canAccessPurchaseSensitive) cards.push({ key: 'supplierCount', label: '公司供应商库', value: this.loading.supplier ? '—' : this.supplierTotal, routePath: '/procurement/supplier' })
      return cards
    },
    recentApplyList() {
      return (this.applyList || []).slice(0, 8)
    },
    reportTotalAmount() {
      return (this.applyList || []).reduce((sum, row) => sum + Number(row.applyAmount || 0), 0)
    },
    reportPaidAmount() {
      if (this.workbench && this.workbench.paidAmount !== undefined && this.workbench.paidAmount !== null) {
        return Number(this.workbench.paidAmount || 0)
      }
      return (this.applyList || []).reduce((sum, row) => sum + Number(row.paidAmount || 0), 0)
    },
    reportUnpaidAmount() {
      if (this.workbench && this.workbench.unpaidAmount !== undefined && this.workbench.unpaidAmount !== null) {
        return Number(this.workbench.unpaidAmount || 0)
      }
      return (this.applyList || []).reduce((sum, row) => sum + Number(row.unpaidAmount || 0), 0)
    },
    statusReportRows() {
      return (this.workbench.applicationStatuses || []).map(row => ({
        status: row.status, count: row.count, amount: row.amount, label: this.statusText(row.status)
      })).sort((a, b) => Number(a.status) - Number(b.status))
    },
    supplierReportRows() {
      return (this.supplierList || []).filter(row => Number(row.cumulativePurchaseAmount || 0) > 0)
        .slice().sort((a, b) => Number(b.cumulativePurchaseAmount || 0) - Number(a.cumulativePurchaseAmount || 0))
    },
    displayApplyList() {
      return this.applyList || []
    },
    pagedApplyList() {
      return this.displayApplyList
    },
    applyListSummaryText() {
      const parts = []
      if (this.activeQueueLabel) parts.push(this.activeQueueLabel)
      if (this.queryParams.status) parts.push(this.statusText(this.queryParams.status))
      if (this.queryParams.purchaseType) parts.push(this.purchaseTypeText(this.queryParams.purchaseType))
      if (this.queryParams.keyword) parts.push(`关键词：${this.queryParams.keyword}`)
      parts.push(`共 ${this.applyTotal} 条`)
      return parts.join(' · ')
    },
    detailPaidAmount() {
      const supplierOrders = this.isApplicationDetail ? (this.detail.supplierOrderList || []) : []
      if (supplierOrders.length) {
        return supplierOrders.reduce((sum, row) => sum + Number(row.paidAmount || 0), 0)
      }
      return this.applyForm.paidAmount
    },
    detailUnpaidAmount() {
      const supplierOrders = this.isApplicationDetail ? (this.detail.supplierOrderList || []) : []
      if (supplierOrders.length) {
        return supplierOrders.reduce((sum, row) => sum + Number(row.unpaidAmount || 0), 0)
      }
      return this.applyForm.unpaidAmount
    },
    supplierOptions() {
      const map = new Map()
      ;(this.supplierReferenceList || []).concat(this.supplierList || []).forEach(item => {
        if (item && item.id && Number(item.status || 1) === 1 && !map.has(item.id)) {
          map.set(item.id, item)
        }
      })
      return Array.from(map.values())
    },
    directOrderAmount() {
      const total = (this.directOrderForm && this.directOrderForm.itemList ? this.directOrderForm.itemList : [])
        .reduce((sum, item) => sum + this.directOrderItemRawAmount(item), 0)
      return this.roundMoneyValue(total)
    },
    purchaseTypeOptionGroups() {
      const groups = [
        { label: '项目采购', options: [] },
        { label: '非项目采购', options: [] },
        { label: '项目/非项目采购均可', options: [] }
      ]
      ;(this.purchaseTypeOptions || []).forEach(item => {
        const target = groups.find(group => group.label === item.group) || groups[1]
        target.options.push(item)
      })
      return groups.filter(group => group.options.length)
    },
    isQuoteSnapshotMode() {
      return this.isApplicationDetail && this.applyForm && this.applyForm.id && ![10, 30].includes(Number(this.applyForm.status || 10))
    },
    quoteRecommendationRows() {
      return (this.applyForm.itemList || [])
        .map((item, index) => ({ item, index }))
        .filter(row => row.item && row.item.materialName && this.isActualPurchaseRow(row.item))
        .sort((left, right) => this.compareApplyItemOrder(left.item, right.item, left.index, right.index))
        .map((row, index) => this.buildQuoteRecommendationRow(row.item, index))
    },
    approvalItemRows() {
      return (this.applyForm.itemList || [])
        .map((item, index) => ({ item, index }))
        .filter(row => row.item && row.item.materialName)
        .sort((left, right) => this.compareApplyItemOrder(left.item, right.item, left.index, right.index))
        .map(({ item, index }) => {
          const quantity = this.referenceNumberValue(item.quantity) || 0
          const unitPrice = this.referenceUnitPriceValue(item.purchaseUnitPrice)
          const amount = this.referenceMoneyValue(item.amount) || (unitPrice !== null && quantity ? roundPurchaseMoney(unitPrice * quantity) : 0)
          const history = this.approvalHistoryForItem(item)
          return {
            key: item.id || item.sortNo || `${item.materialName}-${index}`,
            materialName: item.materialName,
            specification: item.specification,
            materialQualityBrand: item.materialQualityBrand,
            quantity,
            unit: item.unit,
            unitPrice,
            amount,
            history
          }
        })
    },
    quoteSummaryCards() {
      const rows = this.quoteRecommendationRows
      return [
        { key: 'item', label: '采购明细', value: rows.length },
        { key: 'confirmed', label: '已定商', value: rows.filter(row => this.quoteRowSupplierConfirmed(row)).length },
        { key: 'history', label: '有价格依据', value: rows.filter(item => item.historyRecords.length || item.recommendUnitPrice !== null).length },
        { key: 'risk', label: '需关注', value: rows.filter(item => item.riskLevel !== 'ok').length }
      ]
    },
    quoteRiskItems() {
      const rows = this.quoteRecommendationRows
      const risks = []
      const selectedRows = rows.filter(row => this.quoteRowSupplierConfirmed(row))
      const highPrice = rows.filter(item => item.riskLevel === 'high').length
      const missingSpec = rows.filter(item => item.riskLevel === 'spec').length
      if (!selectedRows.length) risks.push('尚未选择真实采购清单的拟定供应商')
      if (highPrice) risks.push(`${highPrice}条价格高于历史参考价`)
      if (missingSpec) risks.push(`${missingSpec}条明细规格不完整`)
      if (!rows.length) risks.push('采购需求明细为空，无法形成价格依据')
      return risks
    },
    approvalSummaryCards() {
      return [
        { key: 'type', label: '采购类型', value: this.purchaseTypeText(this.applyForm.purchaseType) },
        { key: 'amount', label: '采购金额', value: this.applicationAmountText(this.applyForm) },
        { key: 'items', label: '明细数量', value: `${this.approvalItemRows.length} 条` },
        { key: 'quote', label: '审批结论', value: this.approvalConclusionText }
      ]
    },
    approvalConclusionText() {
      const status = Number(this.applyForm.status || 10)
      if (status === 40 || status === 50 || status === 60 || status === 70 || status === 80 || status === 90 || status === 100 || status === 110) return '已通过'
      if (status === 30) return '已退回'
      if (status === 120) return '已作废'
      if (status === 115) return '线下已结束'
      return this.approvalRiskItems.length ? '需关注后审批' : '可审批'
    },
    approvalAdvice() {
      const role = this.currentApprovalRoleName()
      const amount = this.referenceMoneyValue(this.applyForm.applyAmount || this.totalApplyAmount) || 0
      const overBudget = this.applyForm.budgetAmount && amount > Number(this.applyForm.budgetAmount || 0)
      const roleAdviceMap = {
        department: '重点看采购需求是否清楚、到货时间是否满足业务需要；明细无明显异常时可通过。',
        warehouse: '重点看物料名称、规格型号、单位和数量是否清楚，后续能否按明细验收到货；规格不清或单位不准建议退回补充。',
        technical: '重点看项目采购是否匹配关联合同和技术要求，规格型号是否满足项目使用场景；技术口径清楚后再通过。',
        manager: '重点查看采购员提交的多家报价和推荐意见，并确定最终供应商。',
        default: '重点看物料、规格型号、数量和历史价格参考；信息清楚且风险可接受时可通过。'
      }
      const tips = this.approvalRiskItems.slice()
      if (overBudget) tips.push('申请金额超过预算')
      if (!tips.length) tips.push('关键信息基本完整')
      return {
        roleKey: role.key,
        roleLabel: role.label,
        conclusion: roleAdviceMap[role.key] || roleAdviceMap.default,
        tips
      }
    },
    approvalFactItems() {
      const items = [
        { label: '采购金额', value: this.applicationAmountText(this.applyForm) },
        { label: '明细数量', value: `${(this.applyForm.itemList || []).filter(item => item && item.materialName).length} 条` }
      ]
      if (this.positiveAmount(this.applyForm.estimatedFreightAmount) || this.positiveAmount(this.applyForm.estimatedOtherFeeAmount)) {
        items.push({
          label: '预计费用',
          value: `运费 ${this.money(this.applyForm.estimatedFreightAmount)}；其他 ${this.money(this.applyForm.estimatedOtherFeeAmount)}`
        })
      }
      if (this.isProjectPurchase) {
        items.push({ label: '项目/用途', value: this.applyForm.projectName || this.applyForm.projectCode || '-' })
        items.push({ label: '关联合同', value: this.applyForm.contractNum || '-' })
      }
      if (this.applyForm.purchaseReason) {
        items.push({ label: '采购原因', value: this.applyForm.purchaseReason })
      }
      return items
    },
    approvalRiskItems() {
      const status = Number(this.applyForm.status || 10)
      if (![10, 20, 30].includes(status)) return []
      const risks = []
      const missingSpecCount = this.approvalItemRows.filter(item => !item.specification).length
      const missingHistoryCount = this.approvalItemRows.filter(item => !item.history || !item.history.hasHistory).length
      if (this.isProjectPurchase && !this.applyForm.contractId) risks.push('工程项目采购未关联合同')
      if (missingSpecCount) risks.push(`${missingSpecCount}条明细规格待确认`)
      if (missingHistoryCount) risks.push(`${missingHistoryCount}条暂无历史参考价`)
      return risks
    },
    selectedQuoteSupplierName() {
      const quote = (this.detail.quoteList || []).find(item => Number(item.selectedFlag) === 1)
      return quote ? quote.supplierName : ''
    },
    workflowMenus() {
      return [
        {
          key: 'dashboard',
          label: '工作台',
          desc: '待办、录入、概览',
          value: this.workbench.totalCount || 0,
          icon: 'el-icon-menu',
          tab: 'dashboard'
        },
        {
          key: 'apply',
          label: '采购申请',
          desc: '需求、预算、审批',
          value: this.workbench.totalCount || 0,
          icon: 'el-icon-s-order',
          tab: 'apply'
        },
        {
          key: 'order',
          label: '采购执行单',
          desc: '合同、付款、到货验收',
          value: (this.applyList || []).filter(item => Number(item.documentType) === 2).length,
          icon: 'el-icon-document-checked',
          tab: 'order'
        },
        {
          key: 'sourcing',
          label: '价格依据',
          desc: '历史价、报价、定商说明',
          value: this.workbenchQueueStats.draftCount || 0,
          icon: 'el-icon-s-check',
          tab: 'apply',
          queue: 'sourcing'
        },
        {
          key: 'approval',
          label: '审批中心',
          desc: '部门负责人、仓管员、技术负责人',
          value: this.workbenchQueueStats.pendingApprovalCount || 0,
          icon: 'el-icon-finished',
          tab: 'apply',
          queue: 'approval'
        },
        {
          key: 'payment',
          label: '付款记录',
          desc: '付款金额、未付余额',
          value: this.workbenchQueueStats.paymentPendingCount || 0,
          icon: 'el-icon-bank-card',
          tab: 'order',
          queue: 'payment'
        },
        {
          key: 'receipts',
          label: '到货验收',
          desc: '到货验收、验收资料',
          value: this.workbenchQueueStats.arrivalPendingCount || 0,
          icon: 'el-icon-box',
          tab: 'order',
          queue: 'arrival'
        },
        {
          key: 'supplier',
          label: '供应商库',
          desc: '档案、采购统计、余额',
          value: this.supplierTotal || this.supplierList.length || 0,
          icon: 'el-icon-office-building',
          tab: 'supplier'
        },
        {
          key: 'price',
          label: '价格库',
          desc: '已定商最终价、来源采购单',
          value: this.priceTotal || this.priceList.length || 0,
          icon: 'el-icon-data-analysis',
          tab: 'price'
        },
        {
          key: 'report',
          label: '采购报表',
          desc: '金额、状态、供应商',
          value: this.workbench.totalCount || 0,
          icon: 'el-icon-pie-chart',
          tab: 'report'
        }
      ].filter(item => item.key !== 'price' || this.canAccessPurchasePrice)
    },
    recognitionActiveStep() {
      const stage = this.recognitionStage
      if (stage === 'EXTRACT_TEXT') return 0
      if (stage === 'RENDER_DOCUMENT' || stage === 'OCR_CONTRACT') return 1
      if (stage && stage.indexOf('CALL_QWEN') === 0) return 2
      if (stage === 'PARSE_RESULT' || stage === 'VALIDATE_RESULT') return 3
      if (stage === 'SAVE_RESULT' || stage === 'BUILD_DETAIL') return 4
      if (stage === 'DONE') return 5
      return stage ? 0 : -1
    },
    recognitionMeta() {
      if (!this.contractForm || !this.contractForm.recognitionJson) return {}
      try {
        return JSON.parse(this.contractForm.recognitionJson) || {}
      } catch (e) {
        return {}
      }
    },
    recognitionModelText() {
      return this.recognitionFillMode === 'apply' ? '采购需求识别' : '供应商合同识别'
    },
    recognitionStageText() {
      if (this.recognitionStage === 'ERROR') return '识别失败'
      if (this.recognizingContract) return '识别中'
      if (this.aiEntryOpen && !this.aiRecognizedResult) return '待识别'
      if (this.aiRecognizedResult) return '已识别待填入'
      if (this.contractForm && this.contractForm.recognitionJson) return '已回填待复核'
      return '待识别'
    },
    recognitionDisplayMessage() {
      return this.cleanRecognitionMessage(this.recognitionMessage)
    },
    recognitionStageDetailText() {
      if (this.recognizingContract) return '处理中'
      if (this.recognitionStage === 'DONE') return '识别完成'
      if (this.recognitionStage === 'ERROR') return '识别失败'
      return this.recognitionModelText
    },
    recognitionModelSubSteps() {
      const elapsed = this.recognitionElapsedSeconds || 0
      const progress = Number(this.recognitionProgress || 0)
      const activeIndex = this.recognitionStage === 'CALL_QWEN_MERGE' || this.recognitionStage === 'PARSE_RESULT'
        ? 3
        : (this.recognitionStage === 'VALIDATE_RESULT' || this.recognitionStage === 'DONE'
          ? 4
          : Math.min(3, Math.floor(elapsed / 3)))
      const steps = this.recognitionFillMode === 'apply'
        ? [
          { key: 'structure', title: '识别栏目层级' },
          { key: 'material', title: '提取物料信息' },
          { key: 'quantity', title: '提取规格数量' },
          { key: 'merge', title: '合并需求明细' }
        ]
        : [
          { key: 'vision', title: '理解合同页面' },
          { key: 'fields', title: '提取合同字段' },
          { key: 'payment', title: '提取付款条款' },
          { key: 'merge', title: '合并识别结果' }
        ]
      return steps.map((step, index) => {
        let state = index < activeIndex ? 'done' : (index === activeIndex ? 'active' : 'wait')
        if (progress >= 88) state = 'done'
        return Object.assign({}, step, { state })
      })
    },
    textExtractionModeText() {
      const mode = this.recognitionMeta.textExtractionMode
      if (!mode) return '-'
      if (mode.indexOf('DIRECT_PDF_PAGE_IMAGE') > -1) return 'PDF识别'
      if (mode.indexOf('DIRECT_IMAGE') > -1) return '图片识别'
      if (mode.indexOf('PDF_PAGE_IMAGE_OCR') > -1) return 'PDF识别'
      if (mode.indexOf('IMAGE_OCR') > -1) return '图片识别'
      if (mode.indexOf('FILE_TEXT') > -1) return '文件文本'
      if (mode === 'MANUAL_TEXT') return '粘贴文本'
      return mode
    },
    recognitionConfidenceText() {
      const result = this.recognitionMeta.result || {}
      const value = result.confidence
      if (value === undefined || value === null || value === '') return '-'
      return `${value}%`
    },
    currentFlowKey() {
      if (!this.applyForm || !this.applyForm.id) return 'basic'
      const status = Number(this.applyForm.status || 10)
      const paymentStatus = Number(this.applyForm.paymentStatus || 10)
      const arrivalStatus = Number(this.applyForm.arrivalStatus || 10)
      if (this.applicationSupplierOrdersComplete || this.isSupplierOrderLogicallyComplete(this.applyForm)) return 'finish'
      if (status === 120 || status === 110 || status === 115) return 'finish'
      if (this.isApplicationDetail) {
        if ([10, 30].includes(status)) return this.quoteRiskItems.length ? 'quote' : 'basic'
        if (status === 20) return 'approval'
        if (status === 40) return 'order'
        return 'basic'
      }
      if (!this.isContractStepComplete(this.applyForm)) return 'basic'
      if ([10, 30].includes(status)) return this.quoteRiskItems.length ? 'quote' : 'basic'
      if (status === 20) return 'approval'
      if ([80, 90, 100].includes(status) || [20, 30, 40, 50].includes(arrivalStatus)) return 'arrival'
      if ([40, 50, 60, 70].includes(status) || [20, 30, 40, 60].includes(paymentStatus)) return 'payment'
      return 'basic'
    },
    purchaseFlowSteps() {
      const status = Number(this.applyForm.status || 10)
      if (this.isApplicationDetail) {
        const quoteStatusText = [10, 30, 40].includes(status)
          ? (this.quoteRiskItems.length ? '待补报价' : '资料可审')
          : '资料已入单'
        const steps = [
          { key: 'basic', label: '采购申请', statusText: this.applyForm.id ? '已建申请' : '待录入', icon: 'el-icon-document', tab: 'basic' },
          { key: 'quote', label: '供应商报价', statusText: quoteStatusText, icon: 'el-icon-s-check', tab: 'quote' },
          { key: 'approval', label: '审批流', statusText: this.statusText(this.applyForm.status), icon: 'el-icon-finished', tab: 'basic' },
          { key: 'order', label: '采购执行单', statusText: this.supplierOrderCount ? `${this.supplierOrderCount}张` : '待生成', icon: 'el-icon-document-checked', tab: 'order' },
          { key: 'finish', label: '完成', statusText: status === 115 ? '线下已结束' : (this.applicationSupplierOrdersComplete ? '已完成' : '待完成'), icon: 'el-icon-circle-check', tab: 'basic' }
        ]
        const activeKey = this.currentFlowKey
        const activeIndex = Math.max(0, steps.findIndex(item => item.key === activeKey))
        return steps.map((step, index) => Object.assign({}, step, {
          state: index < activeIndex ? 'done' : (index === activeIndex ? 'active' : 'wait')
        }))
      }
      const steps = [
        { key: 'basic', label: '采购清单', statusText: this.applyForm.id ? '已生成' : '待生成', icon: 'el-icon-document', tab: 'basic' },
        { key: 'payment', label: '付款记录', statusText: this.paymentStatusText(this.applyForm.paymentStatus), icon: 'el-icon-bank-card', tab: 'payment' },
        { key: 'arrival', label: '到货验收', statusText: this.arrivalStatusText(this.applyForm.arrivalStatus), icon: 'el-icon-box', tab: 'arrival' },
        { key: 'finish', label: '完成', statusText: Number(this.applyForm.status) === 120 ? '已作废' : (this.isSupplierOrderLogicallyComplete(this.applyForm) || Number(this.applyForm.status) === 110 ? '已完成' : '待完成'), icon: 'el-icon-circle-check', tab: 'basic' }
      ]
      const activeKey = this.currentFlowKey
      const activeIndex = Math.max(0, steps.findIndex(item => item.key === activeKey))
      return steps.map((step, index) => Object.assign({}, step, {
        state: index < activeIndex ? 'done' : (index === activeIndex ? 'active' : 'wait')
      }))
    },
    visiblePurchaseFlowSteps() {
      if (this.applyForm && this.applyForm.id) return this.purchaseFlowSteps
      return [
        {
          key: 'basic',
          label: '采购申请录入',
          statusText: '待录入',
          icon: 'el-icon-document',
          state: 'active'
        },
        {
          key: 'submit',
          label: '保存提交',
          statusText: '待保存',
          icon: 'el-icon-s-promotion',
          state: 'wait'
        },
        {
          key: 'followup',
          label: '后续流转',
          statusText: '未开始',
          icon: 'el-icon-connection',
          state: 'wait'
        }
      ]
    },
    nextAction() {
      const status = Number(this.applyForm.status || 10)
      if (!this.applyForm.id) {
        return {
          title: '先完成采购申请',
          desc: '录入采购需求明细和预估金额后提交审批；真实采购清单由采购询价后维护。',
          actions: [
            { key: 'saveDraft', label: '保存草稿', type: 'primary', icon: 'el-icon-document-checked' },
            { key: 'saveSubmit', label: '保存并提交', type: 'success', icon: 'el-icon-s-promotion' }
          ]
        }
      }
      if ([10, 30].includes(status)) {
        if (this.quoteRiskItems.length) {
          return {
            title: '补充供应商报价',
            desc: '审批前可查看历史价、补充供应商报价或记录不比价原因；采购执行单在审批通过后再生成。',
            actions: [
              { key: 'goQuote', label: '查看供应商报价', type: 'primary', icon: 'el-icon-s-check' },
              { key: 'saveSubmit', label: '仍要提交审批', type: 'success', plain: true, icon: 'el-icon-s-promotion' }
            ]
          }
        }
        return {
          title: '复核采购信息后提交审批',
          desc: '确认采购主题、物料、规格型号、数量和附件后，可以提交审批。',
          actions: [
            { key: 'goQuote', label: '补充供应商报价', type: 'primary', plain: true, icon: 'el-icon-s-check' },
            { key: 'saveSubmit', label: '提交审批', type: 'success', icon: 'el-icon-s-promotion' }
          ]
        }
      }
      if (status === 20) {
        return {
          title: '等待采购审批流处理',
          desc: '流程按所在部门负责人、仓管员、项目采购技术负责人流转。',
          actions: [
            { key: 'goApproval', label: '进入审批', type: 'primary', icon: 'el-icon-finished' }
          ]
        }
      }
      if (this.isApplicationDetail && status === 40) {
        if (this.supplierOrderCount > 0) {
          return {
            title: '已进入采购执行',
            desc: '供应商已确定，请进入供应商采购单继续登记付款和到货；合同资料可在采购申请中统一维护。',
            actions: [
              { key: 'goOrder', label: '查看供应商采购单', type: 'primary', icon: 'el-icon-document-checked' }
            ]
          }
        }
        return {
          title: '采购执行单待生成',
          desc: '采购申请详情只展示采购执行单链接；生成后进入执行单登记付款和到货，合同资料从主单整包维护。',
          actions: [
            { key: 'goOrder', label: '查看采购单列表', type: 'primary', icon: 'el-icon-document-checked' }
          ]
        }
      }
      if (this.currentFlowKey === 'payment') {
        return {
          title: '登记付款金额',
          desc: '审批通过后，财务直接添加实际付款记录；付款凭证为选填材料。',
          actions: [
            { key: 'goPayment', label: '登记付款', type: 'primary', icon: 'el-icon-bank-card' },
            { key: 'goArrival', label: '查看到货', type: 'primary', plain: true, icon: 'el-icon-box' }
          ]
        }
      }
      if (this.currentFlowKey === 'arrival') {
        return {
          title: '登记到货验收',
          desc: '仓管逐项登记物料到货、入库或直发项目现场，已登记内容会沉淀为到货进度和出入库轨迹。',
          actions: [
            { key: 'goArrival', label: '到货验收', type: 'primary', icon: 'el-icon-box' },
            { key: 'goPayment', label: '查看付款', type: 'primary', plain: true, icon: 'el-icon-bank-card' }
          ]
        }
      }
      if (status === 120) {
        return {
          title: `${this.detailDocumentTitle}已作废`,
          desc: `该${this.detailDocumentTitle}不再继续流转，可查看作废原因和操作日志。`,
          done: true,
          actions: [
            { key: 'goLog', label: '查看日志', type: 'primary', plain: true, icon: 'el-icon-time' }
          ]
        }
      }
      if (status === 115) {
        return {
          title: '采购申请已在线下结束',
          desc: '该采购已由询价节点办理人填写备注并结束线上流程，不再生成采购执行单。',
          done: true,
          actions: [
            { key: 'goApproval', label: '查看结束记录', type: 'primary', plain: true, icon: 'el-icon-finished' },
            { key: 'goLog', label: '查看日志', type: 'primary', plain: true, icon: 'el-icon-time' }
          ]
        }
      }
      if (status === 110) {
        return {
          title: `${this.detailDocumentTitle}已完成`,
          desc: '采购、审批、付款和到货资料已闭环，可查看操作日志和历史记录。',
          done: true,
          actions: [
            { key: 'goLog', label: '查看日志', type: 'primary', plain: true, icon: 'el-icon-time' }
          ]
        }
      }
      return {
        title: '补齐采购资料',
        desc: '继续完善报价、合同、付款或到货信息，系统会根据状态推荐下一步。',
        actions: [
          { key: 'goQuote', label: '维护供应商报价', type: 'primary', plain: true, icon: 'el-icon-s-check' },
          { key: 'goBasic', label: '查看采购单', type: 'primary', icon: 'el-icon-document' }
        ]
      }
    }
  },
  watch: {
    '$route'(to) {
      this.applyRouteView(to.path, true, to.query || {})
    }
  },
  created() {
    this.applyRouteView(this.$route.path, false, this.$route.query || {})
    this.loadApplyData()
    this.startPriceLibraryUpdates()
    if (this.canAccessPurchaseSensitive) {
      this.getSupplierList()
      this.loadAllSupplierReferences()
      this.getPriceList()
    }
  },
  beforeDestroy() {
    this.stopPriceLibraryUpdates()
    this.stopDecisionAnalysisPolling()
    this.stopRecognitionTicker()
  },
  methods: {
    hasProcurementPermi(...perms) {
      const required = Array.isArray(perms[0]) ? perms[0] : perms
      const permissions = (this.$store && this.$store.getters && this.$store.getters.permissions) || []
      return permissions.includes('*:*:*') || required.some(item => permissions.includes(item))
    },
    defaultAiScopeValues() {
      if (this.isSupplierOrderDetail || ['contract', 'inlineContract'].includes(this.recognitionFillMode)) return ['contract']
      return ['basic', 'items']
    },
    aiScopeVisible(scope) {
      const allowed = this.aiAllowedScopeValues && this.aiAllowedScopeValues.length
        ? this.aiAllowedScopeValues
        : this.defaultAiScopeValues()
      return allowed.includes(scope)
    },
    normalizeAiScopes(scopes) {
      const allowed = this.aiAllowedScopeValues && this.aiAllowedScopeValues.length
        ? this.aiAllowedScopeValues
        : this.defaultAiScopeValues()
      const selected = (this.toArray(scopes).length ? this.toArray(scopes) : allowed).filter(scope => allowed.includes(scope))
      return selected.length ? selected : allowed.slice(0, 1)
    },
    defaultAiResultTab(result) {
      const allowed = this.aiAllowedScopeValues && this.aiAllowedScopeValues.length
        ? this.aiAllowedScopeValues
        : this.defaultAiScopeValues()
      if (result) {
        if (allowed.includes('items') && result.itemList && result.itemList.length) return 'items'
        if (allowed.includes('contract') && (result.contractNo || result.contractName || result.supplierName || result.partyB)) return 'contract'
        if (allowed.includes('payment') && result.paymentPlanList && result.paymentPlanList.length) return 'payment'
      }
      return allowed.includes('items') ? 'items' : (allowed.includes('contract') ? 'contract' : allowed[0])
    },
    splitSupplierNames(value) {
      return this.uniqueReferenceValues(String(value || '')
        .split(/[,\uFF0C;\uFF1B\u3001\n\r]+/)
        .map(item => item.trim())
        .filter(Boolean))
    },
    recognizedSupplierCandidates(result) {
      const names = []
      const data = result || {}
      names.push(...this.splitSupplierNames(data.supplierName))
      names.push(...this.splitSupplierNames(data.partyB))
      this.toObjectArray(data.itemList).forEach(item => {
        names.push(...this.splitSupplierNames(item && (item._supplierCandidateName || item.supplierName)))
      })
      return this.uniqueReferenceValues(names)
    },
    supplierCandidateText(row) {
      const names = this.uniqueReferenceValues([].concat(
        this.splitSupplierNames(row && row._supplierCandidateName),
        this.splitSupplierNames(row && row.supplierName)
      ))
      return names.join('、') || '-'
    },
    cleanRecognitionMessage(message) {
      const text = String(message || '').trim()
      if (!text) return '待处理'
      if (!/(qwen|千问|模型|视觉|ocr|OCR|页图|直出|结构化|批次|调用)/.test(text)) {
        return text
      }
      const stage = this.recognitionStage || ''
      const applicationMode = this.recognitionFillMode === 'apply'
      if (stage === 'START') return '准备识别'
      if (stage === 'EXTRACT_TEXT') return '读取文件'
      if (stage === 'RENDER_DOCUMENT') return applicationMode ? '理解资料结构' : '解析合同页面'
      if (stage === 'OCR_CONTRACT') return applicationMode ? '识别采购需求' : '识别合同内容'
      if (stage.indexOf('CALL_QWEN') === 0) return applicationMode ? '提取采购需求明细' : '提取合同字段'
      if (stage === 'PARSE_RESULT') return applicationMode ? '整理需求明细' : '整理合同识别结果'
      if (stage === 'VALIDATE_RESULT') return applicationMode ? '校验需求数据' : '校验合同识别结果'
      if (stage === 'SAVE_RESULT' || stage === 'BUILD_DETAIL') return '生成可确认预览'
      if (stage === 'DONE') return '识别完成'
      if (stage === 'ERROR') return '识别失败'
      return '处理中'
    },
    emptyDetail() {
      return {
        supplierOrderList: [],
        contractSealItemList: [],
        contractSealBatch: null,
        contractSealWorkOrder: null,
        quoteList: [],
        approvalRecordList: [],
        approvalWorkOrder: null,
        paymentPlanList: [],
        arrivalList: [],
        shipmentList: [],
        operationLogList: []
      }
    },
    emptyAiRecognitionForm() {
      return {
        fileInfoList: [],
        contractText: ''
      }
    },
    emptyApplyForm() {
      return {
        id: null,
        status: 10,
        documentType: 1,
        parentApplyId: null,
        supplierId: null,
        supplierName: '',
        splitStatus: 10,
        decisionAmount: undefined,
        contractStatus: 10,
        contractMode: 1,
        contractSealStatus: 10,
        contractSealBatchId: null,
        contractSealWorkOrderId: null,
        noContractReason: '',
        noContractBy: null,
        noContractByName: '',
        noContractTime: '',
        shipmentStatus: 10,
        paymentStatus: 10,
        arrivalStatus: 10,
        invoiceStatus: 10,
        applyTitle: '',
        purchaseType: 1,
        purchaseMode: 1,
        sourceMode: 1,
        purchaseOwnerId: null,
        purchaseOwnerName: '',
        applyDeptName: '',
        projectCode: '',
        projectName: '',
        contractId: null,
        contractNum: '',
        expectedArrivalDate: '',
        purchaseReason: '',
        applyAmount: undefined,
        remark: '',
        budgetAmount: undefined,
        estimatedFreightAmount: undefined,
        estimatedOtherFeeAmount: undefined,
        freightAmount: undefined,
        otherFeeAmount: undefined,
        feeRemark: '',
        itemList: [],
        attachmentList: []
      }
    },
    contractFileCount(row) {
      const files = row && row.contractInfo && row.contractInfo.fileInfoList
      return Array.isArray(files) ? files.length : 0
    },
    openContractSealApprovalDialog() {
      if (this.detail.contractSealBatch && this.detail.contractSealBatch.approvalTemplateCode === 'purchaseContractApprovalProcess') { this.openPurchaseContractApplication(this.detail.contractSealBatch.id); return }
      if (!this.contractSealWorkOrderAvailable) {
        this.msgWarning('当前采购申请尚未生成用章审批单')
        return
      }
      this.contractSealApprovalDialogOpen = true
    },
    handleContractSealApprovalUpdate(payload) {
      if (!this.detail.contractSealWorkOrder || !payload) return
      this.detail.contractSealWorkOrder = Object.assign({}, this.detail.contractSealWorkOrder, payload)
    },
    handleContractSealApprovalSuccess() {
      this.contractSealApprovalDialogOpen = false
      return this.refreshCurrentDetail()
    },
    downloadSingleContractSealFile(file) {
      const url = this.quoteFileUrl(file)
      if (!url) {
        this.msgWarning('附件地址不存在，无法下载')
        return
      }
      saveAs(url, this.quoteFileName(file))
    },
    downloadAllContractSealFiles() {
      if (!this.applyForm.id || !this.contractSealAllFiles.length || this.contractSealDownloading) return
      this.contractSealDownloading = true
      downloadPurchaseContractSealFiles(this.applyForm.id).then(async blob => {
        if (!blob || !(blob instanceof Blob) || !(await blobValidate(blob))) {
          let message = '合同附件打包失败，请稍后重试'
          if (blob && typeof blob.text === 'function') {
            try {
              const result = JSON.parse(await blob.text())
              message = result.msg || result.message || message
            } catch (e) {
              // 非 JSON 错误响应沿用统一提示
            }
          }
          throw new Error(message)
        }
        const batchNo = this.detail && this.detail.contractSealBatch && this.detail.contractSealBatch.batchNo
        saveAs(new Blob([blob], { type: 'application/zip' }), `${batchNo || this.applyForm.applyNo || '采购申请'}_合同用章资料.zip`)
      }).catch(error => {
        this.msgError(error && error.message ? error.message : '合同附件打包失败，请稍后重试')
      }).finally(() => {
        this.contractSealDownloading = false
      })
    },
    openContractBatchUpload() {
      if (!this.canManageContractSealPackage) return
      this.contractBatchFiles = []
      this.contractBatchMappingRows = []
      this.contractBatchRemark = ''
      this.contractBatchUploadKey += 1
      this.contractBatchDialogOpen = true
    },
    contractBatchFileKey(file) {
      if (!file) return ''
      return String(file.id || file.uid || file.url || `${file.name || ''}-${file.size || ''}`)
    },
    handleContractBatchFileChange(files) {
      const currentFiles = Array.isArray(files) ? files : []
      const fileKeySet = new Set(currentFiles.map(file => this.contractBatchFileKey(file)))
      this.contractBatchMappingRows = this.contractBatchMappingRows.filter(row => fileKeySet.has(row.fileKey))
      currentFiles.forEach(file => {
        const fileKey = this.contractBatchFileKey(file)
        if (!fileKey || this.contractBatchMappingRows.some(row => row.fileKey === fileKey)) return
        const matched = this.matchContractOrderByFileName(file.name)
        this.contractBatchMappingRows.push({
          fileKey,
          fileInfo: file,
          applyId: matched ? matched.id : null,
          autoMatched: !!matched,
          contractAmount: matched ? Number(matched.applyAmount || 0) : undefined
        })
      })
    },
    handleContractBatchRawUploaded(payload) {
      const fileInfo = payload && payload.fileInfo
      if (!fileInfo) return
      this.handleContractBatchFileChange(this.contractBatchFiles)
      const fileKey = this.contractBatchFileKey(fileInfo)
      const row = this.contractBatchMappingRows.find(item => item.fileKey === fileKey)
      if (!row || row.applyId) return
      const matched = this.matchContractOrderByFileName(fileInfo.name)
      if (matched) this.handleContractBatchOrderChange(row, matched.id, true)
    },
    contractNoFromFileName(name) {
      return String(name || '').replace(/\.(pdf|docx?|png|jpe?g|webp)$/i, '').trim()
    },
    normalizedContractMatchText(value) {
      return String(value || '').toLowerCase().replace(/[\s_\-—·（）()\[\]【】.,，。]/g, '')
    },
    contractSupplierNameCandidates(order) {
      if (!order) return []
      const supplier = (this.supplierOptions || []).find(item =>
        order.supplierId && String(item.id) === String(order.supplierId)
      )
      const names = [order.supplierName]
      if (supplier) {
        names.push(supplier.supplierName, supplier.shortName)
        if (supplier.aliases) {
          supplier.aliases.split(/[、,，;；\s|/\n]+/).forEach(item => names.push(item))
        }
      }
      const fullName = String(order.supplierName || '').trim()
      const withoutLegalSuffix = fullName.replace(/(?:股份有限公司|有限责任公司|有限公司|集团公司|公司)$/u, '')
      const withoutRegionPrefix = withoutLegalSuffix.replace(/^(?:北京|天津|上海|重庆|河北|山西|辽宁|吉林|黑龙江|江苏|浙江|安徽|福建|江西|山东|河南|湖北|湖南|广东|海南|四川|贵州|云南|陕西|甘肃|青海|台湾|内蒙古|广西|西藏|宁夏|新疆|香港|澳门)/u, '')
      const commonBusinessSuffix = /(?:供应链|新材料|自动化|管道|管业|科技|工业|材料|设备|环保|实业|贸易|商贸|机电|机械|工程|电气|化工|智能)$/u
      let brandName = withoutRegionPrefix
      while (brandName && commonBusinessSuffix.test(brandName)) {
        brandName = brandName.replace(commonBusinessSuffix, '')
      }
      names.push(withoutLegalSuffix, withoutRegionPrefix, brandName)
      const seen = new Set()
      return names.map(item => this.normalizedContractMatchText(item)).filter(item => {
        if (!item || item.length < 2 || seen.has(item)) return false
        seen.add(item)
        return true
      })
    },
    matchContractOrderByFileName(name) {
      const normalizedName = this.normalizedContractMatchText(this.contractNoFromFileName(name))
      if (!normalizedName) return this.contractBatchTargetRows.length === 1 ? this.contractBatchTargetRows[0] : null
      const matches = this.contractBatchTargetRows.filter(order => {
        const applyNo = this.normalizedContractMatchText(order.applyNo)
        return this.contractSupplierNameCandidates(order).some(candidate => normalizedName.includes(candidate)) ||
          (applyNo && normalizedName.includes(applyNo))
      })
      return matches.length === 1 ? matches[0] : (this.contractBatchTargetRows.length === 1 ? this.contractBatchTargetRows[0] : null)
    },
    handleContractBatchOrderChange(row, applyId, autoMatched = false) {
      if (!row) return
      const order = this.contractBatchTargetRows.find(item => String(item.id) === String(applyId))
      row.applyId = order ? order.id : null
      row.autoMatched = !!(order && autoMatched)
      if (order && (row.contractAmount === undefined || row.contractAmount === null)) {
        row.contractAmount = Number(order.applyAmount || 0)
      }
    },
    buildContractBatchPayload() {
      const grouped = new Map()
      this.contractBatchMappingRows.forEach(row => {
        const order = this.contractBatchTargetRows.find(item => String(item.id) === String(row.applyId))
        if (!order) return
        let contract = grouped.get(order.id)
        if (!contract) {
          const current = order.contractInfo || {}
          contract = Object.assign({}, current, {
            id: current.id || null,
            applyId: order.id,
            contractNo: '',
            contractName: current.contractName || `${order.supplierName || ''}采购合同`,
            partyA: current.partyA || this.currentTenantName(),
            partyB: current.partyB || order.supplierName || '',
            supplierId: order.supplierId || current.supplierId || null,
            supplierName: order.supplierName || current.supplierName || '',
            contractAmount: row.contractAmount === undefined ? (current.contractAmount || order.applyAmount) : row.contractAmount,
            fileInfoList: []
          })
          grouped.set(order.id, contract)
        }
        if ((contract.contractAmount === undefined || contract.contractAmount === null) && row.contractAmount !== undefined) {
          contract.contractAmount = row.contractAmount
        }
        const file = row.fileInfo
        const key = this.contractBatchFileKey(file)
        if (file && !contract.fileInfoList.some(item => this.contractBatchFileKey(item) === key)) {
          contract.fileInfoList.push(file)
        }
      })
      return {
        parentApplyId: this.applyForm.id,
        contractList: Array.from(grouped.values())
      }
    },
    saveContractBatch(submitAfter) {
      if (!this.contractBatchCanSave) {
        this.msgWarning('请先为全部文件匹配供应商采购单')
        return
      }
      const payload = this.buildContractBatchPayload()
      const loadingKey = submitAfter ? 'contractBatchSubmitting' : 'contractBatchSaving'
      let contractsSaved = false
      this[loadingKey] = true
      batchSavePurchaseContracts(payload).then(res => {
        contractsSaved = true
        this.fillDetail(res.data || {})
        if (!submitAfter) {
          this.msgSuccess(`已批量保存${payload.contractList.length}张供应商合同`)
          this.contractBatchDialogOpen = false
          return null
        }
        this.contractBatchDialogOpen = false
        this.openPurchaseContractApplication()
        return null
      }).catch(err => {
        const message = err && err.message ? err.message : '请检查合同文件和供应商匹配'
        this.$message.error(contractsSaved && submitAfter
          ? `合同已批量保存，但整包尚未提交：${message}`
          : `批量处理合同失败：${message}`)
      }).finally(() => {
        this[loadingKey] = false
      })
    },
    openPurchaseContractApplication(id) {
      this.$router.push({ path: id ? `/procurement/contracts/detail/${id}` : `/procurement/contracts/edit`, query: { ...(id ? {} : { parentApplyId: this.applyForm.id }), returnTo: this.$route.fullPath } })
    },
    submitCurrentContractSealPackage() {
      this.openPurchaseContractApplication()
    },
    emptyDirectOrderForm() {
      return {
        applyTitle: '',
        purchaseType: 5,
        sourceMode: 4,
        documentType: 2,
        supplierId: null,
        supplierName: '',
        expectedArrivalDate: '',
        purchaseReason: '',
        contractMode: 1,
        noContractReason: '',
        applyAmount: 0,
        itemList: [this.emptyApplyItem()]
      }
    },
    emptyShipmentForm() {
      return {
        id: null,
        applyId: null,
        shipmentMethod: 1,
        logisticsCompanyName: '',
        trackingNo: '',
        shipmentDate: '',
        completeFlag: 0,
        remark: '',
        fileInfoList: []
      }
    },
    positiveAmount(value) {
      const number = Number(value || 0)
      return Number.isFinite(number) && number > 0 ? number : 0
    },
    pendingSplitSupplierFeeForKey(key) {
      return (this.pendingSplitSupplierFeeMap && this.pendingSplitSupplierFeeMap[key]) || {}
    },
    supplierGroupFeeValue(group, field) {
      const fee = this.pendingSplitSupplierFeeForKey(group && group.key)
      if (field === 'feeRemark') return fee.feeRemark || ''
      return this.positiveAmount(fee[field])
    },
    setSupplierGroupFeeValue(group, field, value) {
      if (!group || !group.key) return
      const current = Object.assign({}, this.pendingSplitSupplierFeeForKey(group.key))
      current[field] = field === 'feeRemark' ? value : this.positiveAmount(value)
      this.$set(this.pendingSplitSupplierFeeMap, group.key, current)
    },
    buildSupplierFeePayload() {
      if (!this.isApplicationPendingSplit) return []
      return this.pendingSplitSupplierGroups.map(group => {
        const fee = this.pendingSplitSupplierFeeForKey(group.key)
        return {
          supplierId: group.supplierId || null,
          supplierName: group.supplierName || '',
          freightAmount: this.positiveAmount(fee.freightAmount),
          otherFeeAmount: this.positiveAmount(fee.otherFeeAmount),
          feeRemark: fee.feeRemark || ''
        }
      }).filter(item => item.supplierName)
    },
    currentUserId() {
      const store = this.$store || {}
      return (store.getters && store.getters.userId) || (store.state && store.state.user && store.state.user.userId) || null
    },
    isOwnPurchaseApplication(row) {
      const source = row || {}
      if (Number(source.documentType || 1) !== 1) return false
      if (!source.id) return true
      const applicantId = source.applicantId === undefined || source.applicantId === null
        ? source.createBy
        : source.applicantId
      return applicantId !== undefined && applicantId !== null &&
        String(applicantId) === String(this.currentUserId())
    },
    currentUserName() {
      const getters = this.$store && this.$store.getters ? this.$store.getters : {}
      return getters.nickName || getters.name || ''
    },
    currentTenantName() {
      const store = this.$store || {}
      const getters = store.getters || {}
      const stateUser = store.state && store.state.user ? store.state.user : {}
      const tenantId = getters.tenantId || stateUser.tenantId
      const tenants = getters.tenants || stateUser.tenants || []
      const current = tenants.find(item => String(item.tenantId) === String(tenantId)) || tenants[0] || {}
      return current.fullName || current.tenantName || current.name || ''
    },
    emptyContractForm() {
      return {
        id: null,
        applyId: null,
        contractNo: '',
        contractName: '',
        signDate: '',
        partyA: this.currentTenantName(),
        partyB: '',
        supplierId: null,
        supplierName: '',
        contractAmount: undefined,
        taxRate: undefined,
        paymentTerms: '',
        deliveryPeriod: '',
        attachmentListText: '',
        fileInfoList: [],
        contractText: '',
        aiFocusPoints: '',
        recognitionJson: '',
        confirmRemark: ''
      }
    },
    emptyApplyItem() {
      return {
        materialName: '',
        materialCode: '',
        specification: '',
        materialQualityBrand: '',
        processSection: '',
        itemGroupName: '',
        modelNo: '',
        technicalParameter: '',
        materialRequirement: '',
        quantity: 1,
        unit: '',
        purchaseUnitPrice: undefined,
        amount: 0,
        supplierId: null,
        supplierName: '',
        expectedArrivalDate: '',
        remark: '',
        sourceRowNo: null,
        sourceSheetName: '',
        importBatchNo: '',
        historyPriceMatched: false
      }
    },
    emptyQuoteForm() {
      return {
        applyId: null,
        comparisonGroupNo: '',
        comparisonGroupName: '',
        purchaseMode: 1,
        editorLayoutMode: 'supplier',
        itemList: [],
        recommendedSupplierKey: '',
        recommendedOfferMap: {},
        recommendedReasonMap: {},
        recommendationReason: '',
        recommendationTouched: false,
        supplierList: []
      }
    },
    emptyPaymentActionForm() {
      return {
        applyId: null,
        paymentPlanId: null,
        paidAmount: undefined,
        paymentTime: '',
        supplierAccountInfo: '',
        duplicateCheckRemark: '',
        paymentVoucherFileList: []
      }
    },
    emptyArrivalForm() {
      return {
        id: null,
        applyId: null,
        itemId: null,
        materialName: '',
        specification: '',
        quantity: undefined,
        arrivedQuantity: undefined,
        unarrivedQuantity: undefined,
        arrivalDate: '',
        status: 30,
        fileInfoList: [],
        issueDescription: '',
        qualityScore: undefined,
        qualityRemark: ''
      }
    },
    emptyInlineOrder() {
      return {
        open: false,
        loading: false,
        id: null,
        tab: 'contract',
        applyForm: this.emptyApplyForm(),
        detail: this.emptyDetail(),
        contractForm: this.emptyContractForm(),
        paymentPlanList: [],
        paymentPlan: {},
        paymentForm: this.emptyPaymentActionForm(),
        arrivalForm: this.emptyArrivalForm()
      }
    },
    emptySupplierForm() {
      return {
        id: null,
        supplierName: '',
        creditCode: '',
        shortName: '',
        aliases: '',
        contactName: '',
        contactPhone: '',
        bankInfo: '',
        supplierType: '',
        mainPurchaseContent: '',
        status: 1
      }
    },
    routeViewFromPath(path) {
      const normalizedPath = (path || '').replace(/\/$/, '')
      if (/\/procurement\/apply\/detail\/[^/]+$/.test(normalizedPath)) return { key: 'apply', tab: 'apply', detail: true }
      if (normalizedPath.endsWith('/procurement/apply/new')) return { key: 'apply', tab: 'apply', detail: true, create: true }
      if (normalizedPath.endsWith('/report')) return { key: 'report', tab: 'report' }
      if (normalizedPath.endsWith('/apply')) return { key: 'apply', tab: 'apply' }
      if (normalizedPath.endsWith('/order')) return { key: 'order', tab: 'order' }
      if (normalizedPath.endsWith('/todo')) return { key: 'todo', tab: 'todo' }
      if (normalizedPath.endsWith('/supplier')) return { key: 'supplier', tab: 'supplier' }
      if (normalizedPath.endsWith('/price')) return { key: 'price', tab: 'price' }
      return { key: 'dashboard', tab: 'dashboard' }
    },
    applyRouteView(path, refresh = false, query = {}) {
      const view = this.routeViewFromPath(path)
      this.activeWorkflowKey = query.workflow || view.key
      this.activeTab = view.tab
      this.resetProcurementScroll()
      if (view.create) {
        this.initNewApply(query.entryMode || 'ai')
        return
      }
      if (view.detail) {
        const detailId = this.$route && this.$route.params ? this.$route.params.id : null
        this.syncApplyQueryFromRoute(query)
        if (detailId) {
          this.openApplyDetailById(detailId, query.tab || undefined, query.approval === '1' || query.approval === 'true')
        }
        return
      }
      if (view.tab === 'apply' || view.tab === 'order' || view.tab === 'todo') {
        this.syncApplyQueryFromRoute(query)
      } else {
        this.queryParams = { keyword: '', purchaseType: null, status: null, queue: '' }
        this.applyPage.pageNum = 1
      }
      if (view.tab === 'supplier' && typeof query.keyword !== 'undefined') {
        this.supplierQuery.keyword = query.keyword || ''
      }
      if (view.tab === 'price') {
        this.priceQuery.materialName = query.materialName || ''
        this.priceQuery.specification = query.specification || ''
        this.priceQuery.supplierName = query.supplierName || ''
        this.priceQuery.purchaseType = query.purchaseType ? Number(query.purchaseType) : null
      }
      if ((view.tab === 'apply' || view.tab === 'order' || view.tab === 'todo') && query.detailId) {
        this.$router.replace({ path: `/procurement/apply/detail/${query.detailId}` })
        return
      }
      if (refresh) {
        this.refreshWorkspace()
      }
    },
    resetProcurementScroll() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined' && window.scrollTo) {
          window.scrollTo(0, 0)
        }
        const scrollNodes = [
          document.documentElement,
          document.body,
          document.querySelector('.app-main'),
          document.querySelector('.procurement-page')
        ].filter(Boolean)
        scrollNodes.forEach(node => {
          node.scrollLeft = 0
          node.scrollTop = 0
        })
        document.querySelectorAll('.el-table__body-wrapper, .el-table__header-wrapper').forEach(node => {
          node.scrollLeft = 0
        })
      })
    },
    syncApplyQueryFromRoute(query = {}) {
      this.queryParams = {
        keyword: query.keyword || '',
        purchaseType: query.purchaseType ? Number(query.purchaseType) : null,
        status: query.status ? Number(query.status) : null,
        queue: query.queue || '',
        myApplications: [true, 1, '1', 'true'].includes(query.myApplications),
        myRelated: query.myRelated === '1' || query.myRelated === 'true' || query.myRelated === true || query.myRelated === 1
      }
      this.applyPage.pageNum = query.pageNum ? Number(query.pageNum) : 1
      this.applyPage.pageSize = 10
    },
    normalizeRouteQuery(query = {}) {
      const normalized = {}
      Object.keys(query).forEach(key => {
        const value = query[key]
        if (value === undefined || value === null || value === '') return
        normalized[key] = String(value)
      })
      return normalized
    },
    routeQueryEquals(left = {}, right = {}) {
      const leftKeys = Object.keys(left).sort()
      const rightKeys = Object.keys(right).sort()
      if (leftKeys.length !== rightKeys.length) return false
      return leftKeys.every((key, index) => key === rightKeys[index] && String(left[key]) === String(right[key]))
    },
    pushProcurementRoute(path, query = {}) {
      const routeQuery = this.normalizeRouteQuery(query)
      if (this.$route.path === path && this.routeQueryEquals(this.normalizeRouteQuery(this.$route.query || {}), routeQuery)) {
        this.applyRouteView(path, true, routeQuery)
        return
      }
      this.$router.push({ path, query: routeQuery })
    },
    pushApplyRoute(query = {}, options = {}) {
      const base = options.reset ? { keyword: '', purchaseType: null, status: null, queue: '' } : this.queryParams
      const next = Object.assign({}, base, query)
      if (query.queue) next.status = null
      if (typeof query.status !== 'undefined' && query.status !== null && query.status !== '') next.queue = ''
      next.pageNum = query.pageNum || 1
      next.pageSize = 10
      const targetPath = this.activeTab === 'order'
        ? '/procurement/order'
        : (this.activeTab === 'todo' ? '/procurement/todo' : '/procurement/apply')
      this.pushProcurementRoute(targetPath, next)
    },
    pushApplyDetailRoute(id, query = {}, replace = false) {
      if (!id) return
      const route = { path: `/procurement/apply/detail/${id}`, query: this.normalizeRouteQuery(query) }
      if (replace) {
        this.$router.replace(route)
        return
      }
      this.$router.push(route)
    },
    openSourcePurchaseApply() {
      if (!this.applyForm || !this.applyForm.parentApplyId) return
      this.pushApplyDetailRoute(this.applyForm.parentApplyId, { tab: 'basic' })
    },
    openRelatedContract() {
      if (!this.applyForm || !this.applyForm.contractId) return
      this.$router.push({ path: `/crm/contract/detail/${this.applyForm.contractId}` })
    },
    loadApplyData() {
      this.getWorkbench()
      this.getApplyList()
    },
    getWorkbench() {
      const params = Object.assign({}, this.queryParams)
      if (this.shouldUsePersonalWorkbenchScope) {
        params.myRelated = true
      } else {
        delete params.myRelated
      }
      params.personalWorkbench = this.activeTab === 'dashboard'
      getPurchaseWorkbench(params).then(res => {
        this.workbench = res.data || {}
      })
    },
    getApplyList() {
      this.loading.apply = true
      const params = Object.assign({}, this.queryParams, {
        pageNum: this.applyPage.pageNum || 1,
        pageSize: this.applyPage.pageSize || 10
      })
      if (this.shouldUsePersonalWorkbenchScope) {
        params.myRelated = true
      }
      if (this.activeTab === 'todo' && !params.queue) {
        params.queue = 'todo'
      }
      if (this.activeDocumentType) {
        params.documentType = this.activeDocumentType
      }
      if (this.activeTab === 'dashboard') {
        params.myApplications = true
        params.documentType = 1
      }
      listPurchaseApply(params).then(res => {
        this.applyList = this.responseRows(res)
        this.applyTotal = this.responseTotal(res)
      }).finally(() => {
        this.loading.apply = false
      })
    },
    responseRows(res) {
      if (res && Array.isArray(res.rows)) return res.rows
      if (res && Array.isArray(res.data)) return res.data
      if (res && res.data && Array.isArray(res.data.rows)) return res.data.rows
      return []
    },
    responseTotal(res) {
      if (res && typeof res.total !== 'undefined') return Number(res.total || 0)
      if (res && res.data && typeof res.data.total !== 'undefined') return Number(res.data.total || 0)
      const rows = this.responseRows(res)
      return rows.length
    },
    getSupplierList() {
      if (!this.canAccessPurchaseSensitive) {
        this.supplierList = []
        this.supplierTotal = 0
        return Promise.resolve([])
      }
      this.loading.supplier = true
      const params = ['dashboard', 'report'].includes(this.activeTab)
        ? { pageNum: 1, pageSize: 20, rankByPurchaseAmount: true }
        : this.supplierQuery
      return listPurchaseSupplier(params).then(res => {
        const rows = this.responseRows(res)
        this.supplierList = rows
        this.supplierTotal = this.responseTotal(res)
        this.mergeSupplierReferences(rows)
      }).finally(() => {
        this.loading.supplier = false
      })
    },
    loadAllSupplierReferences() {
      if (!this.canAccessPurchaseSensitive) return Promise.resolve([])
      return listPurchaseSupplier({ status: 1, pageNum: 1, pageSize: 500 }).then(res => {
        const rows = this.responseRows(res)
        this.mergeSupplierReferences(rows)
        return rows
      })
    },
    startPriceLibraryUpdates() {
      this.stopPriceLibraryUpdates()
      this.priceRefreshTimer = window.setInterval(this.refreshVisiblePriceLibrary, 30000)
      window.addEventListener('focus', this.refreshVisiblePriceLibrary)
      document.addEventListener('visibilitychange', this.refreshVisiblePriceLibrary)
    },
    stopPriceLibraryUpdates() {
      if (this.priceRefreshTimer !== null) window.clearInterval(this.priceRefreshTimer)
      this.priceRefreshTimer = null
      window.removeEventListener('focus', this.refreshVisiblePriceLibrary)
      document.removeEventListener('visibilitychange', this.refreshVisiblePriceLibrary)
    },
    refreshVisiblePriceLibrary() {
      if (this.activeTab !== 'price' || !this.canAccessPurchasePrice || document.hidden || this.loading.price) return
      return this.getPriceList().catch(() => {})
    },
    getPriceList() {
      if (!this.canAccessPurchasePrice) {
        this.priceList = []
        this.priceTotal = 0
        return Promise.resolve([])
      }
      this.loading.price = true
      return listPurchasePrice(this.priceQuery).then(res => {
        if (!this.canAccessPurchasePrice) { this.priceList = []; this.priceTotal = 0; return }
        const rows = this.responseRows(res)
        this.priceList = rows
        this.priceTotal = this.responseTotal(res)
        this.mergePriceReferences(rows)
      }).finally(() => {
        this.loading.price = false
      })
    },
    handleSupplierQuery() {
      this.supplierQuery.pageNum = 1
      this.pushProcurementRoute('/procurement/supplier', { keyword: this.supplierQuery.keyword })
    },
    resetSupplierQuery() {
      this.supplierQuery.keyword = ''
      this.supplierQuery.status = null
      this.handleSupplierQuery()
    },
    handlePriceQuery() {
      this.priceQuery.pageNum = 1
      this.pushProcurementRoute('/procurement/price', {
        materialName: this.priceQuery.materialName,
        specification: this.priceQuery.specification,
        supplierName: this.priceQuery.supplierName,
        purchaseType: this.priceQuery.purchaseType
      })
    },
    resetPriceQuery() {
      this.priceQuery.materialName = ''
      this.priceQuery.specification = ''
      this.priceQuery.supplierName = ''
      this.priceQuery.purchaseType = null
      this.handlePriceQuery()
    },
    openPriceLookup() {
      if (!this.canAccessPurchasePrice) return
      this.priceLookupTargetRow = null
      this.priceLookupQuery = {
        materialName: this.priceQuery.materialName || '',
        specification: this.priceQuery.specification || '',
        supplierName: this.priceQuery.supplierName || ''
      }
      this.priceLookupRows = []
      this.priceLookupOpen = true
      if (this.priceLookupQuery.materialName || this.priceLookupQuery.specification || this.priceLookupQuery.supplierName) {
        this.$nextTick(this.queryPriceLookup)
      }
    },
    openItemPriceLookup(row) {
      if (!this.canAccessPurchasePrice) return
      this.priceLookupTargetRow = row
      this.priceLookupQuery = {
        materialName: row && row.materialName ? row.materialName : '',
        specification: row && row.specification ? row.specification : '',
        supplierName: row && row.supplierName ? row.supplierName : ''
      }
      this.priceLookupRows = []
      this.priceLookupOpen = true
      this.$nextTick(this.queryPriceLookup)
    },
    resetPriceLookup() {
      this.priceLookupQuery = { materialName: '', specification: '', supplierName: '' }
      this.priceLookupRows = []
    },
    priceQueryContext(query = {}) {
      return {
        materialName: query.materialName || '',
        specification: query.specification || '',
        supplierName: query.supplierName || '',
        materialQualityBrand: query.materialQualityBrand || '',
        unit: query.unit || ''
      }
    },
    queryPriceMaterialSuggestions(query, callback) {
      this.queryPriceContextMaterialSuggestions(query, this.priceQueryContext(this.priceQuery), callback)
    },
    queryPriceLookupMaterialSuggestions(query, callback) {
      this.queryPriceContextMaterialSuggestions(query, this.priceQueryContext(this.priceLookupQuery), callback)
    },
    queryPriceContextMaterialSuggestions(query, context, callback) {
      const row = Object.assign({}, context)
      const local = this.materialSuggestionOptions(row, query)
      if (!query || local.length >= 8) {
        callback(local)
        return
      }
      this.loadMaterialSupplementReferencesForRow(Object.assign({}, row, { materialName: query })).then(() => {
        callback(this.materialSuggestionOptions(row, query))
      }).catch(() => callback(local))
    },
    handlePriceMaterialSelect(item) {
      this.applyPriceMaterialSelection(this.priceQuery, item)
    },
    handlePriceLookupMaterialSelect(item) {
      this.applyPriceMaterialSelection(this.priceLookupQuery, item)
    },
    applyPriceMaterialSelection(target, item) {
      if (!target || !item) return
      this.$set(target, 'materialName', item.materialName || item.value || '')
    },
    queryPriceSpecificationSuggestions(query, callback) {
      this.queryItemSpecificationSuggestions(query, this.priceQueryContext(this.priceQuery), callback)
    },
    queryPriceLookupSpecificationSuggestions(query, callback) {
      this.queryItemSpecificationSuggestions(query, this.priceQueryContext(this.priceLookupQuery), callback)
    },
    handlePriceSpecificationSelect(item) {
      this.applyPriceSpecificationSelection(this.priceQuery, item)
    },
    handlePriceLookupSpecificationSelect(item) {
      this.applyPriceSpecificationSelection(this.priceLookupQuery, item)
    },
    applyPriceSpecificationSelection(target, item) {
      if (!target || !item) return
      this.$set(target, 'specification', item.value || item.specification || '')
    },
    queryPriceSupplierSuggestions(query, callback) {
      this.queryItemSupplierSuggestions(query, this.priceQueryContext(this.priceQuery), callback)
    },
    queryPriceLookupSupplierSuggestions(query, callback) {
      this.queryItemSupplierSuggestions(query, this.priceQueryContext(this.priceLookupQuery), callback)
    },
    handlePriceSupplierSelect(item) {
      this.applyPriceSupplierSelection(this.priceQuery, item)
    },
    handlePriceLookupSupplierSelect(item) {
      this.applyPriceSupplierSelection(this.priceLookupQuery, item)
    },
    applyPriceSupplierSelection(target, item) {
      if (!target || !item) return
      this.$set(target, 'supplierName', item.supplierName || item.value || '')
    },
    priceSupplierOptionDetails(item) {
      const referenceDetails = this.itemSupplierOptionDetails(item)
      return referenceDetails.length ? referenceDetails : this.supplierOptionDetails(item)
    },
    queryPriceLookup() {
      if (!this.canAccessPurchasePrice) return
      const materialName = String(this.priceLookupQuery.materialName || '').trim()
      const specification = String(this.priceLookupQuery.specification || '').trim()
      const supplierName = String(this.priceLookupQuery.supplierName || '').trim()
      if (!materialName && !specification && !supplierName) {
        this.priceLookupRows = []
        this.msgWarning('请输入物料名称、规格型号或供应商')
        return
      }
      this.priceLookupLoading = true
      const exactMaterialName = Boolean(this.priceLookupTargetRow &&
        materialName &&
        this.sameReferenceText(materialName, this.priceLookupTargetRow.materialName))
      const exactSpecification = Boolean(this.priceLookupTargetRow &&
        specification &&
        this.sameReferenceSpecification(specification, this.priceLookupTargetRow.specification, materialName, this.priceLookupTargetRow.materialName))
      listPurchasePrice({
        materialName,
        specification,
        supplierName,
        exactMaterialName,
        exactSpecification,
        pageNum: 1,
        pageSize: exactMaterialName && exactSpecification ? 200 : 100
      }).then(res => {
        const rows = this.responseRows(res).filter(row => {
          if (exactMaterialName && !this.sameReferenceText(row.materialName, materialName)) return false
          if (exactSpecification && !this.sameReferenceSpecification(row.specification, specification, row.materialName, materialName)) return false
          return true
        })
        this.priceLookupRows = this.dedupePriceLookupRows(rows).sort((left, right) => {
          const leftSpec = this.referenceSpecificationKey(this.referenceSpecificationDisplay(left), left.materialName)
          const rightSpec = this.referenceSpecificationKey(this.referenceSpecificationDisplay(right), right.materialName)
          if (leftSpec !== rightSpec) return leftSpec.localeCompare(rightSpec)
          const priceDiff = Number(left.purchaseUnitPrice || 0) - Number(right.purchaseUnitPrice || 0)
          if (priceDiff) return priceDiff
          return this.normalizeReferenceName(left.supplierName).localeCompare(this.normalizeReferenceName(right.supplierName))
        })
        this.mergePriceReferences(rows)
      }).finally(() => {
        this.priceLookupLoading = false
      })
    },
    adoptLookupPrice(row) {
      if (!this.priceLookupTargetRow || !row) return
      this.applySelectedPriceRecordToItem(this.priceLookupTargetRow, row)
      this.priceLookupOpen = false
    },
    priceLookupSourceText(row) {
      const count = Number(row && row._historyCount || 0)
      const source = [row.applyNo, row.applyTitle, row.applyCreateTime].filter(Boolean).join(' / ') || '历史价格'
      return count > 1 ? `历史${count}次，最近：${source}` : source
    },
    priceLookupRangeText(row) {
      const minPrice = this.referenceNumberValue(row && row._minPurchaseUnitPrice)
      const maxPrice = this.referenceNumberValue(row && row._maxPurchaseUnitPrice)
      const currentPrice = this.referenceNumberValue(row && row.purchaseUnitPrice)
      if (minPrice !== null && maxPrice !== null && minPrice !== maxPrice) {
        return `${this.money(minPrice)} - ${this.money(maxPrice)}`
      }
      if (currentPrice !== null) return this.money(currentPrice)
      return '-'
    },
    priceLookupQuantityText(row) {
      const minQuantity = this.referenceNumberValue(row && row._minQuantity)
      const maxQuantity = this.referenceNumberValue(row && row._maxQuantity)
      if (minQuantity !== null && maxQuantity !== null && minQuantity !== maxQuantity) {
        return `${this.numberText(minQuantity)} - ${this.numberText(maxQuantity)}`
      }
      const quantity = this.referenceNumberValue(row && row.quantity)
      return quantity !== null ? this.numberText(quantity) : '-'
    },
    priceLookupDedupKey(row) {
      return [
        this.referenceMaterialDisplayName(row),
        this.referenceSpecificationKey(this.referenceSpecificationDisplay(row), row && row.materialName),
        row && row.materialQualityBrand,
        row && (row.supplierId || row.supplierName),
        row && row.unit
      ].map(value => this.normalizeReferenceName(value)).join('|')
    },
    priceLookupTimeValue(row) {
      const text = row && (row.applyCreateTime || row.purchaseDate || row.createTime || row.updateTime)
      const time = text ? new Date(String(text).replace(/-/g, '/')).getTime() : 0
      return Number.isFinite(time) ? time : 0
    },
    buildPriceLookupRow(row, meta = {}) {
      const prices = (meta.prices || [row && row.purchaseUnitPrice]).map(value => this.referenceNumberValue(value)).filter(value => value !== null)
      const quantities = (meta.quantities || [row && row.quantity]).map(value => this.referenceNumberValue(value)).filter(value => value !== null)
      const brands = meta.brands || [row && row.materialQualityBrand]
      const brandList = this.uniqueReferenceValues(brands && brands.length ? brands : [row && row.materialQualityBrand])
      const minPrice = prices.length ? Math.min.apply(null, prices) : this.referenceNumberValue(row && row.purchaseUnitPrice)
      const maxPrice = prices.length ? Math.max.apply(null, prices) : this.referenceNumberValue(row && row.purchaseUnitPrice)
      const minQuantity = quantities.length ? Math.min.apply(null, quantities) : this.referenceNumberValue(row && row.quantity)
      const maxQuantity = quantities.length ? Math.max.apply(null, quantities) : this.referenceNumberValue(row && row.quantity)
      return Object.assign({}, row, {
        purchaseUnitPrice: minPrice !== null ? minPrice : row && row.purchaseUnitPrice,
        amount: minPrice !== null && row && row.quantity ? roundPurchaseMoney(Number(row.quantity || 0) * minPrice) : row && row.amount,
        _historyCount: Number(meta.historyCount || 1),
        _materialQualityBrands: brandList,
        _materialQualityBrandSummary: brandList.join(' / '),
        _minPurchaseUnitPrice: minPrice,
        _maxPurchaseUnitPrice: maxPrice,
        _latestPurchaseUnitPrice: this.referenceNumberValue(row && row.purchaseUnitPrice),
        _minQuantity: minQuantity,
        _maxQuantity: maxQuantity
      })
    },
    dedupePriceLookupRows(rows) {
      const grouped = new Map()
      ;(rows || []).forEach(row => {
        if (!row) return
        const key = this.priceLookupDedupKey(row)
        const exists = grouped.get(key)
        if (!exists) {
          grouped.set(key, this.buildPriceLookupRow(row, {
            historyCount: 1,
            brands: [row.materialQualityBrand],
            prices: [row.purchaseUnitPrice],
            quantities: [row.quantity]
          }))
          return
        }
        const historyCount = Number(exists._historyCount || 1) + 1
        const brands = this.uniqueReferenceValues([].concat(exists._materialQualityBrands || exists.materialQualityBrand || [], row.materialQualityBrand || []))
        const prices = [].concat(exists._minPurchaseUnitPrice, exists._maxPurchaseUnitPrice, row.purchaseUnitPrice)
        const quantities = [].concat(exists._minQuantity, exists._maxQuantity, row.quantity)
        if (this.priceLookupTimeValue(row) > this.priceLookupTimeValue(exists)) {
          grouped.set(key, this.buildPriceLookupRow(row, {
            historyCount,
            brands,
            prices,
            quantities
          }))
        } else {
          exists._historyCount = historyCount
          exists._materialQualityBrands = brands
          exists._materialQualityBrandSummary = brands.join(' / ')
          const normalizedPrices = prices.map(value => this.referenceNumberValue(value)).filter(value => value !== null)
          const normalizedQuantities = quantities.map(value => this.referenceNumberValue(value)).filter(value => value !== null)
          if (normalizedPrices.length) {
            exists._minPurchaseUnitPrice = Math.min.apply(null, normalizedPrices)
            exists._maxPurchaseUnitPrice = Math.max.apply(null, normalizedPrices)
            exists.purchaseUnitPrice = exists._minPurchaseUnitPrice
          }
          if (normalizedQuantities.length) {
            exists._minQuantity = Math.min.apply(null, normalizedQuantities)
            exists._maxQuantity = Math.max.apply(null, normalizedQuantities)
          }
        }
      })
      return Array.from(grouped.values())
    },
    handleQuery() {
      this.pushApplyRoute(Object.assign({}, this.queryParams, { pageNum: 1 }))
    },
    resetQuery() {
      const scope = { myApplications: this.queryParams.myApplications, myRelated: this.queryParams.myRelated }
      this.queryParams = Object.assign({ keyword: '', purchaseType: null, status: null, queue: '' }, scope)
      this.pushApplyRoute(Object.assign({ keyword: '', purchaseType: null, status: null, queue: '', pageNum: 1 }, scope))
    },
    handleApplyPagination() {
      this.pushApplyRoute({ pageNum: this.applyPage.pageNum, pageSize: this.applyPage.pageSize })
    },
    clearApplyQueue() {
      if (this.activeTab === 'todo') {
        this.pushProcurementRoute('/procurement/workbench')
        return
      }
      this.pushApplyRoute({ queue: '', pageNum: 1 })
    },
    refreshWorkspace() {
      if (this.activeTab === 'dashboard' || this.activeTab === 'report') {
        this.loadApplyData()
        if (this.canAccessPurchaseSensitive) {
          this.getSupplierList()
          this.getPriceList()
        }
        return
      }
      if (this.activeTab === 'supplier') {
        this.getSupplierList()
        return
      }
      if (this.activeTab === 'price') {
        this.getPriceList()
        return
      }
      if (this.activeTab === 'apply' || this.activeTab === 'order' || this.activeTab === 'todo') {
        this.loadApplyData()
      }
    },
    filterMetric(card) {
      if (card.routePath) {
        this.pushProcurementRoute(card.routePath)
        return
      }
      if (card.queue) {
        const query = { queue: card.queue, status: null, workflow: card.workflowKey || card.key }
        query.myRelated = 1
        query.myApplications = false
        if (card.tab === 'order' || card.tab === 'todo') {
          this.pushProcurementRoute(card.tab === 'todo' ? '/procurement/todo' : '/procurement/order', query)
          return
        }
        this.pushProcurementRoute('/procurement/apply', query)
        return
      }
      if (typeof card.status !== 'undefined' && card.status !== null && card.status !== '') {
        const query = { status: card.status, queue: '' }
        if (this.activeTab === 'dashboard') query.myApplications = 1
        this.pushApplyRoute(query)
        return
      }
      if (card.tab) {
        if (card.tab === 'apply') {
          if (this.activeTab === 'dashboard') {
            this.pushProcurementRoute('/procurement/apply', { myApplications: 1 })
            return
          }
          this.pushApplyRoute({}, { reset: true })
          return
        }
        const pathMap = {
          dashboard: '/procurement/workbench',
          report: '/procurement/report',
          order: '/procurement/order',
          todo: '/procurement/todo',
          supplier: '/procurement/supplier',
          price: '/procurement/price'
        }
        this.pushProcurementRoute(pathMap[card.tab] || '/procurement/workbench')
      }
    },
    openWorkflowMenu(node) {
      if (node.queue) {
        const query = { queue: node.queue, workflow: node.key, status: null }
        if (this.activeTab === 'dashboard') query.myRelated = 1
        if (node.tab === 'order' || node.tab === 'todo') {
          this.pushProcurementRoute(node.tab === 'todo' ? '/procurement/todo' : '/procurement/order', query)
          return
        }
        this.pushProcurementRoute('/procurement/apply', query)
        return
      }
      if (node.status) {
        this.pushApplyRoute({ status: node.status, workflow: node.key, queue: '' })
        return
      }
      if (node.tab === 'apply' || node.tab === 'order' || node.tab === 'todo') {
        if (node.tab === 'order') {
          this.pushProcurementRoute('/procurement/order', Object.assign({ workflow: node.key }, this.activeTab === 'dashboard' ? { myRelated: 1 } : {}, node.queue ? { queue: node.queue } : {}))
          return
        }
        if (node.tab === 'todo') {
          this.pushProcurementRoute('/procurement/todo', Object.assign({ workflow: node.key }, this.activeTab === 'dashboard' ? { myRelated: 1 } : {}, node.queue ? { queue: node.queue } : {}))
          return
        }
        if (this.activeTab === 'dashboard') {
          this.pushProcurementRoute('/procurement/apply', { workflow: node.key, myRelated: 1 })
          return
        }
        this.pushApplyRoute({ workflow: node.key }, { reset: true })
        return
      }
      const pathMap = {
        dashboard: '/procurement/workbench',
        report: '/procurement/report',
        order: '/procurement/order',
        todo: '/procurement/todo',
        supplier: '/procurement/supplier',
        price: '/procurement/price'
      }
      this.pushProcurementRoute(pathMap[node.tab] || '/procurement/workbench', node.key ? { workflow: node.key } : {})
    },
    matchesPaymentPurchaser(row) {
      const roles = this.currentRoleKeys
      if (roles.some(key => ['cg', 'gly'].includes(key))) return true
      const type = Number(row && row.purchaseType)
      if (type === 2) return roles.includes('xmcgy')
      if (type === 7) return roles.some(key => ['xmcgy', 'fxmcgy'].includes(key))
      return roles.includes('fxmcgy')
    },
    applyMatchesQueue(row, queue) {
      if (!row || !queue) return true
      const status = Number(row.status || 10)
      const documentType = Number(row.documentType || 1)
      const paymentStatus = Number(row.paymentStatus || 10)
      const arrivalStatus = Number(row.arrivalStatus || 10)
      const splitStatus = Number(row.splitStatus || 10)
      const paidAmount = Number(row.paidAmount || 0)
      const unpaidAmount = Number(row.unpaidAmount || 0)
      const executableStatus = ![10, 20, 30, 110, 115, 120].includes(status)
      if (queue === 'draft') return documentType === 1 && [10, 30].includes(status)
      if (queue === 'supplierConfirmation') return documentType === 1 && status === 40 && splitStatus !== 20
      if (queue === 'approval') return documentType === 1 && status === 20
      if (queue === 'contract') return false
      if (queue === 'payment') return this.canReceivePurchasePaymentTodo && this.matchesPaymentPurchaser(row) && documentType === 2 && executableStatus && [20, 40, 60].includes(paymentStatus)
      if (queue === 'arrival') {
        return documentType === 2 && executableStatus && [10, 20, 40].includes(arrivalStatus)
      }
      if (queue === 'todo') {
        return this.applyMatchesQueue(row, 'draft') ||
          this.applyMatchesQueue(row, 'approval') ||
          (documentType === 1 && status === 40 && splitStatus !== 20) ||
          this.applyMatchesQueue(row, 'contract') ||
          this.applyMatchesQueue(row, 'payment') ||
          this.applyMatchesQueue(row, 'arrival')
      }
      if (queue === 'paid') return documentType === 2 && executableStatus && paidAmount > 0
      if (queue === 'unpaid') return documentType === 2 && executableStatus && unpaidAmount > 0
      if (queue === 'sourcing') return documentType === 1 && [10, 30].includes(status)
      return true
    },
    buildRecognitionReviewItems(source) {
      const data = source || {}
      const items = []
      const supplierName = data.supplierName || data.partyB
      if (this.shouldShowSupplierInputColumn && !supplierName) items.push('待补供应商')
      if (this.aiScopeVisible('contract') && this.isSupplierOrderDetail && !data.contractAmount) items.push('合同金额未识别')
      const materialRows = this.toObjectArray(data.itemList).filter(item => item && item.materialName)
      if (!materialRows.length) {
        items.push('待补采购清单')
      } else {
        const missingSpecCount = materialRows.filter(item => !item.specification).length
        const missingSupplierCount = materialRows.filter(item => !item.supplierName && !item.supplierId).length
        const missingPriceCount = materialRows.filter(item => !item.purchaseUnitPrice && !item.amount).length
        if (missingSpecCount) items.push(`${missingSpecCount}条明细待补规格`)
        if (this.shouldShowSupplierInputColumn && missingSupplierCount) items.push(`${missingSupplierCount}条明细待选供应商`)
        if (this.isSupplierOrderDetail && missingPriceCount) items.push(`${missingPriceCount}条明细待补价格`)
      }
      if (this.aiScopeVisible('payment') && this.isSupplierOrderDetail && !this.toObjectArray(data.paymentPlanList).some(item => item && item.nodeName)) items.push('待补付款条款')
      if (!this.shouldShowSupplierInputColumn && this.recognizedSupplierCandidates(data).length > 1) {
        items.push('识别到多个供应商，审批通过后再逐项确认最终供应商')
      }
      return items
    },
    showContractTextInput() {
      this.$nextTick(() => {
        const input = this.$el.querySelector('.ai-recognition-dialog .contract-text-input textarea, .contract-text-input textarea')
        if (input) input.focus()
      })
    },
    focusPurchaseTitle() {
      this.$nextTick(() => {
        const input = this.$el.querySelector('.purchase-form input[placeholder="请输入采购主题"]')
        if (input) input.focus()
      })
    },
    handleAddApply(entryMode = 'ai') {
      if (this.isDetailPage && this.routeViewFromPath(this.$route.path).create) {
        this.initNewApply(entryMode)
        return
      }
      this.$router.push({ path: '/procurement/apply/new', query: this.normalizeRouteQuery({ entryMode }) })
    },
    initNewApply(entryMode = 'ai') {
      this.activeWorkflowKey = 'apply'
      this.applyDialogTitle = '新增采购申请'
      this.detailTab = 'basic'
      this.uploadRenderKey += 1
      this.stopRecognitionTicker()
      this.recognitionProgress = 0
      this.recognitionMessage = entryMode === 'ai' ? '待AI录入' : '待填写'
      this.recognitionStage = ''
      this.recognitionElapsedSeconds = 0
      this.aiEntryOpen = false
      this.aiRecognitionForm = this.emptyAiRecognitionForm()
      this.aiRecognizedResult = null
      this.aiRecognitionRawFiles = []
      this.aiAllowedScopeValues = this.defaultAiScopeValues()
      this.aiApplyScopes = this.aiAllowedScopeValues.slice()
      this.aiOverwriteExisting = false
      this.aiResultTab = this.defaultAiResultTab()
      this.applyWorkbookDialogOpen = false
      this.applyWorkbookPreview = { itemList: [], warningList: [] }
      this.applyWorkbookSourceFile = null
      this.applyWorkbookSourceFileInfo = null
      this.detail = this.emptyDetail()
      this.applyForm = this.emptyApplyForm()
      this.contractQueryKeyword = ''
      this.contractSearchRequestSeq += 1
      this.contractForm = this.emptyContractForm()
      this.quoteForm = this.emptyQuoteForm()
      this.arrivalEditingExisting = false
      this.arrivalForm = this.emptyArrivalForm()
      this.contractPaymentPlanList = []
      this.contractOptions = []
      this.addApplyItem()
      this.addAttachment(8)
      this.$nextTick(() => {
        this.detailTab = 'basic'
        if (this.$refs.applyForm) this.$refs.applyForm.clearValidate()
      })
    },
    openContractDraft() {
      this.handleAddApply('ai')
      this.activeWorkflowKey = 'apply'
    },
    isRowActionEvent(event) {
      const target = event && event.target
      return !!(target && target.closest && target.closest('.el-button, .el-dropdown, .el-dropdown-menu, .el-checkbox, .el-input, .el-select, .el-date-editor'))
    },
    handleRecentApplyRowClick(row, column, event) {
      if (this.isRowActionEvent(event)) return
      this.handleEditApply(row)
    },
    handleApplyRowClick(row, column, event) {
      if (this.isRowActionEvent(event)) return
      this.handleViewApply(row)
    },
    handleViewApply(row) {
      this.handleEditApply(row, 'basic')
    },
    handleProcessApply(row) {
      this.handleEditApply(row, this.recommendedDetailTab(row))
    },
    handleEditApply(row, preferredTab) {
      if (!row || !row.id) return
      const query = preferredTab ? { tab: preferredTab } : {}
      this.pushApplyDetailRoute(row.id, query)
    },
    openApplyDetailById(id, preferredTab, openApprovalFlow = false) {
      if (!id) return
      getPurchaseApplyDetail(id).then(res => {
        const detail = res.data || {}
        this.fillDetail(detail)
        this.detailTab = typeof preferredTab === 'string' ? preferredTab : 'basic'
        this.$nextTick(() => {
          this.ensureDetailTabVisible()
          if (openApprovalFlow) this.openApprovalFlowDialog()
        })
      })
    },
    backToApplyList() {
      const query = Object.assign({}, this.queryParams, {
        pageNum: this.applyPage.pageNum,
        pageSize: this.applyPage.pageSize
      })
      const path = this.isSupplierOrderDetail ? '/procurement/order' : '/procurement/apply'
      this.pushProcurementRoute(path, query)
    },
    openApproval(row) {
      if (!row || !row.id) return
      this.pushApplyDetailRoute(row.id, { tab: 'basic', approval: '1' })
    },
    fillDetail(detail) {
      this.uploadRenderKey += 1
      this.quoteRequirementsExpanded = false
      this.aiEntryOpen = false
      this.aiRecognitionForm = this.emptyAiRecognitionForm()
      this.aiRecognizedResult = null
      this.pendingSplitSupplierFeeMap = {}
      this.detail = Object.assign(this.emptyDetail(), detail)
      this.contractEditing = false
      this.contractEditSnapshot = null
      this.contractModeDraft = Number(detail.contractMode || 1)
      this.noContractReasonDraft = detail.noContractReason || ''
      this.shipmentEditing = false
      this.shipmentForm = Object.assign(this.emptyShipmentForm(), { applyId: detail.id })
      this.applyForm = Object.assign(this.emptyApplyForm(), detail, {
        itemList: detail.itemList && detail.itemList.length ? detail.itemList : [],
        attachmentList: (detail.attachmentList || []).filter(item => {
          return Number(item.relationType || 1) === 1 && Number(item.attachmentType || 8) === 8
        }).map(item => {
          return Object.assign({}, item, { attachmentFileObjs: item.attachmentFileObjs || [] })
        })
      })
      if (![1, 2, 3, 4, 5, 6, 7].includes(Number(this.applyForm.purchaseType))) {
        this.applyForm.purchaseType = 1
      }
      this.aiAllowedScopeValues = this.defaultAiScopeValues()
      this.aiApplyScopes = this.aiAllowedScopeValues.slice()
      this.aiResultTab = this.defaultAiResultTab()
      this.applyDialogTitle = detail.applyNo ? `${this.detailDocumentTitle}：${detail.applyNo}` : this.detailDocumentTitle
      this.ensureContractOption(this.applyForm)
      if (!this.applyForm.itemList.length && !this.isAttachmentOnlyApplication) this.addApplyItem()
      this.contractForm = Object.assign(this.emptyContractForm(), detail.contractInfo || {}, {
        applyId: detail.id,
        fileInfoList: detail.contractInfo && detail.contractInfo.fileInfoList ? detail.contractInfo.fileInfoList : [],
        contractText: ''
      })
      this.applySupplierOrderContractDefaults()
      this.applyForm.expectedArrivalDate = this.normalizeDateValue(this.applyForm.expectedArrivalDate)
      this.applyForm.itemList = (this.applyForm.itemList || []).map(item => Object.assign({}, item, {
        expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate),
        modelNo: item.modelNo || item.specification || '',
        specification: item.specification || item.modelNo || '',
        materialRequirement: item.materialRequirement || item.materialQualityBrand || ''
      }))
      this.contractForm.signDate = this.normalizeDateValue(this.contractForm.signDate)
      this.contractPaymentPlanList = (detail.paymentPlanList || []).map(item => Object.assign({}, item, {
        payableDate: this.normalizeDateValue(item.payableDate)
      }))
      this.quoteForm = Object.assign(this.emptyQuoteForm(), { applyId: detail.id })
      this.arrivalEditingExisting = false
      this.arrivalForm = Object.assign(this.emptyArrivalForm(), { applyId: detail.id })
      this.$nextTick(() => {
        this.autoMatchRecognizedReferences()
        this.ensureDetailTabVisible()
      })
    },
    applySupplierOrderContractDefaults() {
      if (!this.isSupplierOrderDetail || !this.contractForm || !this.applyForm) return
      const supplierName = this.applyForm.supplierName || ''
      if (!this.contractForm.partyA) this.$set(this.contractForm, 'partyA', this.currentTenantName())
      if (!this.contractForm.supplierId && this.applyForm.supplierId) this.$set(this.contractForm, 'supplierId', this.applyForm.supplierId)
      if (!this.contractForm.supplierName && supplierName) this.$set(this.contractForm, 'supplierName', supplierName)
      if (!this.contractForm.partyB && (this.contractForm.supplierName || supplierName)) {
        this.$set(this.contractForm, 'partyB', this.contractForm.supplierName || supplierName)
      }
      if (!this.contractForm.contractAmount && this.applyForm.applyAmount) {
        this.$set(this.contractForm, 'contractAmount', Number(this.applyForm.applyAmount || 0))
      }
      if (!this.contractForm.contractName && this.applyForm.applyTitle) {
        this.$set(this.contractForm, 'contractName', this.applyForm.applyTitle)
      }
    },
    replaceContractOptions(rows, keyword = '') {
      const options = (rows || []).filter(item => item && item.id)
      const selectedId = this.applyForm && this.applyForm.contractId
      const selectedExists = selectedId && options.some(item => String(item.id) === String(selectedId))
      if (!String(keyword || '').trim() && selectedId && !selectedExists) {
        options.unshift({
          id: selectedId,
          contractNum: this.applyForm.contractNum,
          contractName: this.applyForm.projectName
        })
      }
      this.contractOptions = options
    },
    tenantPartyOptions(query) {
      const store = this.$store || {}
      const getters = store.getters || {}
      const stateUser = store.state && store.state.user ? store.state.user : {}
      const tenants = getters.tenants || stateUser.tenants || []
      const normalized = this.normalizeReferenceName(query)
      const seen = new Set()
      return tenants.map(item => {
        const fullName = item.fullName || item.tenantName || item.name || ''
        if (!fullName) return null
        const key = this.normalizeReferenceName(fullName)
        if (!key || seen.has(key)) return null
        seen.add(key)
        const shortName = item.shortName || item.name || ''
        const searchText = this.normalizeReferenceName([fullName, shortName].filter(Boolean).join(' '))
        let score = normalized ? 0 : 1
        if (normalized && searchText.indexOf(normalized) > -1) score += 80
        return {
          tenantId: item.tenantId,
          fullName,
          shortName,
          score
        }
      }).filter(item => item && item.score > 0).sort((left, right) => right.score - left.score).slice(0, 20)
    },
    queryTenantPartySuggestions(query, callback) {
      const options = this.tenantPartyOptions(query)
      if (options.length) {
        callback(options)
        return
      }
      const current = this.currentTenantName()
      callback(current ? [{ fullName: current, shortName: '当前租户' }] : [])
    },
    handleContractPartyASelect(item) {
      if (item && item.fullName) this.$set(this.contractForm, 'partyA', item.fullName)
    },
    handleContractPartyABlur() {
      if (!this.contractForm.partyA) this.$set(this.contractForm, 'partyA', this.currentTenantName())
    },
    ensureContractOption(source) {
      if (!source || !source.contractId) return
      const exists = (this.contractOptions || []).some(item => String(item.id) === String(source.contractId))
      if (exists) return
      this.contractOptions.push({
        id: source.contractId,
        contractNum: source.contractNum,
        contractName: source.contractName || source.projectName
      })
    },
    contractOptionLabel(item) {
      if (!item) return ''
      return [item.contractNum, item.contractName || item.customerName || item.businessName].filter(Boolean).join(' | ')
    },
    searchContracts(keyword) {
      this.contractQueryKeyword = keyword || ''
      const normalizedKeyword = this.contractQueryKeyword.trim()
      const requestSeq = this.contractSearchRequestSeq + 1
      this.contractSearchRequestSeq = requestSeq
      this.loading.contract = true
      listPurchaseContractOptions(normalizedKeyword).then(res => {
        if (requestSeq !== this.contractSearchRequestSeq) return
        this.replaceContractOptions(this.responseRows(res), normalizedKeyword)
      }).catch(() => {
        if (requestSeq !== this.contractSearchRequestSeq) return
        this.replaceContractOptions([], normalizedKeyword)
      }).finally(() => {
        if (requestSeq !== this.contractSearchRequestSeq) return
        this.loading.contract = false
      })
    },
    handleContractChange(contractId) {
      if (!contractId) {
        this.applyForm.contractNum = ''
        this.applyForm.projectCode = ''
        this.applyForm.projectName = ''
        return
      }
      const contract = (this.contractOptions || []).find(item => String(item.id) === String(contractId))
      if (!contract) return
      this.applyForm.contractNum = contract.contractNum || ''
      this.applyForm.projectCode = contract.contractNum || ''
      this.applyForm.projectName = contract.contractName || contract.businessName || ''
    },
    handlePurchaseTypeChange(value) {
      if (Number(value) !== 2) {
        this.contractSearchRequestSeq += 1
        this.loading.contract = false
        this.contractOptions = []
        this.applyForm.projectCode = ''
        this.applyForm.projectName = ''
        this.applyForm.contractId = null
        this.applyForm.contractNum = ''
        this.$nextTick(() => {
          if (this.$refs.applyForm) this.$refs.applyForm.clearValidate('contractId')
        })
        return
      }
      this.searchContracts('')
      this.$nextTick(() => {
        if (this.$refs.applyForm) this.$refs.applyForm.validateField('contractId')
      })
    },
    refreshCurrentDetail() {
      if (!this.applyForm.id) return Promise.resolve()
      return getPurchaseApplyDetail(this.applyForm.id).then(res => {
        this.fillDetail(res.data || {})
        this.loadApplyData()
        this.getSupplierList()
        this.getPriceList()
      })
    },
    recommendedDetailTab(row) {
      const status = Number(row && row.status ? row.status : 10)
      const documentType = Number(row && row.documentType ? row.documentType : 1)
      const paymentStatus = Number(row && row.paymentStatus ? row.paymentStatus : 10)
      const arrivalStatus = Number(row && row.arrivalStatus ? row.arrivalStatus : 10)
      if (this.activeWorkflowKey === 'sourcing' && [10, 30].includes(status)) return 'quote'
      if (this.queryParams.queue === 'contract' || this.activeWorkflowKey === 'contractPendingCount') return documentType === 1 && status >= 40 ? 'order' : 'basic'
      if (this.queryParams.queue === 'payment' || this.activeWorkflowKey === 'paymentPendingCount' || this.activeWorkflowKey === 'payment') return 'payment'
      if (this.queryParams.queue === 'arrival' || this.activeWorkflowKey === 'arrivalPendingCount' || this.activeWorkflowKey === 'receipts') return 'arrival'
      if (documentType === 1 && status === 40) return 'order'
      if (status === 20) return 'basic'
      if (documentType === 2 && !this.isContractStepComplete(row)) return 'contract'
      if ([60, 70].includes(status) || [20, 30, 40, 60].includes(paymentStatus)) return 'payment'
      if ([80, 90, 100].includes(status) || [20, 30, 40, 50].includes(arrivalStatus)) return 'arrival'
      if (status === 110) return 'basic'
      return 'basic'
    },
    shouldShowDetailTab(tab) {
      if (tab === 'basic') return true
      if (!this.applyForm || !this.applyForm.id) return false
      const status = Number(this.applyForm.status || 10)
      const flowKey = this.currentFlowKey
      if (tab === 'log') return true
      if (tab === 'decision') {
        return this.isApplicationDetail && this.canViewPurchaseSensitive && this.finalDecisionSupplierGroups.length > 0
      }
      if (tab === 'contract') return this.isSupplierOrderDetail
      if (tab === 'shipment') return this.isSupplierOrderDetail
      if (tab === 'quote') {
        if (!this.isApplicationDetail) return false
        return this.canViewPurchaseSensitive
      }
      if (tab === 'order') {
        if (!this.isApplicationDetail) return false
        return status >= 40 || this.isApplicationPendingSplit || (this.detail.supplierOrderList || []).length > 0
      }
      if (tab === 'payment') {
        if (!this.isSupplierOrderDetail) return false
        return ['payment', 'arrival', 'finish'].includes(flowKey) || (this.detail.paymentPlanList || []).length > 0
      }
      if (tab === 'arrival') {
        if (!this.isSupplierOrderDetail) return false
        return ['payment', 'arrival', 'finish'].includes(flowKey) || (this.detail.arrivalList || []).length > 0
      }
      return false
    },
    ensureDetailTabVisible() {
      if (this.shouldShowDetailTab(this.detailTab)) return
      const flowTabMap = {
        basic: 'basic',
        quote: 'quote',
        approval: 'basic',
        order: 'order',
        contract: 'contract',
        shipment: 'shipment',
        payment: 'payment',
        arrival: 'arrival',
        finish: 'basic'
      }
      const target = flowTabMap[this.currentFlowKey] || 'basic'
      this.detailTab = this.shouldShowDetailTab(target) ? target : 'basic'
    },
    jumpToFlowStep(step) {
      const target = step.tab || 'basic'
      this.detailTab = this.shouldShowDetailTab(target) ? target : 'basic'
      if (step.key === 'basic') {
        this.$nextTick(this.focusPurchaseTitle)
      }
      if (step.key === 'approval') {
        this.openApprovalFlowDialog()
      }
    },
    ensureWorkflowEditable(allowed, message) {
      if (allowed) return true
      this.msgWarning(message || '当前流程状态下不能执行该操作')
      return false
    },
    scrollPurchaseOperateLog() {
      this.detailTab = 'log'
      this.$nextTick(() => {
        const target = this.$refs.purchaseOperateLog || this.$refs.purchaseDetailSide
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },
    openApprovalFlowDialog() {
      if (!this.ensureWorkflowEditable(this.shouldShowApprovalFlowButton, '当前采购单还未进入审批节点')) return
      this.initializeApprovalSelections()
      this.approvalDialogOpen = true
    },
    initializeApprovalSelections() {
      this.approvalSelectionMap = {}
      this.approvalQuoteGroups.forEach(group => {
        const selectedIds = this.approvalMarkedQuoteIdsForGroup(group, 'selected')
        const recommendedIds = this.approvalRecommendedQuoteIdsForGroup(group)
        const quoteIds = selectedIds.length ? selectedIds : recommendedIds
        if (quoteIds.length) {
          this.$set(this.approvalSelectionMap, group.key, quoteIds.length === 1 ? quoteIds[0] : quoteIds)
        }
      })
    },
    approvalAvailableOffersForItem(group, item) {
      if (!group || !item || !item.offerMap) return []
      if (!this.quoteItemRequiresDecision(item)) return []
      return (group.suppliers || group.offers || []).map(supplier => item.offerMap[supplier.key])
        .filter(offer => offer && offer.id && this.quoteDisplayOfferIsEffective(offer))
    },
    approvalQuoteValueList(value) {
      if (Array.isArray(value)) return value
      return value ? [value] : []
    },
    approvalUniqueQuoteIds(values) {
      const seen = new Set()
      return (values || []).filter(quoteId => {
        const key = String(quoteId || '')
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    approvalMarkedQuoteIdsForGroup(group, field) {
      const quoteIds = []
      ;(group && group.items || []).forEach(item => {
        this.approvalAvailableOffersForItem(group, item).forEach(offer => {
          if (offer && offer[field] && offer.id) quoteIds.push(offer.id)
        })
      })
      if (!quoteIds.length && !(group && group.items && group.items.length)) {
        ;(group && group.offers || []).forEach(offer => {
          if (offer && offer[field] && offer.id) quoteIds.push(offer.id)
        })
      }
      return this.approvalUniqueQuoteIds(quoteIds)
    },
    approvalAutoCandidateQuoteIdsForGroup(group) {
      const items = group && group.items ? group.items : []
      if (!items.length) {
        const offers = (group && group.offers ? group.offers : []).filter(offer => offer && offer.id)
        return offers.length === 1 ? [offers[0].id] : []
      }
      const quoteIds = []
      items.forEach(item => {
        const availableOffers = this.approvalAvailableOffersForItem(group, item)
        if (availableOffers.length === 1) quoteIds.push(availableOffers[0].id)
      })
      return this.approvalUniqueQuoteIds(quoteIds)
    },
    approvalSingleCandidateQuoteIdsForGroup(group) {
      const items = group && group.items ? group.items : []
      if (!items.length) {
        const offers = (group && group.offers ? group.offers : []).filter(offer => offer && offer.id)
        return offers.length === 1 ? [offers[0].id] : []
      }
      const quoteIds = []
      for (let index = 0; index < items.length; index++) {
        const availableOffers = this.approvalAvailableOffersForItem(group, items[index])
        if (availableOffers.length !== 1) return []
        quoteIds.push(availableOffers[0].id)
      }
      return quoteIds
    },
    approvalRecommendedQuoteIdsForGroup(group) {
      const quoteIds = []
      ;(group && group.items || []).forEach(item => {
        const recommended = this.approvalAvailableOffersForItem(group, item)
          .find(offer => offer && offer.recommended && offer.id)
        if (recommended) quoteIds.push(recommended.id)
      })
      if (!quoteIds.length && !(group && group.items && group.items.length)) {
        ;(group && group.offers || []).forEach(offer => {
          if (offer && offer.recommended && offer.id) quoteIds.push(offer.id)
        })
      }
      return this.approvalUniqueQuoteIds(quoteIds)
    },
    approvalSelectedOfferForGroup(group) {
      const selectedIds = new Set(this.approvalQuoteValueList(
        group && this.approvalSelectionMap ? this.approvalSelectionMap[group.key] : null
      ).map(quoteId => String(quoteId)))
      if (!selectedIds.size) return null
      return (group.offers || []).find(offer => {
        if (selectedIds.has(String(offer.id))) return true
        return (offer.lineList || []).some(line => selectedIds.has(String(line.id)))
      }) || null
    },
    approvalQuoteIdsForGroup(group) {
      const quoteIds = []
      this.approvalQuoteValueList(group && this.approvalSelectionMap ? this.approvalSelectionMap[group.key] : null)
        .forEach(quoteId => quoteIds.push(quoteId))
      this.approvalAutoCandidateQuoteIdsForGroup(group).forEach(quoteId => quoteIds.push(quoteId))
      return this.approvalUniqueQuoteIds(quoteIds)
    },
    approvalGroupSelectionComplete(group) {
      if (!group) return false
      const selectedOffer = this.approvalSelectedOfferForGroup(group)
      if (selectedOffer && Number((selectedOffer.lineList || []).length) >= Number(group.itemCount || 0)) {
        return true
      }
      const selectedIds = new Set(this.approvalQuoteIdsForGroup(group).map(quoteId => String(quoteId)))
      const items = group.items || []
      if (!items.length) return selectedIds.size > 0
      return items.every(item => {
        const availableOffers = this.approvalAvailableOffersForItem(group, item)
        if (!availableOffers.length) return true
        return availableOffers.some(offer => selectedIds.has(String(offer.id)))
      })
    },
    approvalOfferSelected(group, offer) {
      if (!group || !offer) return false
      const selectedIds = new Set(this.approvalQuoteValueList(this.approvalSelectionMap[group.key])
        .map(quoteId => String(quoteId)))
      if (selectedIds.size) {
        return selectedIds.has(String(offer.id)) ||
          (offer.lineList || []).some(line => selectedIds.has(String(line.id)))
      }
      const autoIds = new Set(this.approvalAutoCandidateQuoteIdsForGroup(group).map(quoteId => String(quoteId)))
      return autoIds.has(String(offer.id)) ||
        (offer.lineList || []).some(line => autoIds.has(String(line.id)))
    },
    selectApprovalQuote(group, offer) {
      if (!group || !group.key || !offer) return
      const quoteIds = this.approvalUniqueQuoteIds((offer.lineList || []).map(line => line && line.id)
        .concat(offer.id ? [offer.id] : []))
      if (!quoteIds.length) return
      this.$set(this.approvalSelectionMap, group.key, quoteIds.length === 1 ? quoteIds[0] : quoteIds)
    },
    adoptAllRecommendedQuotes() {
      let adoptedCount = 0
      this.approvalQuoteGroups.forEach(group => {
        const recommendedIds = this.approvalRecommendedQuoteIdsForGroup(group)
        if (recommendedIds.length) {
          this.$set(this.approvalSelectionMap, group.key, recommendedIds.length === 1 ? recommendedIds[0] : recommendedIds)
          adoptedCount++
        }
      })
      if (!adoptedCount) {
        this.msgWarning('采购员尚未推荐供应商或店铺')
        return
      }
      this.msgSuccess(`已采用${adoptedCount}个报价组的采购员推荐`)
    },
    openInquiryQuoteTab() {
      this.approvalDialogOpen = false
      this.detailTab = 'quote'
    },
    openOfflineCompleteDialog() {
      if (!this.canOfflineComplete) {
        this.msgWarning('只有当前采购员询价节点的办理人可以线下结束流程')
        return
      }
      this.offlineCompleteRemark = ''
      this.offlineCompleteDialogOpen = true
    },
    submitOfflineComplete() {
      const remark = String(this.offlineCompleteRemark || '').trim()
      if (remark.length < 5 || remark.length > 200) {
        this.msgWarning('线下结束备注请输入5至200个字符')
        return
      }
      const workOrderId = this.detail && this.detail.approvalWorkOrder && this.detail.approvalWorkOrder.workOrderId
      if (!workOrderId || this.offlineCompleteSubmitting) return
      this.offlineCompleteSubmitting = true
      handleWorkOrder({ workOrderId, operationType: 10, remark }).then(() => {
        this.msgSuccess('采购流程已标记为线下结束')
        this.offlineCompleteDialogOpen = false
        this.approvalDialogOpen = false
        this.offlineCompleteRemark = ''
        return this.refreshCurrentDetail()
      }).then(() => {
        return this.refreshPurchaseApprovalInfo()
      }).then(() => {
        this.detailTab = 'basic'
      }).finally(() => {
        this.offlineCompleteSubmitting = false
      })
    },
    handlePurchaseApprovalAction(payload) {
      const request = Object.assign({}, payload)
      if (Number(request.operationType) === 1 && this.isSupplierDecisionApprovalNode) {
        if (!this.approvalQuoteGroups.length || this.approvalSelectedGroupCount !== this.approvalQuoteGroups.length) {
          this.msgWarning('请为每个普通报价组选择一家供应商，并为每个电商采购项选择一家店铺')
          return Promise.reject(new Error('报价组定商尚未完成'))
        }
        request.selectedQuoteIdList = this.approvalSelectedQuoteIds
      }
      return handleWorkOrder(request)
    },
    refreshOperateLogList() {
      if (this.$refs.operateLogListRef && this.$refs.operateLogListRef.refresh) {
        this.$refs.operateLogListRef.refresh()
      }
    },
    refreshPurchaseApprovalInfo() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          const approvalInfo = this.$refs.purchaseApprovalInfo
          if (!approvalInfo || typeof approvalInfo.refresh !== 'function') {
            resolve()
            return
          }
          Promise.resolve(approvalInfo.refresh()).then(resolve).catch(reject)
        })
      })
    },
    handleGroupMemberSuccess() {
      this.refreshOperateLogList()
      this.refreshCurrentDetail()
    },
    runNextAction(actionKey) {
      const actions = {
        saveDraft: () => this.saveApply(false),
        saveSubmit: () => this.saveApply(true),
        goBasic: () => { this.detailTab = 'basic' },
        goContract: () => {
          if (this.ensureWorkflowEditable(this.shouldShowDetailTab('contract'), '当前采购单还不能查看采购合同')) this.detailTab = 'contract'
        },
        goQuote: () => {
          if (this.ensureWorkflowEditable(this.shouldShowDetailTab('quote'), '请先保存采购申请后再查看供应商报价')) this.detailTab = 'quote'
        },
        goOrder: () => {
          if (this.ensureWorkflowEditable(this.shouldShowDetailTab('order'), '审批通过后才能查看采购执行单')) this.detailTab = 'order'
        },
        goApproval: () => {
          this.openApprovalFlowDialog()
        },
        goPayment: () => {
          if (this.ensureWorkflowEditable(this.shouldShowDetailTab('payment'), '当前采购单还未进入付款节点')) this.detailTab = 'payment'
        },
        goArrival: () => {
          if (this.ensureWorkflowEditable(this.shouldShowDetailTab('arrival'), '当前采购单还未进入到货验收节点')) this.detailTab = 'arrival'
        },
        goLog: () => this.scrollPurchaseOperateLog()
      }
      if (actions[actionKey]) actions[actionKey]()
    },
    openDirectOrderDialog() {
      if (!this.ensureWorkflowEditable(this.canCreateDirectOrder, '只有采购员可以新增零星采购')) return
      this.directOrderForm = this.emptyDirectOrderForm()
      this.directOrderDialogOpen = true
    },
    addDirectOrderItem() {
      this.directOrderForm.itemList.push(this.emptyApplyItem())
    },
    removeDirectOrderItem(index) {
      this.directOrderForm.itemList.splice(index, 1)
      if (!this.directOrderForm.itemList.length) this.addDirectOrderItem()
      this.recalculateDirectOrder()
    },
    directOrderItemAmount(item) {
      return this.roundMoneyValue(this.directOrderItemRawAmount(item))
    },
    directOrderItemRawAmount(item) {
      const quantity = Number(item && item.quantity || 0)
      const unitPrice = Number(item && item.purchaseUnitPrice || 0)
      return Number.isFinite(quantity) && Number.isFinite(unitPrice) ? quantity * unitPrice : 0
    },
    recalculateDirectOrder() {
      ;(this.directOrderForm.itemList || []).forEach(item => {
        this.$set(item, 'amount', this.directOrderItemAmount(item))
      })
      this.$set(this.directOrderForm, 'applyAmount', this.directOrderAmount)
    },
    handleDirectSupplierInput() {
      this.$set(this.directOrderForm, 'supplierId', null)
    },
    handleDirectSupplierSelect(item) {
      this.$set(this.directOrderForm, 'supplierId', item && item.id ? item.id : null)
      this.$set(this.directOrderForm, 'supplierName', item && item.supplierName ? item.supplierName : '')
    },
    validateDirectOrder() {
      const form = this.directOrderForm || {}
      if (!String(form.applyTitle || '').trim()) return '请填写采购主题'
      if (!form.purchaseType) return '请选择采购类型'
      if (!form.expectedArrivalDate) return '请选择期望到货日期'
      if (!String(form.supplierName || '').trim()) return '请填写完整供应商名称'
      if (!String(form.purchaseReason || '').trim()) return '请填写采购原因'
      if (Number(form.contractMode) === 2 && !String(form.noContractReason || '').trim()) return '请填写无需合同的原因'
      const rows = (form.itemList || []).filter(item => String(item.materialName || '').trim())
      if (!rows.length) return '请至少填写一条真实采购项'
      const invalid = rows.find(item => Number(item.quantity || 0) <= 0 || item.purchaseUnitPrice === undefined || item.purchaseUnitPrice === null || Number(item.purchaseUnitPrice) <= 0)
      if (invalid) return `请补齐“${invalid.materialName || '采购项'}”的数量和单价`
      return ''
    },
    submitDirectOrder() {
      if (!this.ensureWorkflowEditable(this.canCreateDirectOrder, '只有采购员可以新增零星采购')) return
      this.recalculateDirectOrder()
      const error = this.validateDirectOrder()
      if (error) {
        this.msgWarning(error)
        return
      }
      const payload = Object.assign({}, this.directOrderForm, {
        sourceMode: 4,
        documentType: 2,
        applyAmount: this.directOrderAmount,
        expectedArrivalDate: this.normalizeDateValue(this.directOrderForm.expectedArrivalDate),
        itemList: (this.directOrderForm.itemList || []).filter(item => String(item.materialName || '').trim()).map((item, index) => Object.assign({}, item, {
          sortNo: index + 1,
          amount: this.directOrderItemAmount(item),
          supplierId: this.directOrderForm.supplierId || null,
          supplierName: String(this.directOrderForm.supplierName || '').trim(),
          expectedArrivalDate: this.normalizeDateValue(this.directOrderForm.expectedArrivalDate)
        }))
      })
      this.directOrderSaving = true
      saveDirectPurchaseOrder(payload).then(res => {
        const orderId = res && res.data ? res.data : null
        this.msgSuccess('零星采购单已生成')
        this.directOrderDialogOpen = false
        this.loadApplyData()
        if (orderId) this.handleEditApply({ id: orderId, documentType: 2 }, 'basic')
      }).finally(() => {
        this.directOrderSaving = false
      })
    },
    openShipmentEditor(row) {
      if (!this.ensureWorkflowEditable(this.canManageShipment, '只有采购员可以维护发货物流')) return
      this.uploadRenderKey += 1
      this.shipmentForm = Object.assign(this.emptyShipmentForm(), row || {}, {
        applyId: this.applyForm.id,
        shipmentDate: this.normalizeDateValue(row && row.shipmentDate),
        fileInfoList: row && row.fileInfoList ? row.fileInfoList.slice() : []
      })
      this.shipmentEditing = true
    },
    cancelShipmentEdit() {
      this.shipmentEditing = false
      this.shipmentForm = Object.assign(this.emptyShipmentForm(), { applyId: this.applyForm.id })
    },
    handleSaveShipment() {
      if (!this.ensureWorkflowEditable(this.canManageShipment, '只有采购员可以维护发货物流')) return
      const form = this.shipmentForm || {}
      if (!form.shipmentDate) {
        this.msgWarning('请选择发货日期')
        return
      }
      if (Number(form.shipmentMethod) === 1 && !String(form.trackingNo || '').trim()) {
        this.msgWarning('快递/物流发货时必须填写物流单号')
        return
      }
      this.shipmentSaving = true
      savePurchaseShipment(Object.assign({}, form, {
        applyId: this.applyForm.id,
        shipmentDate: this.normalizeDateValue(form.shipmentDate)
      })).then(() => {
        this.msgSuccess('物流记录已保存')
        this.cancelShipmentEdit()
        return this.refreshCurrentDetail()
      }).finally(() => {
        this.shipmentSaving = false
      })
    },
    handleRemoveShipment(row) {
      if (!this.ensureWorkflowEditable(this.canManageShipment, '只有采购员可以维护发货物流')) return
      this.$confirm('确认删除这条物流记录？', '提示', { type: 'warning' }).then(() => {
        return removePurchaseShipment(row.id)
      }).then(() => {
        this.msgSuccess('物流记录已删除')
        return this.refreshCurrentDetail()
      }).catch(() => {})
    },
    openShipmentAttachments(row) {
      const files = row && row.fileInfoList ? row.fileInfoList : []
      if (!files.length) return
      if (files.length === 1) {
        this.openQuoteFile(files[0])
        return
      }
      this.shipmentAttachmentFiles = files.slice()
      this.shipmentAttachmentDialogOpen = true
    },
    addApplyItem() {
      this.applyForm.itemList.push(this.emptyApplyItem())
      this.normalizeApplyAmounts()
    },
    handleAttachmentOnlyModeChange(enabled) {
      if (!this.canEditProcurementBase) return
      if (!enabled) {
        this.$set(this.applyForm, 'sourceMode', 1)
        this.$set(this.applyForm, 'applyAmount', 0)
        this.$set(this.applyForm, 'budgetAmount', 0)
        if (!(this.applyForm.itemList || []).length) this.addApplyItem()
        return
      }
      const enableAttachmentOnly = () => {
        this.$set(this.applyForm, 'sourceMode', 6)
        this.$set(this.applyForm, 'itemList', [])
        this.$set(this.applyForm, 'applyAmount', undefined)
        this.$set(this.applyForm, 'budgetAmount', undefined)
      }
      const demandRows = (this.applyForm.itemList || []).filter(item => item && String(item.materialName || '').trim())
      if (!demandRows.length) {
        enableAttachmentOnly()
        return
      }
      this.$confirm(
        '切换后将清空当前已填写的采购需求明细，原始需求请通过附件上传。是否继续？',
        '切换为仅附件申请',
        {
          confirmButtonText: '继续切换',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(enableAttachmentOnly).catch(() => {})
    },
    syncApplicationModel(row, value) {
      if (!row || !this.isApplicationDetail) return
      this.$set(row, 'modelNo', value || '')
    },
    syncPreviewModel(row, value) {
      if (!row) return
      this.$set(row, 'specification', value || '')
    },
    updateApplyWorkbookSection(group, value) {
      const normalized = String(value || '')
      const rows = (group && group.items) || []
      rows.forEach(row => {
        this.$set(row, 'processSection', normalized)
      })
    },
    updateApplyWorkbookItemGroup(items, rowIndex, value) {
      const rows = items || []
      const current = rows[rowIndex]
      if (!current) return
      const previousValue = String(current.itemGroupName || '')
      let start = rowIndex
      let end = rowIndex
      if (previousValue) {
        while (start > 0 && String(rows[start - 1].itemGroupName || '') === previousValue) start--
        while (end + 1 < rows.length && String(rows[end + 1].itemGroupName || '') === previousValue) end++
      }
      for (let index = start; index <= end; index++) {
        this.$set(rows[index], 'itemGroupName', String(value || ''))
      }
    },
    applyWorkbookGroupSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex !== 0) return [1, 1]
      const rows = this.applyWorkbookCategoryGroups.reduce((result, group) => {
        if (group.items.indexOf(row) > -1) return group.items
        return result
      }, [])
      const groupName = String(row && row.itemGroupName || '')
      if (!groupName || !rows.length) return [1, 1]
      if (rowIndex > 0 && String(rows[rowIndex - 1].itemGroupName || '') === groupName) return [0, 0]
      let span = 1
      while (rowIndex + span < rows.length &&
        String(rows[rowIndex + span].itemGroupName || '') === groupName) {
        span++
      }
      return [span, 1]
    },
    applyWorkbookSourceCellStyle(cell) {
      const horizontal = String(cell && cell.horizontalAlign || '').toLowerCase()
      const vertical = String(cell && cell.verticalAlign || '').toLowerCase()
      return {
        border: cell && cell.bordered ? '1px solid #111827' : '1px solid transparent',
        backgroundColor: cell && cell.backgroundColor ? cell.backgroundColor : '#ffffff',
        color: cell && cell.fontColor ? cell.fontColor : '#111827',
        fontWeight: cell && cell.bold ? 700 : 400,
        fontSize: `${cell && cell.fontSizePx ? cell.fontSizePx : 13}px`,
        textAlign: ['center', 'left', 'right'].includes(horizontal) ? horizontal : 'left',
        verticalAlign: ['top', 'bottom', 'center'].includes(vertical)
          ? (vertical === 'center' ? 'middle' : vertical)
          : 'middle',
        whiteSpace: cell && cell.wrapText ? 'pre-wrap' : 'nowrap'
      }
    },
    runApplyWorkbookRecognition(entry) {
      const file = entry && entry.rawFile
      if (!file) {
        this.msgWarning('原始Excel文件已丢失，请重新选择')
        return
      }
      if (!/\.xlsx?$/i.test(String(file.name || ''))) {
        this.msgWarning('请选择xls或xlsx采购需求文件')
        return
      }
      if (Number(file.size || 0) > 20 * 1024 * 1024) {
        this.msgWarning('采购需求文件不能超过20MB')
        return
      }
      this.aiRecognizedResult = null
      this.recognizingContract = true
      this.applyWorkbookLoading = true
      this.resetRecognitionProgress()
      this.updateRecognitionProgress({
        stage: 'CALL_QWEN_WORKBOOK',
        message: '正在解析表格结构并提取采购需求明细',
        percent: 28
      })
      this.startRecognitionTicker()
      parsePurchaseApplyWorkbook(file).then(response => {
        const preview = response.data || response || {}
        this.updateRecognitionProgress({
          stage: 'PARSE_RESULT',
          message: '正在整理采购需求明细',
          percent: 92
        })
        this.prepareApplyWorkbookPreview(file, preview, entry.fileInfo)
        this.updateRecognitionProgress({
          stage: 'DONE',
          message: '采购需求清单已生成预览',
          percent: 100
        })
        this.aiEntryOpen = false
        this.applyWorkbookDialogOpen = true
        this.msgSuccess('采购需求清单识别完成，请在预览中核对后填入')
      }).catch(error => {
        this.recognitionStage = 'ERROR'
        this.recognitionMessage = error && error.message ? error.message : '采购需求清单识别失败'
        this.$message.error(this.recognitionMessage)
      }).finally(() => {
        this.recognizingContract = false
        this.applyWorkbookLoading = false
        this.stopRecognitionTicker()
      })
    },
    prepareApplyWorkbookPreview(file, preview, uploadedFileInfo) {
      const source = preview || {}
      const rows = (source.itemList || []).map(row => {
        const item = Object.assign(this.emptyApplyItem(), row)
        item.modelNo = item.modelNo || item.specification || ''
        item.specification = item.specification || item.modelNo || ''
        item.materialRequirement = item.materialRequirement || item.materialQualityBrand || ''
        item.materialQualityBrand = item.materialQualityBrand || item.materialRequirement || ''
        item.purchaseUnitPrice = undefined
        item.budgetUnitPrice = undefined
        item.amount = 0
        item.supplierId = null
        item.supplierName = ''
        return item
      })
      if (!rows.length) {
        throw new Error('清单中没有识别到可导入的采购需求')
      }
      this.applyWorkbookPreview = Object.assign({}, source, { itemList: rows })
      this.applyWorkbookSourceFile = file
      this.applyWorkbookSourceFileInfo = uploadedFileInfo || null
      this.applyWorkbookOverwrite = !(this.applyForm.itemList || []).some(item => item && item.materialName)
      this.applyWorkbookPreviewTab = 'structured'
    },
    confirmApplyWorkbookPreview() {
      const rows = (this.applyWorkbookPreview.itemList || []).filter(item => item && item.materialName)
      if (!rows.length) {
        this.msgWarning('请至少保留一条采购需求')
        return
      }
      const invalidIndex = rows.findIndex(item => Number(item.quantity || 0) <= 0 || !String(item.unit || '').trim())
      if (invalidIndex > -1) {
        this.msgWarning(`第 ${invalidIndex + 1} 条需求的数量或单位不完整`)
        return
      }
      if (!this.applyWorkbookSourceFile && !this.applyWorkbookSourceFileInfo) {
        this.msgWarning('原需求文件已丢失，请重新选择')
        return
      }
      this.applyWorkbookConfirming = true
      const archiveTask = this.applyWorkbookSourceFileInfo
        ? Promise.resolve({ data: this.applyWorkbookSourceFileInfo })
        : uploadPurchaseApplySourceFile(this.applyWorkbookSourceFile)
      archiveTask.then(response => {
        const fileInfo = response.data || response || {}
        if (!fileInfo.url && !fileInfo.id) {
          throw new Error('原需求文件归档失败')
        }
        const currentFiles = this.applicationAttachmentFileObjs || []
        const exists = currentFiles.some(item => item && (
          (fileInfo.id && String(item.id) === String(fileInfo.id)) ||
          (fileInfo.url && item.url === fileInfo.url)
        ))
        if (!exists) {
          this.applicationAttachmentFileObjs = currentFiles.concat([Object.assign({
            uid: fileInfo.uid || `${Date.now()}-${fileInfo.name || 'workbook'}`
          }, fileInfo)])
        }
        const normalizedRows = rows.map((row, index) => {
          const item = Object.assign(this.emptyApplyItem(), row, {
            sortNo: index + 1,
            modelNo: row.modelNo || row.specification || '',
            specification: row.specification || row.modelNo || '',
            materialRequirement: row.materialRequirement || row.materialQualityBrand || '',
            materialQualityBrand: row.materialQualityBrand || row.materialRequirement || '',
            supplierId: null,
            supplierName: '',
            budgetUnitPrice: undefined,
            purchaseUnitPrice: undefined,
            amount: 0
          })
          return item
        })
        const existingRows = (this.applyForm.itemList || []).filter(item => item && item.materialName)
        this.$set(this.applyForm, 'itemList', this.applyWorkbookOverwrite
          ? normalizedRows : existingRows.concat(normalizedRows))
        const preview = this.applyWorkbookPreview || {}
        if (!this.applyForm.applyTitle && preview.applyTitle) this.$set(this.applyForm, 'applyTitle', preview.applyTitle)
        if (!this.applyForm.projectName && preview.projectName) this.$set(this.applyForm, 'projectName', preview.projectName)
        if (!this.applyForm.projectCode && preview.projectCode) this.$set(this.applyForm, 'projectCode', preview.projectCode)
        if (!this.applyForm.expectedArrivalDate && preview.expectedArrivalDate) {
          this.$set(this.applyForm, 'expectedArrivalDate', this.normalizeDateValue(preview.expectedArrivalDate))
        }
        this.$set(this.applyForm, 'sourceMode', 2)
        this.normalizeApplyAmounts()
        this.applyWorkbookDialogOpen = false
        this.applyWorkbookSourceFile = null
        this.applyWorkbookSourceFileInfo = null
        this.msgSuccess(`已填入${normalizedRows.length}条采购需求，请核对后保存`)
      }).catch(error => {
        this.$message.error(error && error.message ? error.message : '原需求文件归档失败，请重试')
      }).finally(() => {
        this.applyWorkbookConfirming = false
      })
    },
    removeApplyItem(index) {
      this.applyForm.itemList.splice(index, 1)
      this.normalizeApplyAmounts()
    },
    normalizeAttachmentType(type) {
      const number = Number(type)
      return this.attachmentTypeOptions.some(item => Number(item.value) === number) ? number : 8
    },
    addAttachment(type) {
      this.applyForm.attachmentList.push({ attachmentType: this.normalizeAttachmentType(type), relationType: 1, attachmentFileObjs: [], remark: '' })
    },
    removeAttachment(index) {
      this.applyForm.attachmentList.splice(index, 1)
    },
    isActualPurchaseRow(row) {
      const quantity = Number(row && row.quantity || 0)
      return Number.isFinite(quantity) && quantity > 0
    },
    recalculateRow(row) {
      this.normalizeApplyItemAmount(row)
      this.normalizeApplyAmounts()
    },
    normalizeRowUnitPrice(row) {
      if (!row) return
      const unitPrice = this.referenceUnitPriceValue(row.purchaseUnitPrice)
      if (unitPrice === null) return
      this.$set(row, 'purchaseUnitPrice', unitPrice)
      this.normalizeApplyItemAmount(row)
      this.normalizeApplyAmounts()
    },
    handleItemSupplierChange(row) {
      const supplier = this.supplierOptions.find(item => item.id === row.supplierId)
      row.supplierName = supplier ? supplier.supplierName : ''
      const exactContext = this.hasExactMaterialSpec(row)
      this.applyPriceRecordToItem(row, exactContext
        ? this.findExactPriceRecordForSupplier(row)
        : (this.findMatchedPriceRecord(row) || this.findPriceRecordBySpecification(row)))
    },
    handleItemSupplierInput(row) {
      const supplier = this.findSupplierByName(row && row.supplierName)
      if (supplier) {
        this.$set(row, 'supplierId', supplier.id)
        this.$set(row, 'supplierName', supplier.supplierName)
        const typed = this.normalizeReferenceName(row.supplierName)
        const exact = this.supplierMatchTokens(supplier).includes(typed)
        const exactContext = this.hasExactMaterialSpec(row)
        const priceRecord = exactContext
          ? this.findExactPriceRecordForSupplier(row)
          : (this.findMatchedPriceRecord(row) || this.findPriceRecordBySpecification(row))
        if (exact) {
          this.applySelectedPriceRecordToItem(row, priceRecord)
        } else {
          this.applyPriceRecordToItem(row, priceRecord)
        }
        return
      }
      this.$set(row, 'supplierId', null)
    },
    handleItemSupplierSelect(row, supplier) {
      if (!row || !supplier) return
      this.$set(row, 'supplierId', supplier.id)
      this.$set(row, 'supplierName', supplier.supplierName)
      const exactContext = this.hasExactMaterialSpec(row)
      const priceRecord = exactContext
        ? (supplier._referenceRecord || this.findExactPriceRecordForSupplier(row))
        : (supplier._referenceRecord || this.findMatchedPriceRecord(row) || this.findPriceRecordBySpecification(row))
      this.applySelectedPriceRecordToItem(row, priceRecord)
    },
    handleItemSupplierBlur(row) {
      if (!row || !row.supplierName) return
      this.handleItemSupplierInput(row)
    },
    handlePendingSplitSupplierInput(row, value) {
      if (!row) return
      if (value !== undefined) {
        this.$set(row, 'supplierName', value)
      }
      const supplierName = String(value !== undefined ? value : row.supplierName || '').trim()
      if (!supplierName) {
        this.$set(row, 'supplierId', null)
        return
      }
      const supplier = this.findExactSupplierByName(supplierName)
      if (supplier) {
        this.$set(row, 'supplierId', supplier.id)
      } else {
        this.$set(row, 'supplierId', null)
      }
    },
    handlePendingSplitSupplierSelect(row, supplier) {
      if (!row || !supplier) return
      this.$set(row, 'supplierId', supplier.id || null)
      this.$set(row, 'supplierName', supplier.supplierName || '')
    },
    handlePendingSplitSupplierBlur(row) {
      if (!row) return
      const supplierName = String(row.supplierName || '').trim()
      this.$set(row, 'supplierName', supplierName)
      if (!supplierName) {
        this.$set(row, 'supplierId', null)
        return
      }
      const supplier = this.findExactSupplierByName(supplierName)
      if (supplier) {
        this.$set(row, 'supplierId', supplier.id)
        this.$set(row, 'supplierName', supplier.supplierName)
      } else {
        this.$set(row, 'supplierId', null)
      }
    },
    querySupplierSuggestions(query, callback) {
      const local = this.supplierSuggestionOptions(query)
      if (!query || local.length >= 8) {
        callback(local)
        return
      }
      listPurchaseSupplier({ keyword: query, status: 1, pageNum: 1, pageSize: 20 }).then(res => {
        this.mergeSupplierReferences(this.responseRows(res))
        callback(this.supplierSuggestionOptions(query))
      }).catch(() => callback(local))
    },
    queryItemSupplierSuggestions(query, row, callback) {
      const local = this.itemSupplierSuggestionOptions(row, query)
      const exactContext = this.hasExactMaterialSpec(row)
      if (!exactContext && (!query || local.length >= 8)) {
        callback(local)
        return
      }
      const tasks = []
      if (!exactContext || query) {
        tasks.push(listPurchaseSupplier({ keyword: query, status: 1, pageNum: 1, pageSize: 20 }).then(res => {
          this.mergeSupplierReferences(this.responseRows(res))
        }))
      }
      if (row && (row.materialName || row.specification)) {
        const lookupRow = exactContext ? Object.assign({}, row, { supplierName: '' }) : Object.assign({}, row, { supplierName: query })
        tasks.push(this.loadMaterialReferencesForRow(lookupRow, {
          exactMaterialName: exactContext,
          exactSpecification: exactContext
        }))
      }
      Promise.all(tasks).then(() => {
        callback(this.itemSupplierSuggestionOptions(row, query))
      }).catch(() => callback(local))
    },
    supplierSuggestionOptions(query) {
      const normalized = this.normalizeReferenceName(query)
      return (this.supplierOptions || []).map(item => {
        const tokens = this.supplierMatchTokens(item)
        let score = normalized ? 0 : 1
        if (normalized && tokens.includes(normalized)) score += 100
        if (normalized && tokens.some(token => token.indexOf(normalized) > -1 || normalized.indexOf(token) > -1)) score += 60
        return Object.assign({}, item, { score })
      }).filter(item => item.score > 0).sort((left, right) => right.score - left.score).slice(0, 20)
    },
    itemSupplierSuggestionOptions(row, query) {
      const normalized = this.normalizeReferenceName(query)
      const exactContext = this.hasExactMaterialSpec(row)
      const supplierMap = new Map()
      const mergeSupplier = (supplier, score, reference) => {
        if (!supplier || !supplier.supplierName) return
        const key = supplier.id ? `id:${supplier.id}` : `name:${this.normalizeReferenceName(supplier.supplierName)}`
        const current = supplierMap.get(key)
        const currentScore = current ? Number(current.score || 0) : 0
        const nextScore = Math.max(currentScore, score || 0)
        const shouldUseReference = reference && (!current || !current._referenceRecord ||
          Number(score || 0) > currentScore ||
          (Number(score || 0) === currentScore && Number(reference.purchaseUnitPrice || 0) < Number(current._referencePurchaseUnitPrice || Infinity)))
        const next = Object.assign({}, current || {}, supplier, {
          score: nextScore
        })
        if (shouldUseReference) {
          next._referenceRecord = reference
          next._referenceMaterialName = reference.materialName || next._referenceMaterialName
          next._referenceSpecification = reference.specification || next._referenceSpecification
          next._referenceUnit = reference.unit || next._referenceUnit
          next._referencePurchaseUnitPrice = reference.purchaseUnitPrice || next._referencePurchaseUnitPrice
        }
        supplierMap.set(key, next)
      }
      if (!exactContext || normalized) {
        ;(this.supplierOptions || []).forEach(supplier => {
          const tokens = this.supplierMatchTokens(supplier)
          let score = normalized ? 0 : (exactContext ? 0 : 4)
          if (normalized && tokens.includes(normalized)) score += 100
          if (normalized && tokens.some(token => token.indexOf(normalized) > -1 || normalized.indexOf(token) > -1)) score += 60
          if (score > 0) mergeSupplier(supplier, score)
        })
      }
      const records = exactContext ? this.exactPriceRecordsForItem(row) : this.priceReferenceRecords()
      records.forEach(record => {
        if (!record || !record.supplierName) return
        const score = exactContext ? 200 : this.scorePriceRecordForItemSupplier(row, record)
        if (score <= 0) return
        if (normalized && this.normalizeReferenceName(record.supplierName).indexOf(normalized) === -1) return
        const supplier = this.findSupplierByName(record.supplierName) || {
          id: record.supplierId,
          supplierName: record.supplierName
        }
        mergeSupplier(supplier, score + 80, record)
      })
      return Array.from(supplierMap.values())
        .sort((left, right) => {
          if (exactContext) {
            const leftPrice = Number(left._referencePurchaseUnitPrice || Infinity)
            const rightPrice = Number(right._referencePurchaseUnitPrice || Infinity)
            if (leftPrice !== rightPrice) return leftPrice - rightPrice
          }
          return Number(right.score || 0) - Number(left.score || 0)
        })
        .slice(0, 20)
    },
    hasExactMaterialSpec(row) {
      return Boolean(row && this.normalizeReferenceName(row.materialName) && this.normalizeReferenceName(row.specification))
    },
    isExactPriceRecordForItem(row, record) {
      if (!row || !record) return false
      const rowMaterial = this.normalizeReferenceName(this.referenceMaterialDisplayName(row))
      const rowSpec = this.referenceSpecificationKey(row.specification, row.materialName)
      if (!rowMaterial || !rowSpec) return false
      return this.normalizeReferenceName(this.referenceMaterialDisplayName(record)) === rowMaterial &&
        this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName) === rowSpec
    },
    exactPriceRecordsForItem(row) {
      const seen = new Set()
      return this.priceReferenceRecords()
        .filter(record => this.isExactPriceRecordForItem(row, record))
        .filter(record => {
          const key = [
            this.normalizeReferenceName(record.supplierName),
            this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName),
            Number(record.purchaseUnitPrice || 0)
          ].join('|')
          if (seen.has(key)) return false
          seen.add(key)
          return true
        })
    },
    findBestExactPriceRecord(row) {
      const records = this.exactPriceRecordsForItem(row)
      if (!records.length) return null
      records.sort((left, right) => Number(left.purchaseUnitPrice || 0) - Number(right.purchaseUnitPrice || 0))
      return records[0]
    },
    findExactPriceRecordForSupplier(row) {
      if (!row || !row.supplierName) return null
      const supplierName = this.normalizeReferenceName(row.supplierName)
      const records = this.exactPriceRecordsForItem(row)
        .filter(record => this.normalizeReferenceName(record.supplierName) === supplierName)
      if (!records.length) return null
      records.sort((left, right) => Number(left.purchaseUnitPrice || 0) - Number(right.purchaseUnitPrice || 0))
      return records[0]
    },
    scorePriceRecordForItemSupplier(row, record) {
      if (!row || !record) return 0
      const rowSpec = this.referenceSpecificationKey(row.specification, row.materialName)
      const recordSpec = this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName)
      if (rowSpec && recordSpec !== rowSpec) return 0
      if (row.materialName && !this.referenceMaterialMatches(record, row)) return 0
      let score = 0
      if (row.materialName && this.referenceTextSimilar(record.materialName, row.materialName)) score += 45
      if (row.materialName && this.referenceMaterialRelated(record, row)) score += 35
      if (rowSpec && recordSpec === rowSpec) score += 50
      if (this.hasReferenceNumberOverlap(record, row)) score += 25
      if (row.unit && this.normalizeReferenceUnit(record.unit) === this.normalizeReferenceUnit(row.unit)) score += 10
      return score
    },
    supplierOptionMeta(item) {
      return [item.shortName, item.supplierType, item.mainPurchaseContent].filter(Boolean).join(' / ') || '供应商库'
    },
    supplierOptionDetails(item) {
      const details = []
      if (item._referenceSpecification) details.push({ label: '历史规格', value: item._referenceSpecification })
      if (item._referenceUnit) details.push({ label: '单位', value: item._referenceUnit })
      if (item.supplierType) details.push({ label: '类型', value: item.supplierType })
      if (item.mainPurchaseContent) details.push({ label: '采购内容', value: item.mainPurchaseContent })
      if (item.contactName) details.push({ label: '联系人', value: item.contactName })
      return details
    },
    itemSupplierOptionDetails(item) {
      const details = []
      if (item._referenceSpecification) details.push({ label: '规格', value: item._referenceSpecification })
      if (item._referenceUnit) details.push({ label: '单位', value: item._referenceUnit })
      if (!details.length && item.mainPurchaseContent) details.push({ label: '采购内容', value: item.mainPurchaseContent })
      return details
    },
    handleContractSupplierInput() {
      const supplier = this.findSupplierByName(this.contractForm && this.contractForm.supplierName)
      if (supplier) {
        this.applyContractSupplier(supplier, 'supplier')
        return
      }
      this.$set(this.contractForm, 'supplierId', null)
      if (!this.contractForm.partyB) this.$set(this.contractForm, 'partyB', this.contractForm.supplierName || '')
    },
    handleContractSupplierSelect(supplier) {
      this.applyContractSupplier(supplier, 'supplier')
    },
    handleContractSupplierBlur() {
      this.handleContractSupplierInput()
      if (!this.contractForm.partyB && this.contractForm.supplierName) this.$set(this.contractForm, 'partyB', this.contractForm.supplierName)
    },
    handleContractPartyBInput() {
      const supplier = this.findSupplierByName(this.contractForm && this.contractForm.partyB)
      if (supplier) {
        this.applyContractSupplier(supplier, 'partyB')
        return
      }
      this.$set(this.contractForm, 'supplierId', null)
      if (!this.contractForm.supplierName) this.$set(this.contractForm, 'supplierName', this.contractForm.partyB || '')
    },
    handleContractPartyBSelect(supplier) {
      this.applyContractSupplier(supplier, 'partyB')
    },
    handleContractPartyBBlur() {
      this.handleContractPartyBInput()
      if (!this.contractForm.supplierName && this.contractForm.partyB) this.$set(this.contractForm, 'supplierName', this.contractForm.partyB)
    },
    applyContractSupplier(supplier, source = 'supplier') {
      if (!supplier) return
      const shouldSyncPartyB = source === 'partyB' ||
        !this.contractForm.partyB ||
        this.sameReferenceText(this.contractForm.partyB, this.contractForm.supplierName)
      this.$set(this.contractForm, 'supplierId', supplier.id || null)
      this.$set(this.contractForm, 'supplierName', supplier.supplierName || '')
      if (shouldSyncPartyB) {
        this.$set(this.contractForm, 'partyB', supplier.supplierName || '')
      }
    },
    handleItemSpecificationChange(row, options = {}) {
      if (row && row.specification) {
        const normalizedSpec = this.normalizeReferenceSpecDisplay(row.specification, row.materialName)
        if (normalizedSpec && normalizedSpec !== row.specification) this.$set(row, 'specification', normalizedSpec)
      }
      const materialKey = this.normalizeReferenceName(row && row.materialName)
      const specificationKey = this.referenceSpecificationKey(row && row.specification, row && row.materialName)
      this.clearStalePriceMatch(row)
      const exactContext = this.hasExactMaterialSpec(row)
      const allowSpecOnlyMatch = Boolean(options.allowSpecOnlyMatch)
      const matched = exactContext
        ? this.findBestExactPriceRecord(row)
        : (allowSpecOnlyMatch ? (this.findBestExactPriceRecord(row) || this.findPriceRecordBySpecification(row)) : null)
      if (matched) {
        this.applySelectedPriceRecordToItem(row, matched)
      }
      this.loadMaterialReferencesForRow(row, {
        exactMaterialName: exactContext,
        exactSpecification: exactContext
      }).then(() => {
        if (materialKey !== this.normalizeReferenceName(row && row.materialName) ||
          specificationKey !== this.referenceSpecificationKey(row && row.specification, row && row.materialName)) return
        const latestMatched = exactContext
          ? this.findBestExactPriceRecord(row)
          : (allowSpecOnlyMatch ? (this.findBestExactPriceRecord(row) || this.findPriceRecordBySpecification(row) || this.findMatchedPriceRecord(row)) : null)
        this.applySelectedPriceRecordToItem(row, latestMatched)
      })
      this.loadMaterialSupplementReferencesForRow(row, {
        exactMaterialName: exactContext,
        exactSpecification: exactContext
      })
    },
    handleItemSpecificationInput(row) {
      this.clearStalePriceMatch(row)
    },
    handleItemSpecificationBlur(row) {
      this.handleItemSpecificationChange(row, { allowSpecOnlyMatch: false })
    },
    handleSpecificationSuggestionSelect(row, item) {
      if (!row || !item) return
      this.$set(row, 'specification', item.value || '')
      this.handleItemSpecificationChange(row, { allowSpecOnlyMatch: true })
    },
    handleItemMaterialInput(row) {
      this.clearStalePriceMatch(row)
      this.normalizeTypedMaterial(row, { preferTypedSpec: true })
    },
    handleItemMaterialBlur(row) {
      this.normalizeTypedMaterial(row, { preferTypedSpec: true })
      const exactContext = this.hasExactMaterialSpec(row)
      if (!exactContext) {
        this.loadMaterialReferencesForRow(row)
        this.loadMaterialSupplementReferencesForRow(row)
        return
      }
      const matched = this.findBestExactPriceRecord(row)
      if (matched) {
        this.applyPriceRecordToItem(row, matched)
        return
      }
      this.loadMaterialReferencesForRow(row, {
        exactMaterialName: exactContext,
        exactSpecification: exactContext
      }).then(() => {
        const latestMatched = this.findBestExactPriceRecord(row)
        this.applyPriceRecordToItem(row, latestMatched)
      })
      this.loadMaterialSupplementReferencesForRow(row, {
        exactMaterialName: true
      })
    },
    handleMaterialSuggestionSelect(row, record) {
      if (!row || !record) return
      const materialName = record.materialName || ''
      this.$set(row, 'materialName', materialName)
      this.$set(row, 'materialCode', '')
      this.$set(row, 'specification', '')
      this.$set(row, 'materialQualityBrand', '')
      this.$set(row, 'unit', '')
      this.$set(row, 'supplierId', null)
      this.$set(row, 'supplierName', '')
      this.$set(row, 'purchaseUnitPrice', undefined)
      this.$set(row, 'amount', 0)
      this.$set(row, 'historyPriceMatched', false)
      this.clearPriceMatchSnapshot(row)
      this.loadMaterialReferencesForRow(row, { exactMaterialName: true })
      this.loadMaterialSupplementReferencesForRow(row, { exactMaterialName: true })
    },
    queryMaterialSuggestions(query, row, callback) {
      const local = this.materialSuggestionOptions(row, query)
      if (local.length >= 8) {
        callback(local)
        return
      }
      const keyword = String(query || '').trim()
      const request = keyword
        ? this.loadMaterialSupplementReferencesForRow(Object.assign({}, row, { materialName: keyword }))
        : listPurchasePrice({
          includeMaterialSupplement: true,
          pageNum: 1,
          pageSize: 200
        }).then(res => this.mergeMaterialReferences(this.responseRows(res)))
      request.then(() => {
        callback(this.materialSuggestionOptions(row, query))
      }).catch(() => callback(local))
    },
    queryItemSpecificationSuggestions(query, row, callback) {
      const local = this.itemSpecificationSuggestionOptions(row, query)
      const shouldRefreshMaterialWide = Boolean(row && row.materialName)
      if ((!query || local.length >= 8) && !shouldRefreshMaterialWide) {
        callback(local)
        return
      }
      const tasks = []
      if (shouldRefreshMaterialWide) {
        tasks.push(this.loadMaterialWideReferencesForRow(row))
      }
      const next = Object.assign({}, row, { specification: query })
      if (query) {
        tasks.push(this.loadMaterialReferencesForRow(next, {
          exactMaterialName: Boolean(row && row.materialName),
          exactSpecification: false
        }))
        tasks.push(this.loadMaterialSupplementReferencesForRow(next, {
          exactMaterialName: Boolean(row && row.materialName),
          exactSpecification: false
        }))
      }
      Promise.all(tasks).then(() => {
        callback(this.itemSpecificationSuggestionOptions(row, query))
      }).catch(() => callback(local))
    },
    itemSpecificationSuggestionOptions(row, query) {
      const keyword = this.normalizeReferenceName(query)
      return this.itemSpecificationOptions(row).filter(item => {
        if (!keyword) return true
        return this.normalizeReferenceName([
          item.value,
          item.detail
        ].filter(Boolean).join(' ')).indexOf(keyword) > -1
      })
    },
    materialSuggestionOptions(row, query) {
      const keyword = String(query || '').trim()
      const normalizedKeyword = this.normalizeReferenceName(keyword)
      const currentSpec = this.referenceSpecificationKey(row && row.specification, row && row.materialName)
      const currentSupplier = this.normalizeReferenceName(row && row.supplierName)
      const currentNumbers = this.referenceNumbers(keyword, row && row.specification, row && row.materialQualityBrand)
      const materialMap = new Map()
      this.materialReferenceRecords().forEach(record => {
        if (!record || !record.materialName) return null
        const materialName = this.referenceMaterialDisplayName(record)
        const specification = this.referenceSpecificationDisplay(record)
        const searchText = this.normalizeReferenceName([
          record.materialName,
          materialName,
          record.materialCode
        ].filter(Boolean).join(' '))
        let score = normalizedKeyword ? 0 : 1
        if (normalizedKeyword && this.normalizeReferenceName(materialName) === normalizedKeyword) score += 110
        if (normalizedKeyword && searchText.indexOf(normalizedKeyword) > -1) score += 80
        if (normalizedKeyword && this.referenceTextSimilar(materialName, keyword)) score += 45
        if (currentSpec && this.referenceSpecificationKey(specification, materialName) === currentSpec) score += 35
        if (currentSupplier && this.normalizeReferenceName(record.supplierName) === currentSupplier) score += 20
        if (currentNumbers.length && this.hasReferenceNumberOverlap(record, {
          materialName: keyword,
          specification: row && row.specification,
          materialQualityBrand: row && row.materialQualityBrand
        })) score += 25
        const key = this.normalizeReferenceName(materialName)
        if (!score || !key) return
        const current = materialMap.get(key) || {
          materialName,
          materialCode: record.materialCode || '',
          score: 0,
          specs: new Set(),
          suppliers: new Set(),
          units: new Set(),
          minPrice: null
        }
        current.score = Math.max(Number(current.score || 0), score)
        if (!current.materialCode && record.materialCode) current.materialCode = record.materialCode
        if (specification) current.specs.add(specification)
        if (record.supplierName) current.suppliers.add(record.supplierName)
        if (record.unit) current.units.add(record.unit)
        const price = this.referenceNumberValue(record.purchaseUnitPrice)
        if (price !== null && (current.minPrice === null || price < current.minPrice)) current.minPrice = price
        materialMap.set(key, current)
      })
      return Array.from(materialMap.values()).sort((left, right) => right.score - left.score).slice(0, 30)
    },
    materialSuggestionOptionDetails(item) {
      const details = []
      const specs = item && item.specs ? Array.from(item.specs).filter(Boolean) : []
      if (specs.length) details.push(`规格 ${this.compactReferenceList(specs, 3)}`)
      const supplierCount = item && item.suppliers ? item.suppliers.size : 0
      if (supplierCount) details.push(`${supplierCount}家供应商`)
      if (item && item.minPrice !== null && item.minPrice !== undefined) details.push(`最低 ${this.money(item.minPrice)}`)
      const units = item && item.units ? Array.from(item.units).filter(Boolean) : []
      if (units.length) details.push(`单位 ${this.compactReferenceList(units, 2)}`)
      return details
    },
    compactReferenceList(values, limit = 3) {
      const list = this.uniqueReferenceValues(values).slice(0, limit)
      const suffix = this.uniqueReferenceValues(values).length > limit ? '等' : ''
      return list.join(' / ') + suffix
    },
    materialOptionMeta(item) {
      const parts = []
      if (item.materialCode) parts.push(item.materialCode)
      if (item.specification) parts.push(item.specification)
      if (item.materialQualityBrand) parts.push(item.materialQualityBrand)
      if (item.unit) parts.push(item.unit)
      if (item.supplierName) parts.push(item.supplierName)
      if (item.purchaseUnitPrice) parts.push(`¥${this.unitPriceText(item.purchaseUnitPrice)}`)
      return parts.join(' / ') || '历史物料'
    },
    materialOptionDetails(item) {
      const details = []
      if (item.specification) details.push({ label: '规格', value: item.specification })
      if (item.materialQualityBrand) details.push({ label: '材质/品牌', value: item.materialQualityBrand })
      if (item.unit) details.push({ label: '单位', value: item.unit })
      if (item.supplierName) details.push({ label: '供应商', value: item.supplierName })
      if (item.purchaseUnitPrice) details.push({ label: '单价', value: this.unitPriceText(item.purchaseUnitPrice) })
      return details
    },
    referencePriceSummary(row) {
      const price = this.referenceNumberValue(row && row._matchedPurchaseUnitPrice)
      if (price !== null) return `参考单价 ${this.money(price)}`
      const best = this.findBestExactPriceRecord(row)
      const bestPrice = this.referenceNumberValue(best && best.purchaseUnitPrice)
      if (bestPrice !== null) return `参考单价 ${this.money(bestPrice)}`
      return '暂无历史参考价'
    },
    referencePriceMeta(row) {
      const records = this.exactPriceRecordsForItem(row)
      if (records.length) {
        const suppliers = this.uniqueReferenceValues(records.map(item => item.supplierName)).filter(Boolean)
        const prices = records.map(item => this.referenceNumberValue(item.purchaseUnitPrice)).filter(value => value !== null)
        const minPrice = prices.length ? Math.min.apply(null, prices) : null
        const parts = []
        if (suppliers.length) parts.push(`${suppliers.length}家供应商`)
        if (minPrice !== null) parts.push(`最低 ${this.money(minPrice)}`)
        return parts.join(' / ') || '历史价格参考'
      }
      if (row && row._matchedSupplierName && this.referenceNumberValue(row._matchedPurchaseUnitPrice) !== null) return `参考供应商：${row._matchedSupplierName}`
      return '可手动填写预估单价，真实采购价格以采购执行单为准'
    },
    normalizeTypedMaterial(row, options = {}) {
      if (!row || !row.materialName) return
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      if (derivedSpec && (!row.specification || options.preferTypedSpec || row.historyPriceMatched)) {
        this.$set(row, 'specification', derivedSpec)
        this.$set(row, 'materialName', this.cleanMaterialName(row.materialName, derivedSpec))
      }
      if (row.specification) {
        const normalizedSpec = this.normalizeReferenceSpecDisplay(row.specification, row.materialName)
        if (normalizedSpec && normalizedSpec !== row.specification) this.$set(row, 'specification', normalizedSpec)
      }
      if (!row.materialQualityBrand) {
        const brand = this.deriveMaterialQualityBrand([row.materialName, row.specification].filter(Boolean).join(' '))
        if (brand) {
          this.$set(row, 'materialQualityBrand', brand)
          this.$set(row, '_autoMaterialQualityBrand', true)
        }
      }
    },
    loadMaterialReferencesForRow(row, options = {}) {
      if (!row || (!row.materialName && !row.specification && !row.supplierName)) return Promise.resolve()
      const tasks = []
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      const materialName = derivedSpec ? this.cleanMaterialName(row.materialName, derivedSpec) : row.materialName
      const specification = this.referenceSpecificationQueryValue(row.specification || derivedSpec, materialName)
      const exactMaterialName = Boolean(options.exactMaterialName && materialName)
      const exactSpecification = Boolean(options.exactSpecification && specification)
      const baseQuery = {
        materialName,
        specification,
        supplierName: row.supplierName,
        pageNum: 1,
        pageSize: 500
      }
      if (exactMaterialName) baseQuery.exactMaterialName = true
      if (exactSpecification) baseQuery.exactSpecification = true
      if (baseQuery.materialName) {
        tasks.push(listPurchasePrice(baseQuery).then(res => this.mergePriceReferences(this.responseRows(res))))
      }
      if (baseQuery.specification && !(exactMaterialName && exactSpecification)) {
        tasks.push(listPurchasePrice({
          specification: baseQuery.specification,
          exactSpecification,
          supplierName: baseQuery.supplierName,
          pageNum: 1,
          pageSize: 500
        }).then(res => this.mergePriceReferences(this.responseRows(res))))
      }
      return Promise.all(tasks)
    },
    loadMaterialWideReferencesForRow(row) {
      if (!row || !row.materialName) return Promise.resolve()
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      const materialName = derivedSpec ? this.cleanMaterialName(row.materialName, derivedSpec) : row.materialName
      const wideRow = Object.assign({}, row, {
        materialName,
        specification: '',
        supplierName: ''
      })
      return Promise.all([
        this.loadMaterialReferencesForRow(wideRow, { exactMaterialName: true }),
        this.loadMaterialSupplementReferencesForRow(wideRow, { exactMaterialName: true })
      ])
    },
    loadMaterialSupplementReferencesForRow(row, options = {}) {
      if (!row || (!row.materialName && !row.specification)) return Promise.resolve()
      const tasks = []
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      const materialName = derivedSpec ? this.cleanMaterialName(row.materialName, derivedSpec) : row.materialName
      const specification = this.referenceSpecificationQueryValue(row.specification || derivedSpec, materialName)
      const exactMaterialName = Boolean(options.exactMaterialName && materialName)
      const exactSpecification = Boolean(options.exactSpecification && specification)
      const baseQuery = {
        materialName,
        specification,
        includeMaterialSupplement: true,
        pageNum: 1,
        pageSize: 500
      }
      if (exactMaterialName) baseQuery.exactMaterialName = true
      if (exactSpecification) baseQuery.exactSpecification = true
      if (baseQuery.materialName) {
        tasks.push(listPurchasePrice(baseQuery).then(res => this.mergeMaterialReferences(this.responseRows(res))))
      }
      if (baseQuery.specification && !(exactMaterialName && exactSpecification)) {
        tasks.push(listPurchasePrice({
          specification: baseQuery.specification,
          exactSpecification,
          includeMaterialSupplement: true,
          pageNum: 1,
          pageSize: 500
        }).then(res => this.mergeMaterialReferences(this.responseRows(res))))
      }
      return Promise.all(tasks)
    },
    itemSpecificationOptions(row) {
      const options = []
      const seen = new Set()
      const pushOption = (record, current = false, detail = '') => {
        const rawValue = current ? row.specification : this.referenceSpecificationDisplay(record)
        const value = this.normalizeReferenceSpecDisplay(rawValue, current ? row && row.materialName : record && record.materialName)
        if (!value) return
        const key = this.referenceSpecificationKey(value, current ? row && row.materialName : record && record.materialName)
        if (!key || seen.has(key)) return
        seen.add(key)
        options.push({
          key: key + '-' + options.length,
          value,
          label: value,
          detail
        })
      }
      const materialKnown = Boolean(row && row.materialName)
      const grouped = new Map()
      this.materialReferenceRecords()
        .filter(record => record && this.referenceSpecificationDisplay(record))
        .forEach(record => {
          const materialMatched = !materialKnown || this.referenceMaterialMatches(record, row)
          if (materialKnown && !materialMatched) return
          let score = 0
          if (!materialKnown) score += 5
          if (materialKnown && this.referenceTextSimilar(record.materialName, row.materialName)) score += 80
          if (materialKnown && this.referenceMaterialRelated(record, row)) score += 45
          if (!materialKnown && this.hasReferenceNumberOverlap(record, row)) score += 25
          if (row && row.supplierName && this.sameReferenceText(record.supplierName, row.supplierName)) score += 20
          if (materialKnown && score <= 0) return
          const displaySpec = this.referenceSpecificationDisplay(record)
          const key = this.referenceSpecificationKey(displaySpec, record.materialName)
          const current = grouped.get(key) || {
            record: Object.assign({}, record, { specification: displaySpec }),
            score: 0,
            suppliers: new Set(),
            units: new Set(),
            brands: new Set(),
            minPrice: null
          }
          current.score = Math.max(current.score, score)
          if (record.supplierName) current.suppliers.add(record.supplierName)
          if (record.unit) current.units.add(record.unit)
          if (record.materialQualityBrand) current.brands.add(record.materialQualityBrand)
          const price = this.referenceNumberValue(record.purchaseUnitPrice)
          if (price !== null && (current.minPrice === null || price < current.minPrice)) current.minPrice = price
          grouped.set(key, current)
        })
      Array.from(grouped.values())
        .sort((left, right) => {
          if (right.score !== left.score) return right.score - left.score
          return this.referenceSpecificationKey(left.record.specification, left.record.materialName).localeCompare(this.referenceSpecificationKey(right.record.specification, right.record.materialName))
        })
        .forEach(group => pushOption(group.record, false, this.specificationOptionDetail(group)))
      pushOption(null, true)
      return options.slice(0, 80)
    },
    specificationOptionDetail(group) {
      const details = []
      const supplierCount = group && group.suppliers ? group.suppliers.size : 0
      if (supplierCount) details.push(`${supplierCount}家供应商`)
      if (group && group.minPrice !== null) details.push(`最低 ${this.money(group.minPrice)}`)
      const units = group && group.units ? Array.from(group.units).filter(Boolean) : []
      if (units.length) details.push(`单位 ${units.slice(0, 2).join('/')}`)
      const brands = group && group.brands ? Array.from(group.brands).filter(Boolean) : []
      if (brands.length) details.push(`材质 ${brands.slice(0, 2).join('/')}`)
      return details.join(' / ')
    },
    findPriceRecordBySpecification(row) {
      const specification = this.referenceSpecificationKey(row && row.specification, row && row.materialName)
      if (!specification) return null
      const materialKnown = Boolean(row && row.materialName)
      const scoredRecords = this.priceReferenceRecords().map(record => {
        if (!record || this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName) !== specification) return null
        if (materialKnown && !this.referenceMaterialMatches(record, row)) return null
        let score = 80
        if (materialKnown && this.referenceTextSimilar(record.materialName, row.materialName)) score += 60
        if (materialKnown && this.referenceMaterialRelated(record, row)) score += 36
        if (!materialKnown && this.hasReferenceNumberOverlap(record, row)) score += 24
        if (row && row.supplierName && this.sameReferenceText(record.supplierName, row.supplierName)) score += 20
        if (row && row.unit && this.normalizeReferenceUnit(row.unit) === this.normalizeReferenceUnit(record.unit)) score += 10
        return { record, score }
      }).filter(Boolean).filter(item => item.score >= (materialKnown ? 70 : 80))
      if (!scoredRecords.length) return null
      scoredRecords.sort((left, right) => {
        if (right.score !== left.score) return right.score - left.score
        return Number(left.record.purchaseUnitPrice || 0) - Number(right.record.purchaseUnitPrice || 0)
      })
      return scoredRecords[0].record
    },
    applyPriceRecordToItem(row, priceRecord) {
      if (!row || !priceRecord) return
      if (!row.materialCode && priceRecord.materialCode) this.$set(row, 'materialCode', priceRecord.materialCode)
      if (!row.materialName && priceRecord.materialName) this.$set(row, 'materialName', priceRecord.materialName)
      const displaySpecification = this.referenceSpecificationDisplay(priceRecord)
      if (!row.specification && displaySpecification) this.$set(row, 'specification', displaySpecification)
      if (this.shouldApplyReferenceMaterialQualityBrand(row, priceRecord.materialQualityBrand)) {
        this.$set(row, 'materialQualityBrand', priceRecord.materialQualityBrand)
        this.$set(row, '_autoMaterialQualityBrand', false)
      }
      if (!row.unit && priceRecord.unit) this.$set(row, 'unit', priceRecord.unit)
      if (this.shouldPersistItemSupplier) {
        if (!row.supplierId && priceRecord.supplierId) this.$set(row, 'supplierId', priceRecord.supplierId)
        if (!row.supplierName && priceRecord.supplierName) this.$set(row, 'supplierName', priceRecord.supplierName)
      }
      const referencePrice = this.referenceUnitPriceValue(priceRecord.purchaseUnitPrice)
      if ((!row.purchaseUnitPrice || Number(row.purchaseUnitPrice) === 0) && referencePrice !== null) {
        this.$set(row, 'purchaseUnitPrice', referencePrice)
        this.recalculateRow(row)
      }
      this.$set(row, 'historyPriceMatched', true)
      this.markPriceRecordMatched(row, priceRecord)
    },
    applySelectedPriceRecordToItem(row, priceRecord) {
      if (!row || !priceRecord) return
      if (priceRecord.materialCode) {
        this.$set(row, 'materialCode', priceRecord.materialCode)
      } else if (row._matchedMaterialCode && this.sameReferenceText(row.materialCode, row._matchedMaterialCode)) {
        this.$set(row, 'materialCode', '')
      }
      if (priceRecord.materialName) this.$set(row, 'materialName', priceRecord.materialName)
      const displaySpecification = this.referenceSpecificationDisplay(priceRecord)
      if (displaySpecification) this.$set(row, 'specification', displaySpecification)
      if (priceRecord.materialQualityBrand) {
        this.$set(row, 'materialQualityBrand', priceRecord.materialQualityBrand)
        this.$set(row, '_autoMaterialQualityBrand', false)
      }
      if (priceRecord.unit) this.$set(row, 'unit', priceRecord.unit)
      if (this.shouldPersistItemSupplier) {
        if (priceRecord.supplierId) this.$set(row, 'supplierId', priceRecord.supplierId)
        if (priceRecord.supplierName) this.$set(row, 'supplierName', priceRecord.supplierName)
      }
      const referencePrice = this.referenceUnitPriceValue(priceRecord.purchaseUnitPrice)
      if (referencePrice !== null) {
        this.$set(row, 'purchaseUnitPrice', referencePrice)
        this.recalculateRow(row)
      }
      this.$set(row, 'historyPriceMatched', true)
      this.markPriceRecordMatched(row, priceRecord)
    },
    markPriceRecordMatched(row, priceRecord) {
      if (!row || !priceRecord) return
      this.$set(row, '_matchedMaterialName', priceRecord.materialName || '')
      this.$set(row, '_matchedMaterialCode', priceRecord.materialCode || '')
      this.$set(row, '_matchedSpecification', this.referenceSpecificationDisplay(priceRecord) || '')
      this.$set(row, '_matchedMaterialQualityBrand', priceRecord.materialQualityBrand || '')
      this.$set(row, '_matchedUnit', priceRecord.unit || '')
      this.$set(row, '_matchedSupplierId', priceRecord.supplierId || null)
      this.$set(row, '_matchedSupplierName', priceRecord.supplierName || '')
      const referencePrice = this.referenceUnitPriceValue(priceRecord.purchaseUnitPrice)
      const matchedAmount = referencePrice !== null && row.quantity
        ? roundPurchaseMoney(Number(row.quantity || 0) * referencePrice)
        : this.referenceMoneyValue(priceRecord.amount)
      this.$set(row, '_matchedPurchaseUnitPrice', referencePrice)
      this.$set(row, '_matchedAmount', matchedAmount)
    },
    shouldApplyReferenceMaterialQualityBrand(row, referenceBrand) {
      if (!referenceBrand) return false
      if (!row || !row.materialQualityBrand) return true
      if (this.sameReferenceText(row.materialQualityBrand, referenceBrand)) return false
      if (row._autoMaterialQualityBrand) return true
      const derivedBrand = this.deriveMaterialQualityBrand([row.materialName, row.specification].filter(Boolean).join(' '))
      return Boolean(derivedBrand && this.sameReferenceText(row.materialQualityBrand, derivedBrand))
    },
    clearStalePriceMatch(row) {
      if (!row || !row.historyPriceMatched || !row._matchedMaterialName || !row.materialName) return
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      const currentMaterial = this.normalizeReferenceName(row.materialName)
      const cleanMaterial = this.normalizeReferenceName(derivedSpec ? this.cleanMaterialName(row.materialName, derivedSpec) : row.materialName)
      const matchedMaterial = this.normalizeReferenceName(row._matchedMaterialName)
      const currentSpecification = this.referenceSpecificationKey(row.specification, row.materialName)
      const matchedSpecification = this.referenceSpecificationKey(row._matchedSpecification, row._matchedMaterialName)
      const materialStillMatched = currentMaterial === matchedMaterial || cleanMaterial === matchedMaterial
      const specificationStillMatched = !matchedSpecification || currentSpecification === matchedSpecification
      if (materialStillMatched && specificationStillMatched) return

      this.$set(row, 'historyPriceMatched', false)
      if (this.normalizeReferenceName(row.materialCode) === this.normalizeReferenceName(row._matchedMaterialCode)) this.$set(row, 'materialCode', '')
      if (this.sameReferenceSpecification(row.specification, row._matchedSpecification, row.materialName, row._matchedMaterialName)) this.$set(row, 'specification', '')
      if (this.normalizeReferenceName(row.materialQualityBrand) === this.normalizeReferenceName(row._matchedMaterialQualityBrand)) this.$set(row, 'materialQualityBrand', '')
      if (this.normalizeReferenceUnit(row.unit) === this.normalizeReferenceUnit(row._matchedUnit)) this.$set(row, 'unit', '')
      if (this.shouldShowSupplierInputColumn) {
        if (row.supplierId && String(row.supplierId) === String(row._matchedSupplierId || '')) this.$set(row, 'supplierId', null)
        if (this.normalizeReferenceName(row.supplierName) === this.normalizeReferenceName(row._matchedSupplierName)) this.$set(row, 'supplierName', '')
      }
      if (this.referenceNumberExact(row.purchaseUnitPrice, row._matchedPurchaseUnitPrice)) {
        this.$set(row, 'purchaseUnitPrice', undefined)
        this.recalculateRow(row)
      }
      if (this.referenceNumberExact(row.amount, row._matchedAmount, 0.01) && !row.purchaseUnitPrice) this.$set(row, 'amount', 0)
      this.clearPriceMatchSnapshot(row)
    },
    clearPriceMatchSnapshot(row) {
      if (!row) return
      ;[
        '_matchedMaterialName',
        '_matchedMaterialCode',
        '_matchedSpecification',
        '_matchedMaterialQualityBrand',
        '_matchedUnit',
        '_matchedSupplierId',
        '_matchedSupplierName',
        '_matchedPurchaseUnitPrice',
        '_matchedAmount'
      ].forEach(key => this.$delete(row, key))
    },
    normalizeReferenceName(value) {
      return String(value || '').replace(/[\s（）()【】\[\]、，,。.;；:：-]/g, '').toLowerCase()
    },
    normalizeReferenceNumberText(value) {
      const number = Number(value)
      if (!Number.isFinite(number)) return String(value || '').trim()
      return Number.isInteger(number) ? String(number) : String(number).replace(/\.?0+$/, '')
    },
    parseReferenceSpecification(value) {
      const text = String(value || '')
        .trim()
        .toUpperCase()
        .replace(/×/g, '*')
        .replace(/[X]/g, '*')
        .replace(/ＣＭ/g, 'CM')
        .replace(/ＭＭ/g, 'MM')
        .replace(/ＫＧ/g, 'KG')
        .replace(/\s+/g, '')
      if (!text) return null
      const match = text.match(/^(\d+(?:\.\d+)?)(CM|MM|M|KG|G|ML|L)?$/)
      if (!match) return null
      return {
        number: this.normalizeReferenceNumberText(match[1]),
        unit: match[2] || '',
        source: text
      }
    },
    normalizeReferenceSpecDisplay(value, materialName = '') {
      if (this.isNoSpecSpecification(value)) return this.referenceNoSpecLabel()
      const parsed = this.parseReferenceSpecification(value)
      if (!parsed) return String(value || '').trim()
      if (parsed.unit) return `${parsed.number}${parsed.unit}`
      const derived = this.parseReferenceSpecification(this.deriveSpecificationFromMaterialName(materialName))
      if (derived && derived.number === parsed.number && derived.unit) return `${parsed.number}${derived.unit}`
      if (String(value || '').indexOf('.') > -1 && Number(parsed.number) > 0 && Number(parsed.number) < 20) {
        return `${parsed.number}CM`
      }
      return parsed.number
    },
    referenceNoSpecLabel() {
      return '无固定规格'
    },
    isNoSpecSpecification(value) {
      const normalized = this.normalizeReferenceName(value)
      return ['无独立规格', '无需独立规格', '无固定规格', '无规格', '无型号']
        .map(item => this.normalizeReferenceName(item))
        .includes(normalized)
    },
    referenceSpecificationQueryValue(value, materialName = '') {
      const normalized = this.normalizeReferenceSpecDisplay(value, materialName)
      return this.isNoSpecSpecification(normalized) ? '无独立规格' : normalized
    },
    referenceSpecificationKey(value, materialName = '') {
      return this.normalizeReferenceName(this.normalizeReferenceSpecDisplay(value, materialName))
    },
    sameReferenceSpecification(left, right, leftMaterial = '', rightMaterial = '') {
      const leftKey = this.referenceSpecificationKey(left, leftMaterial)
      const rightKey = this.referenceSpecificationKey(right, rightMaterial)
      if (!leftKey || !rightKey) return false
      if (leftKey === rightKey) return true
      const leftParsed = this.parseReferenceSpecification(left)
      const rightParsed = this.parseReferenceSpecification(right)
      return Boolean(leftParsed && rightParsed && leftParsed.number === rightParsed.number && (!leftParsed.unit || !rightParsed.unit))
    },
    referenceMaterialDisplayName(record) {
      if (!record) return ''
      const materialName = record.materialName || ''
      const derivedSpec = this.deriveSpecificationFromMaterialName(materialName)
      if (derivedSpec) return this.cleanMaterialName(materialName, derivedSpec)
      return materialName
    },
    referenceSpecificationDisplay(record) {
      if (!record) return ''
      const derivedSpec = this.deriveSpecificationFromMaterialName(record.materialName)
      const value = record.specification || derivedSpec
      if (!value) return ''
      return this.normalizeReferenceSpecDisplay(value, record.materialName)
    },
    normalizeReferenceUnit(value) {
      const normalized = this.normalizeReferenceName(value)
      if (!normalized) return ''
      if (['kg', 'kgs', '千克'].includes(normalized)) return '公斤'
      return normalized
    },
    referenceNumbers() {
      const text = Array.prototype.slice.call(arguments).map(value => this.normalizeReferenceName(value)).join(' ')
      return Array.from(new Set((text.match(/\d+(?:\.\d+)?/g) || []).filter(value => value.length >= 2 || value.indexOf('.') > -1)))
    },
    hasReferenceNumberOverlap(record, item) {
      const recordNumbers = this.referenceNumbers(record && record.materialName, record && record.specification, record && record.materialQualityBrand)
      const itemNumbers = this.referenceNumbers(item && item.materialName, item && item.specification, item && item.materialQualityBrand)
      return recordNumbers.some(value => itemNumbers.includes(value))
    },
    supplierMatchTokens(supplier) {
      const tokens = [supplier && supplier.supplierName, supplier && supplier.shortName]
      if (supplier && supplier.aliases) {
        supplier.aliases.split(/[、,，;；\s|/\n]+/).forEach(item => tokens.push(item))
      }
      return tokens.map(this.normalizeReferenceName).filter(Boolean)
    },
    uniqueSupplierMatches(rows) {
      const map = new Map()
      ;(rows || []).forEach(supplier => {
        if (!supplier) return
        const key = supplier.id
          ? `id:${supplier.id}`
          : `name:${this.normalizeReferenceName(supplier.supplierName)}`
        if (key && !map.has(key)) map.set(key, supplier)
      })
      return Array.from(map.values())
    },
    supplierNameMatchState(name) {
      const normalized = this.normalizeReferenceName(name)
      if (!normalized) return { status: 'empty', supplier: null, candidates: [], matchType: '' }
      const suppliers = this.supplierOptions || []
      const exact = this.uniqueSupplierMatches(
        suppliers.filter(supplier => this.supplierMatchTokens(supplier).includes(normalized))
      )
      if (exact.length === 1) {
        return { status: 'matched', supplier: exact[0], candidates: exact, matchType: 'exact' }
      }
      if (exact.length > 1) {
        return { status: 'ambiguous', supplier: null, candidates: exact, matchType: 'exact' }
      }
      if (normalized.length < 2) {
        return { status: 'unlinked', supplier: null, candidates: [], matchType: '' }
      }
      const fragments = this.uniqueSupplierMatches(suppliers.filter(supplier => {
        const fullName = this.normalizeReferenceName(supplier && supplier.supplierName)
        const masterName = this.normalizeReferenceName(supplier && supplier.masterSupplierName)
        return (fullName && fullName.indexOf(normalized) > -1) ||
          (masterName && masterName.indexOf(normalized) > -1)
      }))
      if (fragments.length === 1) {
        return { status: 'matched', supplier: fragments[0], candidates: fragments, matchType: 'fragment' }
      }
      if (fragments.length > 1) {
        return { status: 'ambiguous', supplier: null, candidates: fragments, matchType: 'fragment' }
      }
      return { status: 'unlinked', supplier: null, candidates: [], matchType: '' }
    },
    findExactSupplierByName(name) {
      const state = this.supplierNameMatchState(name)
      return state.status === 'matched' && state.matchType === 'exact' ? state.supplier : null
    },
    findSupplierByName(name) {
      const state = this.supplierNameMatchState(name)
      return state.status === 'matched' ? state.supplier : null
    },
    sameReferenceText(left, right) {
      return this.normalizeReferenceName(left) === this.normalizeReferenceName(right)
    },
    referenceTextSimilar(left, right) {
      const normalizedLeft = this.normalizeReferenceName(left)
      const normalizedRight = this.normalizeReferenceName(right)
      if (!normalizedLeft || !normalizedRight) return false
      return normalizedLeft === normalizedRight || normalizedLeft.indexOf(normalizedRight) > -1 || normalizedRight.indexOf(normalizedLeft) > -1
    },
    referenceMaterialMatches(record, item) {
      if (!item || !item.materialName) return true
      return this.referenceTextSimilar(this.referenceMaterialDisplayName(record), this.referenceMaterialDisplayName(item)) ||
        this.referenceTextSimilar(record && record.materialName, item.materialName) ||
        this.referenceMaterialRelated(record, item)
    },
    referenceNumberValue(value) {
      if (value === null || value === undefined) return null
      const text = String(value).replace(/,/g, '').trim()
      if (!text) return null
      const number = Number(text)
      return Number.isFinite(number) ? number : null
    },
    referenceMoneyValue(value) {
      const number = this.referenceNumberValue(value)
      return number === null ? null : roundPurchaseMoney(number)
    },
    referenceUnitPriceValue(value) {
      const number = this.referenceNumberValue(value)
      return number === null ? null : roundPurchaseMoney(number)
    },
    referenceNumberExact(left, right, precision = 0.0001) {
      const leftValue = this.referenceNumberValue(left)
      const rightValue = this.referenceNumberValue(right)
      if (leftValue === null || rightValue === null) return false
      return Math.abs(leftValue - rightValue) <= precision
    },
    referenceNumberClose(left, right, tolerance = 0.05) {
      const leftValue = this.referenceNumberValue(left)
      const rightValue = this.referenceNumberValue(right)
      if (leftValue === null || rightValue === null) return false
      const base = Math.max(Math.abs(leftValue), Math.abs(rightValue), 1)
      return Math.abs(leftValue - rightValue) / base <= tolerance
    },
    referenceMaterialRelated(record, item) {
      const recordText = this.normalizeReferenceName([
        this.referenceMaterialDisplayName(record),
        record && record.materialName,
        this.referenceSpecificationDisplay(record),
        record && record.specification,
        record && record.materialQualityBrand
      ].filter(Boolean).join(' '))
      const itemText = this.normalizeReferenceName([
        this.referenceMaterialDisplayName(item),
        item && item.materialName,
        this.referenceSpecificationDisplay(item),
        item && item.specification,
        item && item.materialQualityBrand
      ].filter(Boolean).join(' '))
      if (!recordText || !itemText) return false
      if (recordText.indexOf(itemText) > -1 || itemText.indexOf(recordText) > -1) return true
      const aliasGroups = [
        ['pet无纺布', '无纺布', '衬布', '基布'],
        ['螺丝', '螺栓', '螺钉', '紧固件'],
        ['pvdf', '聚偏二氟乙烯', '膜丝', '膜材料', '中空纤维膜丝'],
        ['pvc', 'pvc管', 'pvc材料', '管材']
      ].map(group => group.map(this.normalizeReferenceName))
      return aliasGroups.some(group => {
        const recordHit = group.some(token => token && recordText.indexOf(token) > -1)
        const itemHit = group.some(token => token && itemText.indexOf(token) > -1)
        return recordHit && itemHit
      })
    },
    findMatchedPriceRecord(item) {
      if (!item || !item.materialName) return null
      const materialName = this.normalizeReferenceName(this.referenceMaterialDisplayName(item))
      const specification = this.referenceSpecificationKey(item.specification, item.materialName)
      const unit = this.normalizeReferenceUnit(item.unit)
      const supplierName = this.normalizeReferenceName(item.supplierName)
      const scoredRecords = this.priceReferenceRecords().map(record => {
        const recordMaterial = this.normalizeReferenceName(this.referenceMaterialDisplayName(record))
        const recordSpecification = this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName)
        const recordUnit = this.normalizeReferenceUnit(record.unit)
        const recordSupplierName = this.normalizeReferenceName(record.supplierName)
        const materialExact = recordMaterial === materialName
        const materialFuzzyAllowed = Boolean(specification || supplierName)
        const materialFuzzy = materialFuzzyAllowed && this.referenceTextSimilar(record.materialName, item.materialName)
        const materialRelated = this.referenceMaterialRelated(record, item)
        const numberOverlap = this.hasReferenceNumberOverlap(record, item)
        const priceExact = this.referenceNumberExact(record.purchaseUnitPrice, item.purchaseUnitPrice)
        const priceClose = this.referenceNumberClose(record.purchaseUnitPrice, item.purchaseUnitPrice, 0.03)
        const amountExact = this.referenceNumberExact(record.amount, item.amount, 0.01)
        const amountClose = this.referenceNumberClose(record.amount, item.amount, 0.03)
        const quantityExact = this.referenceNumberExact(record.quantity, item.quantity)
        const quantityClose = this.referenceNumberClose(record.quantity, item.quantity, 0.03)
        if (materialName && specification && (!materialExact || recordSpecification !== specification)) return null
        if (!materialExact && !materialFuzzy && !materialRelated && !(supplierName && numberOverlap)) return null
        if (specification && recordSpecification && recordSpecification !== specification && !numberOverlap && !materialRelated) return null
        if (unit && recordUnit && recordUnit !== unit) return null
        if (supplierName && recordSupplierName !== supplierName) return null
        const hasSpecSignal = Boolean(recordSpecification && specification && (recordSpecification === specification || numberOverlap || materialRelated))
        const hasCommercialSignal = priceExact || amountExact || (priceClose && (quantityExact || quantityClose || amountClose)) || (amountClose && quantityExact)
        if (specification && !recordSpecification && !hasCommercialSignal && !(supplierName && unit && (materialExact || materialRelated))) return null
        let score = 0
        if (materialExact) score += 80
        if (materialFuzzy) score += 60
        if (materialRelated) score += 45
        if (recordSpecification && recordSpecification === specification) score += 30
        if (numberOverlap) score += 25
        if (unit && recordUnit === unit) score += 10
        if (supplierName && recordSupplierName === supplierName) score += 20
        if (priceExact) score += 34
        else if (priceClose) score += 18
        if (amountExact) score += 26
        else if (amountClose) score += 12
        if (quantityExact) score += 12
        else if (quantityClose) score += 6
        if (specification && !recordSpecification && !hasSpecSignal) score -= 8
        return { record, score }
      }).filter(Boolean).filter(item => item.score >= (supplierName ? 70 : 95))
      if (!scoredRecords.length) return null
      scoredRecords.sort((left, right) => right.score - left.score)
      return scoredRecords[0].record
    },
    isMaterialSupplementRecord(row) {
      return Boolean(row && Number(row.referenceScope || 1) === 2)
    },
    isPriceReferenceRecord(row) {
      return Boolean(row && Number(row.referenceScope || 1) === 1)
    },
    priceReferenceRecords() {
      return (this.priceReferenceList || []).concat(this.priceList || []).filter(this.isPriceReferenceRecord)
    },
    materialReferenceRecords() {
      return this.priceReferenceRecords().concat(this.materialSupplementList || [])
    },
    mergeSupplierReferences(rows) {
      const indexById = new Map()
      ;(this.supplierReferenceList || []).forEach((item, index) => {
        if (item && item.id) indexById.set(String(item.id), index)
      })
      ;(rows || []).forEach(row => {
        if (!row || !row.id) return
        const key = String(row.id)
        if (indexById.has(key)) {
          const index = indexById.get(key)
          this.$set(this.supplierReferenceList, index, Object.assign({}, this.supplierReferenceList[index], row))
        } else {
          this.supplierReferenceList.push(row)
          indexById.set(key, this.supplierReferenceList.length - 1)
        }
      })
    },
    mergePriceReferences(rows) {
      const keyOf = row => [
        this.referenceMaterialDisplayName(row),
        this.referenceSpecificationKey(this.referenceSpecificationDisplay(row), row && row.materialName),
        row.materialQualityBrand,
        row.unit,
        row.supplierName,
        row.purchaseUnitPrice
      ].map(this.normalizeReferenceName).join('|')
      const exists = new Set((this.priceReferenceList || []).map(keyOf))
      ;(rows || []).forEach(row => {
        if (!row || !this.isPriceReferenceRecord(row)) return
        const key = keyOf(row)
        if (!exists.has(key)) {
          this.priceReferenceList.push(row)
          exists.add(key)
        }
      })
    },
    mergeMaterialSupplementReferences(rows) {
      const keyOf = row => [
        this.referenceMaterialDisplayName(row),
        this.referenceSpecificationKey(this.referenceSpecificationDisplay(row), row && row.materialName),
        row.materialQualityBrand,
        row.unit
      ].map(this.normalizeReferenceName).join('|')
      const exists = new Set((this.materialSupplementList || []).map(keyOf))
      ;(rows || []).forEach(row => {
        if (!this.isMaterialSupplementRecord(row)) return
        const key = keyOf(row)
        if (!exists.has(key)) {
          this.materialSupplementList.push(row)
          exists.add(key)
        }
      })
    },
    mergeMaterialReferences(rows) {
      this.mergePriceReferences(rows)
      this.mergeMaterialSupplementReferences(rows)
    },
    toArray(value) {
      if (Array.isArray(value)) return value
      if (value === undefined || value === null || value === '') return []
      return [value]
    },
    toTextArray(value) {
      if (Array.isArray(value)) {
        return value.reduce((result, item) => result.concat(this.toTextArray(item)), [])
      }
      if (value === undefined || value === null || value === '') return []
      if (typeof value === 'string') {
        return value
          .split(/[\n\r；;]+/)
          .map(item => item.trim())
          .filter(Boolean)
      }
      if (typeof value === 'object') {
        const text = value.message || value.text || value.label || value.value || value.name
        return text ? [text] : []
      }
      return [value]
    },
    toTextValue(value) {
      return this.toTextArray(value).join('\n')
    },
    toObjectArray(value) {
      return this.toArray(value).filter(item => item && typeof item === 'object')
    },
    uniqueReferenceValues(values) {
      const seen = new Set()
      return this.toTextArray(values).map(value => String(value || '').trim()).filter(value => {
        if (!value) return false
        const key = this.normalizeReferenceName(value)
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    ensureProcurementReferences(targeted = false) {
      if (!this.canAccessPurchaseSensitive) return Promise.resolve([])
      const tasks = []
      if (!this.supplierReferenceList || !this.supplierReferenceList.length) {
        tasks.push(listPurchaseSupplier(this.supplierQuery).then(res => {
          this.mergeSupplierReferences(this.responseRows(res))
        }))
      }
      if (!this.priceReferenceList || !this.priceReferenceList.length) {
        tasks.push(listPurchasePrice(this.priceQuery).then(res => {
          this.mergePriceReferences(this.responseRows(res))
        }))
      }
      if (targeted) {
        const supplierNames = this.uniqueReferenceValues([
          this.contractForm && this.contractForm.supplierName,
          this.contractForm && this.contractForm.partyB
        ].concat((this.applyForm.itemList || []).map(item => item.supplierName)))
        supplierNames.forEach(name => {
          tasks.push(listPurchaseSupplier({ keyword: name, status: 1, pageNum: 1, pageSize: 50 }).then(res => {
            this.mergeSupplierReferences(this.responseRows(res))
          }))
        })
        ;(this.applyForm.itemList || []).filter(item => item.materialName).forEach(item => {
          const baseQuery = {
            materialName: item.materialName,
            specification: item.specification,
            unit: item.unit,
            supplierName: item.supplierName || (this.contractForm && (this.contractForm.supplierName || this.contractForm.partyB)),
            pageNum: 1,
            pageSize: 50
          }
          if (item.materialName && item.specification) {
            baseQuery.exactMaterialName = true
            baseQuery.exactSpecification = true
            baseQuery.pageSize = 200
          }
          tasks.push(listPurchasePrice(baseQuery).then(res => {
            this.mergePriceReferences(this.responseRows(res))
          }))
          if ((item.specification || item.supplierName) && !(baseQuery.exactMaterialName && baseQuery.exactSpecification)) {
            tasks.push(listPurchasePrice({
              specification: item.specification,
              exactSpecification: Boolean(item.specification),
              unit: item.unit,
              supplierName: baseQuery.supplierName,
              pageNum: 1,
              pageSize: 50
            }).then(res => {
              this.mergePriceReferences(this.responseRows(res))
            }))
          }
          if (baseQuery.supplierName) {
            tasks.push(listPurchasePrice({
              supplierName: baseQuery.supplierName,
              pageNum: 1,
              pageSize: 100
            }).then(res => {
              this.mergePriceReferences(this.responseRows(res))
            }))
          }
        })
      }
      return Promise.all(tasks)
    },
    autoMatchRecognizedReferences() {
      if (!this.contractForm && (!this.applyForm || !this.applyForm.itemList)) return
      const contractForm = this.contractForm || {}
      if (!contractForm.partyA) this.$set(this.contractForm, 'partyA', this.currentTenantName())
      if (!contractForm.partyB && contractForm.supplierName) this.$set(this.contractForm, 'partyB', contractForm.supplierName)
      if (!contractForm.supplierName && contractForm.partyB) this.$set(this.contractForm, 'supplierName', contractForm.partyB)
      const contractSupplier = this.findSupplierByName(contractForm.supplierName || contractForm.partyB)
      if (contractSupplier) {
        this.applyContractSupplier(contractSupplier, contractForm.partyB ? 'partyB' : 'supplier')
      }
      ;(this.applyForm.itemList || []).forEach(item => {
        const supplier = this.findSupplierByName(item.supplierName || (contractSupplier && contractSupplier.supplierName))
        if (supplier && this.shouldPersistItemSupplier) {
          this.$set(item, 'supplierId', supplier.id)
          this.$set(item, 'supplierName', supplier.supplierName)
        }
        const priceRecord = this.findMatchedPriceRecord(item)
        this.applyPriceRecordToItem(item, priceRecord || this.findPriceRecordBySpecification(item))
      })
    },
    async saveApply(submitAfterSave) {
      if (this.applySaving) return
      const splitGenerateMode = this.isApplicationPendingSplit && !submitAfterSave
      const canSaveCurrentFlow = splitGenerateMode ? this.canConfirmApplicationSupplier : this.canEditProcurementBase
      if (!this.ensureWorkflowEditable(canSaveCurrentFlow, splitGenerateMode ? '当前状态不能确认供应商' : `${this.detailDocumentTitle}已进入后续流程，基础信息不能再编辑`)) return
      this.applySaving = true
      this.applySavingAction = submitAfterSave ? 'submit' : 'save'
      try {
        const valid = await new Promise(resolve => {
          this.$refs.applyForm.validate(result => resolve(result))
        })
        if (!valid) {
          this.msgWarning('请检查必填项')
          return
        }
        await this.prepareApplyBeforeSave()
        if (this.isApplicationDetail && submitAfterSave) {
          if (this.isAttachmentOnlyApplication) {
            if (!(this.applicationAttachmentFileObjs || []).length) {
              this.msgWarning('仅附件申请必须上传采购需求附件')
              return
            }
          } else {
            const demandRows = (this.applyForm.itemList || []).filter(item => item && item.materialName)
            if (!demandRows.length) {
              this.msgWarning('请至少填写一条采购需求，复杂清单也可切换为仅附件申请')
              return
            }
            const invalidIndex = demandRows.findIndex(item => Number(item.quantity || 0) <= 0 || !String(item.unit || '').trim())
            if (invalidIndex > -1) {
              this.msgWarning(`请补全第 ${invalidIndex + 1} 条采购需求的数量和单位`)
              return
            }
          }
          if (this.isAttachmentOnlyApplication && Number(this.applyForm.applyAmount || 0) <= 0) {
            this.msgWarning('请填写大于0的预估总价')
            return
          }
        }
        const res = await savePurchaseApply(this.buildApplyPayload())
        const id = res.data || this.applyForm.id
        if (this.hasContractContent()) {
          this.applyForm.id = id
          try {
            await this.confirmContractAfterSave(id)
          } catch (err) {
            const message = err && err.message ? err.message : '请检查合同附件、合同金额和供应商信息'
            this.$message.error(submitAfterSave
              ? `采购申请已保存，但合同信息保存失败，未提交审批：${message}`
              : `采购申请已保存，但合同信息保存失败：${message}`)
            this.loadApplyData()
            this.getPriceList()
            return
          }
        }
        if (!submitAfterSave) {
          this.msgSuccess(splitGenerateMode
            ? (this.isPendingSplitReady ? '供应商已确认，正在生成采购执行单' : '供应商信息已保存')
            : `${this.detailDocumentTitle}已保存`)
          this.afterApplySaved(id, false)
          return
        }
        await submitPurchaseApply(id)
        this.msgSuccess('采购申请已提交')
        this.afterApplySaved(id, true)
      } finally {
        this.applySaving = false
        this.applySavingAction = ''
      }
    },
    afterApplySaved(id, submitted) {
      this.applyForm.id = id
      this.loadApplyData()
      this.getPriceList()
      if (this.$route.path !== `/procurement/apply/detail/${id}`) {
        this.pushApplyDetailRoute(id, submitted ? { tab: 'basic' } : {}, this.isDetailPage)
        return
      }
      this.refreshCurrentDetail()
      if (submitted) {
        this.detailTab = 'basic'
      }
    },
    normalizeApplyItemAmount(row) {
      if (!row) return 0
      const hasQuantity = row.quantity !== undefined && row.quantity !== null && row.quantity !== ''
      const hasUnitPrice = row.purchaseUnitPrice !== undefined && row.purchaseUnitPrice !== null && row.purchaseUnitPrice !== ''
      if (hasQuantity && hasUnitPrice) {
        const quantity = Number(row.quantity || 0)
        const unitPrice = this.roundMoneyValue(row.purchaseUnitPrice)
        this.$set(row, 'purchaseUnitPrice', unitPrice)
        const rawAmount = quantity * unitPrice
        const amount = this.roundMoneyValue(rawAmount)
        this.$set(row, 'amount', amount)
        return amount
      } else if (!this.isApplicationDetail && row.amount !== undefined && row.amount !== null && row.amount !== '') {
        const amount = this.roundMoneyValue(row.amount)
        this.$set(row, 'amount', amount)
        return amount
      } else {
        this.$set(row, 'amount', 0)
      }
      return 0
    },
    normalizeApplyAmounts() {
      if (this.isAttachmentOnlyApplication) {
        const estimatedTotal = this.positiveAmount(this.applyForm.applyAmount)
        this.$set(this.applyForm, 'budgetAmount', roundPurchaseMoney(estimatedTotal))
        this.$set(this.applyForm, 'applyAmount', roundPurchaseMoney(estimatedTotal))
        return this.applyForm.applyAmount
      }
      const itemTotal = (this.applyForm.itemList || []).reduce((sum, row) => sum + this.normalizeApplyItemAmount(row), 0)
      const feeTotal = this.isSupplierOrderDetail
        ? this.positiveAmount(this.applyForm.freightAmount) + this.positiveAmount(this.applyForm.otherFeeAmount)
        : 0
      const total = itemTotal + feeTotal
      this.$set(this.applyForm, 'applyAmount', roundPurchaseMoney(total))
      return this.applyForm.applyAmount
    },
    prepareApplyBeforeSave() {
      if (this.isApplicationDetail) {
        ;(this.applyForm.itemList || []).forEach(row => {
          this.normalizeTypedMaterial(row)
          this.$set(row, 'modelNo', row.modelNo || row.specification || '')
          this.$set(row, 'specification', row.specification || row.modelNo || '')
          this.$set(row, 'materialRequirement', row.materialRequirement || row.materialQualityBrand || '')
          this.$set(row, 'materialQualityBrand', row.materialQualityBrand || row.materialRequirement || '')
          this.$set(row, 'supplierId', null)
          this.$set(row, 'supplierName', '')
          this.normalizeRowUnitPrice(row)
          this.$set(row, 'budgetUnitPrice', row.purchaseUnitPrice)
          this.normalizeApplyItemAmount(row)
        })
        this.normalizeApplyAmounts()
        return Promise.resolve()
      }
      ;(this.applyForm.itemList || []).forEach(row => {
        this.normalizeTypedMaterial(row)
        this.normalizeRowUnitPrice(row)
        this.handleItemSupplierBlur(row)
      })
      return this.ensureProcurementReferences(true).then(() => {
        this.autoMatchRecognizedReferences()
        this.normalizeApplyAmounts()
      }).catch(() => {
        this.autoMatchRecognizedReferences()
        this.normalizeApplyAmounts()
      })
    },
    buildApplyPayload() {
      const projectPurchase = Number(this.applyForm.purchaseType) === 2
      const applyAmount = this.normalizeApplyAmounts()
      const shouldPersistItemSupplier = this.shouldPersistItemSupplier
      return {
        id: this.applyForm.id,
        applyNo: this.applyForm.applyNo,
        applyTitle: this.applyForm.applyTitle,
        documentType: this.applyForm.documentType || 1,
        parentApplyId: this.applyForm.parentApplyId || null,
        supplierId: this.isSupplierOrderDetail ? (this.applyForm.supplierId || null) : null,
        supplierName: this.isSupplierOrderDetail ? (this.applyForm.supplierName || '') : '',
        splitStatus: this.applyForm.splitStatus || 10,
        contractMode: this.applyForm.contractMode || 1,
        noContractReason: this.applyForm.noContractReason || '',
        purchaseType: this.applyForm.purchaseType,
        sourceMode: this.applyForm.sourceMode || 1,
        purchaseOwnerId: this.applyForm.purchaseOwnerId,
        purchaseOwnerName: this.applyForm.purchaseOwnerName,
        applyDeptName: this.applyForm.applyDeptName,
        projectCode: projectPurchase ? this.applyForm.projectCode : '',
        projectName: projectPurchase ? this.applyForm.projectName : '',
        contractId: projectPurchase ? this.applyForm.contractId : null,
        contractNum: projectPurchase ? this.applyForm.contractNum : '',
        expectedArrivalDate: this.normalizeDateValue(this.applyForm.expectedArrivalDate),
        purchaseReason: this.isSupplierOrderDetail ? this.applyForm.purchaseReason : '',
        budgetAmount: this.isApplicationDetail ? applyAmount : this.applyForm.budgetAmount,
        applyAmount,
        estimatedFreightAmount: 0,
        estimatedOtherFeeAmount: 0,
        freightAmount: this.isSupplierOrderDetail ? this.positiveAmount(this.applyForm.freightAmount) : 0,
        otherFeeAmount: this.isSupplierOrderDetail ? this.positiveAmount(this.applyForm.otherFeeAmount) : 0,
        feeRemark: this.isSupplierOrderDetail ? (this.applyForm.feeRemark || '') : '',
        fulfillmentProjectId: this.applyForm.fulfillmentProjectId,
        remark: this.applyForm.remark,
        supplierFeeList: this.buildSupplierFeePayload(),
        itemList: (this.applyForm.itemList || []).filter(item => item.materialName).map((item, index) => {
          const row = Object.assign({}, item, {
            sortNo: index + 1,
            expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate),
            modelNo: item.modelNo || item.specification || '',
            specification: item.specification || item.modelNo || '',
            materialRequirement: item.materialRequirement || item.materialQualityBrand || '',
            materialQualityBrand: item.materialQualityBrand || item.materialRequirement || ''
          })
          if (!shouldPersistItemSupplier) {
            row.supplierId = null
            row.supplierName = ''
          }
          if (this.isApplicationDetail) {
            row.budgetUnitPrice = row.purchaseUnitPrice
          }
          return this.stripItemTransientFields(row)
        }),
        attachmentList: this.isApplicationDetail ? this.buildApplicationAttachmentPayload() : []
      }
    },
    buildApplicationAttachmentPayload() {
      const files = this.applicationAttachmentFileObjs || []
      if (!files.length) return []
      return [{
        attachmentType: 8,
        relationType: 1,
        attachmentFileObjs: files,
        remark: ''
      }]
    },
    shouldShowRowPaymentProgress(row) {
      const documentType = Number(row && row.documentType ? row.documentType : 1)
      if (documentType !== 2) return false
      const status = Number(row && row.status ? row.status : 10)
      return ![10, 20, 30, 40, 50, 120].includes(status)
    },
    canViewRowSensitive(row) {
      return !!(row && row.sensitiveDataVisible === true)
    },
    canEditApplyRow(row) {
      return !!row && this.hasProcurementPermi('crm:procurement:save') &&
        Number(row.documentType || 1) === 1 && [10, 30].includes(Number(row.status)) &&
        (!this.isFinanceProcurementRestrictedUser || this.isOwnPurchaseApplication(row))
    },
    canSubmit(row) {
      return (!this.isFinanceProcurementRestrictedUser || this.isOwnPurchaseApplication(row)) &&
        this.hasProcurementPermi('crm:procurement:submit') &&
        Number(row && row.documentType || 1) === 1 &&
        [10, 30].includes(Number(row && row.status))
    },
    canApproveRow(row) {
      const status = Number(row && row.status)
      const documentType = Number(row && row.documentType || 1)
      if (!this.hasProcurementPermi('crm:procurement:approve') || documentType !== 1 || status !== 20) {
        return false
      }
      const hasAuth = row && row.approvalHasAuth
      return Number(hasAuth) === 1 || hasAuth === true
    },
    canGenerateSupplierOrder(row) {
      if (this.isFinanceProcurementRestrictedUser) return false
      const status = Number(row && row.status)
      const documentType = Number(row && row.documentType || 1)
      const splitStatus = Number(row && row.splitStatus || 10)
      return this.hasProcurementPermi('crm:procurement:save') &&
        documentType === 1 &&
        status === 40 &&
        splitStatus !== 20
    },
    canCancelRow(row) {
      if (!this.hasProcurementPermi('crm:procurement:cancel')) return false
      if (this.isFinanceProcurementRestrictedUser && !this.isOwnPurchaseApplication(row)) return false
      const status = Number(row && row.status)
      const documentType = Number(row && row.documentType || 1)
      return documentType === 1 && [10, 30].includes(status)
    },
    canDeleteWithdrawnRow(row) {
      return this.hasProcurementPermi('crm:procurement:save', 'crm:procurement:submit') && row.canDeleteWithdrawn === true
    },
    canDeleteDraftRow(row) {
      return this.hasProcurementPermi('crm:procurement:save') && row.canDeleteDraft === true
    },
    rowPrimaryAction(row) {
      const status = Number(row && row.status)
      const documentType = Number(row && row.documentType || 1)
      if (this.canSubmit(row)) return { key: 'submit', label: '提交' }
      if (this.canApproveRow(row)) return { key: 'approve', label: '审批' }
      if (this.queryParams.queue === 'payment' && this.applyMatchesQueue(row, 'payment') && this.hasProcurementPermi('crm:procurement:finance')) {
        return { key: 'process', label: '登记付款' }
      }
      if (this.queryParams.queue === 'arrival' && this.applyMatchesQueue(row, 'arrival') && this.hasProcurementPermi('crm:procurement:arrival')) {
        return { key: 'process', label: '到货验收' }
      }
      if (documentType === 2 && [60, 70].includes(status) && this.hasProcurementPermi('crm:procurement:finance')) {
        return { key: 'process', label: '登记付款' }
      }
      if (documentType === 2 && [80, 90, 100].includes(status) && this.hasProcurementPermi('crm:procurement:arrival')) {
        return { key: 'process', label: '到货验收' }
      }
      return null
    },
    handleRowPrimaryAction(row) {
      const action = this.rowPrimaryAction(row)
      if (!action) return
      if (action.key === 'submit') {
        this.handleSubmitApply(row)
        return
      }
      if (action.key === 'approve') {
        this.openApproval(row)
        return
      }
      this.handleProcessApply(row)
    },
    handleSubmitApply(row) {
      if (this.applySubmitLoadingId) return
      this.applySubmitLoadingId = row.id
      this.$confirm(`确认提交采购申请 ${row.applyNo}？`, '提示', { type: 'warning' }).then(() => {
        return submitPurchaseApply(row.id).then(() => {
          this.msgSuccess('采购申请已提交')
          this.loadApplyData()
        })
      }).catch(() => {}).finally(() => {
        this.applySubmitLoadingId = null
      })
    },
    handleWithdrawApply() {
      const id = this.applyForm && this.applyForm.id
      if (!id) return
      this.$confirm(
        '撤回后当前审批将结束，申请回到待修改状态；重新提交后将从第一节点重新审批。',
        '确认撤回采购申请？',
        { type: 'warning', confirmButtonText: '撤回', cancelButtonText: '取消' }
      ).then(() => {
        return withdrawPurchaseApply(id).then(() => {
          this.msgSuccess('采购申请已撤回，可重新编辑')
          return this.refreshCurrentDetail()
        })
      }).catch(() => {})
    },
    handleRecallSupplierDecision() {
      const id = this.applyForm && this.applyForm.id
      if (!id) return
      this.$confirm(
        '撤回后流程回到采购员询价，修改报价后请在审批流程中点击“完成询价”。',
        '确认撤回修改报价？',
        { type: 'warning', confirmButtonText: '撤回', cancelButtonText: '取消' }
      ).then(() => {
        return recallPurchaseSupplierDecision(id).then(() => {
          this.msgSuccess('已撤回，可修改报价')
          this.detailTab = 'quote'
          return this.refreshCurrentDetail()
        })
      }).catch(() => {})
    },
    handleGenerateDecisionAnalysis() {
      const id = this.applyForm && this.applyForm.id
      if (!id || this.decisionAnalysisGenerating) return
      this.decisionAnalysisGenerating = true
      generatePurchaseSupplierDecisionAnalysis(id).then(() => {
        this.msgSuccess('定商分析已开始生成')
        return this.refreshCurrentDetail().then(() => this.startDecisionAnalysisPolling())
      }).finally(() => {
        this.decisionAnalysisGenerating = false
      })
    },
    startDecisionAnalysisPolling() {
      this.stopDecisionAnalysisPolling()
      if (!this.applyForm || !this.applyForm.id) return
      let attempts = 0
      this.decisionAnalysisPollTimer = window.setInterval(() => {
        attempts += 1
        this.refreshCurrentDetail().then(() => {
          const analysis = this.purchaserDecisionAnalysis
          if (!analysis || analysis.analysisStatus !== 'GENERATING' || attempts >= 12) {
            this.stopDecisionAnalysisPolling()
          }
        }).catch(() => this.stopDecisionAnalysisPolling())
      }, 5000)
    },
    stopDecisionAnalysisPolling() {
      if (this.decisionAnalysisPollTimer) {
        window.clearInterval(this.decisionAnalysisPollTimer)
        this.decisionAnalysisPollTimer = null
      }
    },
    scrollToPurchaserDecisionAnalysis() {
      this.$nextTick(() => {
        const element = document.getElementById('purchaser-decision-analysis')
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },
    handleCancelApply(row) {
      this.$confirm(`确认作废采购申请 ${row.applyNo}？`, '提示', { type: 'warning' }).then(() => {
        cancelPurchaseApply(row.id).then(() => {
          this.msgSuccess('已作废')
          this.loadApplyData()
        })
      }).catch(() => {})
    },
    handleDeleteWithdrawnApply(row) {
      if (!row || !row.id) return
      this.$confirm(`删除后，采购申请 ${row.applyNo || ''} 将从列表移除，审批记录仍会保留。确认删除？`, '删除已撤回申请', {
        type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消'
      }).then(() => deleteWithdrawnPurchaseApply(row.id)).then(() => {
        this.msgSuccess('申请已删除')
        if (this.isDetailPage) this.backToApplyList()
        this.loadApplyData()
      }).catch(() => {})
    },
    handleDeleteDraftApply(row) {
      if (!row || !row.id) return
      this.$confirm(`删除后，采购草稿 ${row.applyNo || ''} 将从列表移除。确认删除？`, '删除草稿', {
        type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消'
      }).then(() => deleteDraftPurchaseApply(row.id)).then(() => {
        this.msgSuccess('草稿已删除')
        if (this.isDetailPage) this.backToApplyList()
        this.loadApplyData()
      }).catch(() => {})
    },
    supplierOrderNextTab(row) {
      if (!row) return 'basic'
      if (this.isSupplierOrderLogicallyComplete(row)) return 'basic'
      if (this.applyMatchesQueue(row, 'payment')) return 'payment'
      if (this.applyMatchesQueue(row, 'arrival')) return 'arrival'
      return this.recommendedDetailTab(row) || 'basic'
    },
    supplierOrderNextActionText(row) {
      if (this.isSupplierOrderLogicallyComplete(row)) return '查看采购单'
      const tab = this.supplierOrderNextTab(row)
      if (tab === 'payment') return this.hasProcurementPermi('crm:procurement:finance') ? '登记付款' : '查看采购单'
      if (tab === 'arrival') return this.hasProcurementPermi('crm:procurement:arrival') ? '到货验收' : '查看采购单'
      return '查看采购单'
    },
    supplierOrderProgressText(row) {
      if (!row) return '-'
      if (this.isSupplierOrderLogicallyComplete(row)) return '已付清 / 已验收'
      const paymentText = this.paymentStatusText(row.paymentStatus)
      const arrivalText = this.arrivalStatusText(row.arrivalStatus)
      return [paymentText, arrivalText].filter(Boolean).join(' / ')
    },
    handleSupplierOrderNext(row) {
      this.handleEditApply(row, this.supplierOrderNextTab(row))
    },
    closeInlineSupplierOrder() {
      this.inlineOrder = this.emptyInlineOrder()
    },
    openInlineSupplierOrder(row, tab = 'contract') {
      if (!row || !row.id) return
      this.inlineOrder = Object.assign(this.emptyInlineOrder(), {
        open: true,
        loading: true,
        id: row.id,
        tab: tab === 'basic' ? 'contract' : tab
      })
      getPurchaseApplyDetail(row.id).then(res => {
        this.fillInlineSupplierOrder(res.data || {}, tab === 'basic' ? 'contract' : tab)
      }).catch(err => {
        const message = err && err.message ? err.message : '请稍后重试'
        this.$message.error(`采购执行单加载失败：${message}`)
        this.closeInlineSupplierOrder()
      })
    },
    refreshInlineSupplierOrder() {
      if (!this.inlineOrder || !this.inlineOrder.id) return Promise.resolve()
      this.$set(this.inlineOrder, 'loading', true)
      return getPurchaseApplyDetail(this.inlineOrder.id).then(res => {
        this.fillInlineSupplierOrder(res.data || {}, this.inlineOrder.tab || 'contract')
        return res
      }).finally(() => {
        if (this.inlineOrder) this.$set(this.inlineOrder, 'loading', false)
      })
    },
    fillInlineSupplierOrder(detail, tab = 'contract') {
      const applyForm = Object.assign(this.emptyApplyForm(), detail, {
        itemList: detail.itemList && detail.itemList.length ? detail.itemList.map(item => Object.assign({}, item, {
          expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate)
        })) : [],
        attachmentList: []
      })
      const contractForm = Object.assign(this.emptyContractForm(), detail.contractInfo || {}, {
        applyId: detail.id,
        fileInfoList: detail.contractInfo && detail.contractInfo.fileInfoList ? detail.contractInfo.fileInfoList : [],
        contractText: '',
        signDate: this.normalizeDateValue(detail.contractInfo && detail.contractInfo.signDate)
      })
      if (!contractForm.partyA) contractForm.partyA = this.currentTenantName()
      if (!contractForm.supplierId && applyForm.supplierId) contractForm.supplierId = applyForm.supplierId
      if (!contractForm.supplierName && applyForm.supplierName) contractForm.supplierName = applyForm.supplierName
      if (!contractForm.partyB && (contractForm.supplierName || applyForm.supplierName)) contractForm.partyB = contractForm.supplierName || applyForm.supplierName
      if (!contractForm.contractAmount && applyForm.applyAmount) contractForm.contractAmount = Number(applyForm.applyAmount || 0)
      if (!contractForm.contractName && applyForm.applyTitle) contractForm.contractName = applyForm.applyTitle
      const paymentPlanList = (detail.paymentPlanList || []).map(item => Object.assign({}, item, {
        payableDate: this.normalizeDateValue(item.payableDate)
      }))
      this.inlineOrder = Object.assign(this.emptyInlineOrder(), {
        open: true,
        loading: false,
        id: detail.id,
        tab: tab || 'contract',
        applyForm,
        detail: Object.assign(this.emptyDetail(), detail),
        contractForm,
        paymentPlanList,
        paymentPlan: {},
        paymentForm: this.emptyPaymentActionForm(),
        arrivalForm: Object.assign(this.emptyArrivalForm(), { applyId: detail.id })
      })
      this.syncInlineSupplierOrderSummary(detail)
      this.uploadRenderKey += 1
      this.$nextTick(() => {
        const panel = this.$el && this.$el.querySelector ? this.$el.querySelector('.inline-order-panel') : null
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      })
    },
    syncInlineSupplierOrderSummary(detail) {
      if (!detail || !detail.id || !this.detail || !Array.isArray(this.detail.supplierOrderList)) return
      const index = this.detail.supplierOrderList.findIndex(row => String(row.id) === String(detail.id))
      if (index === -1) return
      const current = this.detail.supplierOrderList[index] || {}
      this.$set(this.detail.supplierOrderList, index, Object.assign({}, current, {
        status: detail.status,
        businessStatus: detail.businessStatus,
        contractStatus: detail.contractStatus,
        contractMode: detail.contractMode,
        shipmentStatus: detail.shipmentStatus,
        paymentStatus: detail.paymentStatus,
        arrivalStatus: detail.arrivalStatus,
        applyAmount: detail.applyAmount,
        paidAmount: detail.paidAmount,
        unpaidAmount: detail.unpaidAmount,
        supplierId: detail.supplierId,
        supplierName: detail.supplierName,
        contractNum: detail.contractNum,
        updateTime: detail.updateTime
      }))
    },
    isSupplierOrderLogicallyComplete(row) {
      if (!row || Number(row.documentType || 2) !== 2) return false
      return this.supplierOrderContractComplete(row) &&
        this.supplierOrderPaymentComplete(row) &&
        this.supplierOrderArrivalComplete(row)
    },
    supplierOrderContractComplete(row) {
      return this.isContractStepComplete(row)
    },
    supplierOrderPaymentComplete(row) {
      const status = Number(row && row.paymentStatus || 10)
      const paid = Number(row && row.paidAmount || 0)
      const amount = Number(row && (row.applyAmount || row.contractAmount) || 0)
      const unpaid = row && row.unpaidAmount !== undefined && row.unpaidAmount !== null
        ? Number(row.unpaidAmount || 0)
        : Math.max(amount - paid, 0)
      return status === 50 || (amount > 0 && paid >= amount && unpaid <= 0)
    },
    supplierOrderArrivalComplete(row) {
      return Number(row && row.arrivalStatus || 10) === 50
    },
    addInlinePaymentPlan() {
      if (!this.inlineOrder) return
      this.inlineOrder.paymentPlanList.push({
        nodeName: '',
        paymentRate: undefined,
        payableAmount: undefined,
        payableDate: '',
        paymentCondition: '',
        status: 20
      })
    },
    inlineContractPayload() {
      const order = this.inlineOrder || this.emptyInlineOrder()
      const form = order.applyForm || {}
      return Object.assign({}, order.contractForm, {
        applyId: form.id,
        signDate: this.normalizeDateValue(order.contractForm && order.contractForm.signDate),
        itemList: (form.itemList || []).filter(item => item.materialName).map(item => {
          const row = Object.assign({}, item, {
            expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate)
          })
          return this.stripItemTransientFields(row)
        }),
        paymentPlanList: (order.paymentPlanList || []).filter(item => item.nodeName).map(item => Object.assign({}, item, {
          payableDate: this.normalizeDateValue(item.payableDate)
        }))
      })
    },
    saveInlineSupplierContract() {
      if (!this.ensureWorkflowEditable(this.inlineOrderContractEditable, '当前状态不能保存合同信息')) return
      confirmPurchaseContract(this.inlineContractPayload()).then(() => {
        this.msgSuccess('合同信息已保存')
        return this.refreshInlineSupplierOrder()
      }).then(() => {
        return this.refreshCurrentDetail()
      }).catch(err => {
        const message = err && err.message ? err.message : '请检查合同附件、合同金额和供应商信息'
        this.$message.error(`合同信息保存失败：${message}`)
      })
    },
    canRegisterInlinePaymentPlan(row) {
      if (!row || !row.id) return this.inlineOrderCanRegisterPayment
      return this.inlineOrderCanRegisterPayment && [40, 50].includes(this.paymentPlanStatus(row)) && Number(row && row.financeAuditStatus) === 20
    },
    openInlinePayment(row) {
      if (!this.ensureWorkflowEditable(this.inlineOrderCanRegisterPayment, '当前状态不能登记付款')) return
      if (row && !this.ensureWorkflowEditable(this.canRegisterInlinePaymentPlan(row), '该付款节点尚未确认，不能登记付款')) return
      const form = (this.inlineOrder && this.inlineOrder.applyForm) || {}
      const unpaidAmount = Number((row && row.unpaidAmount) || form.unpaidAmount || 0)
      const payableAmount = Number((row && row.payableAmount) || form.applyAmount || 0)
      this.uploadRenderKey += 1
      this.$set(this.inlineOrder, 'tab', 'payment')
      this.$set(this.inlineOrder, 'paymentPlan', row || {})
      this.$set(this.inlineOrder, 'paymentForm', Object.assign(this.emptyPaymentActionForm(), {
        applyId: form.id,
        paymentPlanId: row && row.id ? row.id : null,
        paidAmount: unpaidAmount > 0 ? unpaidAmount : undefined,
        paymentTime: this.currentDateTimeValue(),
        supplierAccountInfo: row && row.supplierAccountInfo || '',
        duplicateCheckRemark: row && row.duplicateCheckRemark ? row.duplicateCheckRemark : `采购单金额${this.money(payableAmount)}，未付${this.money(unpaidAmount || payableAmount)}`,
        invoiceFileList: row && row.invoiceFileList || []
      }))
    },
    cancelInlinePayment() {
      this.$set(this.inlineOrder, 'paymentPlan', {})
      this.$set(this.inlineOrder, 'paymentForm', this.emptyPaymentActionForm())
    },
    validateInlinePaymentForm() {
      const form = (this.inlineOrder && this.inlineOrder.paymentForm) || {}
      if (!form.paidAmount || Number(form.paidAmount) <= 0) {
        this.msgWarning('本次付款金额必须大于0')
        return false
      }
      return true
    },
    registerInlinePayment() {
      if (!this.ensureWorkflowEditable(this.inlineOrderCanRegisterPayment, '当前状态不能登记付款')) return
      if (!this.validateInlinePaymentForm()) return
      registerPurchasePayment(this.inlineOrder.paymentForm).then(() => {
        this.msgSuccess('付款已登记')
        this.cancelInlinePayment()
        return this.refreshInlineSupplierOrder()
      }).then(() => {
        return this.refreshCurrentDetail()
      })
    },
    openInlineArrivalForItem(row) {
      if (!this.ensureWorkflowEditable(this.inlineOrderCanEditArrival, '当前采购执行单还未进入到货验收节点')) return
      const item = row && row.item
      if (!item) return
      const remaining = row.remainingQuantity
      const quantity = remaining > 0 ? remaining : Number(item.quantity || 0)
      const form = Object.assign(this.emptyArrivalForm(), {
        applyId: this.inlineOrder.applyForm.id,
        itemId: item.id || null,
        materialName: item.materialName || '',
        specification: item.specification || '',
        quantity,
        arrivedQuantity: quantity,
        unarrivedQuantity: 0,
        status: this.inferArrivalStatusCode({ quantity, arrivedQuantity: quantity, qualityScore: 100, issueDescription: '' }),
        arrivalDate: this.formatDateValue(new Date()),
        qualityScore: 100
      })
      this.uploadRenderKey += 1
      this.$set(this.inlineOrder, 'tab', 'arrival')
      this.$set(this.inlineOrder, 'arrivalForm', form)
    },
    cancelInlineArrival() {
      this.$set(this.inlineOrder, 'arrivalForm', Object.assign(this.emptyArrivalForm(), { applyId: this.inlineOrder.applyForm.id }))
    },
    prepareInlineArrivalBeforeSave() {
      const form = (this.inlineOrder && this.inlineOrder.arrivalForm) || {}
      const quantity = Number(form.quantity || 0)
      const arrived = Number(form.arrivedQuantity || 0)
      this.$set(this.inlineOrder.arrivalForm, 'unarrivedQuantity', Math.max(quantity - arrived, 0))
      this.$set(this.inlineOrder.arrivalForm, 'status', this.inferArrivalStatusCode(form))
    },
    validateInlineArrivalForm() {
      const form = (this.inlineOrder && this.inlineOrder.arrivalForm) || {}
      if (!form.materialName) {
        this.msgWarning('请填写到货物料')
        return false
      }
      if (!form.quantity || Number(form.quantity) <= 0) {
        this.msgWarning('应到数量必须大于0')
        return false
      }
      if (form.arrivedQuantity === undefined || form.arrivedQuantity === null || Number(form.arrivedQuantity) < 0) {
        this.msgWarning('请填写正确的到货数量')
        return false
      }
      if (Number(form.arrivedQuantity) > Number(form.quantity) && !form.issueDescription) {
        this.msgWarning('超收到货时请填写问题说明')
        return false
      }
      if (this.inferArrivalStatusCode(form) === 40 && !form.issueDescription) {
        this.msgWarning('到货异常或质量评分偏低时请填写问题说明')
        return false
      }
      return true
    },
    saveInlineArrival() {
      if (!this.ensureWorkflowEditable(this.inlineOrderCanEditArrival, '当前采购执行单还未进入到货验收节点')) return
      this.prepareInlineArrivalBeforeSave()
      if (!this.validateInlineArrivalForm()) return
      savePurchaseArrival(Object.assign({}, this.inlineOrder.arrivalForm, { applyId: this.inlineOrder.applyForm.id })).then(() => {
        this.msgSuccess('到货验收已保存')
        this.cancelInlineArrival()
        return this.refreshInlineSupplierOrder()
      }).then(() => {
        return this.refreshCurrentDetail()
      })
    },
    addContractPaymentPlan() {
      this.contractPaymentPlanList.push({
        nodeName: '',
        paymentRate: undefined,
        payableAmount: undefined,
        payableDate: '',
        paymentCondition: '',
        status: 20
      })
    },
    contractPayload() {
      this.applySupplierOrderContractDefaults()
      return Object.assign({}, this.contractForm, {
        applyId: this.applyForm.id,
        signDate: this.normalizeDateValue(this.contractForm.signDate),
        itemList: (this.applyForm.itemList || []).filter(item => item.materialName).map(item => {
          const row = Object.assign({}, item, {
            expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate)
          })
          return this.stripItemTransientFields(row)
        }),
        paymentPlanList: (this.contractPaymentPlanList || []).filter(item => item.nodeName).map(item => Object.assign({}, item, {
          payableDate: this.normalizeDateValue(item.payableDate)
        }))
      })
    },
    stripItemTransientFields(row) {
      delete row.historyPriceMatched
      delete row._matchedMaterialName
      delete row._matchedMaterialCode
      delete row._matchedSpecification
      delete row._matchedMaterialQualityBrand
      delete row._matchedUnit
      delete row._matchedSupplierId
      delete row._matchedSupplierName
      delete row._matchedPurchaseUnitPrice
      delete row._matchedAmount
      return row
    },
    hasContractContent() {
      if (!this.isSupplierOrderDetail) return false
      const form = this.contractForm || {}
      const hasPositiveAmount = value => {
        const amount = Number(value)
        return Number.isFinite(amount) && amount > 0
      }
      return Boolean(
        (form.fileInfoList && form.fileInfoList.length) ||
        form.contractText ||
        form.recognitionJson ||
        form.contractNo ||
        form.contractName ||
        form.signDate ||
        form.supplierName ||
        form.partyB ||
        hasPositiveAmount(form.contractAmount) ||
        hasPositiveAmount(form.taxRate) ||
        form.paymentTerms ||
        form.deliveryPeriod ||
        form.attachmentListText ||
        (this.contractPaymentPlanList || []).some(item => item && (
          item.nodeName ||
          hasPositiveAmount(item.paymentRate) ||
          hasPositiveAmount(item.payableAmount) ||
          item.dueDate ||
          item.paymentCondition ||
          (item.invoiceFileList && item.invoiceFileList.length) ||
          (item.paymentVoucherFileList && item.paymentVoucherFileList.length)
        ))
      )
    },
    confirmContractAfterSave(applyId) {
      const payload = Object.assign({}, this.contractPayload(), { applyId })
      return confirmPurchaseContract(payload).then(res => {
        if (res && res.data) {
          this.fillDetail(res.data || {})
        }
        return res
      })
    },
    saveSupplierContract() {
      if (!this.ensureWorkflowEditable(this.canEditContractSection, '当前状态不能保存合同信息')) return
      const mode = Number(this.contractModeDraft || 1)
      const noContractReason = String(this.noContractReasonDraft || this.applyForm.noContractReason || '采购员确认本采购单无合同信息').trim()
      const saveRequest = mode === 2
        ? updatePurchaseContractMode({ applyId: this.applyForm.id, contractMode: 2, noContractReason })
        : this.confirmContractAfterSave(this.applyForm.id)
      this.contractModeSaving = true
      saveRequest.then(() => {
        this.contractEditing = false
        this.contractEditSnapshot = null
        this.msgSuccess(mode === 2 ? '已设置为无合同信息' : '合同信息已保存')
        return this.refreshCurrentDetail()
      }).catch(err => {
        const message = err && err.message ? err.message : '请检查合同附件、合同金额和供应商信息'
        this.$message.error(`合同信息保存失败：${message}`)
      }).finally(() => {
        this.contractModeSaving = false
      })
    },
    startContractEdit() {
      if (!this.ensureWorkflowEditable(this.canManageContractSection, '当前状态不能修改合同信息')) return
      this.contractModeDraft = Number(this.applyForm.contractMode || 1)
      this.noContractReasonDraft = this.applyForm.noContractReason || ''
      this.contractEditSnapshot = {
        form: JSON.parse(JSON.stringify(this.contractForm || {})),
        mode: this.contractModeDraft,
        noContractReason: this.noContractReasonDraft
      }
      this.contractEditing = true
    },
    cancelContractEdit() {
      if (this.contractEditSnapshot) {
        this.contractForm = JSON.parse(JSON.stringify(this.contractEditSnapshot.form || {}))
        this.contractModeDraft = Number(this.contractEditSnapshot.mode || 1)
        this.noContractReasonDraft = this.contractEditSnapshot.noContractReason || ''
      }
      this.contractEditing = false
      this.contractEditSnapshot = null
    },
    handleRecognizeContract() {
      this.openAiEntryDialog(this.isSupplierOrderDetail ? ['basic', 'contract', 'items'] : ['basic', 'items'])
    },
    handleRecognizeContractInfoOnly() {
      this.openAiEntryDialog(['contract'])
    },
    handleRecognizeInlineContract() {
      if (!this.ensureWorkflowEditable(this.inlineOrderContractEditable, '当前状态不能使用AI维护合同')) return
      this.openAiEntryDialog(['contract'], {
        mode: 'inlineContract',
        forceAllowed: true,
        fileInfoList: (this.inlineOrder.contractForm.fileInfoList || []).slice(),
        contractText: this.inlineOrder.contractForm.contractText || ''
      })
    },
    openAiEntryDialog(scopes, options = {}) {
      if (!this.ensureWorkflowEditable(options.forceAllowed || this.canEditProcurementBase || this.canEditContractSection, '当前状态不能使用AI录入')) return
      const selectedScopes = scopes && scopes.length ? scopes : this.defaultAiScopeValues()
      this.recognitionFillMode = options.mode || (selectedScopes.includes('contract') && !selectedScopes.includes('basic') && !selectedScopes.includes('items') ? 'contract' : 'apply')
      this.aiAllowedScopeValues = selectedScopes.slice()
      this.aiEntryOpen = true
      this.aiResultTab = this.defaultAiResultTab()
      this.aiApplyScopes = this.normalizeAiScopes(selectedScopes)
      this.aiRecognizedResult = null
      this.aiRecognitionRawFiles = []
      this.aiRecognitionForm = {
        fileInfoList: options.fileInfoList !== undefined ? options.fileInfoList : (this.contractForm.fileInfoList || []).slice(),
        contractText: options.contractText !== undefined ? options.contractText : (this.contractForm.contractText || '')
      }
      this.recognitionProgress = 0
      this.recognitionMessage = '等待选择文件或粘贴资料'
      this.recognitionStage = ''
      this.recognitionElapsedSeconds = 0
      this.uploadRenderKey += 1
      this.stopRecognitionTicker()
    },
    handleAiRecognitionFileListChange(fileInfoList) {
      const files = (fileInfoList || []).filter(Boolean)
      const visibleKeys = new Set(files.map(file => String(file.uid || file.id || file.url || file.name || '')))
      this.aiRecognitionRawFiles = (this.aiRecognitionRawFiles || []).filter(entry => {
        const info = entry && entry.fileInfo ? entry.fileInfo : {}
        return visibleKeys.has(String(info.uid || info.id || info.url || info.name || ''))
      })
    },
    handleAiRawFileUploaded(payload) {
      const rawFile = payload && payload.rawFile
      const fileInfo = payload && payload.fileInfo
      if (!rawFile || !fileInfo) return
      const key = String(fileInfo.uid || fileInfo.id || fileInfo.url || fileInfo.name || rawFile.name || '')
      const entry = { key, rawFile, fileInfo }
      const index = (this.aiRecognitionRawFiles || []).findIndex(item => item && item.key === key)
      if (index > -1) {
        this.$set(this.aiRecognitionRawFiles, index, entry)
      } else {
        this.aiRecognitionRawFiles.push(entry)
      }
    },
    resolveAiWorkbookEntry(files) {
      if (this.recognitionFillMode !== 'apply' || String(this.aiRecognitionForm.contractText || '').trim()) return null
      if (!files || files.length !== 1) return null
      const fileInfo = files[0] || {}
      if (!/\.xlsx?$/i.test(String(fileInfo.name || ''))) return null
      const fileKey = String(fileInfo.uid || fileInfo.id || fileInfo.url || fileInfo.name || '')
      return (this.aiRecognitionRawFiles || []).find(entry => entry && entry.key === fileKey) || null
    },
    buildAiRecognitionPayload(overrides = {}) {
      const basePayload = this.recognitionFillMode === 'inlineContract'
        ? this.inlineContractPayload()
        : this.contractPayload()
      const hasFileOverride = Object.prototype.hasOwnProperty.call(overrides, 'fileInfoList')
      const hasTextOverride = Object.prototype.hasOwnProperty.call(overrides, 'contractText')
      return Object.assign({}, basePayload, {
        applyId: null,
        fileInfoList: hasFileOverride ? (overrides.fileInfoList || []) : (this.aiRecognitionForm.fileInfoList || []),
        contractText: hasTextOverride ? (overrides.contractText || '') : (this.aiRecognitionForm.contractText || ''),
        targetScopes: (this.aiAllowedScopeValues && this.aiAllowedScopeValues.length ? this.aiAllowedScopeValues : this.defaultAiScopeValues()).slice(),
        recognitionMode: this.recognitionFillMode || 'apply'
      })
    },
    runAiRecognition() {
      if (!this.ensureWorkflowEditable(this.recognitionFillMode === 'inlineContract' ? this.inlineOrderContractEditable : (this.canEditProcurementBase || this.canEditContractSection), '当前状态不能使用AI录入')) return
      const files = (this.aiRecognitionForm.fileInfoList || []).filter(Boolean)
      const hasContractFile = files.length
      if (!hasContractFile && !this.aiRecognitionForm.contractText) {
        this.msgWarning(this.recognitionFillMode === 'apply'
          ? '请先选择采购需求文件或粘贴需求内容'
          : '请先选择文件或粘贴合同正文')
        return
      }
      const workbookEntry = this.resolveAiWorkbookEntry(files)
      if (workbookEntry) {
        this.runApplyWorkbookRecognition(workbookEntry)
        return
      }
      this.aiRecognizedResult = null
      this.recognizingContract = true
      this.resetRecognitionProgress()
      this.startRecognitionTicker()
      const task = this.shouldSplitAiRecognitionByFile(files)
        ? this.runAiRecognitionByFiles(files)
        : recognizePurchaseContractDraftStream(this.buildAiRecognitionPayload(), {
          onProgress: progress => this.updateRecognitionProgress(progress)
        }).then(res => {
          const recognized = this.normalizeRecognizedProcurement(res.data || {})
          this.aiRecognizedResult = recognized
          this.updateRecognitionProgress({ stage: 'DONE', message: '识别完成，请选择要填入的区域', percent: 100 })
          this.aiResultTab = this.defaultAiResultTab(recognized)
          this.msgSuccess('识别完成，请在弹窗内复核后选择填入')
        })
      task.catch(err => {
        this.recognitionStage = 'ERROR'
        const fallbackMessage = this.recognitionFillMode === 'apply' ? '采购需求识别失败' : '合同识别失败'
        this.recognitionMessage = err && err.message ? err.message : fallbackMessage
        this.$message.error(err && err.message ? err.message : fallbackMessage)
      }).finally(() => {
        this.recognizingContract = false
        this.stopRecognitionTicker()
      })
    },
    shouldSplitAiRecognitionByFile(files) {
      const selectedScopes = this.aiAllowedScopeValues && this.aiAllowedScopeValues.length
        ? this.aiAllowedScopeValues
        : this.defaultAiScopeValues()
      return this.recognitionFillMode === 'apply' &&
        files && files.length > 1 &&
        selectedScopes.includes('items') &&
        !String(this.aiRecognitionForm.contractText || '').trim()
    },
    runAiRecognitionByFiles(files) {
      this.aiBatchProgressList = files.map(() => 0)
      this.updateRecognitionProgress({
        stage: 'CALL_QWEN_BATCH_START',
        message: '正在并发识别' + files.length + '个文件',
        percent: 18
      })
      const tasks = files.map((file, index) => {
        const fileName = this.recognitionFileName(file, index)
        return recognizePurchaseContractDraftStream(this.buildAiRecognitionPayload({
          fileInfoList: [file],
          contractText: ''
        }), {
          onProgress: progress => this.updateFileRecognitionProgress(index, fileName, progress)
        }).then(res => {
          this.$set(this.aiBatchProgressList, index, 100)
          this.updateMergedFileRecognitionProgress(fileName)
          return { ok: true, fileName, data: res.data || {} }
        }).catch(error => {
          this.$set(this.aiBatchProgressList, index, 100)
          return { ok: false, fileName, error }
        })
      })
      return Promise.all(tasks).then(results => {
        const successRows = results.filter(item => item.ok)
        const failedRows = results.filter(item => !item.ok)
        if (!successRows.length) {
          const firstError = failedRows[0] && failedRows[0].error
          throw firstError || new Error('多个文件均未识别成功')
        }
        const merged = this.normalizeRecognizedProcurement(this.mergeRecognizedFileResults(successRows))
        if (failedRows.length) {
          const failedNames = failedRows.map(item => item.fileName).join('、')
          merged.warnings = this.uniqueReferenceValues([].concat(merged.warnings || [], failedRows.map(item => item.fileName + '识别失败')))
          this.$message.warning('部分文件未识别成功：' + failedNames)
        }
        this.aiRecognizedResult = merged
        this.aiResultTab = this.defaultAiResultTab(merged)
        this.updateRecognitionProgress({
          stage: 'DONE',
          message: '已合并' + successRows.length + '个文件的识别结果，请选择要填入的区域',
          percent: 100
        })
        this.msgSuccess('识别完成，已按文件合并采购清单')
      })
    },
    updateFileRecognitionProgress(index, fileName, progress) {
      const percent = Math.max(0, Math.min(100, Number(progress && progress.percent || 0)))
      this.$set(this.aiBatchProgressList, index, percent)
      const currentStage = progress && progress.stage ? progress.stage : 'CALL_QWEN_BATCH_START'
      const avg = this.aiBatchProgressList.length
        ? this.aiBatchProgressList.reduce((sum, value) => sum + Number(value || 0), 0) / this.aiBatchProgressList.length
        : percent
      const doneCount = this.aiBatchProgressList.filter(value => Number(value || 0) >= 100).length
      this.updateRecognitionProgress({
        stage: currentStage.indexOf('CALL_QWEN') === 0 ? 'CALL_QWEN_BATCH_START' : currentStage,
        message: '并发识别 ' + doneCount + '/' + this.aiBatchProgressList.length + '：' + fileName,
        percent: Math.min(95, Math.max(this.recognitionProgress || 0, Math.round(18 + avg * 0.76)))
      })
    },
    updateMergedFileRecognitionProgress(fileName) {
      const doneCount = this.aiBatchProgressList.filter(value => Number(value || 0) >= 100).length
      this.updateRecognitionProgress({
        stage: doneCount >= this.aiBatchProgressList.length ? 'CALL_QWEN_MERGE' : 'CALL_QWEN_BATCH_START',
        message: '已返回' + doneCount + '/' + this.aiBatchProgressList.length + '：' + fileName,
        percent: doneCount >= this.aiBatchProgressList.length ? 96 : Math.min(94, 18 + Math.round(doneCount * 76 / this.aiBatchProgressList.length))
      })
    },
    recognitionFileName(file, index) {
      return (file && (file.name || file.fileName || file.originalFilename || file.originalName || file.filePath || file.url)) || ('第' + (index + 1) + '个文件')
    },
    mergeRecognizedFileResults(results) {
      const merged = {
        contractNo: null,
        contractName: null,
        signDate: null,
        partyA: null,
        partyB: null,
        supplierName: null,
        contractAmount: null,
        taxRate: null,
        paymentTerms: null,
        deliveryPeriod: null,
        attachmentListText: null,
        itemList: [],
        paymentPlanList: [],
        aiFocusPoints: [],
        warnings: [],
        confidence: 0
      }
      const supplierNames = []
      let amountTotal = 0
      let confidenceTotal = 0
      let confidenceCount = 0
      ;(results || []).forEach(result => {
        const fileName = result.fileName
        const recognized = this.normalizeRecognizedProcurement(result.data || {})
        const supplierName = this.resolveRecognizedSupplierName(recognized)
        supplierNames.push(...this.splitSupplierNames(supplierName))
        this.copyFirstRecognizedFields(merged, recognized, [
          'contractNo', 'contractName', 'signDate', 'partyA', 'partyB',
          'taxRate', 'paymentTerms', 'deliveryPeriod', 'attachmentListText',
          'expectedArrivalDate'
        ])
        if (recognized.contractAmount && Number(recognized.contractAmount) > 0) {
          amountTotal += Number(recognized.contractAmount)
        }
        if (recognized.confidence !== undefined && recognized.confidence !== null) {
          confidenceTotal += Number(recognized.confidence || 0)
          confidenceCount += 1
        }
        const items = this.toObjectArray(recognized.itemList).filter(item => item && item.materialName)
        items.forEach(item => {
          const row = Object.assign({}, item)
          const candidates = this.uniqueReferenceValues([].concat(
            this.splitSupplierNames(row._supplierCandidateName),
            this.splitSupplierNames(row.supplierName),
            this.splitSupplierNames(supplierName)
          ))
          if (candidates.length) {
            row._supplierCandidateName = candidates.join('、')
          }
          row._sourceFileName = fileName
          row.remark = this.mergeRemark(row.remark, '来源文件：' + fileName)
          merged.itemList.push(row)
        })
        merged.paymentPlanList.push(...this.toObjectArray(recognized.paymentPlanList).map(plan => Object.assign({}, plan, {
          remark: this.mergeRemark(plan.remark, '来源文件：' + fileName)
        })))
        merged.aiFocusPoints.push(...this.prefixRecognitionMessages(recognized.aiFocusPoints, fileName))
        merged.warnings.push(...this.prefixRecognitionMessages(recognized.warnings, fileName))
      })
      const uniqueSuppliers = this.uniqueReferenceValues(supplierNames)
      merged.supplierName = uniqueSuppliers.join('、') || null
      merged.partyB = merged.partyB || merged.supplierName
      merged.contractAmount = amountTotal > 0
        ? roundPurchaseMoney(amountTotal)
        : roundPurchaseMoney((merged.itemList || []).reduce((sum, item) => sum + Number(item.amount || 0), 0)) || null
      if (!merged.contractName) {
        merged.contractName = uniqueSuppliers.length > 1
          ? uniqueSuppliers[0] + '等' + uniqueSuppliers.length + '家采购'
          : (uniqueSuppliers[0] ? uniqueSuppliers[0] + '采购' : null)
      }
      merged.aiFocusPoints = this.uniqueReferenceValues(merged.aiFocusPoints).slice(0, 8)
      merged.warnings = this.uniqueReferenceValues(merged.warnings).slice(0, 8)
      merged.confidence = confidenceCount ? Math.round(confidenceTotal / confidenceCount) : 0
      return merged
    },
    copyFirstRecognizedFields(target, source, fields) {
      fields.forEach(field => {
        if ((target[field] === undefined || target[field] === null || target[field] === '') &&
          source[field] !== undefined && source[field] !== null && source[field] !== '') {
          target[field] = source[field]
        }
      })
    },
    resolveRecognizedSupplierName(recognized) {
      const names = this.uniqueReferenceValues([].concat(
        this.splitSupplierNames(recognized && recognized.supplierName),
        this.splitSupplierNames(recognized && recognized.partyB),
        this.toObjectArray(recognized && recognized.itemList).map(item => item && (item._supplierCandidateName || item.supplierName))
      ))
      return names.join('、')
    },
    mergeRemark(oldValue, appendValue) {
      return this.uniqueReferenceValues([oldValue, appendValue]).join('；')
    },
    prefixRecognitionMessages(messages, fileName) {
      return this.toTextArray(messages).filter(Boolean).map(message => fileName + '：' + message)
    },
    applyAiRecognition(scopes) {
      if (!this.aiRecognizedResult) return
      const selectedScopes = this.normalizeAiScopes(scopes && scopes.length ? scopes : this.aiApplyScopes)
      if (!selectedScopes.length) {
        this.msgWarning('请选择要填入的区域')
        return
      }
      const recognized = this.normalizeRecognizedProcurement(this.aiRecognizedResult || {})
      const overwrite = Boolean(this.aiOverwriteExisting)
      if (this.recognitionFillMode === 'inlineContract') {
        if (selectedScopes.includes('contract')) this.applyRecognizedInlineContractInfo(recognized, overwrite)
        if (selectedScopes.includes('payment')) this.applyRecognizedInlinePaymentPlans(recognized, overwrite)
        if (selectedScopes.includes('contract') || selectedScopes.includes('payment')) {
          this.$set(this.inlineOrder.contractForm, 'fileInfoList', (this.aiRecognitionForm.fileInfoList || []).slice())
          this.$set(this.inlineOrder.contractForm, 'contractText', this.aiRecognitionForm.contractText || '')
        }
        this.aiEntryOpen = false
        this.$set(this.inlineOrder, 'tab', 'contract')
        this.msgSuccess('AI识别结果已填入当前采购执行单，请复核后保存')
        return
      }
      if (selectedScopes.includes('basic')) this.applyRecognizedBasicInfo(recognized, overwrite)
      if (selectedScopes.includes('contract')) this.applyRecognizedContractInfo(recognized, overwrite)
      if (selectedScopes.includes('items')) this.applyRecognizedItems(recognized, overwrite)
      if (selectedScopes.includes('payment')) this.applyRecognizedPaymentPlans(recognized, overwrite)
      if (this.recognitionFillMode === 'apply') {
        this.mergeApplicationAttachments(this.aiRecognitionForm.fileInfoList)
        this.$set(this.applyForm, 'sourceMode', 2)
      }
      if (selectedScopes.includes('contract') || selectedScopes.includes('payment')) {
        this.contractForm.fileInfoList = (this.aiRecognitionForm.fileInfoList || []).slice()
        this.contractForm.contractText = this.aiRecognitionForm.contractText || ''
      }
      this.ensureProcurementReferences(true).then(() => {
        this.autoMatchRecognizedReferences()
      }).catch(() => {
        this.autoMatchRecognizedReferences()
      })
      this.aiEntryOpen = false
      this.detailTab = this.isSupplierOrderDetail && selectedScopes.includes('contract') ? 'contract' : 'basic'
      this.msgSuccess('AI识别结果已填入，请复核后保存')
    },
    mergeApplicationAttachments(fileInfoList) {
      const currentFiles = (this.applicationAttachmentFileObjs || []).slice()
      const knownKeys = new Set(currentFiles.map(item => String(item && (item.id || item.url || item.uid || item.name) || '')))
      ;(fileInfoList || []).filter(Boolean).forEach(file => {
        const key = String(file.id || file.url || file.uid || file.name || '')
        if (key && !knownKeys.has(key)) {
          currentFiles.push(file)
          knownKeys.add(key)
        }
      })
      this.applicationAttachmentFileObjs = currentFiles
    },
    applyRecognizedBasicInfo(recognized, overwrite) {
      this.assignRecognizedField(this.applyForm, 'applyTitle', recognized.contractName || (recognized.supplierName || recognized.partyB ? `${recognized.supplierName || recognized.partyB}采购合同` : ''), overwrite)
      this.assignRecognizedField(this.applyForm, 'expectedArrivalDate', recognized.expectedArrivalDate, overwrite)
      if (recognized.contractNo && (overwrite || !this.applyForm.contractNum)) this.$set(this.applyForm, 'contractNum', recognized.contractNo)
      if (!this.isApplicationDetail) {
        this.assignRecognizedField(this.applyForm, 'budgetAmount', recognized.contractAmount, overwrite)
        if (recognized.contractAmount && (overwrite || !this.applyForm.applyAmount)) this.$set(this.applyForm, 'applyAmount', recognized.contractAmount)
      }
    },
    applyRecognizedContractInfo(recognized, overwrite) {
      const currentFiles = this.contractForm.fileInfoList || []
      const currentText = this.contractForm.contractText || ''
      ;[
        ['contractNo', recognized.contractNo],
        ['contractName', recognized.contractName],
        ['signDate', recognized.signDate],
        ['partyA', recognized.partyA || this.currentTenantName()],
        ['partyB', recognized.partyB || recognized.supplierName],
        ['supplierName', recognized.supplierName || recognized.partyB],
        ['contractAmount', recognized.contractAmount],
        ['taxRate', recognized.taxRate],
        ['paymentTerms', recognized.paymentTerms],
        ['deliveryPeriod', recognized.deliveryPeriod],
        ['attachmentListText', recognized.attachmentListText],
        ['aiFocusPoints', recognized.aiFocusPoints],
        ['recognitionJson', recognized.recognitionJson]
      ].forEach(([key, value]) => this.assignRecognizedField(this.contractForm, key, value, overwrite))
      if (!this.contractForm.partyA) this.$set(this.contractForm, 'partyA', this.currentTenantName())
      if (!this.contractForm.partyB && this.contractForm.supplierName) this.$set(this.contractForm, 'partyB', this.contractForm.supplierName)
      if (!this.contractForm.supplierName && this.contractForm.partyB) this.$set(this.contractForm, 'supplierName', this.contractForm.partyB)
      this.contractForm.fileInfoList = currentFiles
      this.contractForm.contractText = currentText
    },
    applyRecognizedInlineContractInfo(recognized, overwrite) {
      const contract = (this.inlineOrder && this.inlineOrder.contractForm) || {}
      const currentFiles = contract.fileInfoList || []
      const currentText = contract.contractText || ''
      ;[
        ['contractNo', recognized.contractNo],
        ['contractName', recognized.contractName],
        ['signDate', recognized.signDate],
        ['partyA', recognized.partyA || this.currentTenantName()],
        ['partyB', recognized.partyB || recognized.supplierName],
        ['supplierName', recognized.supplierName || recognized.partyB],
        ['contractAmount', recognized.contractAmount],
        ['taxRate', recognized.taxRate],
        ['paymentTerms', recognized.paymentTerms],
        ['deliveryPeriod', recognized.deliveryPeriod],
        ['attachmentListText', recognized.attachmentListText],
        ['aiFocusPoints', recognized.aiFocusPoints],
        ['recognitionJson', recognized.recognitionJson]
      ].forEach(([key, value]) => this.assignRecognizedField(contract, key, value, overwrite))
      if (!contract.partyA) this.$set(contract, 'partyA', this.currentTenantName())
      if (!contract.partyB && contract.supplierName) this.$set(contract, 'partyB', contract.supplierName)
      if (!contract.supplierName && contract.partyB) this.$set(contract, 'supplierName', contract.partyB)
      if (!contract.supplierId && this.inlineOrder.applyForm.supplierId) this.$set(contract, 'supplierId', this.inlineOrder.applyForm.supplierId)
      contract.fileInfoList = currentFiles
      contract.contractText = currentText
    },
    applyRecognizedItems(recognized, overwrite) {
      const rows = (recognized.itemList || []).filter(item => item && item.materialName)
      if (!rows.length) return
      const normalizedRows = rows.map((item, index) => {
        const row = Object.assign(this.emptyApplyItem(), item, {
          sortNo: index + 1,
          expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate)
        })
        if (this.isApplicationDetail) {
          row.supplierId = null
          row.supplierName = ''
          row.budgetUnitPrice = undefined
          row.purchaseUnitPrice = undefined
          row.amount = 0
        }
        return row
      })
      const currentRows = (this.applyForm.itemList || []).filter(item => item && item.materialName)
      if (overwrite || !currentRows.length) {
        this.applyForm.itemList = normalizedRows
        return
      }
      const seen = new Set(currentRows.map(item => [item.materialName, item.specification, item.supplierName, item.purchaseUnitPrice].map(this.normalizeReferenceName).join('|')))
      normalizedRows.forEach(row => {
        const key = [row.materialName, row.specification, row.supplierName, row.purchaseUnitPrice].map(this.normalizeReferenceName).join('|')
        if (!seen.has(key)) {
          this.applyForm.itemList.push(row)
          seen.add(key)
        }
      })
    },
    applyRecognizedPaymentPlans(recognized, overwrite) {
      const rows = (recognized.paymentPlanList || []).filter(item => item && item.nodeName)
      if (!rows.length) return
      const normalizedRows = rows.map((item, index) => Object.assign({}, item, {
        sortNo: index + 1,
        payableDate: this.normalizeDateValue(item.payableDate)
      }))
      const currentRows = (this.contractPaymentPlanList || []).filter(item => item && item.nodeName)
      if (overwrite || !currentRows.length) {
        this.contractPaymentPlanList = normalizedRows
        return
      }
      const seen = new Set(currentRows.map(item => [item.nodeName, item.payableAmount, item.paymentRate].map(this.normalizeReferenceName).join('|')))
      normalizedRows.forEach(row => {
        const key = [row.nodeName, row.payableAmount, row.paymentRate].map(this.normalizeReferenceName).join('|')
        if (!seen.has(key)) {
          this.contractPaymentPlanList.push(row)
          seen.add(key)
        }
      })
    },
    applyRecognizedInlinePaymentPlans(recognized, overwrite) {
      const rows = (recognized.paymentPlanList || []).filter(item => item && item.nodeName)
      if (!rows.length) return
      const normalizedRows = rows.map((item, index) => Object.assign({}, item, {
        sortNo: index + 1,
        payableDate: this.normalizeDateValue(item.payableDate)
      }))
      const currentRows = ((this.inlineOrder && this.inlineOrder.paymentPlanList) || []).filter(item => item && item.nodeName)
      if (overwrite || !currentRows.length) {
        this.$set(this.inlineOrder, 'paymentPlanList', normalizedRows)
        return
      }
      const seen = new Set(currentRows.map(item => [item.nodeName, item.payableAmount, item.paymentRate].map(this.normalizeReferenceName).join('|')))
      normalizedRows.forEach(row => {
        const key = [row.nodeName, row.payableAmount, row.paymentRate].map(this.normalizeReferenceName).join('|')
        if (!seen.has(key)) {
          this.inlineOrder.paymentPlanList.push(row)
          seen.add(key)
        }
      })
    },
    assignRecognizedField(target, key, value, overwrite) {
      if (value === undefined || value === null || value === '') return
      if (overwrite || target[key] === undefined || target[key] === null || target[key] === '') {
        this.$set(target, key, value)
      }
    },
    resetRecognitionProgress() {
      this.recognitionProgress = 8
      this.recognitionMessage = '开始识别'
      this.recognitionStage = 'START'
      this.recognitionElapsedSeconds = 0
      this.aiBatchProgressList = []
      this.stopRecognitionTicker()
    },
    startRecognitionTicker() {
      this.stopRecognitionTicker()
      this.recognitionElapsedSeconds = 0
      this.recognitionTicker = window.setInterval(() => {
        this.recognitionElapsedSeconds += 1
        this.advanceRecognitionEstimate()
      }, 1000)
    },
    stopRecognitionTicker() {
      if (this.recognitionTicker) {
        window.clearInterval(this.recognitionTicker)
        this.recognitionTicker = null
      }
    },
    updateRecognitionProgress(progress) {
      if (!progress) return
      this.recognitionStage = progress.stage || this.recognitionStage
      this.recognitionMessage = progress.message || this.recognitionMessage
      this.recognitionProgress = Math.max(this.recognitionProgress || 0, Number(progress.percent || 0))
    },
    advanceRecognitionEstimate() {
      if (!this.recognizingContract || !this.recognitionStage || this.recognitionStage.indexOf('CALL_QWEN') !== 0 || this.recognitionStage === 'CALL_QWEN_RETURN' || this.recognitionStage === 'CALL_QWEN_MERGE') {
        return
      }
      const elapsed = this.recognitionElapsedSeconds || 0
      const estimated = elapsed <= 3
        ? 58 + elapsed * 6
        : (elapsed <= 10 ? 76 + Math.floor((elapsed - 3) * 1.5) : (elapsed <= 25 ? 86 + Math.floor((elapsed - 10) / 3) : 92))
      this.recognitionProgress = Math.max(this.recognitionProgress || 0, Math.min(92, estimated))
    },
    applyDraftRecognition(recognized) {
      recognized = this.normalizeRecognizedProcurement(recognized || {})
      const currentFiles = this.contractForm.fileInfoList || []
      const currentText = this.contractForm.contractText || ''
      this.contractForm = Object.assign({}, this.contractForm, recognized, {
        applyId: this.applyForm.id,
        fileInfoList: currentFiles,
        contractText: currentText
      })
      if (recognized.contractName && !this.applyForm.applyTitle) {
        this.applyForm.applyTitle = recognized.contractName
      }
      if (!this.applyForm.applyTitle && (recognized.supplierName || recognized.partyB)) {
        this.applyForm.applyTitle = `${recognized.supplierName || recognized.partyB}采购合同`
      }
      if (recognized.contractAmount && !this.applyForm.budgetAmount) {
        this.applyForm.budgetAmount = recognized.contractAmount
      }
      if (recognized.expectedArrivalDate && !this.applyForm.expectedArrivalDate) {
        this.applyForm.expectedArrivalDate = recognized.expectedArrivalDate
      }
      if (recognized.itemList && recognized.itemList.length) {
        this.applyForm.itemList = recognized.itemList.map((item, index) => Object.assign(this.emptyApplyItem(), item, {
          sortNo: index + 1,
          expectedArrivalDate: this.normalizeDateValue(item.expectedArrivalDate)
        }))
      }
      this.ensureProcurementReferences(true).then(() => {
        this.autoMatchRecognizedReferences()
      })
    },
    applyContractInfoRecognition(recognized) {
      recognized = this.normalizeRecognizedProcurement(recognized || {})
      const currentFiles = this.contractForm.fileInfoList || []
      const currentText = this.contractForm.contractText || ''
      const nextContract = Object.assign({}, this.contractForm, {
        contractNo: recognized.contractNo || this.contractForm.contractNo,
        contractName: recognized.contractName || this.contractForm.contractName,
        signDate: recognized.signDate || this.contractForm.signDate,
        partyA: recognized.partyA || this.contractForm.partyA || this.currentTenantName(),
        partyB: recognized.partyB || recognized.supplierName || this.contractForm.partyB,
        supplierId: this.contractForm.supplierId,
        supplierName: recognized.supplierName || recognized.partyB || this.contractForm.supplierName,
        contractAmount: recognized.contractAmount || this.contractForm.contractAmount,
        taxRate: recognized.taxRate === undefined || recognized.taxRate === null ? this.contractForm.taxRate : recognized.taxRate,
        paymentTerms: recognized.paymentTerms || this.contractForm.paymentTerms,
        deliveryPeriod: recognized.deliveryPeriod || this.contractForm.deliveryPeriod,
        attachmentListText: recognized.attachmentListText || this.contractForm.attachmentListText,
        aiFocusPoints: recognized.aiFocusPoints || this.contractForm.aiFocusPoints,
        recognitionJson: recognized.recognitionJson || this.contractForm.recognitionJson,
        fileInfoList: currentFiles,
        contractText: currentText
      })
      this.contractForm = nextContract
      if (!this.contractForm.partyA) this.$set(this.contractForm, 'partyA', this.currentTenantName())
      if (!this.contractForm.partyB && this.contractForm.supplierName) this.$set(this.contractForm, 'partyB', this.contractForm.supplierName)
      if (!this.contractForm.supplierName && this.contractForm.partyB) this.$set(this.contractForm, 'supplierName', this.contractForm.partyB)
      if (recognized.contractAmount && !this.applyForm.budgetAmount) this.applyForm.budgetAmount = recognized.contractAmount
      if (recognized.expectedArrivalDate && !this.applyForm.expectedArrivalDate) this.applyForm.expectedArrivalDate = recognized.expectedArrivalDate
      this.ensureProcurementReferences(true).then(() => {
        this.autoMatchRecognizedReferences()
      })
    },
    normalizeRecognizedProcurement(recognized) {
      const normalized = Object.assign({}, recognized)
      if (!normalized.supplierName && normalized.partyB) {
        normalized.supplierName = normalized.partyB
      }
      if (!normalized.contractName && normalized.contractNo) {
        normalized.contractName = `${normalized.contractNo}采购合同`
      }
      normalized.signDate = this.normalizeDateValue(normalized.signDate)
      normalized.expectedArrivalDate = this.normalizeDateValue(normalized.expectedArrivalDate)
      normalized.itemList = this.toObjectArray(normalized.itemList).map(item => this.normalizeRecognizedItem(item, normalized))
      normalized.paymentPlanList = this.toObjectArray(normalized.paymentPlanList).map(item => Object.assign({}, item, {
        payableDate: this.normalizeDateValue(item.payableDate)
      }))
      normalized.aiFocusPoints = this.toTextValue(normalized.aiFocusPoints)
      normalized.warnings = this.toTextArray(normalized.warnings)
      if ((!normalized.paymentPlanList || !normalized.paymentPlanList.length) && normalized.paymentTerms && normalized.contractAmount) {
        normalized.paymentPlanList = [this.buildFallbackPaymentPlan(normalized)]
      }
      return normalized
    },
    normalizeRecognizedItem(item, recognized) {
      const row = Object.assign({}, item)
      const rowSupplierCandidates = this.uniqueReferenceValues(this.splitSupplierNames(row.supplierName))
      const documentSupplierCandidates = this.uniqueReferenceValues([].concat(
        this.splitSupplierNames(recognized && recognized.supplierName),
        this.splitSupplierNames(recognized && recognized.partyB)
      ))
      const supplierCandidates = rowSupplierCandidates.length
        ? rowSupplierCandidates
        : (this.shouldShowSupplierInputColumn || documentSupplierCandidates.length === 1 ? documentSupplierCandidates : [])
      if (supplierCandidates.length) {
        row._supplierCandidateName = supplierCandidates.join('、')
      }
      if (!this.shouldShowSupplierInputColumn) {
        row.supplierId = null
        row.supplierName = ''
      } else if (!row.supplierName && supplierCandidates.length === 1) {
        row.supplierName = supplierCandidates[0]
      }
      const derivedSpec = this.deriveSpecificationFromMaterialName(row.materialName)
      if (derivedSpec && (!row.specification || this.sameReferenceSpecification(row.specification, derivedSpec, row.materialName, row.materialName))) {
        row.specification = derivedSpec
      } else if (row.specification) {
        row.specification = this.normalizeReferenceSpecDisplay(row.specification, row.materialName)
      }
      if (row.specification && row.materialName) {
        row.materialName = this.cleanMaterialName(row.materialName, row.specification)
      }
      if (!row.materialQualityBrand) {
        row.materialQualityBrand = this.deriveMaterialQualityBrand(row.materialName)
      }
      row.expectedArrivalDate = this.normalizeDateValue(row.expectedArrivalDate)
      if ((!row.amount || Number(row.amount) === 0) && row.quantity && row.purchaseUnitPrice) {
        row.amount = roundPurchaseMoney(Number(row.quantity || 0) * Number(row.purchaseUnitPrice || 0))
      }
      return row
    },
    buildFallbackPaymentPlan(recognized) {
      return {
        nodeName: '按合同约定付款',
        paymentRate: 100,
        payableAmount: recognized.contractAmount,
        payableDate: '',
        paymentCondition: recognized.paymentTerms,
        remark: '请复核付款节点',
        status: 20
      }
    },
    deriveSpecificationFromMaterialName(materialName) {
      const text = String(materialName || '').trim()
      if (!text) return ''
      const patterns = [
        /\bM\d+(?:\.\d+)?(?:[-xX*×]\d+(?:\.\d+)?){1,3}\b/i,
        /\bST\d+(?:\.\d+)?(?:[-xX*×]\d+(?:\.\d+)?){1,3}\b/i,
        /\bDN\d+(?:[-xX*×]\d+(?:\.\d+)?){0,2}\b/i,
        /\b\d+(?:\.\d+)?\s*(?:mm|cm|m|kg|g|ml|l)\b/i,
        /[Φφ]\s*\d+(?:\.\d+)?(?:[-xX*×]\d+(?:\.\d+)?){0,2}/,
        /\b\d+(?:\.\d+)?[-xX*×]\d+(?:\.\d+)?(?:[-xX*×]\d+(?:\.\d+)?){0,2}\b/
      ]
      for (const pattern of patterns) {
        const match = text.match(pattern)
        if (match && match[0]) return this.normalizeReferenceSpecDisplay(match[0].replace(/×/g, '*').replace(/[xX]/g, '*').replace(/\s+/g, ''), text)
      }
      return ''
    },
    cleanMaterialName(materialName, specification) {
      if (!materialName || !specification) return materialName
      const variants = [
        specification,
        specification.toLowerCase(),
        specification.toUpperCase(),
        specification.replace(/\*/g, '×'),
        specification.replace(/\*/g, 'x'),
        specification.replace(/\*/g, 'X')
      ]
      let text = String(materialName)
      variants.forEach(value => {
        if (value) text = text.replace(new RegExp(this.escapeRegExp(value), 'ig'), '')
      })
      text = text.replace(/[\s,，;；/（）()【】\[\]-]+$/g, '').trim()
      return text || materialName
    },
    escapeRegExp(value) {
      return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    deriveMaterialQualityBrand(materialName) {
      const text = String(materialName || '').toUpperCase()
      const materials = ['316L', '316', '304', 'PVDF', 'PVC', 'PTFE', 'PET', 'PP', 'PE', 'ABS']
      return materials.find(item => text.indexOf(item) > -1) || ''
    },
    normalizeDateValue(value) {
      if (value === null || value === undefined || value === '') return ''
      if (Array.isArray(value)) {
        return this.normalizeDateValue(value[0])
      }
      if (value instanceof Date) {
        return this.formatDateValue(value)
      }
      if (typeof value === 'number') {
        const date = value > 100000000000
          ? new Date(value)
          : (value > 10000 ? new Date(Math.round((value - 25569) * 86400 * 1000)) : null)
        return date && !Number.isNaN(date.getTime()) ? this.formatDateValue(date) : ''
      }
      if (typeof value === 'object') {
        if (value.year || value.month || value.day) {
          const year = Number(value.year)
          const month = Number(value.month || 1)
          const day = Number(value.day || 1)
          if (year) return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
        }
        return this.normalizeDateValue(value.date || value.value || value.text || '')
      }
      const text = String(value).trim()
      if (!text) return ''
      const iso = text.match(/^(\d{4})[-/.年](\d{1,2})[-/.月](\d{1,2})/)
      if (iso) return `${iso[1]}-${iso[2].padStart(2, '0')}-${iso[3].padStart(2, '0')}`
      const compact = text.match(/^(\d{4})(\d{2})(\d{2})$/)
      if (compact) return `${compact[1]}-${compact[2]}-${compact[3]}`
      const parsed = new Date(text)
      return Number.isNaN(parsed.getTime()) ? '' : this.formatDateValue(parsed)
    },
    formatDateValue(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    currentDateTimeValue() {
      const date = new Date()
      const day = this.formatDateValue(date)
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const second = String(date.getSeconds()).padStart(2, '0')
      return `${day} ${hour}:${minute}:${second}`
    },
    quoteItemLabel(item) {
      if (!item) return '-'
      const spec = [item.specification, item.materialQualityBrand].filter(Boolean).join('/')
      const qty = item.quantity ? `${this.numberText(item.quantity)}${item.unit || ''}` : ''
      return [item.materialName, spec, qty].filter(Boolean).join(' | ')
    },
    compareApplyItemOrder(left, right, leftIndex = 0, rightIndex = 0) {
      const leftSort = this.referenceNumberValue(left && left.sortNo)
      const rightSort = this.referenceNumberValue(right && right.sortNo)
      if (leftSort !== null || rightSort !== null) {
        if (leftSort === null) return 1
        if (rightSort === null) return -1
        if (leftSort !== rightSort) return leftSort - rightSort
      }
      const leftId = this.referenceNumberValue(left && left.id)
      const rightId = this.referenceNumberValue(right && right.id)
      if (leftId !== null || rightId !== null) {
        if (leftId === null) return 1
        if (rightId === null) return -1
        if (leftId !== rightId) return leftId - rightId
      }
      return leftIndex - rightIndex
    },
    quoteItemById(itemId) {
      if (!itemId) return null
      return (this.applyForm.itemList || []).find(item => String(item.id) === String(itemId)) || null
    },
    quoteMaterialName(quote) {
      if (quote && quote.materialName) {
        const spec = [quote.specification, quote.materialQualityBrand].filter(Boolean).join('/')
        const qty = quote.quantity ? `${this.numberText(quote.quantity)}${quote.unit || ''}` : ''
        return [quote.materialName, spec, qty].filter(Boolean).join(' | ')
      }
      const item = this.quoteItemById(quote && quote.itemId)
      return item ? this.quoteItemLabel(item) : '-'
    },
    quoteFileIdentity(file) {
      if (!file) return ''
      return String(file.id || file.fileId || file.url || file.fileUrl || file.relativePath || file.objectKey || file.fileKey || file.name || file.fileName || '')
    },
    meaningfulOptionalText(value) {
      const text = String(value || '').trim()
      return Boolean(text && !['无', '-', '暂无'].includes(text))
    },
    quoteFileName(file) {
      if (!file) return '未命名附件'
      return String(file.name || file.fileName || file.originalFilename || file.originalName || '未命名附件')
    },
    quoteFileUrl(file) {
      if (!file) return ''
      return file.url || file.fileUrl || file.downloadUrl || file.relativePath || ''
    },
    quoteFileExtension(file) {
      const name = this.quoteFileName(file)
      const match = name.match(/\.([^.?#]+)(?:[?#].*)?$/)
      if (match) return match[1].toLowerCase()
      const contentType = String(file && (file.contentType || file.type) || '').toLowerCase()
      if (contentType.indexOf('pdf') >= 0) return 'pdf'
      if (contentType.indexOf('image') >= 0) return 'image'
      return 'file'
    },
    quoteFileIconClass(file) {
      const extension = this.quoteFileExtension(file)
      if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'image'].includes(extension)) return 'el-icon-picture-outline'
      if (['xls', 'xlsx', 'csv'].includes(extension)) return 'el-icon-s-grid'
      if (['zip', 'rar', '7z'].includes(extension)) return 'el-icon-folder'
      return 'el-icon-document'
    },
    quoteFileMeta(file) {
      const extension = this.quoteFileExtension(file)
      const typeText = extension === 'file' ? '文件' : extension.toUpperCase()
      const bytes = Number(file && (file.size || file.fileSize) || 0)
      if (!bytes) return typeText
      if (bytes < 1024) return `${typeText} · ${bytes} B`
      if (bytes < 1024 * 1024) return `${typeText} · ${(bytes / 1024).toFixed(1)} KB`
      return `${typeText} · ${(bytes / 1024 / 1024).toFixed(1)} MB`
    },
    openQuoteFile(file) {
      const url = this.quoteFileUrl(file)
      if (!url) {
        this.msgWarning('附件地址不存在，无法查看')
        return
      }
      const opened = window.open(url, '_blank')
      if (opened) opened.opener = null
    },
    quoteHistoryRangeText(quote) {
      if (!quote || (!quote.historyMinPrice && !quote.historyMaxPrice)) return '-'
      if (quote.historyMinPrice && quote.historyMaxPrice && !this.referenceNumberExact(quote.historyMinPrice, quote.historyMaxPrice)) {
        return `${this.unitPriceText(quote.historyMinPrice)} - ${this.unitPriceText(quote.historyMaxPrice)}`
      }
      return this.unitPriceText(quote.historyMinPrice || quote.historyMaxPrice)
    },
    quoteListForItem(item) {
      if (!item || !item.id) return []
      return (this.detail.quoteList || []).filter(quote => String(quote.itemId) === String(item.id))
    },
    selectedQuoteForItem(item) {
      const rows = this.quoteListForItem(item)
      return rows.find(quote => Number(quote.selectedFlag) === 1) || null
    },
    bestSavedQuoteForItem(item) {
      const rows = this.quoteListForItem(item)
      if (!rows.length) return null
      const sorted = rows.slice().sort((left, right) => Number(left.quoteAmount || 0) - Number(right.quoteAmount || 0))
      return sorted[0]
    },
    historyRecordsForItem(item) {
      if (!item || !item.materialName) return []
      const seen = new Set()
      return this.priceReferenceRecords().map(record => {
        if (!record || !record.materialName || !record.purchaseUnitPrice) return null
        if (item.id && record.itemId && String(item.id) === String(record.itemId)) return null
        const materialRelated = this.referenceTextSimilar(record.materialName, item.materialName) || this.referenceMaterialRelated(record, item)
        const specKnown = Boolean(item.specification)
        const specMatched = specKnown && record.specification && this.sameReferenceSpecification(record.specification, item.specification, record.materialName, item.materialName)
        const numberOverlap = this.hasReferenceNumberOverlap(record, item)
        if (item.materialName && !materialRelated) return null
        if (!item.materialName && !specMatched && !numberOverlap) return null
        if (specKnown && !specMatched) return null
        let score = 0
        if (this.sameReferenceText(record.materialName, item.materialName)) score += 80
        else if (materialRelated) score += 45
        if (specMatched) score += 50
        if (numberOverlap) score += 25
        if (item.unit && record.unit && this.normalizeReferenceUnit(item.unit) === this.normalizeReferenceUnit(record.unit)) score += 10
        if (item.supplierName && record.supplierName && this.sameReferenceText(item.supplierName, record.supplierName)) score += 15
        if (score < (specKnown ? 55 : 45)) return null
        const key = [
          this.referenceMaterialDisplayName(record),
          this.referenceSpecificationKey(this.referenceSpecificationDisplay(record), record.materialName),
          record.unit,
          record.supplierName,
          record.purchaseUnitPrice
        ].map(this.normalizeReferenceName).join('|')
        if (seen.has(key)) return null
        seen.add(key)
        return { record, score }
      }).filter(Boolean).sort((left, right) => {
        if (right.score !== left.score) return right.score - left.score
        return Number(left.record.purchaseUnitPrice || 0) - Number(right.record.purchaseUnitPrice || 0)
      }).map(item => item.record).slice(0, 12)
    },
    approvalHistoryForItem(item) {
      const records = this.historyRecordsForItem(item)
      const prices = records.map(record => this.referenceUnitPriceValue(record.purchaseUnitPrice)).filter(value => value !== null)
      if (!prices.length) {
        return {
          hasHistory: false,
          text: '暂无历史参考价',
          meta: '审批时结合采购原因和预算判断'
        }
      }
      const minPrice = Math.min.apply(null, prices)
      const maxPrice = Math.max.apply(null, prices)
      const suppliers = this.uniqueReferenceValues(records.map(record => record.supplierName)).filter(Boolean)
      return {
        hasHistory: true,
        text: this.referenceNumberExact(minPrice, maxPrice)
          ? `历史参考 ${this.unitPriceText(minPrice)}`
          : `历史参考 ${this.unitPriceText(minPrice)} - ${this.unitPriceText(maxPrice)}`,
        meta: suppliers.length ? `${suppliers.length}家供应商` : '历史采购记录'
      }
    },
    buildQuoteRecommendationRow(item, index) {
      const snapshotMode = this.isQuoteSnapshotMode
      const quotes = this.quoteListForItem(item)
      const selectedQuote = this.selectedQuoteForItem(item)
      const savedQuote = selectedQuote || this.bestSavedQuoteForItem(item)
      const historyRecords = snapshotMode ? [] : this.historyRecordsForItem(item)
      const savedHistoryPrices = [
        savedQuote && savedQuote.historyMinPrice,
        savedQuote && savedQuote.historyMaxPrice
      ].map(value => this.referenceUnitPriceValue(value)).filter(value => value !== null && value > 0)
      const historyPrices = savedHistoryPrices.length ? savedHistoryPrices : historyRecords.map(record => this.referenceUnitPriceValue(record.purchaseUnitPrice)).filter(value => value !== null && value > 0)
      const historyMinPrice = historyPrices.length ? Math.min.apply(null, historyPrices) : null
      const historyMaxPrice = historyPrices.length ? Math.max.apply(null, historyPrices) : null
      const bestHistory = snapshotMode ? null : (historyRecords.slice().sort((left, right) => Number(left.purchaseUnitPrice || 0) - Number(right.purchaseUnitPrice || 0))[0] || null)
      const quantity = Number(item.quantity || 0)
      let recommendSupplierId = null
      let recommendSupplierName = ''
      let recommendUnitPrice = null
      let reason = ''
      const itemPrice = this.referenceUnitPriceValue(item.purchaseUnitPrice)
      if (savedQuote) {
        recommendSupplierId = savedQuote.supplierId || null
        recommendSupplierName = savedQuote.supplierName || ''
        recommendUnitPrice = this.referenceUnitPriceValue(savedQuote.quoteAmount)
        reason = Number(savedQuote.selectedFlag) === 1 ? (savedQuote.selectionReason || '已选定报价') : '已有报价，可按金额和交期确认'
      } else if (itemPrice !== null) {
        const historySupplier = bestHistory && bestHistory.supplierName ? bestHistory : null
        recommendSupplierId = item.supplierId || (historySupplier && historySupplier.supplierId) || null
        recommendSupplierName = item.supplierName || (historySupplier && historySupplier.supplierName) || ''
        recommendUnitPrice = itemPrice
        reason = item.supplierName
          ? (item.historyPriceMatched ? '提交时已匹配历史价格' : '提交时已填写供应商和单价')
          : (historySupplier ? '按同规格历史供应商推荐' : '提交时已带入历史单价')
      } else if (!snapshotMode && bestHistory) {
        recommendSupplierId = bestHistory.supplierId || null
        recommendSupplierName = bestHistory.supplierName || ''
        recommendUnitPrice = this.referenceUnitPriceValue(bestHistory.purchaseUnitPrice)
        reason = '按同规格历史低价推荐'
      }
      const estimatedAmount = recommendUnitPrice !== null && quantity ? roundPurchaseMoney(recommendUnitPrice * quantity) : Number(item.amount || 0)
      let riskLevel = 'ok'
      let statusText = selectedQuote ? '已定商' : '可采纳'
      let statusTag = selectedQuote ? 'success' : 'primary'
      if (!item.specification) {
        riskLevel = 'spec'
        statusText = '规格待确认'
        statusTag = 'danger'
      } else if (recommendUnitPrice === null) {
        riskLevel = 'missing'
        statusText = '待补依据'
        statusTag = 'warning'
      } else if (historyMaxPrice && recommendUnitPrice > historyMaxPrice * 1.1) {
        riskLevel = 'high'
        statusText = '价格偏高'
        statusTag = 'warning'
      } else if (!snapshotMode && !historyRecords.length && !savedQuote && itemPrice === null) {
        riskLevel = 'missing'
        statusText = '无历史价'
        statusTag = 'warning'
      } else if (!recommendSupplierName) {
        statusText = '可作依据'
        statusTag = 'success'
      }
      const historyText = historyPrices.length
        ? (historyMinPrice === historyMaxPrice ? `历史单价 ${this.unitPriceText(historyMinPrice)}` : `历史单价 ${this.unitPriceText(historyMinPrice)} - ${this.unitPriceText(historyMaxPrice)}`)
        : (snapshotMode && itemPrice !== null ? `本次申请单价 ${this.unitPriceText(itemPrice)}` : '暂无历史价')
      const historySupplierText = bestHistory && bestHistory.supplierName
        ? (snapshotMode ? '历史价格仅作参考' : `参考供应商：${bestHistory.supplierName}`)
        : (snapshotMode && itemPrice !== null ? '提交时价格快照' : '需要报价或说明')
      const recommendPriceText = recommendUnitPrice !== null
        ? `单价 ${this.unitPriceText(recommendUnitPrice)}，预计 ${this.money(estimatedAmount)}`
        : '待录入报价'
      return {
        key: item.id || item.sortNo || `${item.materialName}-${index}`,
        item,
        itemId: item.id || null,
        materialName: item.materialName,
        specification: item.specification,
        materialQualityBrand: item.materialQualityBrand,
        quantity,
        unit: item.unit,
        itemAmount: item.amount || (itemPrice !== null && quantity ? roundPurchaseMoney(itemPrice * quantity) : 0),
        quotes,
        selectedQuote,
        savedQuote,
        historyRecords,
        historyMinPrice,
        historyMaxPrice,
        recommendSupplierId,
        recommendSupplierName,
        recommendUnitPrice,
        estimatedAmount,
        reason,
        riskLevel,
        statusText,
        statusTag,
        historyText,
        historySupplierText,
        recommendPriceText,
        canAdopt: Boolean(!snapshotMode && item.id && recommendSupplierName && recommendUnitPrice !== null && !selectedQuote)
      }
    },
    quoteRecommendationTitle(row) {
      if (!row) return '待补价格依据'
      if (row.recommendSupplierName) return row.recommendSupplierName
      if (row.recommendUnitPrice !== null && row.recommendUnitPrice !== undefined) return '历史价格参考'
      return '待补价格依据'
    },
    quoteRowSupplierConfirmed(row) {
      if (!row) return false
      const item = row.item || {}
      if (row.selectedQuote || row.recommendSupplierName || String(item.supplierName || '').trim()) return true
      return this.isApplicationDetail && this.supplierOrderCount > 0 && Number(this.applyForm.status || 10) >= 40
    },
    pendingSplitQuoteRow(item) {
      return (this.quoteRecommendationRows || []).find(row => row && row.item === item) ||
        (this.quoteRecommendationRows || []).find(row => row && row.itemId && item && String(row.itemId) === String(item.id)) ||
        null
    },
    pendingSplitRecommendationForItem(item) {
      if (!item) return null
      const row = this.pendingSplitQuoteRow(item)
      if (row && row.recommendSupplierName) {
        return {
          supplierId: row.recommendSupplierId || null,
          supplierName: row.recommendSupplierName,
          source: row.reason || '推荐供应商'
        }
      }
      const best = this.findBestExactPriceRecord(item) || this.findPriceRecordBySpecification(item)
      if (best && best.supplierName) {
        return {
          supplierId: best.supplierId || null,
          supplierName: best.supplierName,
          source: '同规格历史供应商'
        }
      }
      if (item.supplierName) {
        return {
          supplierId: item.supplierId || null,
          supplierName: item.supplierName,
          source: '当前已确认供应商'
        }
      }
      return null
    },
    pendingSplitQuoteTitle(item) {
      const row = this.pendingSplitQuoteRow(item)
      return this.quoteRecommendationTitle(row) || '-'
    },
    pendingSplitQuotePriceText(item) {
      const row = this.pendingSplitQuoteRow(item)
      if (row && row.recommendPriceText) return row.recommendPriceText
      if (item && item.purchaseUnitPrice) return `单价 ${this.unitPriceText(item.purchaseUnitPrice)}，预计 ${this.money(item.amount)}`
      return '待确认价格'
    },
    pendingSplitQuoteReason(item) {
      const row = this.pendingSplitQuoteRow(item)
      if (row && row.reason) return row.reason
      if (item && item.historyPriceMatched) return '已匹配历史价格'
      return '可选择供应商后自动带出历史价'
    },
    pendingSplitCanUseRecommendation(item) {
      if (!this.canConfirmApplicationSupplier || !item) return false
      const recommendation = this.pendingSplitRecommendationForItem(item)
      return Boolean(recommendation && recommendation.supplierName &&
        (!item.supplierName || !this.sameReferenceText(item.supplierName, recommendation.supplierName)))
    },
    applyRecommendedSupplierToItem(item) {
      if (!this.ensureWorkflowEditable(this.canConfirmApplicationSupplier, '当前状态不能确认供应商')) return
      const recommendation = this.pendingSplitRecommendationForItem(item)
      if (!item || !recommendation || !recommendation.supplierName) {
        this.msgWarning('该明细暂无可用推荐供应商')
        return
      }
      const supplier = recommendation.supplierId
        ? (this.supplierOptions || []).find(option => String(option.id) === String(recommendation.supplierId))
        : this.findSupplierByName(recommendation.supplierName)
      this.$set(item, 'supplierId', recommendation.supplierId || (supplier && supplier.id) || null)
      this.$set(item, 'supplierName', supplier ? supplier.supplierName : recommendation.supplierName)
    },
    applyAllRecommendedSuppliers() {
      if (!this.ensureWorkflowEditable(this.canConfirmApplicationSupplier, '当前状态不能确认供应商')) return
      let applied = 0
      let alreadyUsingRecommendation = 0
      this.pendingSplitMaterialRows.forEach(item => {
        if (!item) return
        const recommendation = this.pendingSplitRecommendationForItem(item)
        if (!recommendation || !recommendation.supplierName) return
        if (item.supplierName && this.sameReferenceText(item.supplierName, recommendation.supplierName)) {
          alreadyUsingRecommendation++
          return
        }
        const supplier = recommendation.supplierId
          ? (this.supplierOptions || []).find(option => String(option.id) === String(recommendation.supplierId))
          : this.findSupplierByName(recommendation.supplierName)
        this.$set(item, 'supplierId', recommendation.supplierId || (supplier && supplier.id) || null)
        this.$set(item, 'supplierName', supplier ? supplier.supplierName : recommendation.supplierName)
        applied++
      })
      if (applied) this.msgSuccess(`已带入 ${applied} 条推荐供应商`)
      else if (alreadyUsingRecommendation) this.msgSuccess('当前明细已使用推荐供应商，可直接生成采购单')
      else if (this.isPendingSplitReady) this.msgSuccess('供应商已补齐，可直接生成采购单')
      else this.msgWarning('暂无可自动带入的推荐供应商，请逐条选择')
    },
    quotePayloadFromRecommendation(row, extra = {}) {
      return Object.assign({
        applyId: this.applyForm.id,
        itemId: row.itemId,
        supplierId: row.recommendSupplierId,
        supplierName: row.recommendSupplierName,
        materialCode: row.item && row.item.materialCode || '',
        materialName: row.item && row.item.materialName || '',
        specification: row.item && row.item.specification || '',
        parameterValue: '',
        materialQualityBrand: row.item && row.item.materialQualityBrand || '',
        demandQuantity: row.item && row.item.quantity,
        inventoryQuantity: 0,
        quantity: row.item && row.item.quantity,
        unit: row.item && row.item.unit || '',
        quoteAmount: row.recommendUnitPrice,
        taxRate: this.contractForm.taxRate,
        selectedFlag: 1,
        selectionReason: row.reason || '采用系统推荐报价',
        historyMinPrice: row.historyMinPrice,
        historyMaxPrice: row.historyMaxPrice,
        aiRiskTips: row.riskLevel === 'high'
          ? '本次报价高于历史参考区间，请审批关注规格、税率、运费、数量和付款条件差异。'
          : (row.historyRecords.length ? '系统已匹配历史价格作为比价依据。' : '暂无历史价格，已记录采购说明作为审批依据。'),
        fileInfoList: []
      }, extra)
    },
    fillQuoteFormFromRecommendation(row) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      this.uploadRenderKey += 1
      const payload = this.quotePayloadFromRecommendation(row, {
        selectedFlag: row.selectedQuote ? 1 : 0,
        selectionReason: row.selectedQuote ? row.selectedQuote.selectionReason : row.reason,
        fileInfoList: row.savedQuote && row.savedQuote.fileInfoList ? row.savedQuote.fileInfoList : []
      })
      this.quoteForm = Object.assign(this.emptyQuoteForm(), {
        applyId: this.applyForm.id,
        supplierId: payload.supplierId,
        supplierName: payload.supplierName,
        selectionReason: payload.selectionReason,
        fileInfoList: payload.fileInfoList || [],
        itemList: [this.createQuoteLine(payload)]
      })
    },
    openQuoteDialog(row = null) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      this.clearQuoteImportQueue()
      this.uploadRenderKey += 1
      this.quoteDialogRow = row
      this.quoteDialogTitle = '新增报价组'
      const sourceItem = row && row.itemId ? (row.item || this.quoteItemById(row.itemId) || {}) : null
      const itemList = sourceItem
        ? [this.createQuoteLine({
          itemId: sourceItem.id || row.itemId,
          materialCode: sourceItem.materialCode || '',
          materialName: sourceItem.materialName || '',
          specification: sourceItem.specification || '',
          parameterValue: '',
          materialQualityBrand: sourceItem.materialQualityBrand || '',
          demandQuantity: sourceItem.quantity || 1,
          inventoryQuantity: 0,
          quantity: sourceItem.quantity || 1,
          unit: sourceItem.unit || ''
        })]
        : [this.createQuoteLine({ quantity: 1 })]
      const supplier = this.createComparisonSupplier({
        supplierId: row && row.recommendSupplierId || null,
        supplierName: row && row.recommendSupplierName || ''
      })
      itemList.forEach(item => this.$set(supplier.priceMap, item._rowKey,
        row && row.recommendUnitPrice ? this.referenceUnitPriceValue(row.recommendUnitPrice) : undefined))
      this.quoteForm = Object.assign(this.emptyQuoteForm(), {
        applyId: this.applyForm.id,
        comparisonGroupName: sourceItem ? this.quoteItemLabel(sourceItem) : '',
        itemList,
        supplierList: [supplier]
      })
      this.quoteDialogOpen = true
      this.$nextTick(() => {
        this.loadLatestQuoteHistoryPrices(itemList)
        this.resolveQuoteSupplierLinks()
      })
    },
    prefillQuoteFromFirstPending() {
      const row = this.quoteRecommendationRows.find(item => item.riskLevel !== 'ok' && !item.selectedQuote) || this.quoteRecommendationRows.find(item => !item.selectedQuote) || this.quoteRecommendationRows[0]
      if (!row) {
        this.msgWarning('请先补充采购需求明细')
        return
      }
      this.openQuoteDialog(row)
    },
    adoptQuoteRecommendation(row) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      if (!row || !row.canAdopt) {
        this.msgWarning('该明细还不能直接采纳，请先补充规格、供应商或报价')
        return
      }
      savePurchaseQuote(this.quotePayloadFromRecommendation(row)).then(() => {
        this.msgSuccess('已采纳推荐报价')
        this.refreshCurrentDetail()
      })
    },
    saveNoCompareReason(row) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      if (!row || !row.itemId) {
        this.msgWarning('请先保存采购单明细后再记录不比价说明')
        return
      }
      this.$prompt('请输入不比价原因', '不比价说明', {
        confirmButtonText: '保存说明',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：指定品牌、独家供应、紧急采购、合同已锁价'
      }).then(({ value }) => {
        const supplierName = row.recommendSupplierName || this.contractForm.supplierName || this.contractForm.partyB || row.item.supplierName
        if (!supplierName) {
          this.msgWarning('请先选择供应商，再保存不比价说明')
          return
        }
        const payload = this.quotePayloadFromRecommendation(Object.assign({}, row, {
          recommendSupplierName: supplierName,
          recommendSupplierId: row.recommendSupplierId || row.item.supplierId || null,
          recommendUnitPrice: row.recommendUnitPrice === null ? (this.referenceUnitPriceValue(row.item.purchaseUnitPrice) || undefined) : this.referenceUnitPriceValue(row.recommendUnitPrice)
        }), {
          selectionReason: `不比价：${value || '已说明原因'}`,
          aiRiskTips: '未进行多家比价，审批时请关注不比价原因和采购紧急性/指定性。',
          selectedFlag: 1
        })
        savePurchaseQuote(payload).then(() => {
          this.msgSuccess('不比价说明已保存')
          this.refreshCurrentDetail()
        })
      }).catch(() => {})
    },
    handleQuoteSupplierSelect(supplier, syncPrice = true) {
      if (!supplier) return
      this.$set(this.quoteForm, 'supplierId', supplier.id || null)
      this.$set(this.quoteForm, 'supplierName', supplier.supplierName || '')
      if (!syncPrice) return
      const line = this.quotePrimaryLine(true)
      const record = supplier._referenceRecord || null
      if (record && record.purchaseUnitPrice) {
        if (line && !line.quoteAmount) this.$set(line, 'quoteAmount', this.referenceUnitPriceValue(record.purchaseUnitPrice))
        if (record.taxRate !== undefined && record.taxRate !== null) this.$set(this.quoteForm, 'taxRate', this.referenceNumberValue(record.taxRate))
      }
    },
    handleQuoteSupplierBlur() {
      const supplier = this.findSupplierByName(this.quoteForm && this.quoteForm.supplierName)
      if (supplier) {
        this.handleQuoteSupplierSelect(supplier, false)
        return
      }
      this.$set(this.quoteForm, 'supplierId', null)
    },
    createQuoteOffer(base = {}) {
      return Object.assign({
        _rowKey: `offer-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        id: null,
        quoteGroupNo: '',
        supplierId: null,
        supplierName: '',
        purchasePlatform: '',
        quoteAmount: undefined,
        taxRate: undefined,
        deliveryDays: undefined,
        paymentCondition: '',
        recommendedFlag: 0,
        selectionReason: '',
        fileInfoList: [],
        remark: ''
      }, base || {})
    },
    createComparisonSupplier(base = {}) {
      return Object.assign({
        _rowKey: `supplier-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        quoteGroupNo: '',
        supplierId: null,
        supplierName: '',
        purchasePlatform: '',
        taxRate: undefined,
        deliveryDays: undefined,
        paymentCondition: '',
        selectionReason: '',
        recommendationReason: '',
        fileInfoList: [],
        priceMap: {},
        _itemOfferMap: {},
        freightAmount: undefined,
        finalTotalAmount: undefined,
        _finalTotalManual: false,
        _detailsExpanded: false
      }, base || {})
    },
    quoteEditorLayoutFromSource(sourceLayoutType, fallback = 'supplier') {
      const layout = String(sourceLayoutType || '').toUpperCase()
      if (layout.indexOf('VERTICAL') >= 0) return 'item'
      return fallback || 'supplier'
    },
    quoteGroupDefaultEditorLayout(group) {
      if (!group) return 'supplier'
      if (this.quoteEditorLayoutFromSource(group.sourceLayoutType || group.layoutType, '') === 'item') return 'item'
      const items = group.items || []
      const suppliers = group.suppliers || []
      if ((this.quoteGroupIsEcommerce(group) || this.quoteGroupIsMixed(group)) && suppliers.length > 1) return 'item'
      if (items.length > 1 && suppliers.some(supplier => {
        return !items.every(item => item && item.offerMap && item.offerMap[supplier.key])
      })) {
        return 'item'
      }
      return 'supplier'
    },
    ensureQuoteFormRecommendationMap() {
      if (!this.quoteForm.recommendedOfferMap) this.$set(this.quoteForm, 'recommendedOfferMap', {})
      return this.quoteForm.recommendedOfferMap
    },
    ensureQuoteFormRecommendationReasonMap() {
      if (!this.quoteForm.recommendedReasonMap) this.$set(this.quoteForm, 'recommendedReasonMap', {})
      return this.quoteForm.recommendedReasonMap
    },
    markSupplierItemOffer(supplier, item) {
      if (!supplier || !item) return
      if (!supplier.priceMap) this.$set(supplier, 'priceMap', {})
      if (!supplier._itemOfferMap) this.$set(supplier, '_itemOfferMap', {})
      this.$set(supplier._itemOfferMap, item._rowKey, true)
      if (!Object.prototype.hasOwnProperty.call(supplier.priceMap, item._rowKey)) {
        this.$set(supplier.priceMap, item._rowKey, undefined)
      }
    },
    unmarkSupplierItemOffer(supplier, item) {
      if (!supplier || !item) return
      if (supplier._itemOfferMap) this.$delete(supplier._itemOfferMap, item._rowKey)
      if (supplier.priceMap) this.$delete(supplier.priceMap, item._rowKey)
    },
    quoteSupplierItemPriceTouched(supplier, item) {
      if (!supplier || !item || !supplier.priceMap) return false
      const value = supplier.priceMap[item._rowKey]
      return value !== undefined && value !== null && value !== ''
    },
    quoteSupplierHasItemOffer(supplier, item) {
      if (!supplier || !item) return false
      if (supplier._itemOfferMap && supplier._itemOfferMap[item._rowKey]) return true
      const scopedKeys = Object.keys(supplier._itemOfferMap || {}).filter(key => supplier._itemOfferMap[key])
      if (this.quoteSupplierItemPriceTouched(supplier, item)) return true
      if (!scopedKeys.length && !this.quoteFormUseItemLayout) return true
      return this.quoteItemRecommendedSupplierKey(item) === supplier._rowKey
    },
    quoteItemSupplierRows(item) {
      return (this.quoteForm.supplierList || []).filter(supplier => this.quoteSupplierHasItemOffer(supplier, item))
    },
    quoteSupplierMarkedItemKeys(supplier) {
      if (!supplier) return []
      const keys = new Set()
      if (supplier._itemOfferMap) {
        Object.keys(supplier._itemOfferMap).forEach(key => {
          if (supplier._itemOfferMap[key]) keys.add(key)
        })
      }
      Object.keys(supplier.priceMap || {}).forEach(key => {
        const value = supplier.priceMap[key]
        if (value !== undefined && value !== null && value !== '') keys.add(key)
      })
      return Array.from(keys)
    },
    quoteSupplierCoversAllItems(supplier, itemList) {
      const items = itemList || (this.quoteForm && this.quoteForm.itemList) || []
      if (!supplier || !items.length) return false
      return items.every(item => this.quoteSupplierItemPriceTouched(supplier, item))
    },
    quoteItemRecommendedSupplierKey(item) {
      if (!item) return ''
      const map = this.quoteForm && this.quoteForm.recommendedOfferMap || {}
      if (map[item._rowKey]) return map[item._rowKey]
      const groupRecommended = this.quoteForm && this.quoteForm.recommendedSupplierKey
      if (!groupRecommended) return ''
      const supplier = (this.quoteForm.supplierList || []).find(row => row._rowKey === groupRecommended)
      return supplier && this.quoteSupplierHasItemOffer(supplier, item) ? groupRecommended : ''
    },
    setQuoteItemRecommendedSupplier(item, supplier) {
      if (!item || !supplier) return
      this.markQuoteRecommendationTouched()
      this.$set(this.ensureQuoteFormRecommendationMap(), item._rowKey, supplier._rowKey)
      if (!this.quoteItemRecommendationReason(item) && this.quoteForm.recommendationReason) {
        this.$set(this.ensureQuoteFormRecommendationReasonMap(), item._rowKey, this.quoteForm.recommendationReason)
      }
      this.$set(this.quoteForm, 'recommendedSupplierKey', '')
    },
    quoteItemRecommendationReason(item) {
      if (!item) return ''
      const map = this.quoteForm && this.quoteForm.recommendedReasonMap || {}
      return map[item._rowKey] || ''
    },
    setQuoteItemRecommendationReason(item, value) {
      if (!item) return
      this.markQuoteRecommendationTouched()
      const text = String(value || '')
      if (text) {
        this.$set(this.ensureQuoteFormRecommendationReasonMap(), item._rowKey, text)
      } else {
        this.$delete(this.ensureQuoteFormRecommendationReasonMap(), item._rowKey)
      }
    },
    clearQuoteItemRecommendation(item) {
      if (!item) return
      this.markQuoteRecommendationTouched()
      this.$delete(this.ensureQuoteFormRecommendationMap(), item._rowKey)
      this.$delete(this.ensureQuoteFormRecommendationReasonMap(), item._rowKey)
    },
    handleQuoteGroupRecommendedSupplierChange() {
      this.markQuoteRecommendationTouched()
      this.$set(this.quoteForm, 'recommendedOfferMap', {})
      this.$set(this.quoteForm, 'recommendedReasonMap', {})
    },
    markQuoteRecommendationTouched() {
      if (this.quoteForm) this.$set(this.quoteForm, 'recommendationTouched', true)
    },
    addComparisonSupplier(base = {}) {
      const supplier = this.createComparisonSupplier(base)
      ;(this.quoteForm.itemList || []).forEach(item => this.$set(supplier.priceMap, item._rowKey, undefined))
      this.quoteForm.supplierList.push(supplier)
    },
    addComparisonSupplierForItem(item) {
      if (!item) return
      const supplier = this.createComparisonSupplier()
      this.markSupplierItemOffer(supplier, item)
      this.quoteForm.supplierList.push(supplier)
    },
    removeComparisonSupplier(index) {
      const supplier = this.quoteForm.supplierList[index]
      const recommendationAffected = supplier && (
        this.quoteForm.recommendedSupplierKey === supplier._rowKey ||
        Object.keys(this.quoteForm.recommendedOfferMap || {})
          .some(itemKey => this.quoteForm.recommendedOfferMap[itemKey] === supplier._rowKey)
      )
      if (recommendationAffected) this.markQuoteRecommendationTouched()
      this.quoteForm.supplierList.splice(index, 1)
      if (supplier && this.quoteForm.recommendedSupplierKey === supplier._rowKey) {
        this.$set(this.quoteForm, 'recommendedSupplierKey', '')
        this.$set(this.quoteForm, 'recommendationReason', '')
      }
      Object.keys(this.quoteForm.recommendedOfferMap || {}).forEach(itemKey => {
        if (this.quoteForm.recommendedOfferMap[itemKey] === supplier._rowKey) {
          this.$delete(this.quoteForm.recommendedOfferMap, itemKey)
          this.$delete(this.quoteForm.recommendedReasonMap || {}, itemKey)
        }
      })
    },
    removeComparisonSupplierFromItem(item, supplier) {
      if (!item || !supplier) return
      const scopedKeys = Object.keys(supplier._itemOfferMap || {}).filter(key => supplier._itemOfferMap[key])
      if (!scopedKeys.length) {
        ;(this.quoteForm.itemList || []).forEach(row => {
          if (row._rowKey !== item._rowKey) this.markSupplierItemOffer(supplier, row)
        })
      }
      this.unmarkSupplierItemOffer(supplier, item)
      if (this.quoteItemRecommendedSupplierKey(item) === supplier._rowKey) {
        this.clearQuoteItemRecommendation(item)
      }
      if (!this.quoteSupplierMarkedItemKeys(supplier).length) {
        const index = (this.quoteForm.supplierList || []).findIndex(row => row._rowKey === supplier._rowKey)
        if (index >= 0) this.removeComparisonSupplier(index)
      } else {
        this.syncComparisonSupplierAutoFinalTotal(supplier)
      }
    },
    clearQuoteRecommendation() {
      this.markQuoteRecommendationTouched()
      this.$set(this.quoteForm, 'recommendedSupplierKey', '')
      this.$set(this.quoteForm, 'recommendedOfferMap', {})
      this.$set(this.quoteForm, 'recommendedReasonMap', {})
      this.$set(this.quoteForm, 'recommendationReason', '')
    },
    toggleComparisonSupplierDetails(supplier) {
      if (!supplier) return
      this.$set(supplier, '_detailsExpanded', !supplier._detailsExpanded)
    },
    comparisonSupplierOptionalCount(supplier) {
      if (!supplier) return 0
      let count = 0
      if (supplier.taxRate !== undefined && supplier.taxRate !== null) count++
      if (supplier.deliveryDays !== undefined && supplier.deliveryDays !== null) count++
      if (this.positiveAmount(supplier.freightAmount)) count++
      if (String(supplier.paymentCondition || '').trim()) count++
      if (this.meaningfulOptionalText(supplier.selectionReason)) count++
      if (supplier.fileInfoList && supplier.fileInfoList.length) count++
      return count
    },
    emptyQuoteAmountSummary() {
      return {
        supplierName: '',
        demandQuantity: 0,
        actualPurchaseQuantity: 0,
        inventoryUseQuantity: 0,
        actualPurchaseAmount: 0,
        inventoryUseAmount: 0,
        freightAmount: 0,
        actualPurchaseTotalAmount: 0,
        totalDemandAmount: 0
      }
    },
    positiveNumber(value) {
      const number = Number(value)
      return Number.isFinite(number) && number > 0 ? number : 0
    },
    roundMoneyValue(value) {
      const number = Number(value || 0)
      return roundPurchaseMoney(number)
    },
    quoteSupplierIdentityKey(supplier) {
      if (!supplier) return ''
      const platform = String(supplier.purchasePlatform || '').trim().replace(/\s+/g, ' ').toLowerCase()
      const supplierName = String(supplier.supplierName || '').trim().replace(/\s+/g, ' ').toLowerCase()
      if (platform && supplierName) return `name|${platform}|${supplierName}`
      if (supplier.supplierId) return `id|${supplier.supplierId}`
      return supplierName ? `name||${supplierName}` : ''
    },
    quoteSupplierDisplayName(supplier, fallback = '') {
      if (!supplier) return fallback
      const platform = String(supplier.purchasePlatform || '').trim()
      const supplierName = String(supplier.supplierName || '').trim()
      if (platform && supplierName && platform !== supplierName) return `${platform} · ${supplierName}`
      return supplierName || platform || fallback
    },
    quoteSupplierRowKeyMatches(supplier, rowKey) {
      if (!supplier || !rowKey) return false
      if (String(supplier._rowKey) === String(rowKey)) return true
      return (supplier._sourceRowKeys || []).some(key => String(key) === String(rowKey))
    },
    mergeQuoteFormSuppliersForItemLayout(supplierList, itemList) {
      const supplierMap = new Map()
      ;(supplierList || []).forEach(source => {
        const key = this.quoteSupplierIdentityKey(source)
        if (!key) return
        let target = supplierMap.get(key)
        if (!target) {
          target = Object.assign({}, source, {
            priceMap: Object.assign({}, source.priceMap || {}),
            _itemOfferMap: Object.assign({}, source._itemOfferMap || {}),
            fileInfoList: (source.fileInfoList || []).slice(),
            _sourceRowKeys: [source._rowKey],
            _finalTotalManual: !!source._finalTotalManual
          })
          supplierMap.set(key, target)
          return
        }
        if (source._rowKey && target._sourceRowKeys.indexOf(source._rowKey) < 0) {
          target._sourceRowKeys.push(source._rowKey)
        }
        if (!target.quoteGroupNo && source.quoteGroupNo) target.quoteGroupNo = source.quoteGroupNo
        if (!target.supplierId && source.supplierId) target.supplierId = source.supplierId
        if (!target.supplierName && source.supplierName) target.supplierName = source.supplierName
        if (!target.purchasePlatform && source.purchasePlatform) target.purchasePlatform = source.purchasePlatform
        if (!target.paymentCondition && source.paymentCondition) target.paymentCondition = source.paymentCondition
        if (!target.deliveryDays && source.deliveryDays) target.deliveryDays = source.deliveryDays
        if (!target.selectionReason && source.selectionReason) target.selectionReason = source.selectionReason
        if (!target.recommendationReason && source.recommendationReason) target.recommendationReason = source.recommendationReason
        if ((!target.fileInfoList || !target.fileInfoList.length) && source.fileInfoList && source.fileInfoList.length) {
          target.fileInfoList = source.fileInfoList.slice()
        }
        target.freightAmount = Math.max(this.positiveAmount(target.freightAmount), this.positiveAmount(source.freightAmount))
        ;(itemList || []).forEach(item => {
          const sourcePrice = this.positiveNumber(source.priceMap && source.priceMap[item._rowKey])
          const targetPrice = this.positiveNumber(target.priceMap && target.priceMap[item._rowKey])
          if (sourcePrice > 0 && targetPrice > 0) {
            target._duplicateItemOfferName = target._duplicateItemOfferName || this.quoteMaterialName(item)
            return
          }
          if (sourcePrice > 0) {
            target.priceMap[item._rowKey] = source.priceMap[item._rowKey]
            target._itemOfferMap[item._rowKey] = true
          }
        })
        target._finalTotalManual = false
      })
      return Array.from(supplierMap.values())
    },
    quoteInventoryUseQuantity(item) {
      if (!item) return 0
      const demandQuantity = this.positiveNumber(item.demandQuantity)
      const inventoryQuantity = this.positiveNumber(item.inventoryQuantity)
      if (!demandQuantity || !inventoryQuantity) return 0
      return Math.min(demandQuantity, inventoryQuantity)
    },
    quoteActualPurchaseAmountRaw(item, unitPrice) {
      return this.positiveNumber(unitPrice) * this.positiveNumber(item && item.quantity)
    },
    quoteActualPurchaseAmount(item, unitPrice) {
      return this.roundMoneyValue(this.quoteActualPurchaseAmountRaw(item, unitPrice))
    },
    quoteInventoryUnitPrice(item) {
      if (!item) return 0
      return this.positiveNumber(item.historyMinPrice) || this.positiveNumber(item.historyMaxPrice)
    },
    quoteInventoryUseAmountRaw(item) {
      return this.quoteInventoryUnitPrice(item) * this.quoteInventoryUseQuantity(item)
    },
    quoteInventoryUseAmount(item) {
      return this.roundMoneyValue(this.quoteInventoryUseAmountRaw(item))
    },
    quoteTotalDemandAmountRaw(item, unitPrice) {
      return this.quoteActualPurchaseAmountRaw(item, unitPrice) + this.quoteInventoryUseAmountRaw(item)
    },
    quoteTotalDemandAmount(item, unitPrice) {
      return this.roundMoneyValue(this.quoteTotalDemandAmountRaw(item, unitPrice))
    },
    quoteSupplierCostSummary(supplier, itemList) {
      const summary = this.emptyQuoteAmountSummary()
      summary.supplierName = supplier && supplier.supplierName || ''
      const items = itemList || (this.quoteForm && this.quoteForm.itemList) || []
      items.forEach(item => {
        const unitPrice = Number(supplier && supplier.priceMap && supplier.priceMap[item._rowKey])
        summary.demandQuantity += this.positiveNumber(item.demandQuantity)
        summary.actualPurchaseQuantity += this.positiveNumber(item.quantity)
        summary.inventoryUseQuantity += this.quoteInventoryUseQuantity(item)
        summary.actualPurchaseAmount += this.quoteActualPurchaseAmountRaw(item, unitPrice)
        summary.inventoryUseAmount += this.quoteInventoryUseAmountRaw(item)
        summary.totalDemandAmount += this.quoteTotalDemandAmountRaw(item, unitPrice)
      })
      summary.freightAmount = this.positiveAmount(supplier && supplier.freightAmount)
      summary.demandQuantity = Number(summary.demandQuantity.toFixed(2))
      summary.actualPurchaseQuantity = Number(summary.actualPurchaseQuantity.toFixed(2))
      summary.inventoryUseQuantity = Number(summary.inventoryUseQuantity.toFixed(2))
      summary.actualPurchaseTotalAmount = this.roundMoneyValue(summary.actualPurchaseAmount + summary.freightAmount)
      summary.actualPurchaseAmount = this.roundMoneyValue(summary.actualPurchaseAmount)
      summary.inventoryUseAmount = this.roundMoneyValue(summary.inventoryUseAmount)
      summary.freightAmount = this.roundMoneyValue(summary.freightAmount)
      summary.totalDemandAmount = this.roundMoneyValue(summary.totalDemandAmount + summary.freightAmount)
      return summary
    },
    quoteItemLayoutAmountSummary() {
      const summary = this.emptyQuoteAmountSummary()
      summary.supplierName = '按产品汇总'
      const freightSupplierKeys = new Set()
      ;(this.quoteForm.itemList || []).forEach(item => {
        const suppliers = this.quoteItemSupplierRows(item)
        const recommendedKey = this.quoteItemRecommendedSupplierKey(item)
        let supplier = suppliers.find(row => row._rowKey === recommendedKey) || null
        if (!supplier) {
          supplier = suppliers.slice().sort((left, right) => {
            const leftPrice = this.positiveNumber(left.priceMap && left.priceMap[item._rowKey])
            const rightPrice = this.positiveNumber(right.priceMap && right.priceMap[item._rowKey])
            if (!leftPrice && !rightPrice) return 0
            if (!leftPrice) return 1
            if (!rightPrice) return -1
            return leftPrice - rightPrice
          })[0] || null
        }
        const unitPrice = supplier ? Number(supplier.priceMap && supplier.priceMap[item._rowKey]) : 0
        summary.demandQuantity += this.positiveNumber(item.demandQuantity)
        summary.actualPurchaseQuantity += this.positiveNumber(item.quantity)
        summary.inventoryUseQuantity += this.quoteInventoryUseQuantity(item)
        summary.actualPurchaseAmount += this.quoteActualPurchaseAmountRaw(item, unitPrice)
        summary.inventoryUseAmount += this.quoteInventoryUseAmountRaw(item)
        summary.totalDemandAmount += this.quoteTotalDemandAmountRaw(item, unitPrice)
        if (supplier && !freightSupplierKeys.has(supplier._rowKey)) {
          summary.freightAmount += this.positiveAmount(supplier.freightAmount)
          freightSupplierKeys.add(supplier._rowKey)
        }
      })
      summary.demandQuantity = Number(summary.demandQuantity.toFixed(2))
      summary.actualPurchaseQuantity = Number(summary.actualPurchaseQuantity.toFixed(2))
      summary.inventoryUseQuantity = Number(summary.inventoryUseQuantity.toFixed(2))
      summary.actualPurchaseAmount = this.roundMoneyValue(summary.actualPurchaseAmount)
      summary.inventoryUseAmount = this.roundMoneyValue(summary.inventoryUseAmount)
      summary.freightAmount = this.roundMoneyValue(summary.freightAmount)
      summary.actualPurchaseTotalAmount = this.roundMoneyValue(summary.actualPurchaseAmount + summary.freightAmount)
      summary.totalDemandAmount = this.roundMoneyValue(summary.totalDemandAmount + summary.freightAmount)
      return summary
    },
    comparisonSupplierDemandQuantity(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).demandQuantity
    },
    comparisonSupplierActualPurchaseQuantity(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).actualPurchaseQuantity
    },
    comparisonSupplierInventoryUseQuantity(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).inventoryUseQuantity
    },
    comparisonSupplierActualPurchaseAmount(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).actualPurchaseAmount
    },
    comparisonSupplierInventoryUseAmount(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).inventoryUseAmount
    },
    comparisonSupplierFreightAmount(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).freightAmount
    },
    comparisonSupplierActualPurchaseTotalAmount(supplier, itemList) {
      const summary = this.quoteSupplierCostSummary(supplier, itemList)
      return summary.actualPurchaseTotalAmount
    },
    comparisonSupplierTotalDemandAmount(supplier, itemList) {
      return this.quoteSupplierCostSummary(supplier, itemList).totalDemandAmount
    },
    handleQuoteDemandInventoryChange(row) {
      if (!row) return
      const demandQuantity = Number(row.demandQuantity)
      const inventoryQuantity = Number(row.inventoryQuantity)
      if (!Number.isFinite(demandQuantity) || demandQuantity < 0) return
      const safeInventory = Number.isFinite(inventoryQuantity) && inventoryQuantity > 0 ? inventoryQuantity : 0
      this.$set(row, 'inventoryQuantity', safeInventory)
      this.$set(row, 'quantity', Number(Math.max(demandQuantity - safeInventory, 0).toFixed(2)))
      this.syncAllComparisonSupplierAutoFinalTotal()
    },
    comparisonSupplierDetailTotal(supplier, itemList) {
      if (!supplier) return 0
      const items = itemList || (this.quoteForm && this.quoteForm.itemList) || []
      const total = items.reduce((sum, item) => {
        const unitPrice = Number(supplier.priceMap && supplier.priceMap[item._rowKey])
        const quantity = Number(item.quantity)
        if (!Number.isFinite(unitPrice) || unitPrice <= 0 || !Number.isFinite(quantity) || quantity <= 0) {
          return sum
        }
        return sum + unitPrice * quantity
      }, 0)
      return roundPurchaseMoney(total + this.positiveAmount(supplier.freightAmount))
    },
    comparisonSupplierFinalTotal(supplier, itemList) {
      if (!supplier) return 0
      if (supplier._finalTotalManual) {
        const manualValue = Number(supplier.finalTotalAmount)
        if (Number.isFinite(manualValue)) return roundPurchaseMoney(manualValue)
      }
      return this.comparisonSupplierDetailTotal(supplier, itemList)
    },
    comparisonSupplierFinalAdjustment(supplier) {
      const detailTotal = this.comparisonSupplierDetailTotal(supplier)
      const finalTotal = this.comparisonSupplierFinalTotal(supplier)
      const adjustment = detailTotal - finalTotal
      return Math.abs(adjustment) < 0.0005 ? 0 : roundPurchaseMoney(adjustment)
    },
    setComparisonSupplierFinalTotal(supplier, value) {
      if (!supplier) return
      const amount = this.referenceMoneyValue(value)
      if (amount === null || amount < 0) {
        this.resetComparisonSupplierFinalTotal(supplier)
        return
      }
      this.$set(supplier, 'finalTotalAmount', amount)
      this.$set(supplier, '_finalTotalManual', true)
    },
    resetComparisonSupplierFinalTotal(supplier) {
      if (!supplier) return
      this.$set(supplier, '_finalTotalManual', false)
      this.syncComparisonSupplierAutoFinalTotal(supplier)
    },
    syncComparisonSupplierAutoFinalTotal(supplier, itemList) {
      if (!supplier || supplier._finalTotalManual) return
      const finalTotal = this.comparisonSupplierDetailTotal(supplier, itemList)
      this.$set(supplier, 'finalTotalAmount', Number.isFinite(finalTotal) ? finalTotal : 0)
    },
    syncAllComparisonSupplierAutoFinalTotal() {
      ;(this.quoteForm.supplierList || []).forEach(supplier => this.syncComparisonSupplierAutoFinalTotal(supplier))
    },
    isLowestComparisonPrice(item, supplier) {
      if (!item || !supplier) return false
      const prices = (this.quoteForm.supplierList || []).map(offer => {
        const value = Number(offer.priceMap && offer.priceMap[item._rowKey])
        return Number.isFinite(value) && value > 0 ? value : null
      }).filter(value => value !== null)
      if (prices.length < 2) return false
      const current = Number(supplier.priceMap && supplier.priceMap[item._rowKey])
      return Number.isFinite(current) && current > 0 && Math.abs(current - Math.min.apply(null, prices)) < 0.000001
    },
    comparisonItemIdentity(item) {
      if (!item) return ''
      const materialName = String(item.materialName || '').trim().replace(/\s+/g, ' ')
      if (!materialName) return ''
      const specification = String(item.specification || '').trim().replace(/\s+/g, ' ')
      const parameterValue = String(item.parameterValue || '').trim().replace(/\s+/g, ' ')
      return `${materialName.toLowerCase()}\u0000${specification.toLowerCase()}\u0000${parameterValue.toLowerCase()}`
    },
    isDuplicateComparisonItem(item) {
      const key = this.comparisonItemIdentity(item)
      return Boolean(key && this.quoteFormDuplicateItemGroups.some(group => group.key === key))
    },
    quoteEditorItemRowClass({ row }) {
      return this.isDuplicateComparisonItem(row) ? 'quote-editor-duplicate-row' : ''
    },
    addComparisonItem(base = {}) {
      const item = this.createQuoteLine(Object.assign({ quantity: 1 }, base))
      this.quoteForm.itemList.push(item)
      ;(this.quoteForm.supplierList || []).forEach(supplier => {
        if (!supplier.priceMap) this.$set(supplier, 'priceMap', {})
        this.$set(supplier.priceMap, item._rowKey, undefined)
      })
    },
    removeComparisonItem(index) {
      const item = this.quoteForm.itemList[index]
      this.quoteForm.itemList.splice(index, 1)
      if (item) this.$delete(this.ensureQuoteFormRecommendationMap(), item._rowKey)
      ;(this.quoteForm.supplierList || []).forEach(supplier => {
        if (supplier.priceMap && item) this.$delete(supplier.priceMap, item._rowKey)
        if (supplier._itemOfferMap && item) this.$delete(supplier._itemOfferMap, item._rowKey)
      })
    },
    quoteGroupExpanded(group, index) {
      if (Object.prototype.hasOwnProperty.call(this.expandedQuoteGroupMap, group.key)) {
        return !!this.expandedQuoteGroupMap[group.key]
      }
      return Number(index) === 0
    },
    toggleQuoteGroup(group, index) {
      this.$set(this.expandedQuoteGroupMap, group.key, !this.quoteGroupExpanded(group, index))
    },
    quoteGroupDisplayLayout(group) {
      if (!group) return 'supplier'
      if (Object.prototype.hasOwnProperty.call(this.quoteGroupDisplayLayoutMap, group.key)) {
        return this.quoteGroupDisplayLayoutMap[group.key] === 'item' ? 'item' : 'supplier'
      }
      return this.quoteGroupDefaultEditorLayout(group)
    },
    setQuoteGroupDisplayLayout(group, layout) {
      if (!group || !group.key) return
      this.$set(this.quoteGroupDisplayLayoutMap, group.key, layout === 'item' ? 'item' : 'supplier')
    },
    quoteDisplayOfferIsEffective(offer) {
      if (!offer) return false
      if (offer.selected || Number(offer.selectedFlag || 0) === 1) return true
      if (offer.recommended || Number(offer.recommendedFlag || 0) === 1) return true
      return this.positiveNumber(offer.quoteAmount) > 0
    },
    quoteItemRequiresDecision(item) {
      return this.positiveNumber(item && item.quantity) > 0
    },
    quoteDisplayItemOffers(group, item) {
      if (!group || !item || !item.offerMap) return []
      return (group.suppliers || group.offers || [])
        .map(supplier => item.offerMap[supplier.key])
        .filter(offer => this.quoteDisplayOfferIsEffective(offer))
    },
    quoteFormSourceLayoutType() {
      if (!this.quoteFormUseItemLayout) return 'HORIZONTAL'
      if (this.quoteFormIsMixed) return 'MIXED_VERTICAL'
      if (this.quoteFormIsEcommerce) return 'ECOMMERCE_VERTICAL'
      return 'STANDARD_VERTICAL'
    },
    rememberSavedQuoteGroupDisplayLayout(payload, layout) {
      const groups = this.quoteDisplayGroups || []
      const target = groups.find(group => payload.comparisonGroupNo && group.comparisonGroupNo === payload.comparisonGroupNo) ||
        groups.slice().reverse().find(group => group.comparisonGroupName === payload.comparisonGroupName)
      if (target) this.setQuoteGroupDisplayLayout(target, layout)
    },
    addQuoteOffer(base = {}) {
      if (!this.quoteForm.offerList) this.$set(this.quoteForm, 'offerList', [])
      if (this.quoteForm.offerList.length >= 3) {
        this.msgWarning('每个采购项最多录入3家供应商报价')
        return
      }
      this.quoteForm.offerList.push(this.createQuoteOffer(base))
    },
    removeQuoteOffer(index) {
      if (!this.quoteForm.offerList) return
      const removed = this.quoteForm.offerList[index]
      this.quoteForm.offerList.splice(index, 1)
      if (removed && this.quoteForm.recommendedOfferKey === removed._rowKey) {
        this.$set(this.quoteForm, 'recommendedOfferKey', '')
      }
    },
    handleQuoteGroupItemChange(itemId) {
      const item = this.quoteItemById(itemId)
      if (!item) return
      this.$set(this.quoteForm, 'materialCode', item.materialCode || '')
      this.$set(this.quoteForm, 'materialName', item.materialName || '')
      this.$set(this.quoteForm, 'specification', item.specification || '')
      this.$set(this.quoteForm, 'materialQualityBrand', item.materialQualityBrand || '')
      this.$set(this.quoteForm, 'quantity', item.quantity || 1)
      this.$set(this.quoteForm, 'unit', item.unit || '')
      if (!this.quoteForm.itemGroupName) {
        this.$set(this.quoteForm, 'itemGroupName', this.quoteItemLabel(item))
      }
    },
    handleQuoteOfferSupplierSelect(offer, supplier) {
      if (!offer || !supplier) return
      this.$set(offer, 'supplierId', supplier.id || null)
      this.$set(offer, 'supplierName', supplier.supplierName || '')
    },
    quoteOfferHasPlatform(offer) {
      return !!String(offer && offer.purchasePlatform || '').trim()
    },
    quoteOfferRequiresSupplierLink(offer) {
      return !this.quoteOfferHasPlatform(offer)
    },
    handleQuoteOfferPlatformChange(offer) {
      if (!offer || this.quoteOfferHasPlatform(offer)) return
      this.resolveQuoteSupplierLinks([offer])
    },
    resolveQuoteSupplierLinks(targetOffers) {
      const offers = targetOffers || (this.quoteForm && this.quoteForm.supplierList) || []
      const pendingNames = new Set()
      ;(offers || []).forEach(offer => {
        if (!offer || this.quoteOfferHasPlatform(offer) || offer.supplierId) return
        this.handleQuoteOfferSupplierBlur(offer)
        const name = String(offer.supplierName || '').trim()
        const state = this.supplierNameMatchState(name)
        if (name && !offer.supplierId && state.status === 'unlinked') {
          pendingNames.add(name)
        }
      })
      if (!pendingNames.size) return Promise.resolve([])
      const tasks = Array.from(pendingNames).map(keyword => {
        return listPurchaseSupplier({ keyword, status: 1, pageNum: 1, pageSize: 20 }).then(res => {
          this.mergeSupplierReferences(this.responseRows(res))
        })
      })
      return Promise.all(tasks).then(() => {
        ;(offers || []).forEach(offer => {
          if (offer && !this.quoteOfferHasPlatform(offer)) this.handleQuoteOfferSupplierBlur(offer)
        })
      }).catch(() => [])
    },
    syncQuoteSupplierReference(supplier, offerKey) {
      if (!supplier) return
      const supplierId = supplier.id === undefined || supplier.id === null ? '' : String(supplier.id)
      ;[this.quoteForm.supplierList || [], this.quoteForm.offerList || []].forEach(rows => {
        rows.forEach(offer => {
          const matchesOffer = offerKey && offer._rowKey === offerKey
          const matchesSupplier = supplierId && offer.supplierId !== undefined &&
            offer.supplierId !== null && String(offer.supplierId) === supplierId
          if (matchesOffer || matchesSupplier) {
            this.handleQuoteOfferSupplierSelect(offer, supplier)
          }
        })
      })
      if (supplierId && this.quoteForm.supplierId !== undefined &&
        this.quoteForm.supplierId !== null && String(this.quoteForm.supplierId) === supplierId) {
        this.$set(this.quoteForm, 'supplierName', supplier.supplierName || '')
      }
    },
    handleQuoteOfferSupplierInput(offer) {
      if (!offer || !offer.supplierId) return
      const bound = (this.supplierOptions || []).find(item => String(item.id) === String(offer.supplierId))
      if (!bound || !this.supplierMatchTokens(bound).includes(this.normalizeReferenceName(offer.supplierName))) {
        this.$set(offer, 'supplierId', null)
      }
    },
    handleQuoteOfferSupplierBlur(offer) {
      if (!offer) return
      const typedName = String(offer.supplierName || '').trim()
      this.$set(offer, 'supplierName', typedName)
      const state = this.supplierNameMatchState(typedName)
      if (state.status === 'matched' && state.supplier) {
        this.$set(offer, 'supplierId', state.supplier.id || null)
      } else {
        this.$set(offer, 'supplierId', null)
      }
    },
    quoteSupplierLinkState(offer) {
      if (!offer || !String(offer.supplierName || '').trim()) {
        return { status: 'empty', icon: 'el-icon-info', message: '' }
      }
      if (this.quoteOfferHasPlatform(offer)) {
        if (offer.supplierId) {
          const bound = (this.supplierOptions || []).find(item => String(item.id) === String(offer.supplierId))
          return {
            status: 'linked',
            icon: 'el-icon-circle-check',
            message: `电商店铺已关联：${bound && bound.supplierName ? bound.supplierName : offer.supplierName}`
          }
        }
        return {
          status: 'ready',
          icon: 'el-icon-shopping-cart-2',
          message: '电商店铺无需维护，保存报价时将自动创建并关联供应商库'
        }
      }
      if (offer.supplierId) {
        const bound = (this.supplierOptions || []).find(item => String(item.id) === String(offer.supplierId))
        return {
          status: 'linked',
          icon: 'el-icon-circle-check',
          message: `已关联供应商库：${bound && bound.supplierName ? bound.supplierName : offer.supplierName}`
        }
      }
      const state = this.supplierNameMatchState(offer.supplierName)
      if (state.status === 'matched') {
        return {
          status: 'ready',
          icon: 'el-icon-link',
          message: state.matchType === 'fragment'
            ? `将关联 ${state.supplier.supplierName}，并自动登记本次输入为简称`
            : `将关联供应商库：${state.supplier.supplierName}`
        }
      }
      if (state.status === 'ambiguous') {
        const names = state.candidates.slice(0, 2).map(item => item.supplierName).join('、')
        return {
          status: 'ambiguous',
          icon: 'el-icon-warning-outline',
          message: `名称可能对应多家供应商${names ? `（${names}${state.candidates.length > 2 ? '等' : ''}）` : ''}，请从下拉列表明确选择`
        }
      }
      return {
        status: 'unlinked',
        icon: 'el-icon-warning-outline',
        message: '未关联供应商库，必须先维护后才能保存'
      }
    },
    quoteSupplierCompactLinkMessage(offer) {
      const state = this.quoteSupplierLinkState(offer)
      if (this.quoteOfferHasPlatform(offer)) {
        return state.status === 'linked'
          ? state.message.replace(/^电商店铺已关联：/, '关联：')
          : '电商店铺，无需维护'
      }
      if (state.status === 'linked' || state.status === 'ready') {
        const matched = this.quoteSupplierMatchedRecord(offer)
        return `关联：${matched && matched.supplierName ? matched.supplierName : offer.supplierName}`
      }
      if (state.status === 'ambiguous') return '名称有歧义，请明确选择'
      return '未关联，必须维护'
    },
    quoteSupplierCanMaintain(offer) {
      if (!this.canEditQuote || !offer || !String(offer.supplierName || '').trim()) return false
      if (this.quoteOfferHasPlatform(offer)) return false
      if (offer.supplierId) return true
      return this.supplierNameMatchState(offer.supplierName).status !== 'ambiguous'
    },
    quoteSupplierMatchedRecord(offer) {
      if (!offer) return null
      const byId = (this.supplierOptions || []).find(item => {
        return offer.supplierId && String(item.id) === String(offer.supplierId)
      })
      if (byId) return byId
      const state = this.supplierNameMatchState(offer.supplierName)
      return state.status === 'matched' ? state.supplier : null
    },
    quoteSupplierMaintainLabel(offer, compact) {
      return this.quoteSupplierMatchedRecord(offer)
        ? (compact ? '编辑' : '编辑供应商')
        : (compact ? '维护' : '维护供应商')
    },
    openSupplierMaintenanceForOffer(offer) {
      if (!offer) return
      const typedName = String(offer.supplierName || '').trim()
      const state = this.supplierNameMatchState(typedName)
      if (state.status === 'ambiguous') {
        this.msgWarning('该名称可能对应多家供应商，请从下拉列表中明确选择')
        return
      }
      const matchedSupplier = this.quoteSupplierMatchedRecord(offer)
      const looksLikeFullName = /(公司|集团|工厂|厂|商行|经营部|旗舰店|专营店|专卖店|企业店|商城)$/.test(typedName)
      this.supplierMaintenanceOfferKey = offer._rowKey || ''
      this.supplierDialogTitle = `${matchedSupplier ? '编辑' : '维护'}报价供应商${typedName ? `：${typedName}` : ''}`
      this.supplierForm = matchedSupplier
        ? Object.assign(this.emptySupplierForm(), matchedSupplier)
        : Object.assign(this.emptySupplierForm(), {
          supplierName: typedName,
          shortName: looksLikeFullName ? '' : typedName
        })
      this.supplierDialogOpen = true
      this.$nextTick(() => {
        if (this.$refs.supplierForm) this.$refs.supplierForm.clearValidate()
      })
    },
    buildItemQuoteGroupPayload() {
      const recommendedKey = this.quoteForm.recommendedOfferKey
      return {
        applyId: this.applyForm.id,
        itemGroupNo: this.quoteForm.itemGroupNo || '',
        itemGroupName: this.quoteForm.itemGroupName || '',
        itemId: this.quoteForm.itemId || null,
        materialCode: this.quoteForm.materialCode || '',
        materialName: this.quoteForm.materialName || '',
        specification: this.quoteForm.specification || '',
        materialQualityBrand: this.quoteForm.materialQualityBrand || '',
        quantity: this.quoteForm.quantity,
        unit: this.quoteForm.unit || '',
        historyMinPrice: this.quoteForm.historyMinPrice,
        historyMaxPrice: this.quoteForm.historyMaxPrice,
        remark: this.quoteForm.remark || '',
        offerList: (this.quoteForm.offerList || []).map(offer => ({
          id: offer.id || null,
          quoteGroupNo: offer.quoteGroupNo || '',
          supplierId: offer.supplierId || null,
          supplierName: offer.supplierName || '',
          quoteAmount: offer.quoteAmount,
          taxRate: offer.taxRate,
          deliveryDays: offer.deliveryDays,
          paymentCondition: offer.paymentCondition || '',
          recommendedFlag: recommendedKey && recommendedKey === offer._rowKey ? 1 : 0,
          recommendationReason: recommendedKey && recommendedKey === offer._rowKey ? String(this.quoteForm.recommendationReason || '').trim() : '',
          selectionReason: offer.selectionReason || '',
          fileInfoList: offer.fileInfoList || [],
          remark: offer.remark || ''
        }))
      }
    },
    validateItemQuoteGroup() {
      if (!this.quoteForm.itemGroupName || !this.quoteForm.materialName) {
        this.msgWarning('请填写报价组名称和真实采购项')
        return false
      }
      if (this.quoteForm.quantity === undefined || this.quoteForm.quantity === null || this.quoteForm.quantity === '' || Number(this.quoteForm.quantity) < 0) {
        this.msgWarning('真实采购数量不能小于0')
        return false
      }
      const actualPurchaseQuantity = Number(this.quoteForm.quantity || 0)
      const offers = this.quoteForm.offerList || []
      if (!offers.length || offers.length > 3) {
        this.msgWarning('每个采购项需要录入1至3家供应商报价')
        return false
      }
      const supplierKeys = new Set()
      for (let index = 0; index < offers.length; index++) {
        const offer = offers[index]
        this.handleQuoteOfferSupplierBlur(offer)
        if (!offer.supplierName && !offer.supplierId) {
          this.msgWarning(`第${index + 1}家供应商不能为空`)
          return false
        }
        if (this.quoteOfferRequiresSupplierLink(offer) && !offer.supplierId) {
          this.msgWarning(`第${index + 1}家供应商尚未关联供应商库，请先维护或选择供应商`)
          return false
        }
        if (actualPurchaseQuantity > 0 && (!offer.quoteAmount || Number(offer.quoteAmount) <= 0)) {
          this.msgWarning(`第${index + 1}家供应商报价单价必须大于0`)
          return false
        }
        if (actualPurchaseQuantity <= 0 && offer.quoteAmount !== undefined && offer.quoteAmount !== null && offer.quoteAmount !== '' && Number(offer.quoteAmount) < 0) {
          this.msgWarning(`第${index + 1}家供应商报价单价不能小于0`)
          return false
        }
        const key = String(offer.supplierId || offer.supplierName || '').trim().toLowerCase()
        if (supplierKeys.has(key)) {
          this.msgWarning('同一采购项不能重复录入同一家供应商')
          return false
        }
        supplierKeys.add(key)
      }
      return true
    },
    handleQuoteItemChange(itemId) {
      const line = this.quotePrimaryLine(true)
      if (line) {
        this.$set(line, 'itemId', itemId)
        this.handleQuoteLineItemChange(line)
      }
    },
    handleQuoteLineItemChange(line) {
      if (!line) return
      const item = this.quoteItemById(line.itemId)
      if (!item) return
      this.fillQuoteLineFromItem(line, item)
    },
    fillQuoteLineFromItem(line, item) {
      if (!line || !item) return
      this.$set(line, 'materialCode', item.materialCode || '')
      this.$set(line, 'materialName', item.materialName || '')
      this.$set(line, 'specification', item.specification || '')
      this.$set(line, 'parameterValue', '')
      this.$set(line, 'materialQualityBrand', item.materialQualityBrand || '')
      this.$set(line, 'demandQuantity', item.quantity || 1)
      this.$set(line, 'inventoryQuantity', 0)
      this.$set(line, 'quantity', item.quantity || 1)
      this.$set(line, 'unit', item.unit || '')
      if (!line.quoteAmount) {
        this.$set(line, 'quoteAmount', this.referenceUnitPriceValue(item.purchaseUnitPrice || item.budgetUnitPrice))
      }
    },
    createQuoteLine(base = {}) {
      const row = Object.assign({
        _rowKey: `quote-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        id: null,
        itemId: null,
        itemGroupNo: '',
        itemGroupName: '',
        quoteGroupNo: '',
        materialCode: '',
        materialName: '',
        specification: '',
        parameterValue: '',
        materialQualityBrand: '',
        demandQuantity: undefined,
        inventoryQuantity: 0,
        quantity: undefined,
        unit: '',
        quoteAmount: undefined,
        paymentCondition: '',
        selectedFlag: 0,
        selectionReason: '',
        historyMinPrice: undefined,
        historyMaxPrice: undefined,
        historyPriceSource: '',
        _historyLoading: false,
        _historySourceText: '',
        _historyAutoFilled: false,
        _historyRequestKey: '',
        aiRiskTips: '',
        remark: ''
      }, base || {})
      if (row.inventoryQuantity === undefined || row.inventoryQuantity === null || row.inventoryQuantity === '') {
        row.inventoryQuantity = 0
      }
      delete row.fileInfoList
      return row
    },
    markQuoteHistoryPriceManual(row) {
      if (!row || row._historyLoading) return
      this.$set(row, '_historyAutoFilled', false)
      this.$set(row, 'historyPriceSource', row.historyMinPrice ? 'PURCHASER_INPUT' : '')
      this.$set(row, 'historyMaxPrice', row.historyMinPrice || undefined)
      this.$set(row, '_historySourceText', row.historyMinPrice ? '人工调整的历史参考价' : '')
    },
    quoteHistoryRecordTime(record) {
      const time = new Date(record && (record.decisionTime || record.applyCreateTime || record.purchaseDate || record.expectedArrivalDate) || 0).getTime()
      return Number.isFinite(time) ? time : 0
    },
    loadLatestQuoteHistoryPrice(row) {
      if (!row || !String(row.materialName || '').trim()) return Promise.resolve(null)
      const sourceItem = this.quoteItemById(row.itemId) || {}
      const materialCode = String(row.materialCode || '').trim()
      const materialName = String(row.materialName || '').trim()
      const specification = String(row.specification || '').trim()
      const modelNo = String(row.modelNo || sourceItem.modelNo || '').trim()
      const technicalParameter = String(row.parameterValue || sourceItem.technicalParameter || '').trim()
      const materialQualityBrand = String(row.materialQualityBrand || '').trim()
      const unit = String(row.unit || '').trim()
      const requestKey = [
        materialCode ? `code:${this.normalizeReferenceName(materialCode)}` : `name:${this.normalizeReferenceName(materialName)}`,
        this.referenceSpecificationKey(specification, materialName),
        this.normalizeReferenceName(modelNo),
        this.normalizeReferenceName(technicalParameter),
        this.normalizeReferenceName(materialQualityBrand),
        this.normalizeReferenceUnit(unit)
      ].join('|')
      if (!requestKey || (row._historyLoading && row._historyRequestKey === requestKey)) {
        return Promise.resolve(null)
      }
      this.$set(row, '_historyLoading', true)
      this.$set(row, '_historyRequestKey', requestKey)
      return listPurchasePrice({
        materialCode: materialCode || undefined,
        exactMaterialCode: Boolean(materialCode),
        materialName: materialCode ? undefined : materialName,
        exactMaterialName: !materialCode && Boolean(materialName),
        specification,
        exactSpecification: Boolean(specification),
        modelNo,
        exactModelNo: Boolean(modelNo),
        technicalParameter,
        exactTechnicalParameter: Boolean(technicalParameter),
        materialQualityBrand,
        exactMaterialQualityBrand: Boolean(materialQualityBrand),
        unit,
        internalPurchaseOnly: true,
        pageNum: 1,
        pageSize: 100
      }).then(res => {
        if (row._historyRequestKey !== requestKey) return null
        const records = this.responseRows(res)
          .filter(record => this.isPriceReferenceRecord(record) && this.referenceUnitPriceValue(record.purchaseUnitPrice) !== null)
          .sort((left, right) => this.quoteHistoryRecordTime(right) - this.quoteHistoryRecordTime(left))
        this.mergePriceReferences(records)
        const latest = records[0] || null
        const canAutoFill = row.historyMinPrice === undefined || row.historyMinPrice === null || row.historyMinPrice === '' || row._historyAutoFilled
        if (!latest) {
          if (canAutoFill) this.$set(row, 'historyMinPrice', undefined)
          if (canAutoFill) this.$set(row, 'historyMaxPrice', undefined)
          if (canAutoFill) this.$set(row, 'historyPriceSource', '')
          if (canAutoFill) this.$set(row, '_historySourceText', '')
          this.$set(row, '_historyAutoFilled', canAutoFill)
          return null
        }
        const latestPrice = this.referenceUnitPriceValue(latest.purchaseUnitPrice)
        const prices = records.map(record => this.referenceUnitPriceValue(record.purchaseUnitPrice))
          .filter(value => value !== null && value > 0)
        if (canAutoFill) {
          this.$set(row, 'historyMinPrice', latestPrice)
          this.$set(row, 'historyMaxPrice', prices.length ? Math.max.apply(null, prices) : latestPrice)
          this.$set(row, 'historyPriceSource', 'HISTORY_DB')
          this.$set(row, '_historyAutoFilled', true)
          const source = [latest.decisionTime ? String(latest.decisionTime).slice(0, 10) : '', latest.supplierName]
            .filter(Boolean)
            .join(' · ')
          this.$set(row, '_historySourceText', source ? `内部已定商采购：${source}` : '最近一次内部已定商采购')
        }
        return latest
      }).finally(() => {
        if (row._historyRequestKey === requestKey) this.$set(row, '_historyLoading', false)
      })
    },
    loadLatestQuoteHistoryPrices(rows) {
      return Promise.all((rows || this.quoteForm.itemList || [])
        .filter(row => row && row.materialName)
        .map(row => this.loadLatestQuoteHistoryPrice(row)))
    },
    quotePrimaryLine(createIfMissing = false) {
      if (!this.quoteForm.itemList) this.$set(this.quoteForm, 'itemList', [])
      if (!this.quoteForm.itemList.length && createIfMissing) {
        this.quoteForm.itemList.push(this.createQuoteLine())
      }
      return this.quoteForm.itemList[0]
    },
    addQuoteLine(base = {}) {
      if (!this.quoteForm.itemList) this.$set(this.quoteForm, 'itemList', [])
      this.quoteForm.itemList.push(this.createQuoteLine(base))
    },
    quoteLineIsBlank(row) {
      if (!row) return true
      return !row.id && !row.itemId && !row.materialName && !row.specification && !row.parameterValue && !row.materialQualityBrand &&
        !row.quantity && !row.unit && !row.quoteAmount
    },
    removeQuoteLine(index) {
      if (!this.quoteForm.itemList) return
      if (this.quoteForm.itemList.length <= 1) {
        this.$set(this.quoteForm, 'itemList', [this.createQuoteLine()])
        return
      }
      this.quoteForm.itemList.splice(index, 1)
    },
    appendQuoteLinesFromApplyItems() {
      const rows = (this.applyForm.itemList || []).filter(item => item && item.materialName && this.isActualPurchaseRow(item))
      if (!rows.length) {
        this.msgWarning('暂无需要实际采购的明细')
        return
      }
      const lines = rows.map(item => {
        const line = this.createQuoteLine({ itemId: item.id || null })
        this.fillQuoteLineFromItem(line, item)
        return line
      })
      const current = this.quoteForm.itemList || []
      if (!current.length || (current.length === 1 && this.quoteLineIsBlank(current[0]))) {
        this.$set(this.quoteForm, 'itemList', lines)
      } else {
        this.quoteForm.itemList = current.concat(lines)
      }
      this.loadLatestQuoteHistoryPrices(lines)
      ;(this.quoteForm.supplierList || []).forEach(supplier => {
        if (!supplier.priceMap) this.$set(supplier, 'priceMap', {})
        lines.forEach(line => {
          if (!Object.prototype.hasOwnProperty.call(supplier.priceMap, line._rowKey)) {
            this.$set(supplier.priceMap, line._rowKey, undefined)
          }
        })
      })
    },
    normalizeQuoteLinePayload(row) {
      return {
        id: row.id || null,
        itemId: row.itemId || null,
        quoteGroupNo: row.quoteGroupNo || this.quoteForm.quoteGroupNo || '',
        materialCode: row.materialCode || '',
        materialName: row.materialName || '',
        specification: row.specification || '',
        parameterValue: row.parameterValue || '',
        materialQualityBrand: row.materialQualityBrand || '',
        demandQuantity: row.demandQuantity,
        inventoryQuantity: row.inventoryQuantity,
        quantity: row.quantity,
        unit: row.unit || '',
        quoteAmount: row.quoteAmount,
        paymentCondition: row.paymentCondition || '',
        selectedFlag: row.selectedFlag || 0,
        selectionReason: row.selectionReason || this.quoteForm.selectionReason || '',
        historyMinPrice: row.historyMinPrice,
        historyMaxPrice: row.historyMaxPrice,
        historyPriceSource: row.historyPriceSource || '',
        aiRiskTips: row.aiRiskTips || '',
        remark: row.remark || ''
      }
    },
    validQuoteLines() {
      return (this.quoteForm.itemList || []).filter(row => !this.quoteLineIsBlank(row))
    },
    validateQuoteLines(lines) {
      if (!lines.length) {
        this.msgWarning('请至少填写一条真实采购项报价')
        return false
      }
      for (let index = 0; index < lines.length; index++) {
        const row = lines[index]
        if (!row.materialName) {
          this.msgWarning(`第${index + 1}行请填写真实采购项名称`)
          return false
        }
        if (row.quantity === undefined || row.quantity === null || row.quantity === '' || Number(row.quantity) < 0) {
          this.msgWarning(`第${index + 1}行实际采购量不能小于0`)
          return false
        }
      }
      return true
    },
    buildQuoteBatchPayload(lines) {
      return {
        applyId: this.applyForm.id,
        quoteGroupNo: this.quoteForm.quoteGroupNo || '',
        supplierId: this.quoteForm.supplierId || null,
        supplierName: this.quoteForm.supplierName || '',
        recommendedFlag: this.quoteForm.recommendedFlag || 0,
        taxRate: this.quoteForm.taxRate,
        deliveryDays: this.quoteForm.deliveryDays,
        selectionReason: this.quoteForm.selectionReason || '',
        fileInfoList: this.quoteForm.fileInfoList || [],
        quoteList: lines.map(row => this.normalizeQuoteLinePayload(row))
      }
    },
    handleQuoteItemChangeLegacy(itemId) {
      const item = this.quoteItemById(itemId)
      if (!item) return
      this.$set(this.quoteForm, 'materialCode', item.materialCode || '')
      this.$set(this.quoteForm, 'materialName', item.materialName || '')
      this.$set(this.quoteForm, 'specification', item.specification || '')
      this.$set(this.quoteForm, 'materialQualityBrand', item.materialQualityBrand || '')
      this.$set(this.quoteForm, 'quantity', item.quantity || 1)
      this.$set(this.quoteForm, 'unit', item.unit || '')
      if (!this.quoteForm.quoteAmount) {
        this.$set(this.quoteForm, 'quoteAmount', this.referenceUnitPriceValue(item.purchaseUnitPrice || item.budgetUnitPrice))
      }
    },
    queryQuoteSupplierSuggestions(query, callback) {
      const line = this.quotePrimaryLine(false) || {}
      const item = this.quoteItemById(line.itemId) || {
        materialName: line.materialName,
        specification: line.specification,
        materialQualityBrand: line.materialQualityBrand,
        unit: line.unit
      }
      if (item) {
        this.queryItemSupplierSuggestions(query, item, callback)
        return
      }
      this.querySupplierSuggestions(query, callback)
    },
    normalizeArrivalText(value) {
      return String(value || '').trim().replace(/\s+/g, '').toLowerCase()
    },
    arrivalRecordMatchesItem(item, record) {
      if (!item || !record) return false
      if (item.id && record.itemId) return String(item.id) === String(record.itemId)
      const itemName = this.normalizeArrivalText(item.materialName)
      const recordName = this.normalizeArrivalText(record.materialName)
      if (!itemName || !recordName || itemName !== recordName) return false
      const itemSpec = this.normalizeArrivalText(item.specification)
      const recordSpec = this.normalizeArrivalText(record.specification)
      return !itemSpec || !recordSpec || itemSpec === recordSpec
    },
    arrivalRecordsForItem(item) {
      return this.arrivalRecordsForItemFromDetail(item, this.detail)
    },
    arrivalRecordsForItemFromDetail(item, detail) {
      return ((detail && detail.arrivalList) || []).filter(row => this.arrivalRecordMatchesItem(item, row))
    },
    buildArrivalProgressRows(applyForm, detail) {
      const form = applyForm || {}
      return (form.itemList || [])
        .filter(item => item && (item.id || item.materialName))
        .map((item, index) => {
          const records = this.arrivalRecordsForItemFromDetail(item, detail || {})
          const latestRecord = this.latestArrivalRecord(records)
          const totalQuantity = Number(item.quantity || 0)
          const arrivedSum = this.sumArrivalQuantity(records)
          const arrivedQuantity = Math.min(arrivedSum, totalQuantity || arrivedSum)
          const remainingQuantity = Math.max(totalQuantity - arrivedQuantity, 0)
          const progressPercent = totalQuantity > 0 ? Math.min(Math.round((arrivedQuantity / totalQuantity) * 100), 100) : (arrivedQuantity > 0 ? 100 : 0)
          const status = this.resolveArrivalProgressStatus(totalQuantity, arrivedQuantity, records, latestRecord)
          const fileCount = records.reduce((count, row) => count + ((row.fileInfoList || []).length), 0)
          return {
            key: item.id || item.sortNo || `${item.materialName || 'item'}-${index}`,
            itemId: item.id || null,
            item,
            records,
            latestRecord,
            totalQuantity,
            arrivedQuantity,
            remainingQuantity,
            progressPercent,
            statusText: status.text,
            statusTagType: status.type,
            fileCount
          }
        })
    },
    sumArrivalQuantity(records) {
      return (records || []).reduce((sum, row) => sum + Number(row.arrivedQuantity || 0), 0)
    },
    latestArrivalRecord(records) {
      const rows = (records || []).slice()
      rows.sort((a, b) => {
        const left = new Date(a.arrivalDate || a.updateTime || a.createTime || 0).getTime() || 0
        const right = new Date(b.arrivalDate || b.updateTime || b.createTime || 0).getTime() || 0
        if (right !== left) return right - left
        return Number(b.id || 0) - Number(a.id || 0)
      })
      return rows[0] || null
    },
    resolveArrivalProgressStatus(totalQuantity, arrivedQuantity, records, latestRecord) {
      if ((records || []).some(row => this.arrivalRecordIsAbnormal(row))) {
        return { text: '到货异常', type: 'danger' }
      }
      if (!records || !records.length || Number(arrivedQuantity || 0) <= 0) {
        return { text: '未到货', type: 'info' }
      }
      if (Number(totalQuantity || 0) > 0 && Number(arrivedQuantity || 0) >= Number(totalQuantity || 0)) {
        return Number(latestRecord && latestRecord.status) === 50
          ? { text: '已验收', type: 'success' }
          : { text: '全部到货', type: 'success' }
      }
      return { text: '部分到货', type: 'warning' }
    },
    arrivalRecordIsAbnormal(record) {
      if (!record) return false
      const qualityScore = record.qualityScore === undefined || record.qualityScore === null || record.qualityScore === '' ? 100 : Number(record.qualityScore)
      if (qualityScore > 0 && qualityScore < 60) return true
      const issueText = String(record.issueDescription || '').trim()
      if (!issueText) return false
      return /异常|破损|损坏|少发|漏发|缺少|不合格|退货|拒收|问题|补发/.test(issueText)
    },
    arrivalProgressStatus(row) {
      if (!row) return undefined
      if (row.statusTagType === 'danger') return 'exception'
      if (row.progressPercent >= 100) return 'success'
      return undefined
    },
    quantityWithUnit(value, unit) {
      return `${this.numberText(value)}${unit || ''}`
    },
    arrivedQuantityForItem(item) {
      if (!item) return 0
      return this.sumArrivalQuantity(this.arrivalRecordsForItem(item))
    },
    remainingQuantityForItem(item) {
      return Math.max(Number(item && item.quantity || 0) - this.arrivedQuantityForItem(item), 0)
    },
    fillArrivalFromItem(item, progressRow) {
      if (!item) return
      this.arrivalEditingExisting = false
      const remaining = progressRow ? progressRow.remainingQuantity : this.remainingQuantityForItem(item)
      const quantity = remaining > 0 ? remaining : Number(item.quantity || 0)
      const status = this.inferArrivalStatusCode({ quantity, arrivedQuantity: quantity, qualityScore: 100, issueDescription: '' })
      this.arrivalForm = Object.assign(this.emptyArrivalForm(), {
        applyId: this.applyForm.id,
        itemId: item.id || null,
        materialName: item.materialName || '',
        specification: item.specification || '',
        quantity,
        arrivedQuantity: quantity,
        unarrivedQuantity: 0,
        status,
        arrivalDate: this.formatDateValue(new Date()),
        qualityScore: 100
      })
    },
    handleArrivalItemChange(itemId) {
      const item = this.quoteItemById(itemId)
      if (item) this.fillArrivalFromItem(item)
    },
    openArrivalForItem(row) {
      if (!this.ensureWorkflowEditable(this.canEditArrival, '当前采购单还未进入到货验收节点')) return
      this.uploadRenderKey += 1
      this.fillArrivalFromItem(row && row.item, row)
      this.$nextTick(() => {
        if (this.$refs.arrivalEditor && this.$refs.arrivalEditor.scrollIntoView) {
          this.$refs.arrivalEditor.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },
    prefillArrivalFromFirstPending() {
      const row = this.arrivalItemProgressRows.find(item => item.remainingQuantity > 0) || this.arrivalItemProgressRows[0]
      if (!row) {
        this.msgWarning('请先补充采购清单')
        return
      }
      this.openArrivalForItem(row)
    },
    saveQuote() {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      if (!this.applyForm.id) return
      const payload = this.buildComparisonGroupPayload()
      if (!payload) return
      const importIndex = this.quoteImportQueueIndex
      const savedDisplayLayout = this.quoteFormUseItemLayout ? 'item' : 'supplier'
      const submitQuoteGroup = () => savePurchaseComparisonGroup(payload).then(() => {
        return this.refreshCurrentDetail().then(() => {
          this.rememberSavedQuoteGroupDisplayLayout(payload, savedDisplayLayout)
          if (importIndex >= 0 && this.quoteImportDraftList[importIndex]) {
            const currentDraft = this.quoteImportDraftList[importIndex]
            this.$set(currentDraft, 'saved', true)
            this.refreshQuoteImportSheetStatus()
            const nextIndex = this.nextUnsavedQuoteImportDraftIndex(importIndex)
            if (nextIndex >= 0) {
              this.activateQuoteImportDraft(nextIndex)
              this.msgSuccess(`“${currentDraft.label}”已保存，可继续切换或核对其他报价组`)
              return
            }
          }
          this.msgSuccess('报价组已保存')
          this.clearQuoteImportQueue()
          this.quoteForm = Object.assign(this.emptyQuoteForm(), {
            applyId: this.applyForm.id,
            itemList: [this.createQuoteLine({ quantity: 1 })],
            supplierList: [this.createComparisonSupplier()]
          })
          this.quoteDialogOpen = false
          this.quoteDialogRow = null
        })
      })
      if (this.quoteFormDuplicateItemGroups.length) {
        const duplicateNames = this.quoteFormDuplicateItemGroups.slice(0, 3).map(group => {
          return group.specification ? `${group.materialName}（${group.specification}）` : `${group.materialName}（无规格）`
        }).join('、')
        const moreText = this.quoteFormDuplicateItemGroups.length > 3 ? '等' : ''
        this.$confirm(
          `检测到重复采购项：${duplicateNames}${moreText}。如果这些行用途或数量需要分开，可继续保存；否则请取消后合并。`,
          '重复采购项确认',
          {
            confirmButtonText: '确认保留并保存',
            cancelButtonText: '返回修改',
            type: 'warning'
          }
        ).then(submitQuoteGroup).catch(() => {})
        return
      }
      submitQuoteGroup()
    },
    quoteGroupIsEcommerce(group) {
      return Number(group && group.purchaseMode || 1) === 2
    },
    quoteGroupIsMixed(group) {
      return Number(group && group.purchaseMode || 1) === 3
    },
    quoteGroupModeLabel(group) {
      if (this.quoteGroupIsEcommerce(group)) return '电商店铺报价组'
      if (this.quoteGroupIsMixed(group)) return '混合报价组'
      return '普通供应商报价组'
    },
    quoteGroupPartyName(group) {
      if (this.quoteGroupIsEcommerce(group)) return '店铺'
      if (this.quoteGroupIsMixed(group)) return '报价方'
      return '供应商'
    },
    quoteGroupSupplierCoversAllItems(group, supplier) {
      const items = group && group.items || []
      if (!group || !supplier || !items.length) return false
      return items.every(item => item && item.offerMap &&
        this.quoteDisplayOfferIsEffective(item.offerMap[supplier.key]))
    },
    handleQuoteFormPurchaseModeChange(purchaseMode) {
      const standard = Number(purchaseMode) === 1
      ;(this.quoteForm.supplierList || []).forEach(supplier => {
        if (standard) this.$set(supplier, 'purchasePlatform', '')
        const matched = this.findSupplierByName(supplier.supplierName)
        this.$set(supplier, 'supplierId', matched ? matched.id : null)
        if (matched) this.$set(supplier, 'supplierName', matched.supplierName)
      })
    },
    confirmAllQuoteImports() {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能维护报价')) return
      const drafts = (this.quoteImportDraftList || []).filter(draft => draft && !draft.saved)
      if (!drafts.length) {
        this.msgWarning('没有待导入的报价组')
        return
      }
      const originalForm = this.quoteForm
      const payloads = []
      const payloadLayouts = []
      for (let index = 0; index < drafts.length; index++) {
        this.quoteForm = drafts[index].form
        const payload = this.buildComparisonGroupPayload()
        if (!payload) {
          const draftIndex = this.quoteImportDraftList.indexOf(drafts[index])
          this.quoteForm = originalForm
          this.activateQuoteImportDraft(draftIndex)
          return
        }
        payloads.push(payload)
        payloadLayouts.push(this.quoteFormUseItemLayout ? 'item' : 'supplier')
      }
      this.quoteForm = originalForm
      const importedModes = Array.from(new Set(payloads.map(payload => Number(payload.purchaseMode || 1))))
      this.quoteImportSaving = true
      savePurchaseQuoteWorkbook({
        applyId: this.applyForm.id,
        purchaseMode: importedModes.length === 1 ? importedModes[0] : null,
        sourceFileList: this.quoteImportSourceFileInfo ? [this.quoteImportSourceFileInfo] : [],
        comparisonGroupList: payloads
      }).then(() => {
        this.msgSuccess(`已一次导入${payloads.length}个比价组`)
        this.quoteDialogOpen = false
        this.clearQuoteImportQueue()
        return this.refreshCurrentDetail().then(() => {
          payloads.forEach((payload, index) => this.rememberSavedQuoteGroupDisplayLayout(payload, payloadLayouts[index]))
        })
      }).finally(() => {
        this.quoteImportSaving = false
      })
    },
    buildComparisonGroupPayload() {
      const groupName = String(this.quoteForm.comparisonGroupName || '').trim()
      if (!groupName) {
        this.msgWarning('请填写报价组名称')
        return null
      }
      const items = (this.quoteForm.itemList || []).filter(row => !this.quoteLineIsBlank(row))
      if (!this.validateQuoteLines(items)) return null
      const rawSuppliers = this.quoteForm.supplierList || []
      const suppliers = this.quoteFormUseItemLayout
        ? this.mergeQuoteFormSuppliersForItemLayout(rawSuppliers, items)
        : rawSuppliers
      const partyName = this.quoteFormPartyName
      if (!suppliers.length) {
        this.msgWarning(`请至少新增一家${partyName}`)
        return null
      }
      const supplierKeys = new Set()
      const itemQuotedMap = {}
      items.forEach(item => { itemQuotedMap[item._rowKey] = 0 })
      const itemRecommendationMap = this.quoteForm.recommendedOfferMap || {}
      const itemRecommendationReasonMap = this.quoteForm.recommendedReasonMap || {}
      if (!this.quoteForm.recommendedSupplierKey) {
        for (let itemIndex = 0; itemIndex < items.length; itemIndex++) {
          const item = items[itemIndex]
          const recommendedSupplierKey = itemRecommendationMap[item._rowKey]
          if (!recommendedSupplierKey) continue
          const supplier = suppliers.find(row => this.quoteSupplierRowKeyMatches(row, recommendedSupplierKey))
          if (!supplier || !this.positiveNumber(supplier.priceMap && supplier.priceMap[item._rowKey])) {
            this.msgWarning(`${item.materialName || `第${itemIndex + 1}个采购项`}推荐的${partyName}尚未填写有效单价`)
            return null
          }
        }
      }
      const supplierQuoteList = []
      for (let supplierIndex = 0; supplierIndex < suppliers.length; supplierIndex++) {
        const supplier = suppliers[supplierIndex]
        this.handleQuoteOfferSupplierBlur(supplier)
        if (this.quoteFormIsEcommerce && !String(supplier.purchasePlatform || '').trim()) {
          this.msgWarning(`第${supplierIndex + 1}家店铺请选择采购平台`)
          return null
        }
        if (this.quoteOfferRequiresSupplierLink(supplier) && !supplier.supplierId) {
          const linkState = this.quoteSupplierLinkState(supplier)
          this.msgWarning(linkState.status === 'ambiguous'
            ? `第${supplierIndex + 1}家供应商名称有歧义，请从下拉列表明确选择`
            : `第${supplierIndex + 1}家供应商尚未关联供应商库，请先维护或选择供应商`)
          return null
        }
        if (!supplier.supplierName && !supplier.supplierId) {
          this.msgWarning(`第${supplierIndex + 1}家${partyName}不能为空`)
          return null
        }
        const supplierKey = this.quoteSupplierIdentityKey(supplier)
        if (supplierKeys.has(supplierKey)) {
          this.msgWarning(`同一报价组不能重复录入同一家${partyName}：${this.quoteSupplierDisplayName(supplier, `第${supplierIndex + 1}家${partyName}`)}`)
          return null
        }
        supplierKeys.add(supplierKey)
        const supplierDisplayName = this.quoteSupplierDisplayName(supplier, `第${supplierIndex + 1}家${partyName}`)
        if (supplier._duplicateItemOfferName) {
          this.msgWarning(`${supplierDisplayName}在采购项“${supplier._duplicateItemOfferName}”下重复报价`)
          return null
        }
        const freightAmount = this.positiveAmount(supplier.freightAmount)
        const groupRecommended = this.quoteSupplierRowKeyMatches(supplier, this.quoteForm.recommendedSupplierKey)
        const quoteList = items.filter(item => {
          const quoteAmount = Number(supplier.priceMap && supplier.priceMap[item._rowKey])
          if (Number.isFinite(quoteAmount) && quoteAmount > 0) return true
          if (this.quoteFormUseItemLayout) return false
          return this.positiveNumber(item.quantity) <= 0
        }).map(item => {
            itemQuotedMap[item._rowKey] += 1
            const quoteAmount = Number(supplier.priceMap && supplier.priceMap[item._rowKey])
            const itemRecommended = !this.quoteForm.recommendedSupplierKey &&
              this.quoteSupplierRowKeyMatches(supplier, itemRecommendationMap[item._rowKey])
            const recommended = groupRecommended || itemRecommended
            const recommendationReason = groupRecommended
              ? String(this.quoteForm.recommendationReason || '').trim()
              : String(itemRecommendationReasonMap[item._rowKey] || this.quoteForm.recommendationReason || '').trim()
            return {
              itemId: item.itemId || null,
              itemGroupNo: item.itemGroupNo || `CLIENT-${this.applyForm.id || 0}-${item._rowKey}`,
            itemGroupName: item.itemGroupName || this.quoteMaterialName(item),
            materialCode: item.materialCode || '',
            materialName: item.materialName || '',
            specification: item.specification || '',
            parameterValue: item.parameterValue || '',
            materialQualityBrand: item.materialQualityBrand || '',
            demandQuantity: item.demandQuantity,
            inventoryQuantity: item.inventoryQuantity,
              quantity: item.quantity,
              unit: item.unit || '',
              historyMinPrice: item.historyMinPrice,
              historyMaxPrice: item.historyMaxPrice,
              historyPriceSource: item.historyPriceSource || '',
              quoteAmount: Number.isFinite(quoteAmount) && quoteAmount > 0 ? quoteAmount : 0,
              freightAmount,
              paymentCondition: supplier.paymentCondition || '',
              recommendedFlag: recommended ? 1 : 0,
              recommendationReason: recommended ? recommendationReason : '',
              remark: item.remark || ''
            }
          })
        if (!quoteList.length) {
          if (this.quoteFormUseItemLayout) continue
          this.msgWarning(`${supplierDisplayName}至少需要填写一个采购项单价`)
          return null
        }
        if (this.quoteSupplierRowKeyMatches(supplier, this.quoteForm.recommendedSupplierKey) && quoteList.length !== items.length) {
          this.msgWarning(`推荐${partyName}必须覆盖报价组内全部采购项`)
          return null
        }
        const finalTotalAmount = this.comparisonSupplierFinalTotal(supplier, items)
        const actualPurchaseAmount = this.comparisonSupplierActualPurchaseAmount(supplier, items)
        if (!Number.isFinite(finalTotalAmount) || finalTotalAmount < 0) {
          this.msgWarning(`${supplierDisplayName}的最终价不能小于0`)
          return null
        }
        if (actualPurchaseAmount > 0 && finalTotalAmount <= 0) {
          this.msgWarning(`${supplierDisplayName}有实际采购量时，最终价必须大于0`)
          return null
        }
        supplierQuoteList.push({
          applyId: this.applyForm.id,
          quoteGroupNo: supplier.quoteGroupNo || '',
          supplierId: supplier.supplierId || null,
          supplierName: supplier.supplierName || '',
          purchasePlatform: supplier.purchasePlatform || '',
          recommendedFlag: groupRecommended ? 1 : 0,
          taxRate: supplier.taxRate,
          deliveryDays: supplier.deliveryDays,
          freightAmount,
          finalTotalAmount,
          selectionReason: supplier.selectionReason || '',
          fileInfoList: supplier.fileInfoList || [],
          quoteList
        })
      }
      if (!supplierQuoteList.length) {
        this.msgWarning(`请至少保留一家有有效单价的${partyName}`)
        return null
      }
      const missingItem = items.find(item => this.positiveNumber(item.quantity) > 0 && !itemQuotedMap[item._rowKey])
      if (missingItem) {
        this.msgWarning(`${missingItem.materialName || '采购项'}尚无任何${partyName}报价`)
        return null
      }
      const recommendedSupplier = suppliers.find(supplier => this.quoteSupplierRowKeyMatches(supplier, this.quoteForm.recommendedSupplierKey))
      return {
        applyId: this.applyForm.id,
        comparisonGroupNo: this.quoteForm.comparisonGroupNo || '',
        comparisonGroupName: groupName,
        purchaseMode: Number(this.quoteForm.purchaseMode || 1),
        sourceLayoutType: this.quoteFormSourceLayoutType(),
        recommendedQuoteGroupNo: recommendedSupplier && recommendedSupplier.quoteGroupNo || '',
        recommendationReason: recommendedSupplier ? String(this.quoteForm.recommendationReason || '').trim() : '',
        recommendationSpecified: !this.quoteForm.comparisonGroupNo || !!this.quoteForm.recommendationTouched,
        supplierQuoteList
      }
    },
    editQuoteGroup(group) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能编辑报价')) return
      this.clearQuoteImportQueue()
      this.uploadRenderKey += 1
      const itemList = (group.items || []).map(item => this.createQuoteLine({
        itemId: item.itemId || null,
        itemGroupNo: item.itemGroupNo || '',
        itemGroupName: item.itemGroupName || '',
        materialCode: item.materialCode || '',
        materialName: item.materialName || '',
        specification: item.specification || '',
        parameterValue: item.parameterValue || '',
        materialQualityBrand: item.materialQualityBrand || '',
        demandQuantity: item.demandQuantity,
        inventoryQuantity: item.inventoryQuantity === undefined || item.inventoryQuantity === null ? 0 : item.inventoryQuantity,
        quantity: item.quantity,
        unit: item.unit || '',
        historyMinPrice: item.historyMinPrice,
        historyMaxPrice: item.historyMaxPrice,
        historyPriceSource: item.historyPriceSource || '',
        remark: item.remark || ''
      }))
      const supplierList = (group.suppliers || []).map(supplier => {
        const editor = this.createComparisonSupplier({
          quoteGroupNo: supplier.quoteGroupNo || '',
          supplierId: supplier.supplierId || null,
          supplierName: supplier.supplierName || '',
          purchasePlatform: supplier.purchasePlatform || '',
          taxRate: supplier.taxRate,
          deliveryDays: supplier.deliveryDays,
          paymentCondition: supplier.paymentCondition || '',
          selectionReason: supplier.selectionReason || '',
          recommendationReason: supplier.recommendationReason || '',
          fileInfoList: supplier.fileInfoList || [],
          freightAmount: supplier.freightAmount,
          finalTotalAmount: supplier.finalTotalAmount
        })
        itemList.forEach((item, itemIndex) => {
          const sourceItem = group.items[itemIndex]
          const sourceOffer = sourceItem && sourceItem.offerMap[supplier.key]
          if (this.quoteDisplayOfferIsEffective(sourceOffer)) {
            this.$set(editor.priceMap, item._rowKey, sourceOffer.quoteAmount)
            this.markSupplierItemOffer(editor, item)
          } else {
            this.$set(editor.priceMap, item._rowKey, undefined)
          }
        })
        const persistedFinalTotal = this.referenceMoneyValue(supplier.finalTotalAmount)
        const detailTotal = this.comparisonSupplierDetailTotal(editor, itemList)
        const hasPersistedFinalTotal = supplier.finalTotalAmount !== undefined &&
          supplier.finalTotalAmount !== null && persistedFinalTotal !== null
        this.$set(editor, '_finalTotalManual',
          hasPersistedFinalTotal && Math.abs(persistedFinalTotal - detailTotal) >= 0.005)
        if (!hasPersistedFinalTotal || !editor._finalTotalManual) {
          this.syncComparisonSupplierAutoFinalTotal(editor, itemList)
        } else {
          this.$set(editor, 'finalTotalAmount', roundPurchaseMoney(persistedFinalTotal))
        }
        if (supplier.recommended) this.$set(this.quoteForm, 'recommendedSupplierKey', editor._rowKey)
        return editor
      })
      const recommended = supplierList.find((supplier, index) => group.suppliers[index] && group.suppliers[index].recommended)
      const recommendedOfferMap = {}
      const recommendedReasonMap = {}
      itemList.forEach((item, itemIndex) => {
        const sourceItem = group.items[itemIndex]
        if (!sourceItem || !sourceItem.offerMap) return
        const recommendedSource = group.suppliers.find(sourceSupplier => {
          const sourceOffer = sourceItem.offerMap[sourceSupplier.key]
          return sourceOffer && Number(sourceOffer.recommended || sourceOffer.recommendedFlag || 0) === 1
        })
        if (!recommendedSource) return
        const supplierIndex = group.suppliers.findIndex(sourceSupplier => sourceSupplier.key === recommendedSource.key)
        const editor = supplierList[supplierIndex]
        if (editor) {
          recommendedOfferMap[item._rowKey] = editor._rowKey
          const sourceOffer = sourceItem.offerMap[recommendedSource.key]
          if (sourceOffer && sourceOffer.recommendationReason) {
            recommendedReasonMap[item._rowKey] = sourceOffer.recommendationReason
          }
        }
      })
      const allItemsUseWholeRecommended = recommended && itemList.length > 0 &&
        itemList.every(item => recommendedOfferMap[item._rowKey] === recommended._rowKey)
      const editorLayoutMode = this.quoteGroupDefaultEditorLayout(group)
      this.quoteForm = Object.assign(this.emptyQuoteForm(), {
        applyId: this.applyForm.id,
        comparisonGroupNo: group.comparisonGroupNo || '',
        comparisonGroupName: group.comparisonGroupName || '',
        purchaseMode: Number(group.purchaseMode || 1),
        editorLayoutMode,
        itemList,
        supplierList,
        recommendedSupplierKey: editorLayoutMode === 'supplier' && allItemsUseWholeRecommended ? recommended._rowKey : '',
        recommendedOfferMap: editorLayoutMode === 'item' || !allItemsUseWholeRecommended ? recommendedOfferMap : {},
        recommendedReasonMap: editorLayoutMode === 'item' || !allItemsUseWholeRecommended ? recommendedReasonMap : {},
        recommendationReason: group.recommendationReason || ''
      })
      this.quoteDialogRow = null
      this.quoteDialogTitle = '编辑报价组'
      this.quoteDialogOpen = true
      this.$nextTick(() => this.resolveQuoteSupplierLinks())
    },
    recommendQuoteGroup(group, supplier) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能推荐供应商')) return
      const cancelRecommendation = !!supplier.fullyRecommended
      const submitRecommendation = recommendationReason => recommendPurchaseComparisonSupplier({
        applyId: this.applyForm.id,
        comparisonGroupNo: group.comparisonGroupNo || group.key,
        quoteGroupNo: supplier.quoteGroupNo,
        recommendedFlag: cancelRecommendation ? 0 : 1,
        recommendationReason: recommendationReason || ''
      }).then(() => {
        this.msgSuccess(cancelRecommendation ? '已取消整组推荐' : '已标记为整组推荐')
        this.refreshCurrentDetail()
      })
      if (cancelRecommendation) {
        submitRecommendation('')
        return
      }
      const partyName = this.quoteGroupPartyName(group)
      this.$prompt(`可填写推荐该${partyName}的理由，总经理确认时会直接看到；不填也可以直接确认。`, `推荐${partyName}`, {
        confirmButtonText: '确认推荐',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValue: group.recommendationReason || '',
        inputPlaceholder: '可不填；如：综合价格最低，交期满足要求，历史合作质量稳定'
      }).then(({ value }) => submitRecommendation(String(value || '').trim())).catch(() => {})
    },
    recommendQuoteItem(group, item, offer) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能推荐供应商')) return
      if (!item || !offer || !offer.id) return
      const itemName = item.materialName || item.itemGroupName || '采购项'
      const partyName = this.quoteGroupPartyName(group)
      const submitRecommendation = recommendationReason => recommendPurchaseItemQuote({
        applyId: this.applyForm.id,
        itemGroupNo: item.itemGroupNo || item.key,
        quoteId: offer.id,
        recommendedFlag: offer.recommended ? 0 : 1,
        recommendationReason: recommendationReason || ''
      }).then(() => {
        this.msgSuccess(offer.recommended ? '已取消推荐' : '已标记为推荐')
        return this.refreshCurrentDetail()
      })
      if (offer.recommended) {
        submitRecommendation('')
        return
      }
      this.$prompt(`可填写推荐该${partyName}用于“${itemName}”的理由，总经理确认时会直接看到；不填也可以直接确认。`, `推荐${partyName}`, {
        confirmButtonText: '确认推荐',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValue: offer.recommendationReason || '',
        inputPlaceholder: '可不填；如：价格低、品牌可靠、交期满足、售后稳定'
      }).then(({ value }) => submitRecommendation(String(value || '').trim())).catch(() => {})
    },
    removeQuoteGroup(group) {
      if (!this.ensureWorkflowEditable(this.canEditQuote, '当前状态不能删除报价')) return
      this.$confirm(`确认删除“${group.comparisonGroupName}”及其${group.itemCount}项、${group.supplierCount}家${this.quoteGroupPartyName(group)}报价？`, '提示', { type: 'warning' }).then(() => {
        removePurchaseComparisonGroup({ applyId: this.applyForm.id, comparisonGroupNo: group.comparisonGroupNo || group.key }).then(() => {
          this.msgSuccess('报价组已删除')
          this.refreshCurrentDetail()
        })
      }).catch(() => {})
    },
    handleQuoteWorkbookUpload(options) {
      const file = options && options.file
      if (!file) return
      const fileName = String(file.name || '').toLowerCase()
      if (!/\.xlsx?$/.test(fileName)) {
        this.msgWarning('请选择xls或xlsx报价文件')
        return
      }
      this.quoteImportLoading = true
      Promise.all([
        parsePurchaseQuoteWorkbook(file),
        uploadPurchaseApplySourceFile(file)
      ]).then(([response, uploadResponse]) => {
        const preview = response.data || response || {}
        const sourceFileInfo = uploadResponse.data || uploadResponse || {}
        const groups = preview.comparisonGroupList || []
        if (!groups.length) {
          this.msgWarning('报价表中没有可填入的报价组')
          return
        }
        this.clearQuoteImportQueue()
        this.quoteImportSourceFileInfo = sourceFileInfo
        this.quoteImportQueue = groups
        this.quoteImportDraftList = groups.map((group, index) => {
          const form = this.buildQuoteFormFromWorkbookGroup(group, index)
          const sourceSheetName = this.quoteImportGroupSheetName(group, index, preview, form)
          const sourceLayoutType = group.sourceLayoutType || group.layoutType || ''
          return {
            key: `workbook-group-${index}-${group.comparisonGroupNo || Date.now()}`,
            label: group.comparisonGroupName || `Sheet ${index + 1}`,
            sourceSheetName,
            sourceLayoutType,
            sheetKey: this.quoteImportGroupSheetKey(sourceSheetName, sourceLayoutType, index),
            form,
            saved: false
          }
        })
        this.quoteImportSheetList = this.buildQuoteImportSheetList(this.quoteImportDraftList)
        this.activateQuoteImportDraft(0)
        const duplicateWarnings = (preview.warningList || []).filter(message => String(message || '').includes('重复'))
        if (duplicateWarnings.length) {
          this.$message({ type: 'warning', showClose: true, duration: 8000, customClass: 'procurement-top-message', message: duplicateWarnings.join('；') })
        } else {
          this.msgSuccess(`已解析${this.quoteImportSheetList.length}个Sheet、${groups.length}个报价组，可在顶部按Sheet切换核对`)
        }
      }).finally(() => {
        this.quoteImportLoading = false
      })
    },
    workbookQuoteItemKey(item) {
      if (!item) return ''
      return item.itemGroupNo || [
        item.materialName,
        item.specification,
        item.parameterValue,
        item.materialQualityBrand,
        item.quantity,
        item.unit
      ].map(value => String(value || '').trim().toLowerCase()).join('|')
    },
    workbookSupplierBatchKey(supplier) {
      if (!supplier) return ''
      const platform = String(supplier.purchasePlatform || '').trim().replace(/\s+/g, ' ').toLowerCase()
      const supplierName = String(supplier.supplierName || '').trim().replace(/\s+/g, ' ').toLowerCase()
      if (platform && supplierName) return `name|${platform}|${supplierName}`
      if (supplier.supplierId) return `id|${supplier.supplierId}`
      return supplierName ? `name||${supplierName}` : ''
    },
    mergeWorkbookSupplierQuoteList(supplierQuoteList) {
      const supplierMap = new Map()
      ;(supplierQuoteList || []).forEach(sourceSupplier => {
        if (!sourceSupplier) return
        const key = this.workbookSupplierBatchKey(sourceSupplier)
        if (!key) return
        let target = supplierMap.get(key)
        if (!target) {
          target = Object.assign({}, sourceSupplier, {
            quoteList: [],
            itemList: [],
            finalTotalAmount: null
          })
          supplierMap.set(key, target)
        } else {
          if (!target.quoteGroupNo && sourceSupplier.quoteGroupNo) target.quoteGroupNo = sourceSupplier.quoteGroupNo
          if (!target.supplierId && sourceSupplier.supplierId) target.supplierId = sourceSupplier.supplierId
          if (!target.supplierName && sourceSupplier.supplierName) target.supplierName = sourceSupplier.supplierName
          if (!target.purchasePlatform && sourceSupplier.purchasePlatform) target.purchasePlatform = sourceSupplier.purchasePlatform
          if (!target.selectionReason && sourceSupplier.selectionReason) target.selectionReason = sourceSupplier.selectionReason
          if (!target.paymentCondition && sourceSupplier.paymentCondition) target.paymentCondition = sourceSupplier.paymentCondition
          if (!target.deliveryDays && sourceSupplier.deliveryDays) target.deliveryDays = sourceSupplier.deliveryDays
          if (!target.fileInfoList || !target.fileInfoList.length) target.fileInfoList = sourceSupplier.fileInfoList || []
          target.freightAmount = Math.max(this.positiveAmount(target.freightAmount), this.positiveAmount(sourceSupplier.freightAmount))
        }
        const sourceFinalTotal = this.referenceMoneyValue(sourceSupplier.finalTotalAmount)
        if (sourceFinalTotal !== null && sourceFinalTotal > 0) {
          const currentFinalTotal = this.referenceMoneyValue(target.finalTotalAmount) || 0
          target.finalTotalAmount = roundPurchaseMoney(currentFinalTotal + sourceFinalTotal)
        }
        const seenItemKeys = new Set((target.quoteList || []).map(row => this.workbookQuoteItemKey(row)))
        ;(sourceSupplier.quoteList || sourceSupplier.itemList || []).forEach(sourceItem => {
          const itemKey = this.workbookQuoteItemKey(sourceItem)
          if (!itemKey || seenItemKeys.has(itemKey)) return
          target.quoteList.push(sourceItem)
          seenItemKeys.add(itemKey)
        })
      })
      return Array.from(supplierMap.values())
    },
    buildQuoteFormFromWorkbookGroup(group, index = 0) {
      if (!group) return Object.assign(this.emptyQuoteForm(), { applyId: this.applyForm.id })
      const sourceSupplierList = this.mergeWorkbookSupplierQuoteList(group.supplierQuoteList || [])
      const itemMap = new Map()
      sourceSupplierList.forEach(supplier => {
        ;((supplier && (supplier.quoteList || supplier.itemList)) || []).forEach(source => {
          const key = this.workbookQuoteItemKey(source)
          if (!key || itemMap.has(key)) return
          itemMap.set(key, this.createQuoteLine({
            itemId: source.itemId || null,
            itemGroupNo: source.itemGroupNo || '',
            itemGroupName: source.itemGroupName || '',
            materialCode: source.materialCode || '',
            materialName: source.materialName || '',
            specification: source.specification || '',
            parameterValue: source.parameterValue || '',
            materialQualityBrand: source.materialQualityBrand || '',
            demandQuantity: source.demandQuantity,
            inventoryQuantity: source.inventoryQuantity,
            quantity: source.quantity,
            unit: source.unit || '',
            historyMinPrice: source.historyMinPrice,
            historyMaxPrice: source.historyMaxPrice,
            historyPriceSource: source.historyPriceSource || (source.historyMinPrice ? 'PURCHASER_INPUT' : ''),
            remark: source.remark || ''
          }))
        })
      })
      const itemList = Array.from(itemMap.values())
      const supplierList = sourceSupplierList.map(sourceSupplier => {
        const supplier = this.createComparisonSupplier({
          quoteGroupNo: sourceSupplier.quoteGroupNo || '',
          supplierId: sourceSupplier.supplierId || null,
          supplierName: sourceSupplier.supplierName || '',
          purchasePlatform: sourceSupplier.purchasePlatform || '',
          taxRate: sourceSupplier.taxRate,
          deliveryDays: sourceSupplier.deliveryDays,
          paymentCondition: sourceSupplier.paymentCondition || '',
          selectionReason: sourceSupplier.selectionReason || '',
          fileInfoList: sourceSupplier.fileInfoList || [],
          freightAmount: sourceSupplier.freightAmount,
          finalTotalAmount: sourceSupplier.finalTotalAmount
        })
        ;(sourceSupplier.quoteList || sourceSupplier.itemList || []).forEach(sourceItem => {
          const item = itemMap.get(this.workbookQuoteItemKey(sourceItem))
          if (item) {
            this.$set(supplier.priceMap, item._rowKey, sourceItem.quoteAmount)
            this.markSupplierItemOffer(supplier, item)
          }
          if (!this.positiveAmount(supplier.freightAmount) && this.positiveAmount(sourceItem && sourceItem.freightAmount)) {
            this.$set(supplier, 'freightAmount', sourceItem.freightAmount)
          }
        })
        const importedFinalTotal = this.referenceMoneyValue(sourceSupplier.finalTotalAmount)
        const detailTotal = this.comparisonSupplierDetailTotal(supplier, itemList)
        const hasImportedFinalTotal = sourceSupplier.finalTotalAmount !== undefined &&
          sourceSupplier.finalTotalAmount !== null && importedFinalTotal !== null
        this.$set(supplier, '_finalTotalManual',
          hasImportedFinalTotal && Math.abs(importedFinalTotal - detailTotal) >= 0.005)
        if (!hasImportedFinalTotal || !supplier._finalTotalManual) {
          this.syncComparisonSupplierAutoFinalTotal(supplier, itemList)
        } else {
          this.$set(supplier, 'finalTotalAmount', roundPurchaseMoney(importedFinalTotal))
        }
        return supplier
      })
      const recommendedSupplierIndex = sourceSupplierList.findIndex(supplier => {
        return Number(supplier.recommendedFlag || 0) === 1 ||
          (group.recommendedQuoteGroupNo && group.recommendedQuoteGroupNo === supplier.quoteGroupNo)
      })
      const recommendedSupplier = recommendedSupplierIndex >= 0 ? supplierList[recommendedSupplierIndex] : null
      const recommendedOfferMap = {}
      const recommendedReasonMap = {}
      itemList.forEach(item => {
        let recommendedReason = ''
        const recommendedIndex = sourceSupplierList.findIndex(sourceSupplier => {
          const sourceItems = sourceSupplier && (sourceSupplier.quoteList || sourceSupplier.itemList) || []
          const hasItem = sourceItems.some(sourceItem => this.workbookQuoteItemKey(sourceItem) === this.workbookQuoteItemKey(item))
          if (!hasItem) return false
          const recommendedLine = sourceItems.find(sourceItem => this.workbookQuoteItemKey(sourceItem) === this.workbookQuoteItemKey(item) &&
            Number(sourceItem.recommendedFlag || 0) === 1)
          if (recommendedLine && recommendedLine.recommendationReason) recommendedReason = recommendedLine.recommendationReason
          return Number(sourceSupplier.recommendedFlag || 0) === 1 ||
            (group.recommendedQuoteGroupNo && group.recommendedQuoteGroupNo === sourceSupplier.quoteGroupNo) ||
            !!recommendedLine
        })
        if (recommendedIndex >= 0 && supplierList[recommendedIndex]) {
          recommendedOfferMap[item._rowKey] = supplierList[recommendedIndex]._rowKey
          if (recommendedReason) recommendedReasonMap[item._rowKey] = recommendedReason
        }
      })
      const hasPlatformQuote = sourceSupplierList.some(supplier => {
        return String(supplier && supplier.purchasePlatform || '').trim()
      })
      const hasNoPlatformQuote = sourceSupplierList.some(supplier => {
        return !String(supplier && supplier.purchasePlatform || '').trim()
      })
      let purchaseMode = Number(group.purchaseMode || 0)
      if (![1, 2, 3].includes(purchaseMode)) purchaseMode = hasPlatformQuote ? 2 : 1
      if (hasPlatformQuote && hasNoPlatformQuote) purchaseMode = 3
      const editorLayoutMode = this.quoteEditorLayoutFromSource(group.sourceLayoutType || group.layoutType, 'supplier')
      const allItemsUseWholeRecommended = recommendedSupplier && itemList.length > 0 &&
        itemList.every(item => recommendedOfferMap[item._rowKey] === recommendedSupplier._rowKey)
      return Object.assign(this.emptyQuoteForm(), {
        applyId: this.applyForm.id,
        comparisonGroupNo: '',
        comparisonGroupName: group.comparisonGroupName || `报价组${index + 1}`,
        purchaseMode,
        editorLayoutMode,
        itemList,
        supplierList,
        recommendedSupplierKey: editorLayoutMode === 'supplier' && allItemsUseWholeRecommended ? recommendedSupplier._rowKey : '',
        recommendedOfferMap: editorLayoutMode === 'item' || !allItemsUseWholeRecommended ? recommendedOfferMap : {},
        recommendedReasonMap: editorLayoutMode === 'item' || !allItemsUseWholeRecommended ? recommendedReasonMap : {},
        recommendationReason: group.recommendationReason || ''
      })
    },
    quoteImportGroupSheetName(group, index, preview, form) {
      const sourceName = group.sourceSheetName || group.sheetName || group.sourceWorkbookSheetName
      if (sourceName) return sourceName
      if ((preview.comparisonGroupList || []).length === 1 && preview.sheetName) return preview.sheetName
      return group.comparisonGroupName || `Sheet ${index + 1}`
    },
    quoteImportGroupSheetKey(sheetName, layoutType, index) {
      const normalizedName = String(sheetName || `Sheet ${Number(index) + 1}`).trim().toLowerCase()
      const normalizedLayout = String(layoutType || '').trim().toLowerCase()
      return `${normalizedName}|${normalizedLayout || 'unknown'}`
    },
    buildQuoteImportSheetList(drafts) {
      const sheetMap = new Map()
      ;(drafts || []).forEach((draft, index) => {
        const sheetKey = draft.sheetKey || this.quoteImportGroupSheetKey(draft.sourceSheetName, draft.sourceLayoutType, index)
        if (!sheetMap.has(sheetKey)) {
          sheetMap.set(sheetKey, {
            key: sheetKey,
            label: draft.sourceSheetName || draft.label || `Sheet ${index + 1}`,
            ecommerce: false,
            mixed: false,
            purchaseMode: 1,
            draftIndexes: [],
            saved: false
          })
        }
        const sheet = sheetMap.get(sheetKey)
        sheet.draftIndexes.push(index)
        const draftMode = this.quoteImportDraftMode(draft)
        if (draftMode === 3) {
          sheet.mixed = true
          sheet.purchaseMode = 3
        } else if (draftMode === 2 && sheet.purchaseMode !== 3) {
          sheet.ecommerce = true
          sheet.purchaseMode = 2
        }
      })
      const sheets = Array.from(sheetMap.values())
      this.refreshQuoteImportSheetStatus(sheets)
      return sheets
    },
    refreshQuoteImportSheetStatus(targetSheets) {
      const sheets = targetSheets || this.quoteImportSheetList || []
      sheets.forEach(sheet => {
        const saved = (sheet.draftIndexes || []).length > 0 &&
          sheet.draftIndexes.every(index => this.quoteImportDraftList[index] && this.quoteImportDraftList[index].saved)
        this.$set(sheet, 'saved', saved)
      })
    },
    activateQuoteImportSheet(sheet) {
      if (!sheet || sheet.saved) return
      const indexes = sheet.draftIndexes || []
      const draftIndex = indexes.find(index => this.quoteImportDraftList[index] && !this.quoteImportDraftList[index].saved)
      if (draftIndex >= 0) this.activateQuoteImportDraft(draftIndex)
    },
    activateQuoteImportDraft(index) {
      const draftIndex = Number(index)
      const draft = this.quoteImportDraftList[draftIndex]
      if (!draft || draft.saved) return
      this.uploadRenderKey += 1
      this.quoteImportQueueIndex = draftIndex
      this.quoteImportActiveKey = String(draftIndex)
      const activeSheet = (this.quoteImportSheetList || []).find(sheet => {
        return (sheet.draftIndexes || []).indexOf(draftIndex) >= 0
      })
      this.quoteImportActiveSheetKey = activeSheet ? activeSheet.key : ''
      this.quoteForm = draft.form
      this.quoteDialogRow = null
      this.quoteDialogTitle = this.quoteImportDraftList.length > 1
        ? `核对导入报价组（${draftIndex + 1}/${this.quoteImportDraftList.length}）`
        : '核对导入报价组'
      this.quoteDialogOpen = true
      this.$nextTick(() => this.resolveQuoteSupplierLinks())
    },
    isQuoteImportDraftEcommerce(draft) {
      return this.quoteImportDraftMode(draft) === 2
    },
    isQuoteImportDraftMixed(draft) {
      return this.quoteImportDraftMode(draft) === 3
    },
    quoteImportDraftMode(draft) {
      const mode = Number(draft && draft.form && draft.form.purchaseMode || 1)
      return [1, 2, 3].includes(mode) ? mode : 1
    },
    quoteImportModeName(mode) {
      if (Number(mode) === 2) return '电商平台店铺'
      if (Number(mode) === 3) return '混合报价'
      return '普通供应商'
    },
    quoteImportSheetTitle(sheet, index) {
      const sheetName = sheet && sheet.label ? sheet.label : `Sheet ${Number(index) + 1}`
      const modeName = this.quoteImportModeName(sheet && sheet.purchaseMode)
      const countText = sheet && sheet.draftIndexes && sheet.draftIndexes.length > 1
        ? `，${sheet.draftIndexes.length}个子报价组` : ''
      const savedText = sheet && sheet.saved ? '（已保存）' : ''
      return `${Number(index) + 1}. ${sheetName}（${modeName}${countText}）${savedText}`
    },
    quoteImportDraftTitle(draft, index) {
      const groupName = draft && draft.label ? draft.label : `报价组${Number(index) + 1}`
      const modeName = this.quoteImportModeName(this.quoteImportDraftMode(draft))
      const savedText = draft && draft.saved ? '（已保存）' : ''
      return `${Number(index) + 1}. ${groupName}（${modeName}）${savedText}`
    },
    handleQuoteImportSelectChange(index) {
      this.activateQuoteImportDraft(Number(index))
    },
    switchQuoteImportDraft(direction) {
      const drafts = this.quoteImportDraftList || []
      if (drafts.length <= 1) return
      const step = Number(direction) < 0 ? -1 : 1
      let index = this.quoteImportQueueIndex + step
      while (index >= 0 && index < drafts.length) {
        if (!drafts[index].saved) {
          this.activateQuoteImportDraft(index)
          return
        }
        index += step
      }
      this.msgWarning(step < 0 ? '已经是第一个待核对报价组' : '已经是最后一个待核对报价组')
    },
    nextUnsavedQuoteImportDraftIndex(currentIndex) {
      const drafts = this.quoteImportDraftList || []
      for (let index = currentIndex + 1; index < drafts.length; index++) {
        if (!drafts[index].saved) return index
      }
      for (let index = 0; index < currentIndex; index++) {
        if (!drafts[index].saved) return index
      }
      return -1
    },
    clearQuoteImportQueue() {
      this.quoteImportQueue = []
      this.quoteImportQueueIndex = -1
      this.quoteImportDraftList = []
      this.quoteImportSheetList = []
      this.quoteImportActiveSheetKey = ''
      this.quoteImportActiveKey = '0'
      this.quoteImportSourceFileInfo = null
    },
    cancelQuoteEditing() {
      this.clearQuoteImportQueue()
      this.quoteDialogOpen = false
      this.quoteDialogRow = null
    },
    handleQuoteDialogClosed() {
      if (this.quoteImportQueueIndex >= 0) this.clearQuoteImportQueue()
    },
    handlePurchaseApprovalSuccess() {
      const wasInquiry = this.isPurchaseInquiryApprovalNode
      this.refreshCurrentDetail().then(() => {
        if (wasInquiry) {
          this.detailTab = this.shouldShowDetailTab('quote') ? 'quote' : 'basic'
          this.startDecisionAnalysisPolling()
          return
        }
        this.detailTab = this.shouldShowDetailTab('order') ? 'order' : 'basic'
      })
    },
    handlePurchaseApprovalUpdate() {
      this.refreshCurrentDetail()
    },
    paymentPlanStatus(row) {
      return Number(row && row.status ? row.status : 20)
    },
    canRegisterPaymentPlan(row) {
      if (!row || !row.id) return this.canRegisterPayment
      return this.canRegisterPayment && [40, 50].includes(this.paymentPlanStatus(row)) && Number(row && row.financeAuditStatus) === 20
    },
    canSupplementInvoicePlan(row) {
      if (!this.canRegisterPayment || !row || !row.id) return false
      const status = this.paymentPlanStatus(row)
      const paidAmount = Number(row.paidAmount || 0)
      const hasInvoice = Array.isArray(row.invoiceFileList) && row.invoiceFileList.length > 0
      return [50, 60].includes(status) && paidAmount > 0 && !hasInvoice
    },
    paymentPlanActionText(row) {
      const status = this.paymentPlanStatus(row)
      if ([10, 20].includes(status)) return '随审批通过确认'
      if (status === 40) return Number(row && row.financeAuditStatus) === 20 ? '待付款' : '待确认'
      if (status === 50) return '部分付款'
      if (status === 60) return row && row.invoiceFileList && row.invoiceFileList.length ? '已付清' : '缺发票'
      if (status === 90) return '已取消'
      return '-'
    },
    recordFileList(row, keys) {
      if (!row) return []
      for (const key of keys) {
        if (Array.isArray(row[key])) return row[key]
      }
      return []
    },
    hasPaymentPlanRecord(row) {
      if (!row) return false
      return Number(row.paidAmount || 0) > 0 ||
        Boolean(row.paymentTime || row.supplierAccountInfo || row.duplicateCheckRemark) ||
        this.recordFileList(row, ['paymentVoucherFileList', 'paymentVoucherFileObjs', 'voucherFileList', 'paymentFileList']).length > 0 ||
        this.recordFileList(row, ['invoiceFileList', 'invoiceFileObjs']).length > 0
    },
    paymentDetailCheckText(row) {
      if (!row) return '-'
      const paid = Number(row.paidAmount || 0)
      const unpaid = Number(row.unpaidAmount || 0)
      if (paid > 0 && unpaid <= 0) {
        return '本节点已付清，未付金额为0；再次付款前需重新核对合同和历史付款记录。'
      }
      if (unpaid > 0) {
        return row.duplicateCheckRemark || `本节点仍有未付 ${this.money(unpaid)}，付款前请核对合同、收款账户和历史付款记录。`
      }
      return row.duplicateCheckRemark || '-'
    },
    openPaymentDetail(row) {
      if (!row) return
      this.uploadRenderKey += 1
      this.paymentDetailPlan = Object.assign({}, row, {
        paymentVoucherFileList: this.recordFileList(row, ['paymentVoucherFileList', 'paymentVoucherFileObjs', 'voucherFileList', 'paymentFileList']),
        invoiceFileList: this.recordFileList(row, ['invoiceFileList', 'invoiceFileObjs'])
      })
      this.paymentDetailOpen = true
    },
    arrivalRecordForDetail(row) {
      if (!row) return {}
      const latestRecord = row.latestRecord || row
      const item = row.item || {}
      return Object.assign({}, latestRecord, {
        materialName: latestRecord.materialName || item.materialName || row.materialName,
        specification: latestRecord.specification || item.specification || row.specification,
        quantity: latestRecord.quantity !== undefined && latestRecord.quantity !== null ? latestRecord.quantity : row.totalQuantity,
        arrivedQuantity: latestRecord.arrivedQuantity !== undefined && latestRecord.arrivedQuantity !== null ? latestRecord.arrivedQuantity : row.arrivedQuantity,
        unarrivedQuantity: latestRecord.unarrivedQuantity !== undefined && latestRecord.unarrivedQuantity !== null ? latestRecord.unarrivedQuantity : row.remainingQuantity,
        fileInfoList: this.recordFileList(latestRecord, ['fileInfoList', 'attachmentFileList', 'arrivalFileList'])
      })
    },
    openArrivalDetail(row) {
      if (!row) return
      this.uploadRenderKey += 1
      this.arrivalDetailRecord = Object.assign({}, row, {
        fileInfoList: this.recordFileList(row, ['fileInfoList', 'attachmentFileList', 'arrivalFileList'])
      })
      this.arrivalDetailOpen = true
    },
    openRegisterPayment(row) {
      if (!this.ensureWorkflowEditable(this.canRegisterPayment, '采购审批通过后才能登记付款')) return
      const unpaidAmount = Number(this.applyForm.unpaidAmount || this.detailUnpaidAmount || 0)
      const payableAmount = Number(this.applyForm.applyAmount || this.totalApplyAmount || 0)
      this.uploadRenderKey += 1
      this.currentPaymentPlan = {
        nodeName: '付款记录',
        payableAmount,
        unpaidAmount
      }
      this.paymentActionForm = Object.assign(this.emptyPaymentActionForm(), {
        applyId: this.applyForm.id,
        paymentPlanId: null,
        paidAmount: unpaidAmount > 0 ? unpaidAmount : payableAmount,
        paymentTime: this.currentDateTimeValue(),
        supplierAccountInfo: '',
        duplicateCheckRemark: ''
      })
      this.paymentActionOpen = true
    },
    editPaymentRecord(row) {
      if (!this.ensureWorkflowEditable(this.canRegisterPayment, '当前状态不能编辑付款记录')) return
      this.uploadRenderKey += 1
      this.currentPaymentPlan = row
      this.paymentActionForm = Object.assign(this.emptyPaymentActionForm(), {
        applyId: this.applyForm.id,
        paymentPlanId: row.id,
        paidAmount: Number(row.paidAmount || 0),
        paymentTime: row.paymentTime || this.currentDateTimeValue(),
        supplierAccountInfo: row.supplierAccountInfo || '',
        duplicateCheckRemark: row.duplicateCheckRemark || row.remark || '',
        paymentVoucherFileList: this.recordFileList(row, ['paymentVoucherFileList', 'paymentVoucherFileObjs', 'voucherFileList', 'paymentFileList'])
      })
      this.paymentActionOpen = true
    },
    deletePaymentRecord(row) {
      if (!this.ensureWorkflowEditable(this.canRegisterPayment, '当前状态不能删除付款记录')) return
      if (!row || !row.id) return
      this.$confirm(`确认删除付款记录 ${this.money(row.paidAmount)}？删除后采购单已付金额会重新计算。`, '删除付款记录', { type: 'warning' }).then(() => {
        return removePurchasePayment(row.id)
      }).then(res => {
        this.msgSuccess('付款记录已删除')
        this.fillDetail(res.data || {})
        this.detailTab = 'payment'
        this.loadApplyData()
      }).catch(() => {})
    },
    validatePaymentRegisterForm() {
      const form = this.paymentActionForm || {}
      if (!form.paidAmount || Number(form.paidAmount) <= 0) {
        this.msgWarning('本次付款金额必须大于0')
        return false
      }
      return true
    },
    registerPayment() {
      if (!this.ensureWorkflowEditable(this.canRegisterPayment, '采购审批通过后才能登记付款')) return
      if (!this.validatePaymentRegisterForm()) return
      registerPurchasePayment(this.paymentActionForm).then(res => {
        this.msgSuccess(this.paymentActionForm.paymentPlanId ? '付款记录已更新' : '付款记录已添加')
        this.paymentActionOpen = false
        this.fillDetail(res.data || {})
        this.detailTab = 'payment'
        this.loadApplyData()
      })
    },
    startArrivalRecordEdit(row) {
      if (!this.ensureWorkflowEditable(this.canEditExistingArrival, '当前状态不能编辑到货验收记录')) return
      this.uploadRenderKey += 1
      const record = this.arrivalRecordForDetail(row)
      this.arrivalDetailOpen = false
      this.arrivalForm = Object.assign(this.emptyArrivalForm(), record, {
        applyId: this.applyForm.id,
        arrivalDate: this.formatDateValue(record.arrivalDate),
        fileInfoList: record.fileInfoList || []
      })
      this.arrivalEditingExisting = true
      this.$nextTick(() => {
        if (this.$refs.arrivalEditor && this.$refs.arrivalEditor.scrollIntoView) {
          this.$refs.arrivalEditor.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },
    cancelArrivalEditing() {
      this.arrivalEditingExisting = false
      this.arrivalForm = Object.assign(this.emptyArrivalForm(), { applyId: this.applyForm.id })
    },
    validateArrivalForm() {
      const form = this.arrivalForm || {}
      if (!form.materialName) {
        this.msgWarning('请填写到货物料')
        return false
      }
      if (!form.quantity || Number(form.quantity) <= 0) {
        this.msgWarning('应到数量必须大于0')
        return false
      }
      if (form.arrivedQuantity === undefined || form.arrivedQuantity === null || Number(form.arrivedQuantity) < 0) {
        this.msgWarning('请填写正确的到货数量')
        return false
      }
      if (Number(form.arrivedQuantity) > Number(form.quantity) && !form.issueDescription) {
        this.msgWarning('超收到货时请填写问题说明')
        return false
      }
      if (this.inferArrivalStatusCode(form) === 40 && !form.issueDescription) {
        this.msgWarning('到货异常或质量评分偏低时请填写问题说明')
        return false
      }
      return true
    },
    inferArrivalStatusCode(form) {
      const data = form || {}
      const quantity = Number(data.quantity || 0)
      const arrived = Number(data.arrivedQuantity || 0)
      const qualityScore = data.qualityScore === undefined || data.qualityScore === null || data.qualityScore === '' ? 100 : Number(data.qualityScore)
      if (qualityScore < 60 || Number(data.status) === 40) return 40
      if (arrived <= 0) return 10
      if (quantity > 0 && arrived >= quantity) return 50
      return 20
    },
    prepareArrivalBeforeSave() {
      const form = this.arrivalForm || {}
      const quantity = Number(form.quantity || 0)
      const arrived = Number(form.arrivedQuantity || 0)
      this.$set(this.arrivalForm, 'unarrivedQuantity', Math.max(quantity - arrived, 0))
      this.$set(this.arrivalForm, 'status', this.inferArrivalStatusCode(form))
    },
    saveArrival() {
      if (!this.ensureWorkflowEditable(this.canEditArrivalForm, '当前状态不能保存到货验收记录')) return
      if (!this.applyForm.id) return
      this.prepareArrivalBeforeSave()
      if (!this.validateArrivalForm()) return
      savePurchaseArrival(Object.assign({}, this.arrivalForm, { applyId: this.applyForm.id })).then(() => {
        this.msgSuccess(this.arrivalEditingExisting ? '到货验收已更新' : '到货验收已保存')
        this.arrivalEditingExisting = false
        this.arrivalForm = Object.assign(this.emptyArrivalForm(), { applyId: this.applyForm.id })
        this.refreshCurrentDetail()
      })
    },
    handleAddSupplier() {
      this.supplierMaintenanceOfferKey = ''
      this.supplierDialogTitle = '新增供应商'
      this.supplierForm = this.emptySupplierForm()
      this.supplierDialogOpen = true
      this.$nextTick(() => {
        if (this.$refs.supplierForm) this.$refs.supplierForm.clearValidate()
      })
    },
    handleEditSupplier(row) {
      this.supplierMaintenanceOfferKey = ''
      this.supplierDialogTitle = `供应商：${row.supplierName}`
      this.supplierForm = Object.assign(this.emptySupplierForm(), row)
      this.supplierDialogOpen = true
    },
    saveSupplier() {
      this.$refs.supplierForm.validate(valid => {
        if (!valid) return
        const pendingOfferKey = this.supplierMaintenanceOfferKey
        const savedForm = Object.assign({}, this.supplierForm)
        const savedKeyword = savedForm.supplierName || savedForm.shortName || savedForm.aliases || ''
        savePurchaseSupplier(this.supplierForm).then(res => {
          const responseData = res && res.data
          const savedId = savedForm.id ||
            (responseData && typeof responseData === 'object' ? responseData.id : responseData) ||
            null
          this.msgSuccess('供应商已保存')
          this.supplierDialogOpen = false
          this.supplierMaintenanceOfferKey = ''
          return Promise.all([
            this.getSupplierList(),
            listPurchaseSupplier({
              keyword: savedKeyword,
              status: 1,
              pageNum: 1,
              pageSize: 20
            })
          ]).then(results => {
            const rows = this.responseRows(results[1])
            this.mergeSupplierReferences(rows)
            const supplier = (this.supplierOptions || []).find(item => savedId && String(item.id) === String(savedId)) ||
              rows.find(item => this.normalizeReferenceName(item.supplierName) === this.normalizeReferenceName(savedForm.supplierName))
            if (supplier) this.syncQuoteSupplierReference(supplier, pendingOfferKey)
          })
        })
      })
    },
    handleRemoveSupplier(row) {
      this.$confirm(`确认删除供应商 ${row.supplierName}？`, '提示', { type: 'warning' }).then(() => {
        removePurchaseSupplier(row.id).then(() => {
          this.msgSuccess('供应商已删除')
          this.getSupplierList()
        })
      }).catch(() => {})
    },
    purchaseTypeText(value) {
      const item = (this.purchaseTypeOptions || []).find(opt => Number(opt.value) === Number(value))
      return item ? item.label : '-'
    },
    purchaseOwnerRoleText(value) {
      if (Number(value) === 2) return '项目采购员'
      if (Number(value) === 7) return '项目采购员或非项目采购员'
      return '非项目采购员'
    },
    requiresPurchaseOwnerClaim(row) {
      return false
    },
    purchaseOwnerFieldLabel(row) {
      return row && row.purchaseOwnerName ? '实际采购执行人' : '采购办理'
    },
    purchaseOwnerDisplayText(row) {
      if (row && row.purchaseOwnerName) return row.purchaseOwnerName
      if (row && Number(row.documentType || 1) === 1 && Number(row.purchaseType) === 7) {
        return '两名询价候选人协同办理'
      }
      if (row && Number(row.documentType || 1) === 1) {
        return `${this.purchaseOwnerRoleText(row.purchaseType)}团队协同办理`
      }
      return '-'
    },
    sourceModeText(value) {
      const map = { 1: '手动创建', 2: 'AI录入', 3: '履约需求生成', 4: '零星采购', 5: 'Excel需求清单', 6: '仅附件申请' }
      return map[Number(value)] || '-'
    },
    isContractStepComplete(row) {
      if (Number(row && row.documentType || 1) === 2) return true
      return Number(row && row.contractMode || 1) === 2 || [40, 50].includes(Number(row && row.contractStatus || 10))
    },
    isLegacyContractEntryComplete(row) {
      if (!row || Number(row.documentType || 1) !== 2 || !row.parentApplyId || !row.createTime) return false
      const contractReady = Number(row.contractMode || 1) === 2 || Number(row.contractStatus || 10) === 40
      const neverEnteredSealFlow = Number(row.contractSealStatus || 10) === 10 &&
        !row.contractSealBatchId && !row.contractSealWorkOrderId
      const rawCreateTime = String(row.createTime)
      const normalizedCreateTime = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(rawCreateTime)
        ? `${rawCreateTime.replace(' ', 'T')}+08:00` : rawCreateTime
      const createTime = new Date(normalizedCreateTime).getTime()
      const sealGoLiveTime = Date.parse('2026-08-11T10:31:41+08:00')
      return contractReady && neverEnteredSealFlow && Number.isFinite(createTime) && createTime < sealGoLiveTime
    },
    isContractSealComplete(row) {
      return Number(row && row.contractSealStatus || 10) === 40 || this.isLegacyContractEntryComplete(row)
    },
    shipmentMethodText(value) {
      const map = { 1: '快递/物流', 2: '供应商送货', 3: '采购自提', 4: '其他' }
      return map[Number(value)] || '-'
    },
    shipmentStatusText(value) {
      const map = { 10: '未发货', 20: '部分发货', 30: '全部发货' }
      return map[Number(value)] || '-'
    },
    statusText(value) {
      const item = this.statusOptions.find(opt => Number(opt.value) === Number(value))
      return item ? item.label : '-'
    },
    workOrderStatusText(value) {
      const map = { 1: '审批中', 2: '已通过', 3: '已驳回', 4: '已取消', 5: '线下已结束' }
      return map[Number(value)] || '-'
    },
    workOrderStatusTag(value) {
      const status = Number(value)
      if (status === 2) return 'success'
      if (status === 5) return 'info'
      if (status === 3 || status === 4) return 'danger'
      return 'warning'
    },
    currentApprovalNodeText(workOrder) {
      const status = Number(workOrder && workOrder.status)
      if ([2, 3, 4, 5].includes(status)) {
        return workOrder.statusStr || this.workOrderStatusText(status)
      }
      const waitRecords = ((workOrder && workOrder.approvalRecordDtoList) || [])
        .filter(record => Number(record.operationType) === 4)
      if (!waitRecords.length) return workOrder ? (workOrder.statusStr || this.workOrderStatusText(workOrder.status)) : '-'
      return waitRecords.map(record => {
        const users = this.formatWorkOrderRecordUsers(record)
        const taskName = record.taskName === '采购员修改询价' ? '采购员询价' : record.taskName
        return [taskName, users].filter(Boolean).join('：')
      }).join('；')
    },
    purchaseApprovalStageInstruction(taskName) {
      const name = String(taskName || '')
      if (!name) return ''
      if (name === '总经理定商') return '普通报价组选择最终供应商；电商报价按每个采购项选择最终店铺。'
      if (name === '采购员完成采购') return '供应商已确定，当前正在采购中；可根据实际采购进度灵活确认完成，未完成的供应商采购单仍可继续办理。'
      if (name === '财务总监审批') return '在采购员询价前核对采购必要性、预算金额及财务风险，确认是否同意进入询价。'
      if (name === '采购员询价') return '按报价组录入供应商报价，推荐供应商时可填写理由。'
      if (name === '采购员修改询价') return '修改供应商报价和推荐结论，完成后在审批流程中点击“完成询价”。'
      if (name === '总经理采购审批' || /总经理.*采购/.test(name)) return '确认是否同意本次采购。'
      if (name === '技术负责人审批' || /技术负责人/.test(name)) return '确认项目采购的规格型号和技术要求。'
      if (name === '仓管员确认' || /仓管/.test(name)) return '核对库存，确认是否需要采购及数量。'
      if (name === '部门负责人审批' || /直属上级|部门负责人|上级领导/.test(name)) {
        return '确认采购是否必要，数量和申请金额是否合理。'
      }
      return ''
    },
    currentPurchaseApprovalInstruction(workOrder) {
      if (!workOrder || Number(workOrder.status) !== 1) return ''
      const currentRecord = ((workOrder.approvalRecordDtoList || [])
        .find(record => Number(record.operationType) === 4))
      return this.purchaseApprovalStageInstruction(workOrder.currentTaskName || (currentRecord && currentRecord.taskName))
    },
    currentApprovalRoleName() {
      const workOrder = this.detail && this.detail.approvalWorkOrder
      const status = Number(workOrder && workOrder.status)
      if ([2, 3, 4, 5].includes(status)) return { key: 'default', label: '流程' }
      const nodeText = this.currentApprovalNodeText(workOrder)
      if (/仓管/.test(nodeText)) return { key: 'warehouse', label: '仓管员' }
      if (/创新|技术/.test(nodeText)) return { key: 'technical', label: '技术负责人' }
      if (/财务总监/.test(nodeText)) return { key: 'finance', label: '财务总监' }
      if (/总经理|总裁|老板|周总/.test(nodeText)) return { key: 'manager', label: '总经理' }
      if (/部门|主管|上级|负责人/.test(nodeText)) return { key: 'department', label: '部门负责人' }
      return { key: 'default', label: '当前节点' }
    },
    approvalWorkOrderHint(workOrder) {
      const status = Number(workOrder && workOrder.status)
      if (status === 2) return '审批流程已完成'
      if (status === 3) return '审批已退回'
      if (status === 4) return '审批已撤回'
      if (status === 5) return '采购流程线下已结束'
      const applyStatus = Number(this.applyForm && this.applyForm.status)
      if ([40, 50, 60, 70, 80, 90, 100, 110].includes(applyStatus)) return '审批流程已完成'
      return Number(workOrder && workOrder.hasAuth || 0) === 1 ? '当前账号可审批' : '等待当前节点审批'
    },
    formatWorkOrderRecordUsers(record) {
      const users = (record && record.userList) || []
      return users.map(user => user.userName || user.nickName || user.userId).filter(Boolean).join('、') || '-'
    },
    businessStatusText(rowOrStatus) {
      const row = typeof rowOrStatus === 'object' ? (rowOrStatus || {}) : { status: rowOrStatus }
      const status = Number(row.status || 10)
      const documentType = Number(row.documentType || 1)
      const splitStatus = Number(row.splitStatus || 10)
      if (documentType === 2 && this.isSupplierOrderLogicallyComplete(row)) return '已完成'
      if (documentType === 1 && this.isApplicationDetail && this.applyForm && String(row.id || '') === String(this.applyForm.id || '') && this.applicationSupplierOrdersComplete) return '已完成'
      if (status === 10) return '草稿待提交'
      if (status === 20) return '审批中'
      if (status === 30) return '退回待修改'
      if (documentType === 1 && status === 40) return splitStatus === 20 ? '已定商，采购中' : '待确认供应商'
      if (status === 40) return '审批已通过'
      if (status === 50) {
        const paymentStatus = Number(row.paymentStatus || 10)
        if (paymentStatus === 10) return '未到付款日'
        if (paymentStatus === 20) return '待付款'
        return '待付款'
      }
      if (status === 60) {
        const paymentStatus = Number(row.paymentStatus || 10)
        if (paymentStatus === 10) return '未到付款日'
        if (paymentStatus === 20) return '待付款'
        return '待付款'
      }
      if (status === 70) return '部分付款待补齐'
      if (status === 80) return '待到货验收'
      if (status === 90) {
        const arrivalStatus = Number(row.arrivalStatus || 10)
        if ([30, 50].includes(arrivalStatus)) return '待完成确认'
        return '待到货验收'
      }
      if (status === 100) return '部分到货待补齐'
      if (status === 110) return '已完成'
      if (status === 120) return '已作废'
      if (status === 115) return '线下已结束'
      return this.statusText(status)
    },
    businessStatusTag(rowOrStatus) {
      const row = typeof rowOrStatus === 'object' ? (rowOrStatus || {}) : { status: rowOrStatus }
      const status = Number(row.status || 10)
      if (this.isSupplierOrderLogicallyComplete(row)) return 'success'
      if (Number(row.documentType || 1) === 1 && this.isApplicationDetail && this.applyForm && String(row.id || '') === String(this.applyForm.id || '') && this.applicationSupplierOrdersComplete) return 'success'
      if ([20, 40, 50, 60, 70, 80, 90, 100].includes(status)) return 'warning'
      if (status === 110) return 'success'
      if (status === 120) return 'info'
      if (status === 115) return 'info'
      if (status === 30) return 'danger'
      return ''
    },
    statusTag(value) {
      const status = Number(value)
      if ([20, 50, 60, 90, 100].includes(status)) return 'warning'
      if ([40, 80, 110].includes(status)) return 'success'
      if (status === 120) return 'info'
      if (status === 30) return 'danger'
      return ''
    },
    contractStatusText(value) {
      const map = { 10: '暂无合同资料', 20: '合同识别中', 30: '合同待确认', 40: '合同已确认', 50: '无需合同', 90: '识别失败' }
      return map[Number(value)] || '-'
    },
    paymentStatusText(value) {
      const map = { 10: '未到付款日', 20: '待付款', 40: '待付款', 50: '已付款', 60: '部分付款', 90: '已取消' }
      return map[Number(value)] || '-'
    },
    planStatusText(value) {
      const map = { 10: '未到付款日', 20: '待付款', 40: '待付款', 50: '部分付款', 60: '已付款', 90: '已取消' }
      return map[Number(value)] || '-'
    },
    financeStatusText(value) {
      const map = { 10: '待登记付款', 20: '可登记付款', 30: '付款信息需补充' }
      return map[Number(value)] || '-'
    },
    arrivalStatusText(value) {
      const map = { 10: '还未到货', 20: '部分到货', 30: '全部到货待验收', 40: '到货异常', 50: '已验收' }
      return map[Number(value)] || '-'
    },
    arrivalRecordStatusText(record) {
      if (!record) return '-'
      if (this.arrivalRecordIsAbnormal(record)) return '到货异常'
      const quantity = Number(record.quantity || 0)
      const arrived = Number(record.arrivedQuantity || 0)
      if (arrived <= 0) return '还未到货'
      if (quantity > 0 && arrived < quantity) return '部分到货'
      if (Number(record.status) === 50) return '已验收'
      if (quantity > 0 && arrived >= quantity) return '全部到货'
      return this.arrivalStatusText(record.status)
    },
    invoiceStatusText(value) {
      const map = { 10: '发票未上传', 20: '发票部分上传', 30: '发票已齐全' }
      return map[Number(value)] || '-'
    },
    workbenchMoney(value) {
      return value === null || value === undefined ? '—' : this.money(value)
    },
    money(value) {
      const num = Number(value || 0)
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    },
    unitPriceText(value) {
      if (value === null || value === undefined || value === '') return '-'
      const num = Number(value)
      if (!Number.isFinite(num)) return '-'
      if (num === 0) return '---'
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 3, maximumFractionDigits: 3 })
    },
    applicationAmountText(row) {
      const amount = Number(row && row.applyAmount || 0)
      if (amount <= 0) return '---'
      return this.money(amount)
    },
    numberText(value) {
      if (value === null || value === undefined || value === '') return '-'
      return Number(value).toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    isHistoricalPrice(row) {
      return String(row && row.applyNo || '').indexOf('HISCG') === 0
    }
  }
}
</script>

<style lang="scss" scoped>
.procurement-page {
  min-height: calc(100vh - 84px);
  background: transparent;

  .procurement-shell {
    display: block;
  }

  .procurement-sidebar {
    position: static;
    display: grid;
    gap: 6px;
    padding: 12px;
    border: 1px solid #d9e1e8;
    border-radius: 6px;
    background: #fff;
  }

  .sidebar-title {
    padding: 4px 4px 10px;
    border-bottom: 1px solid #eef1f4;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 16px;
      line-height: 24px;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .procurement-workspace {
    min-width: 0;
  }

  .procurement-nav-strip {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #d9e1e8;
    border-radius: 6px;
    background: #fff;
  }

  .procurement-nav-groups {
    display: grid;
    gap: 8px;
  }

  .procurement-nav-group {
    display: grid;
    grid-template-columns: 54px minmax(0, 1fr);
    gap: 8px;
    align-items: center;

    > em {
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
      text-align: right;
    }
  }

  .procurement-nav-items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
    gap: 8px;
    min-width: 0;
  }

  .procurement-nav-item {
    position: relative;
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr) auto;
    gap: 8px;
    align-items: center;
    min-width: 0;
    min-height: 38px;
    padding: 7px 10px;
    border: 1px solid #dfe5eb;
    border-radius: 6px;
    background: #fbfcfd;
    color: #303133;
    text-align: left;
    cursor: pointer;
    transition: border-color .18s ease, background .18s ease, box-shadow .18s ease, transform .18s ease;

    &:hover {
      border-color: #409eff;
      box-shadow: 0 6px 14px rgba(64, 158, 255, .1);
      transform: translateY(-1px);
    }

    &.active {
      border-color: #409eff;
      background: #ecf5ff;
      box-shadow: inset 3px 0 0 #409eff;

      i {
        background: #409eff;
        color: #fff;
      }

      span,
      strong {
        color: #1f4e79;
      }
    }

    i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 7px;
      background: #eef3f8;
      color: #409eff;
      font-size: 14px;
    }

    span {
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      min-width: 18px;
      color: #8a94a2;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      text-align: right;
    }
  }

  .workbench-scope-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    strong { display: block; color: #303f50; font-size: 20px; }
    span { display: block; margin-top: 6px; color: #8390a3; font-size: 13px; }
  }
  .procurement-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
    margin-bottom: 10px;
  }

  .stat-tile {
    min-width: 0;
    min-height: 70px;
    padding: 13px 16px 12px;
    border: 1px solid #dfe5eb;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    cursor: pointer;
    transition: border-color .18s ease, background .18s ease;

    &:hover {
      border-color: #409eff;
      background: #f5f9ff;
    }

    span {
      display: block;
      color: #6b7785;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      display: block;
      margin-top: 8px;
      color: #1f2d3d;
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .procurement-board {
    min-height: calc(100vh - 188px);
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  .board-pane {
    min-width: 0;
  }

  .filter-strip {
    margin-bottom: 10px;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  .filter-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .table-toolbar {
    margin-bottom: 8px;
  }

  .table-toolbar__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .purchase-cell,
  .compact-cell,
  .amount-cell {
    display: grid;
    gap: 3px;
    min-width: 0;

    strong,
    em {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
    }

    em {
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
    }
  }

  .status-stack {
    display: grid;
    justify-items: center;
    gap: 6px;

    span {
      color: #4d5967;
      font-size: 13px;
      line-height: 18px;
    }
  }

  .amount-cell {
    justify-items: end;
  }

  .compact-cell.center {
    justify-items: center;
    text-align: center;
  }

  .purchase-type-status {
    width: 100%;
  }

  .purchase-type-status__name {
    max-width: 100%;
    white-space: normal !important;
    word-break: break-word;
    overflow: visible !important;
    text-overflow: clip !important;
    line-height: 18px !important;
  }

  .compact-cell.right {
    justify-items: end;
    text-align: right;
  }

  .progress-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    line-height: 1;
  }

  .row-inline-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    white-space: nowrap;

    .el-button {
      margin: 0;
    }
  }

  .table-empty-action {
    color: #c0c4cc;
  }

  .inline-row-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .el-button {
      margin: 0;
    }
  }

  .payment-record-actions {
    gap: 14px;
  }

  .arrival-record-actions {
    gap: 12px;
  }

  .arrival-edit-text-button {
    padding: 0;
    border: 0;
    background: transparent;
    color: #409eff;
    font: inherit;
    line-height: 1;
    cursor: pointer;

    &:hover,
    &:focus {
      color: #66b1ff;
      outline: none;
    }
  }

  .field-tip {
    margin-top: 4px;
    color: #8a94a2;
    font-size: 12px;
    line-height: 18px;
  }

  .row-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0 8px;

    .el-button {
      margin: 0;
      padding: 3px 0;
    }
  }

  .inline-note {
    margin: 0 0 10px;
    padding: 8px 10px;
    border-left: 3px solid #d9a441;
    border-radius: 4px;
    background: #fff8e8;
    color: #7a5a1f;
    font-size: 12px;
    line-height: 18px;
  }

  .queue-hint {
    margin: 0 0 10px;
  }

  .workspace-grid,
  .dashboard-grid,
  .report-layout {
    display: grid;
    gap: 12px;
    min-width: 0;
  }

  .workspace-grid {
    grid-template-columns: minmax(0, 1.6fr) minmax(300px, .8fr);
    margin-bottom: 12px;
  }

  .dashboard-grid {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }

  .report-layout {
    grid-template-columns: 1fr 1fr;
  }

  .report-layout .workbench-panel:first-child {
    grid-column: 1 / -1;
  }

  .workbench-panel {
    min-width: 0;
    padding: 12px;
    border: 1px solid #d9e1e8;
    border-radius: 4px;
    background: #fff;
  }

  .workbench-panel--primary {
    border-color: #c6ddff;
    background: #fff;
  }

  .panel-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }

    span {
      color: #6f7f8b;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .todo-list,
  .status-report-list,
  .supplier-rank-list {
    display: grid;
    gap: 8px;
  }

  .todo-list button,
  .status-report-list button {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 4px 10px;
    min-height: 54px;
    padding: 9px 10px;
    border: 1px solid #e2e8ef;
    border-radius: 4px;
    background: #fbfcfd;
    text-align: left;

    &:hover {
      border-color: #409eff;
      background: #ecf5ff;
    }

    &.is-role-task {
      border-color: #8cc5ff;
      background: #f4f9ff;
    }

    span {
      color: #44515f;
      font-size: 13px;
      line-height: 18px;
    }

    strong {
      color: #1f2d3d;
      font-size: 18px;
      line-height: 20px;
    }

    em {
      grid-column: 1 / -1;
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
    }
  }

  .todo-list--featured {
    grid-template-columns: repeat(4, minmax(0, 1fr));

    button {
      min-height: 78px;
      align-content: space-between;
      padding: 12px;
      background: #fff;

      strong {
        font-size: 24px;
        line-height: 30px;
      }
    }
  }

  .dashboard-empty {
    min-height: 156px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #dbe4f0;
    border-radius: 8px;
    background: #f8fbff;
    color: #8a97a8;
    font-size: 14px;
  }

  .process-overview-list {
    display: grid;
    gap: 9px;

    div {
      display: grid;
      grid-template-columns: 34px minmax(0, 1fr);
      gap: 2px 10px;
      min-height: 54px;
      align-items: center;
      padding: 9px 10px;
      border: 1px solid #e2e8ef;
      border-radius: 4px;
      background: #fbfcfd;
    }

    i {
      grid-row: 1 / span 2;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 7px;
      background: #ecf5ff;
      color: #409eff;
      font-size: 15px;
    }

    span {
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    em {
      min-width: 0;
      overflow: hidden;
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .supplier-rank-list div {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    min-height: 36px;
    align-items: center;
    padding: 7px 0;
    border-bottom: 1px solid #eef2f5;

    span {
      min-width: 0;
      overflow: hidden;
      color: #44515f;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
    }
  }

  .report-metrics {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;

    button {
      min-height: 72px;
      padding: 12px;
      border: 1px solid #dfe5eb;
      border-left: 3px solid #409eff;
      border-radius: 4px;
      background: #fbfcfd;
      text-align: left;
      cursor: pointer;

      &:hover {
        border-color: #409eff;
        background: #f3f8ff;
      }
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #6f7f8b;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      margin-top: 8px;
      color: #1f2d3d;
      font-size: 20px;
      font-weight: 600;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .entry-intake-panel {
    margin-bottom: 16px;
    padding: 0 0 12px;
    border-bottom: 1px solid #ebeef5;
    background: transparent;
    transition: border-color .2s ease;

    &.is-processing {
      border-color: #409eff;
    }

    &.is-error {
      border-color: #e7bbb6;
    }
  }

  .entry-intake-panel__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }

    span {
      color: #667782;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .entry-intake-panel--compact {
    padding-bottom: 12px;

    .entry-intake-panel__head {
      align-items: center;
      margin-bottom: 0;
    }
  }

  .entry-intake-panel__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
  }

  .ai-compact-summary {
    display: grid;
    grid-template-columns: auto minmax(80px, 1fr) auto;
    align-items: center;
    gap: 8px;
    min-width: 240px;
    padding: 6px 8px;
    border: 1px solid #d9ecff;
    border-radius: 6px;
    background: #f2f8ff;

    span,
    em {
      color: #6f7f8b;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
      white-space: nowrap;
    }

    strong {
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .entry-intake-grid {
    display: grid;
    grid-template-columns: minmax(380px, 1.1fr) minmax(360px, .9fr);
    gap: 12px;
  }

  .entry-source-panel,
  .ai-processing-panel {
    min-width: 0;
    padding: 12px;
    border: 1px solid #dfe5eb;
    border-radius: 8px;
    background: #fff;
  }

  .entry-source-panel {
    transition: border-color .2s ease, background .2s ease;

    &.active {
      border-color: #b3d8ff;
      background: #f7fbff;
    }
  }

  .entry-source-panel__title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    > i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border-radius: 8px;
      background: #409eff;
      color: #fff;
      font-size: 18px;
    }

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .ai-processing-panel {
    overflow: hidden;
    background:
      linear-gradient(90deg, rgba(20, 51, 59, .03) 1px, transparent 1px),
      linear-gradient(180deg, rgba(20, 51, 59, .03) 1px, transparent 1px),
      #ffffff;
    background-size: 18px 18px, 18px 18px, auto;
  }

  .ai-processing-panel__top {
    display: grid;
    grid-template-columns: 92px minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;

    strong,
    span,
    em {
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 17px;
      font-weight: 600;
      line-height: 24px;
    }

    span {
      margin-top: 3px;
      color: #5f6f7a;
      font-size: 13px;
      line-height: 20px;
    }

    em {
      margin-top: 2px;
      color: #b07721;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
    }
  }

  .ai-visualizer {
    position: relative;
    width: 84px;
    height: 84px;
    overflow: hidden;
    border: 1px solid #cbd8de;
    border-radius: 8px;
    background:
      radial-gradient(circle at 50% 50%, rgba(158, 224, 214, .28), transparent 30px),
      linear-gradient(145deg, #102831 0%, #183744 55%, #12282e 100%);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .05), 0 12px 26px rgba(19, 45, 53, .18);
  }

  .ai-visualizer::before {
    content: "";
    position: absolute;
    inset: -32px;
    background: conic-gradient(from 30deg, transparent 0 48deg, rgba(240, 185, 91, .42) 68deg, transparent 88deg 360deg);
    opacity: .62;
    animation: ai-orbit-sweep 5.2s linear infinite;
  }

  .ai-visualizer::after {
    content: "";
    position: absolute;
    inset: 0;
    background:
      linear-gradient(rgba(255, 255, 255, .07) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, .07) 1px, transparent 1px);
    background-size: 12px 12px;
    opacity: .28;
    animation: ai-grid-drift 4.8s linear infinite;
  }

  .ai-ring {
    position: absolute;
    border: 1px solid rgba(121, 205, 193, .42);
    border-radius: 50%;
    z-index: 2;
  }

  .ai-ring--outer {
    inset: 10px;
    border-top-color: #f0b95b;
    animation: ai-ring-rotate 4s linear infinite;
  }

  .ai-ring--middle {
    inset: 21px;
    border-right-color: #9ee0d6;
    animation: ai-ring-rotate-reverse 3.2s linear infinite;
  }

  .ai-core {
    position: absolute;
    inset: 32px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    background: #ecf5ff;
    color: #1f4e79;
    font-size: 14px;
    box-shadow: 0 0 0 1px rgba(158, 224, 214, .54), 0 0 18px rgba(158, 224, 214, .34);
    z-index: 4;
    animation: ai-core-idle 2.4s ease-in-out infinite;
  }

  .ai-scan-line {
    position: absolute;
    left: 10px;
    right: 10px;
    top: 14px;
    height: 2px;
    background: #f0b95b;
    box-shadow: 0 0 14px rgba(240, 185, 91, .7);
    opacity: .75;
    z-index: 3;
    animation: ai-scan 2.4s ease-in-out infinite;
  }

  .ai-dot {
    position: absolute;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #9ee0d6;
    opacity: .75;
    z-index: 3;
  }

  .ai-dot--one {
    top: 15px;
    left: 18px;
    animation: ai-dot-travel-one 2.8s linear infinite;
  }

  .ai-dot--two {
    right: 18px;
    bottom: 16px;
    animation: ai-dot-travel-two 3.1s linear infinite;
  }

  .ai-dot--three {
    left: 22px;
    bottom: 20px;
    background: #f0b95b;
    animation: ai-dot-pulse 1.6s ease-in-out infinite;
  }

  .ai-visualizer.active .ai-core {
    animation: ai-core-pulse 1.15s ease-in-out infinite;
  }

  .ai-visualizer.active::before {
    opacity: .9;
    animation-duration: 2.4s;
  }

  .ai-visualizer.done {
    background: #18392e;

    .ai-core {
      color: #2f6f45;
      background: #e7f7ed;
    }
  }

  .ai-visualizer.error {
    background: #3a2020;

    .ai-core {
      color: #b2554f;
      background: #fff0ed;
    }

    .ai-scan-line {
      background: #dd6b62;
      box-shadow: 0 0 12px rgba(221, 107, 98, .65);
    }
  }

  .ai-progress-bar {
    position: relative;
    height: 8px;
    margin: 14px 0 12px;
    overflow: hidden;
    border-radius: 999px;
    background: #e4eaef;

    span {
      position: relative;
      display: block;
      height: 100%;
      min-width: 4px;
      border-radius: inherit;
      background: linear-gradient(90deg, #1f4e79 0%, #409eff 55%, #d9a441 100%);
      transition: width .28s ease;
    }

    span::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 42px;
      background: rgba(255, 255, 255, .38);
      transform: skewX(-18deg);
      animation: ai-progress-sheen 1.6s linear infinite;
    }
  }

  .ai-step-track {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;

    div {
      position: relative;
      display: grid;
      justify-items: center;
      gap: 6px;
      min-width: 0;
      color: #8a94a2;
      font-size: 12px;
      line-height: 16px;

      i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        border: 1px solid #dfe5eb;
        border-radius: 7px;
        background: #fff;
        color: #8a94a2;
        font-size: 13px;
        transition: all .2s ease;
      }

      span {
        max-width: 64px;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &.active {
        color: #1f4e79;
        font-weight: 600;

        i {
          border-color: #409eff;
          background: #ecf5ff;
          color: #409eff;
          box-shadow: 0 0 0 4px rgba(64, 158, 255, .12);
        }
      }

      &.done {
        color: #3f8f63;

        i {
          border-color: #bfe3ca;
          background: #e7f7ed;
          color: #3f8f63;
        }
      }
    }
  }

  .ai-model-substeps {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    margin-top: 10px;

    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      min-width: 0;
      min-height: 30px;
      padding: 5px 7px;
      border: 1px solid #e5ebf2;
      border-radius: 6px;
      background: rgba(255, 255, 255, .82);
      color: #9aa5b1;
      font-size: 12px;
      line-height: 18px;
      white-space: nowrap;
    }

    span.active {
      border-color: #409eff;
      background: #ecf5ff;
      color: #1f78d1;
      box-shadow: 0 6px 14px rgba(64, 158, 255, .12);
    }

    span.done {
      border-color: #b7ebc6;
      background: #f0fbf3;
      color: #1f8d50;
    }

    i {
      flex-shrink: 0;
    }
  }

  .ai-summary-strip {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    margin-top: 12px;

    span {
      min-width: 0;
      padding: 8px;
      border: 1px solid #edf0f5;
      border-radius: 6px;
      background: #fbfcfd;
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      display: block;
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ai-review-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;

    span {
      display: inline-flex;
      align-items: center;
      min-height: 26px;
      padding: 4px 8px;
      border: 1px solid #f3d19e;
      border-radius: 6px;
      background: #fdf6ec;
      color: #a65f00;
      font-size: 12px;
      line-height: 18px;
    }

    &.is-ok span {
      border-color: #c2e7b0;
      background: #f0f9eb;
      color: #2f7d32;
    }
  }

  .ai-readonly-summary {
    padding-top: 2px;

    .ai-summary-strip {
      margin-top: 0;
    }
  }

  .contract-inline-panel {
    padding: 0;
    border: 0;
    background: transparent;
  }

  .single-attachment-panel {
    margin: -4px 0 18px;
    padding: 12px;
    border: 1px solid #dfe5eb;
    border-radius: 4px;
    background: #fff;
  }

  .attachment-only-tip {
    margin: -4px 0 18px;
  }

  .contract-board {
    display: grid;
    grid-template-columns: minmax(360px, 1.25fr) minmax(300px, .95fr) minmax(260px, .8fr);
    gap: 12px;
    margin-bottom: 14px;
  }

  .contract-card {
    min-width: 0;
    padding: 12px;
    border: 1px solid #dfe5eb;
    border-radius: 6px;
    background: #fff;
  }

  .contract-status-card {
    background: #f8fbfb;

    &.is-error {
      border-color: #f4c7c3;
      background: #fff7f6;
    }
  }

  .card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;

    span,
    strong {
      display: block;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
    }
  }

  .source-file-zone {
    min-height: 112px;
    margin-bottom: 10px;
    padding: 8px;
    border: 1px dashed #cfd8e3;
    border-radius: 6px;
    background: #fbfcfd;
  }

  .source-file-zone--dialog {
    min-height: 132px;
  }

  .ai-source-tip {
    margin: 0 0 10px;
  }

  .contract-text-input {
    margin-bottom: 10px;
  }

  .source-action-row,
  .recognition-fallback {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .recognition-step-list {
    display: grid;
    gap: 7px;
    margin: 12px 0;

    div {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #8a94a2;
      font-size: 13px;
      line-height: 20px;

      i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #e8edf3;
        color: #7b8794;
        font-size: 12px;
      }

      &.active {
        color: #409eff;
        font-weight: 600;

        i {
          background: #ecf5ff;
          color: #409eff;
        }
      }

      &.done {
        color: #3f8f63;

        i {
          background: #e3f4e9;
          color: #3f8f63;
        }
      }
    }
  }

  .manual-mode-panel {
    display: grid;
    gap: 10px;
    margin: 12px 0;
    padding: 12px;
    border: 1px dashed #cfd8e3;
    border-radius: 6px;
    background: #fff;

    span {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #44515f;
      font-size: 13px;
      line-height: 20px;
    }

    i {
      color: #409eff;
      font-size: 15px;
    }
  }

  .recognition-message {
    min-height: 38px;
    margin-bottom: 10px;
    padding: 8px 10px;
    border-radius: 4px;
    background: #eef4f8;
    color: #44515f;
    font-size: 13px;
    line-height: 20px;

    &.danger {
      background: #ffecea;
      color: #b33a2f;
    }

    &.active {
      background: #ecf5ff;
      color: #409eff;
      box-shadow: inset 3px 0 0 #409eff;
    }
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;

    div {
      min-height: 58px;
      padding: 8px;
      border: 1px solid #edf0f5;
      border-radius: 5px;
      background: #fbfcfd;
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      color: #303133;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .section-title--tight {
    margin-top: 4px;
  }

  .contract-confirm-form {
    padding: 12px 12px 0;
    border: 1px solid #e5eaf0;
    border-radius: 6px;
    background: #fbfcfd;
  }

  .workflow-menu__group {
    display: grid;
    gap: 5px;
  }

  .workflow-menu__group + .workflow-menu__group {
    margin-top: 6px;
    padding-top: 8px;
    border-top: 1px solid #eef1f4;
  }

  .workflow-menu__group-title {
    padding: 0 4px;
    color: #8a94a2;
    font-size: 12px;
    font-weight: 600;
    line-height: 22px;
  }

  .workflow-menu__item {
    position: relative;
    min-height: 58px;
    padding: 8px 8px 8px 40px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #303133;
    text-align: left;
    cursor: pointer;
    transition: background .2s ease, color .2s ease;

    &:hover,
    &.active {
      background: #409eff;
      color: #fff;
    }

    i {
      position: absolute;
      top: 10px;
      left: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      border-radius: 5px;
      background: #fff;
      color: #409eff;
      font-size: 14px;
    }

    span {
      display: block;
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
    }

    strong {
      position: absolute;
      top: 9px;
      right: 8px;
      color: inherit;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
    }

    em {
      display: block;
      max-width: 112px;
      margin-top: 2px;
      color: inherit;
      opacity: .72;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
    }
  }

  .procurement-detail-page {
    min-height: calc(100vh - 104px);
  }

  .purchase-detail-base {
    .el-row {
      margin-bottom: 6px;
    }
  }

  .purchase-detail-base__title {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;

    .base-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .purchase-title-item {
    max-width: 360px;
    text-align: left;
  }

  .detail-tabs {
    margin-top: 12px;
    min-height: 560px;

    ::v-deep .el-tabs__header {
      margin: 0 0 12px;
      border-bottom: 1px solid #e5ebf2;
    }

    ::v-deep .el-tabs__content {
      min-width: 0;
      overflow: hidden;
    }

    ::v-deep .el-tab-pane {
      min-width: 0;
      overflow: hidden;
    }

    ::v-deep .el-tabs__item {
      height: 36px;
      color: #5f6f7a;
      font-size: 13px;
      line-height: 36px;
    }

    ::v-deep .el-tabs__item.is-active {
      color: #2f80ed;
      font-weight: 600;
    }

  }

  .detail-overview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    padding: 12px 14px;
    border: 1px solid #e1e7ef;
    border-radius: 6px;
    background: #fbfcfd;
  }

  .detail-overview__title {
    min-width: 0;

    span {
      display: block;
      color: #1f2d3d;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    em {
      display: block;
      color: #909399;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
    }
  }

  .detail-overview__chips {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }

  .purchase-detail-layout {
    width: 100%;
    margin-top: 16px;
  }

  .sidebar-toggle {
    width: 100%;
    margin-bottom: 8px;
    text-align: right;
  }

  .purchase-detail-main {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .purchase-detail-side {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    background: transparent;
    overflow: hidden;
  }

  .purchase-detail-follow {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;

    ::v-deep .el-card__body {
      padding: 20px;
    }
  }

  .purchase-detail-follow .label {
    color: #606266;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }

  .purchase-detail-follow .crm-manager {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    height: auto;
    margin: 12px 0 22px;

    .avatar {
      flex-shrink: 0;
      float: none;
    }

    .name {
      flex: 1;
      min-width: 0;
      margin-left: 0;
      line-height: 22px;
    }

    .value {
      display: block;
      min-width: 0;
      overflow: hidden;
      color: #303133;
      font-size: 14px;
      line-height: 22px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

    .purchase-detail-follow ::v-deep .groupMemberDiv {
      min-width: 0;

      .group-member-list {
        display: block;
      }

      .group-member {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 14px;
      }

      .avatar-wrap {
        flex: 0 0 40px;
      }

      .member-info {
        flex: 1;
        min-width: 0;
        margin-left: 8px;
      }

      .group-member-add-btn {
        position: static;
        margin-top: 2px;
      }
  }

  .purchase-log-pane {
    padding-top: 4px;
  }

  .purchase-operate-log {
    min-height: 540px;
    overflow: visible;
  }

  .purchase-detail-main ::v-deep .el-table {
    max-width: 100%;
  }

  .purchase-detail-main ::v-deep .el-table__body-wrapper,
  .purchase-detail-main ::v-deep .el-table__header-wrapper,
  .purchase-detail-main ::v-deep .el-table__footer-wrapper {
    max-width: 100%;
  }

  .detail-flow-panel {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #e1e7ef;
    border-radius: 6px;
    background: #fbfcfd;

    &.is-compact {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  .detail-flow-step {
    position: relative;
    display: grid;
    grid-template-columns: 28px minmax(0, 1fr);
    gap: 1px 8px;
    min-height: 62px;
    align-items: center;
    padding: 8px 10px;
    border: 1px solid #dfe5eb;
    border-radius: 6px;
    background: #fff;
    color: #5f6f7a;
    text-align: left;
    cursor: default;
    transition: border-color .18s ease, background .18s ease, box-shadow .18s ease;

    i {
      grid-row: 1 / span 2;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 7px;
      background: #eef3f8;
      color: #8a94a2;
      font-size: 14px;
    }

    span,
    em,
    small {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
    }

    em {
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
      line-height: 16px;
    }

    small {
      color: #a8b1bc;
      font-size: 11px;
      line-height: 14px;
    }

    b {
      position: absolute;
      top: 50%;
      right: -9px;
      width: 9px;
      height: 1px;
      background: #dfe5eb;
      transform: translateY(-50%);
      z-index: 1;
    }

    &.done {
      border-color: #b7ebc6;
      background: #f0f9eb;

      i {
        background: #67c23a;
        color: #fff;
      }

      small {
        color: #67c23a;
      }
    }

    &.active {
      border-color: #409eff;
      background: linear-gradient(180deg, #f8fbff 0%, #ecf5ff 100%);
      box-shadow: inset 3px 0 0 #409eff;

      i {
        background: #409eff;
        color: #fff;
      }

      em {
        color: #2f80ed;
        font-weight: 600;
      }

      small {
        color: #2f80ed;
        font-weight: 600;
      }
    }

    &.wait {
      border-style: dashed;
      background: #fcfdff;
    }
  }

  .next-action-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 12px;
    padding: 12px 14px;
    border: 1px solid #c6ddff;
    border-radius: 6px;
    background: #f7fbff;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
    }

    span {
      margin-top: 2px;
      color: #5f6f7a;
      font-size: 13px;
      line-height: 20px;
    }

    &.is-complete {
      border-color: #c2e7b0;
      background: #f0f9eb;
    }
  }

  .next-action-panel__actions {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }

  .readonly-action-text {
    color: #909399;
    font-size: 13px;
    line-height: 32px;
  }

  .is-readonly-section {
    ::v-deep .el-input__inner,
    ::v-deep .el-textarea__inner {
      background-color: #f7f9fb;
      color: #697886;
    }
  }

  .section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 0 0 15px 15px;
    padding-left: 15px;
    border-left: 3px solid #4480F3;
    color: #303133;
    font-size: 17px;
    font-weight: bold;
  }

  .section-title__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }

  .contract-choice-row {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-bottom: 18px;
    min-height: 32px;
  }

  .contract-choice-row__label {
    width: 92px;
    color: #606266;
    text-align: right;
  }

  .shipment-table {
    margin-top: 12px;
  }

  .shipment-editor {
    margin-top: 16px;
    padding: 16px 16px 8px;
    border: 1px solid #dfe7f2;
    border-radius: 6px;
    background: #f8fbff;
  }

  .shipment-editor__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-bottom: 8px;
  }

  .table-action-group {
    display: inline-flex;
    align-items: center;
    gap: 12px;
  }

  .pending-split-alert {
    margin: -4px 0 12px;

    ::v-deep .el-alert__content {
      line-height: 1.5;
    }
  }

  .contract-text-collapse {
    margin-top: 8px;

    ::v-deep .el-collapse-item__header {
      height: 36px;
      padding: 0 10px;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      color: #606266;
      line-height: 36px;
    }

    ::v-deep .el-collapse-item__wrap {
      border: 0;
      background: transparent;
    }

    ::v-deep .el-collapse-item__content {
      padding: 10px 0 0;
    }
  }

  .recognition-progress {
    margin: 8px 0 12px;
    padding: 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fafafa;

    ::v-deep .el-steps--simple {
      margin-top: 10px;
      padding: 8px 12px;
      background: #fff;
    }
  }

  .recognition-progress__top {
    display: flex;
    align-items: center;
    min-height: 22px;
    margin-bottom: 8px;
    color: #303133;
    font-size: 13px;
  }

  .recognition-progress__pulse {
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border-radius: 50%;
    background: #409eff;
    animation: recognition-pulse 1.2s ease-in-out infinite;
  }

  @keyframes recognition-pulse {
    0% {
      opacity: .35;
      transform: scale(.85);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: .35;
      transform: scale(.85);
    }
  }

  @keyframes ai-ring-rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes ai-ring-rotate-reverse {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }

  @keyframes ai-orbit-sweep {
    from {
      transform: rotate(0deg) scale(1);
    }
    to {
      transform: rotate(360deg) scale(1);
    }
  }

  @keyframes ai-grid-drift {
    0% {
      background-position: 0 0, 0 0;
    }
    100% {
      background-position: 12px 12px, 12px 12px;
    }
  }

  @keyframes ai-core-idle {
    0%,
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 1px rgba(158, 224, 214, .54), 0 0 16px rgba(158, 224, 214, .28);
    }
    50% {
      transform: scale(1.04);
      box-shadow: 0 0 0 1px rgba(240, 185, 91, .54), 0 0 24px rgba(240, 185, 91, .36);
    }
  }

  @keyframes ai-scan {
    0% {
      opacity: .24;
      transform: translateY(0);
    }
    48% {
      opacity: 1;
      transform: translateY(54px);
    }
    100% {
      opacity: .24;
      transform: translateY(0);
    }
  }

  @keyframes ai-core-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(240, 185, 91, .36);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(240, 185, 91, 0);
      transform: scale(1.05);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(240, 185, 91, 0);
      transform: scale(1);
    }
  }

  @keyframes ai-dot-travel-one {
    0% {
      transform: translate(0, 0);
    }
    35% {
      transform: translate(38px, 14px);
    }
    70% {
      transform: translate(18px, 47px);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  @keyframes ai-dot-travel-two {
    0% {
      transform: translate(0, 0);
    }
    40% {
      transform: translate(-42px, -12px);
    }
    72% {
      transform: translate(-18px, -48px);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  @keyframes ai-dot-pulse {
    0%,
    100% {
      opacity: .35;
      transform: scale(.7);
    }
    50% {
      opacity: 1;
      transform: scale(1.3);
    }
  }

  @keyframes ai-progress-sheen {
    0% {
      left: -48px;
    }
    100% {
      left: calc(100% + 48px);
    }
  }

  .sub-text {
    display: block;
    color: #909399;
    font-style: normal;
    font-size: 12px;
    line-height: 18px;
  }

  .option-sub-text {
    float: right;
    max-width: 58%;
    overflow: hidden;
    color: #909399;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .form-static-hint {
    min-height: 36px;
    padding: 0 12px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #f8fafc;
    color: #6b7785;
    font-size: 13px;
    line-height: 34px;
  }

  .danger {
    color: #f56c6c;
  }

  .field-help,
  .mb12 {
    margin-bottom: 12px;
  }

  .edit-table {
    margin-bottom: 8px;
  }

  .price-reference-cell {
    min-width: 260px;

    strong,
    em {
      display: block;
      line-height: 20px;
    }

    strong {
      color: #303133;
      font-weight: 600;
    }

    em {
      margin-top: 2px;
      color: #7b8794;
      font-style: normal;
      white-space: normal;
      word-break: break-word;
    }
  }

  .reference-row-tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 5px;
  }

  .price-reference-link {
    padding: 0;
    line-height: 20px;
  }

  .mt5 {
    margin-top: 5px;
  }

  .tab-actions {
    margin: 12px 0;
    text-align: right;
  }

  .inline-form {
    margin-bottom: 8px;
  }

  .quote-decision-panel,
  .approval-brief-panel {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #fff;
  }

  .quote-requirement-panel {
    margin-bottom: 12px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #fff;
  }

  .quote-requirement-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 48px;
    padding: 10px 14px;
    border: 0;
    background: transparent;
    color: #303133;
    cursor: pointer;
    text-align: left;

    span {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    em {
      color: #909399;
      font-size: 12px;
      font-style: normal;
    }
  }

  .quote-requirement-table {
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
  }

  .purchase-mode-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 14px;
    border: 1px solid #f4cf9a;
    border-radius: 4px;
    background: #fff9ef;

    > div:first-child {
      display: flex;
      min-width: 0;
      flex-direction: column;
      gap: 4px;
    }

    > div:first-child > span {
      color: #7a5a2d;
      font-size: 12px;
    }

    .purchase-mode-panel__types {
      display: flex;
      flex: none;
      align-items: center;
      gap: 8px;
    }
  }

  .quote-group-card {
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #dfe6ee;
    border-radius: 4px;
    background: #fff;
  }

  .quote-group-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;

    div {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    span {
      color: #909399;
      font-size: 12px;
    }
  }

  .quote-group-card__toggle {
    width: 100%;
    margin: 0;
    padding: 0 0 10px;
    border: 0;
    border-bottom: 1px solid #edf0f5;
    background: transparent;
    color: inherit;
    cursor: pointer;
    text-align: left;
  }

  .quote-comparison-card__body {
    padding-top: 10px;
  }

  .quote-group-layout-switch {
    flex: none;

    ::v-deep .el-radio-button__inner {
      padding: 5px 10px;
      font-size: 12px;
    }
  }

  .quote-display-item-list {
    display: grid;
    gap: 8px;
    overflow-x: auto;
  }

  .quote-display-item-card {
    min-width: 1080px;
    overflow: hidden;
    border: 1px solid #e4e9f0;
    border-radius: 4px;
    background: #fff;
  }

  .quote-display-item-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 10px;
    border-bottom: 1px solid #edf0f5;
    background: #f8fafc;

    > div:first-child {
      display: grid;
      min-width: 0;
      gap: 2px;
    }

    > div:last-child {
      display: flex;
      flex: none;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 5px;
    }

    strong,
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 14px;
      line-height: 20px;
    }

    span {
      color: #909399;
      font-size: 12px;
      line-height: 17px;
    }
  }

  .quote-display-item-offer-list {
    display: grid;
  }

  .quote-display-item-offer-empty {
    padding: 12px 10px;
    color: #909399;
    font-size: 12px;
  }

  .quote-display-item-offer-row {
    display: grid;
    grid-template-columns: 28px minmax(230px, 1.45fr) 86px 90px 90px 90px minmax(220px, 1fr) minmax(110px, .7fr);
    align-items: center;
    gap: 8px;
    min-height: 40px;
    padding: 6px 10px;
    border-top: 1px dashed #edf0f5;

    &:first-child {
      border-top: 0;
    }

    &.is-recommended {
      background: #fffaf0;
    }

    &.is-selected {
      background: #f0f9eb;
    }
  }

  .quote-display-item-offer-row__index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 5px;
    background: #eef2f7;
    color: #606266;
    font-size: 12px;
  }

  .quote-display-item-offer-row__supplier {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    min-width: 0;
    gap: 6px;

    strong {
      min-width: 0;
      overflow: hidden;
      color: #303133;
      font-size: 13px;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .quote-recommend-inline-button.el-button--mini {
    flex: 0 0 auto;
    margin: 0;
    padding: 5px 8px;
  }

  .quote-display-item-offer-row__price,
  .quote-display-item-offer-row__amount {
    display: grid;
    gap: 2px;
    text-align: right;

    span {
      color: #a0a7b1;
      font-size: 11px;
      line-height: 14px;
    }

    strong {
      color: #303133;
      font-size: 13px;
      line-height: 18px;
      font-weight: 600;
    }
  }

  .quote-display-item-offer-row__note {
    min-width: 0;
    color: #606266;
    font-size: 12px;
    line-height: 18px;

    span {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .quote-display-item-offer-row__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;

    .el-button {
      max-width: 110px;
      margin: 0;
      padding: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
    }
  }

  .quote-supplier-summary-list {
    display: grid;
    margin-bottom: 10px;
    border: 1px solid #e3e8ef;
    border-bottom: 0;
  }

  .quote-supplier-summary {
    display: grid;
    grid-template-columns: minmax(240px, .8fr) minmax(230px, .7fr) minmax(300px, 1.2fr);
    align-items: stretch;
    gap: 0;
    padding: 0;
    border-bottom: 1px solid #e3e8ef;
    background: #f8fafc;

    &.is-recommended {
      background: #fffaf0;
      box-shadow: inset 4px 0 0 #e6a23c;
    }

    &.is-selected {
      background: #f0f9eb;
      box-shadow: inset 4px 0 0 #67c23a;
    }
  }

  .quote-supplier-summary__identity,
  .quote-supplier-summary__price,
  .quote-supplier-summary__evidence {
    padding: 14px 16px;
    min-width: 0;
  }

  .quote-supplier-summary__identity {
    display: grid;
    align-content: center;
    gap: 8px;
    padding-left: 20px;
  }

  .quote-supplier-summary__kind {
    color: #909399;
    font-size: 12px;
  }

  .quote-supplier-summary__name,
  .quote-supplier-summary__status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .quote-supplier-summary__name strong {
    color: #303133;
    font-size: 16px;
    line-height: 1.4;
  }

  .quote-amount-inline {
    color: #606266;
    font-size: 12px;
  }

  .quote-supplier-summary__price {
    display: grid;
    align-content: center;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 16px;
    border-left: 1px solid rgba(223, 230, 238, .9);
    border-right: 1px solid rgba(223, 230, 238, .9);
    background: rgba(255, 255, 255, .55);

    > div {
      display: grid;
      gap: 3px;
    }

    > div > span {
      color: #909399;
      font-size: 12px;
    }

    > div > strong {
      color: #303133;
      font-size: 16px;
    }

    > p {
      display: flex;
      grid-column: 1 / -1;
      gap: 18px;
      margin: 2px 0 0;
      color: #7a8594;
      font-size: 12px;
    }
  }

  .quote-supplier-summary__final {
    strong {
      color: #d46b08 !important;
      font-size: 18px !important;
    }
  }

  .quote-supplier-summary__evidence {
    display: grid;
    align-content: center;
    gap: 8px;
    color: #7a8594;
    font-size: 12px;

    > div:not(.quote-supplier-summary__actions) {
      display: grid;
      grid-template-columns: 66px minmax(0, 1fr);
      gap: 8px;
    }

    > div > span {
      color: #909399;
    }

    p {
      margin: 0;
      color: #606266;
      line-height: 1.55;
    }
  }

  .quote-supplier-summary__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .quote-matrix-scroll {
    width: 100%;
    overflow-x: auto;
  }

  .quote-comparison-matrix {
    min-width: 720px;
  }

  .quote-matrix-recommendation {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    min-height: 24px;
    margin-top: 4px;

    .el-button {
      margin: 0;
      padding: 0;
    }
  }

  ::v-deep .quote-comparison-matrix .el-table__body-wrapper {
    scrollbar-gutter: stable;
  }

  ::v-deep .quote-comparison-matrix .el-table__body td:last-child .cell {
    padding-right: 26px;
  }

  .quote-group-card__identity {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    min-width: 0;
  }

  .quote-group-card__summary {
    display: grid !important;
    justify-items: end;
    gap: 6px !important;
  }

  .quote-group-card__tags,
  .quote-group-card__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px !important;
  }

  .offer-supplier-cell {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;

    strong {
      color: #303133;
      font-weight: 600;
    }
  }

  .ecommerce-store-cell {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }

  .offer-meta-cell,
  .offer-evidence-cell {
    display: grid;
    gap: 4px;
    color: #606266;
    line-height: 18px;
  }

  .offer-evidence-cell .muted,
  .quote-import-dialog .muted {
    color: #a0a7b1;
  }

  .offer-file-links {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 10px;

    .el-button {
      max-width: 210px;
      margin: 0;
      padding: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .quote-group-card__evidence {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 10px;
    padding: 12px 14px;
    border-top: 1px solid #edf0f5;
    background: #f8fafc;
  }

  .quote-group-card__reason,
  .quote-group-card__files {
    min-width: 0;

  }

  .quote-evidence__label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #7b8798;
    font-size: 12px;

    i {
      color: #4b82e8;
      font-size: 14px;
    }

    em {
      margin-left: auto;
      color: #a0a8b4;
      font-style: normal;
    }
  }

  .quote-group-card__reason p {
    margin: 0;
    color: #303133;
    font-size: 14px;
    line-height: 1.7;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .quote-file-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 8px;
  }

  .quote-file-item {
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr) 22px;
    align-items: center;
    gap: 10px;
    min-width: 0;
    min-height: 52px;
    padding: 8px 10px;
    border: 1px solid #dfe6ef;
    border-radius: 4px;
    background: #fff;
    color: #303133;
    cursor: pointer;
    text-align: left;
    transition: border-color .18s ease, background-color .18s ease;

    &:hover {
      border-color: #8eb2f5;
      background: #f4f8ff;
    }
  }

  .quote-file-icon {
    color: #4b82e8;
    font-size: 28px;
    text-align: center;
  }

  .quote-file-content {
    display: grid;
    min-width: 0;
    gap: 3px;

    strong {
      overflow: hidden;
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    small {
      color: #9099a6;
      font-size: 11px;
      line-height: 16px;
    }
  }

  .quote-file-view {
    color: #7c8da5;
    font-size: 16px;
  }

  ::v-deep .quote-group-card__files .upload-files {
    line-height: normal;
  }

  .approval-quote-group__evidence {
    margin-bottom: 8px;
  }

  .quote-offer-empty {
    padding: 36px 20px;
    border: 1px dashed #d9e2ef;
    color: #909399;
    text-align: center;
  }

  .quote-offer-editor {
    margin-bottom: 12px;
    padding: 12px 14px 4px;
    border: 1px solid #dfe6ef;
    border-radius: 4px;
    background: #f8fafc;
  }

  .quote-offer-editor__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    div {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }

  .quote-import-summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 28px;
    margin: 12px 0;
    color: #606266;
  }

  .quote-import-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px;
    border: 1px solid #dfe6ef;
    border-radius: 4px;
    background: #f8fafc;
  }

  .quote-import-item-table {
    margin-top: 10px;
  }

  .quote-recommendation-reason,
  .approval-group-recommendation-reason,
  .approval-item-offer__recommendation {
    color: #9a5b00 !important;
    line-height: 1.6;
    white-space: normal;
    word-break: break-word;
  }

  .quote-editor-section-title {
    margin-top: 14px;
  }

  .quote-editor-price-matrix {
    padding-bottom: 4px;
  }

  .quote-import-offers {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 18px;
  }

  .quote-decision-summary,
  .approval-brief-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 12px;

    div {
      min-height: 58px;
      padding: 9px 10px;
      border: 1px solid #e0e8f2;
      border-radius: 4px;
      background: #fff;
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      margin-top: 2px;
      color: #1f2d3d;
      font-size: 18px;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .approval-advice-panel {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 12px;
    padding: 12px 14px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #f8fbff;
  }

  .approval-advice-main {
    min-width: 0;

    span,
    strong,
    p {
      display: block;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      margin-top: 2px;
      color: #1f2d3d;
      font-size: 18px;
      line-height: 26px;
    }

    p {
      margin: 4px 0 0;
      color: #5d6b7a;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .approval-advice-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
    max-width: 420px;
  }

    .approval-workorder-panel {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
      margin-bottom: 12px;
    }

    .approval-workorder-panel--dialog {
      margin-bottom: 14px;
    }

    .approval-stage-task {
      grid-column: 1 / -1;
      display: flex;
      align-items: center;
      gap: 10px;
      min-height: 44px;
      padding: 10px 12px;
      border-left: 3px solid #409eff;
      background: #f5f9ff;

      span {
        flex: none;
        color: #607086;
        font-size: 12px;
      }

      strong {
        color: #1f2d3d;
        font-size: 14px;
        font-weight: 500;
      }
    }

  .approval-workorder-status {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 8px;
    min-height: 48px;
    padding: 10px 12px;
    border: 1px solid #e0e8f2;
    border-radius: 6px;
    background: #fff;

    span,
    em {
      color: #8a94a2;
      font-size: 12px;
      font-style: normal;
    }

    strong {
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .quote-recommend-table {
    background: #fff;
  }

  .supplier-order-build-panel {
    margin: 12px 0;
    padding: 12px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #fff;
  }

  .supplier-order-build-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      line-height: 22px;
    }

    span {
      margin-top: 2px;
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .supplier-order-build-actions {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8px;
  }

  .supplier-order-build-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
    margin-bottom: 12px;

    div {
      min-height: 54px;
      padding: 8px 10px;
      border: 1px solid #e0e8f2;
      border-radius: 4px;
      background: #f8fbff;
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      margin-top: 2px;
      color: #1f2d3d;
      font-size: 18px;
      line-height: 24px;
    }
  }

  .supplier-order-build-table {
    margin-bottom: 10px;
    background: #fff;
  }

  .supplier-order-list-table {
    ::v-deep .el-table__cell {
      vertical-align: top;
    }
  }

  .inline-order-panel {
    margin: 12px 0 18px;
    padding: 12px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #fff;
  }

  .inline-order-panel__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      line-height: 22px;
    }

    span {
      margin-top: 2px;
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .inline-order-panel__actions {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    gap: 8px;
  }

  .inline-order-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 10px;

    div {
      min-width: 0;
      padding: 8px 10px;
      border: 1px solid #e0e8f2;
      border-radius: 4px;
      background: #f8fbff;
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      overflow: hidden;
      color: #1f2d3d;
      font-size: 14px;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .inline-order-tabs {
    ::v-deep .el-tabs__header {
      margin-bottom: 12px;
    }
  }

  .inline-contract-tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    padding: 10px 12px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #f8fbff;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 14px;
      line-height: 20px;
    }

    span {
      margin-top: 2px;
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .inline-order-form,
  .inline-action-form {
    padding: 12px 12px 4px;
    border: 1px solid #e0e8f2;
    border-radius: 4px;
    background: #fff;
  }

  .inline-order-subhead,
  .inline-action-form__head,
  .inline-order-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .inline-order-subhead {
    margin: 12px 0 8px;

    strong {
      color: #1f2d3d;
      font-size: 14px;
    }
  }

  .inline-action-form {
    margin-top: 12px;
  }

  .inline-action-form__head {
    margin-bottom: 10px;

    strong {
      color: #1f2d3d;
      font-size: 14px;
    }
  }

  .inline-order-footer {
    justify-content: flex-end;
    margin-top: 12px;
  }

  .inline-context-panel {
    margin-bottom: 12px;
    padding: 10px 12px;
    border: 1px solid #e0e8f2;
    border-radius: 4px;
    background: #f8fbff;
  }

  .inline-context-panel__title {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 8px;

    strong {
      color: #1f2d3d;
      font-size: 14px;
    }

    span {
      color: #7b8794;
      font-size: 12px;
    }
  }

  .inline-context-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;

    div {
      min-width: 0;
      padding: 8px 10px;
      border: 1px solid #e0e8f2;
      border-radius: 4px;
      background: #fff;
    }

    span,
    strong {
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      color: #1f2d3d;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .inline-context-alert {
    margin-top: 8px;
  }

  .inline-payment-node-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    margin-bottom: 10px;
    padding: 8px 10px;
    border-radius: 4px;
    background: #f8fbff;
    color: #7b8794;
    font-size: 12px;

    strong {
      color: #1f2d3d;
      font-weight: 600;
    }
  }

  .inline-order-arrival-table {
    margin-bottom: 12px;
  }

  .supplier-order-groups {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 2px;
  }

  .supplier-order-groups__label {
    color: #7b8794;
    font-size: 12px;
  }

  .supplier-order-group {
    display: inline-flex;
    align-items: center;
    max-width: 280px;
    padding: 4px 8px;
    border: 1px solid #d9e8ff;
    border-radius: 4px;
    background: #f8fbff;
    color: #1f2d3d;
    font-size: 12px;

    strong {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      flex-shrink: 0;
      margin-left: 6px;
      color: #7b8794;
    }
  }

  .supplier-order-groups--fee {
    align-items: stretch;
  }

  .supplier-order-group--fee {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1 1 360px;
    max-width: none;
    gap: 8px;
    padding: 8px;
  }

  .supplier-order-group__summary {
    display: flex;
    align-items: center;
    min-width: 0;

    strong {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      flex-shrink: 0;
      margin-left: 8px;
      color: #7b8794;
    }
  }

  .supplier-order-group__inputs {
    display: grid;
    grid-template-columns: 120px 120px minmax(180px, 1fr);
    gap: 8px;
  }

  .quote-list-title {
    margin-top: 14px;
  }

  .quote-line-title {
    margin: 2px 0 10px;
  }

  .quote-line-table {
    .el-input-number {
      width: 100%;
    }

    .el-input-number .el-input__inner {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .quote-line-fields {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
  }

  .quote-editor-context {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin-bottom: 14px;

    div {
      min-width: 0;
      padding: 9px 10px;
      border: 1px solid #e0e8f2;
      border-radius: 4px;
      background: #f8fbff;
    }

    span,
    strong {
      display: block;
    }

    span {
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
    }

    strong {
      margin-top: 2px;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 14px;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .quote-dialog-form {
    .el-form-item {
      margin-bottom: 14px;
    }
  }

  .quote-editor-dialog {
    .el-dialog__body {
      padding: 16px 20px 8px;
    }
  }

  .arrival-workbench {
    display: grid;
    gap: 12px;
  }

  .arrival-toolbar,
  .arrival-editor-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
    }

    span {
      color: #7b8794;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .arrival-toolbar {
    padding: 12px;
    border: 1px solid #d8e6f7;
    border-radius: 4px;
    background: #fff;
  }

  .arrival-progress-table {
    background: #fff;

    ::v-deep .cell {
      line-height: 20px;
      word-break: break-word;
    }

    ::v-deep .el-table__cell {
      vertical-align: top;
    }
  }

  .arrival-material-cell {
    display: grid;
    gap: 6px;
    min-width: 0;

    strong {
      color: #1f2d3d;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      word-break: break-word;
    }
  }

  .arrival-material-cell--compact {
    gap: 4px;
  }

  .arrival-material-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 5px 8px;

    span {
      max-width: 100%;
      padding: 2px 6px;
      border-radius: 4px;
      background: #f1f5f9;
      color: #667482;
      font-size: 12px;
      line-height: 18px;
      word-break: break-word;
    }
  }

  .arrival-material-sub {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
    color: #8793a0;
    font-size: 12px;
    line-height: 18px;

    span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .arrival-secondary-cell {
    display: grid;
    gap: 4px;
    min-width: 0;

    strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
      word-break: break-word;
    }

    span {
      color: #8793a0;
      font-size: 12px;
      line-height: 18px;
      word-break: break-word;
    }

    .tiny-link-button {
      justify-self: start;
      padding: 0;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .arrival-progress-cell {
    display: grid;
    gap: 7px;

    > strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 20px;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    span,
    em {
      font-size: 12px;
      line-height: 18px;
    }

    span {
      color: #1f2d3d;
      font-weight: 600;
    }

    em {
      color: #8793a0;
      font-style: normal;
    }
  }

  .arrival-editor-card,
  .arrival-history-card {
    padding: 12px;
    border: 1px solid #e0e7ef;
    border-radius: 4px;
    background: #fff;
  }

  .arrival-editor-card {
    border-color: #c6ddff;
    background: #fff;
  }

  .arrival-editor-card.is-empty {
    border-style: dashed;
    background: #fbfcfd;
  }

  .arrival-editor-head {
    margin-bottom: 10px;
  }

  .arrival-editor-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 74px;
    color: #8a94a2;
    font-size: 13px;

    i {
      color: #409eff;
      font-size: 18px;
    }
  }

  .arrival-editor-actions {
    display: flex;
    justify-content: flex-end;
  }

  .arrival-history-card .section-title {
    margin-bottom: 8px;
  }

  .muted-text {
    color: #9aa5b1;
  }

  @media (max-width: 768px) {
    .entry-intake-panel__head,
    .source-action-row,
    .recognition-fallback {
      align-items: stretch;
      flex-direction: column;
    }

    .procurement-shell,
    .procurement-nav-strip,
    .procurement-nav-group,
    .contract-board,
    .workspace-grid,
    .dashboard-grid,
    .report-layout,
    .entry-intake-grid,
    .purchase-detail-layout,
    .todo-list--featured,
    .report-metrics,
    .ai-summary-strip,
    .ai-model-substeps {
      grid-template-columns: 1fr;
    }

    .procurement-nav-group > em {
      text-align: left;
    }

    .ai-processing-panel__top {
      grid-template-columns: 72px minmax(0, 1fr);
    }

    .ai-processing-panel__top .el-tag {
      grid-column: 1 / -1;
      justify-self: start;
    }

    .ai-visualizer {
      width: 68px;
      height: 68px;
    }

    .ai-core {
      inset: 24px;
    }

    .procurement-sidebar {
      position: static;
    }

    .procurement-stats {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .quote-decision-summary,
    .approval-brief-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .filter-actions,
    .table-toolbar__actions {
      justify-content: flex-start;
      flex-wrap: wrap;
    }

    .detail-overview {
      align-items: stretch;
      flex-direction: column;
    }

    .detail-overview__chips {
      justify-content: flex-start;
    }

    .detail-flow-panel {
      grid-template-columns: 1fr;
    }

    .detail-flow-step b {
      display: none;
    }

    .next-action-panel {
      align-items: stretch;
      flex-direction: column;
    }

    .next-action-panel__actions {
      justify-content: flex-start;
    }

    .arrival-toolbar,
    .arrival-editor-head {
      align-items: stretch;
      flex-direction: column;
    }

    .quote-supplier-summary {
      grid-template-columns: 1fr;
    }

    .quote-supplier-summary__price {
      border: 0;
      border-top: 1px solid rgba(223, 230, 238, .9);
      border-bottom: 1px solid rgba(223, 230, 238, .9);
    }

  }

  @media (min-width: 769px) and (max-width: 1280px) {
    .procurement-shell {
      display: block;
    }

    .procurement-stats {
      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    }

    .procurement-nav-strip {
      grid-template-columns: 1fr;
    }

    .contract-board {
      grid-template-columns: 1fr 1fr;
    }

    .contract-summary-card {
      grid-column: 1 / -1;
    }

    .workspace-grid,
    .dashboard-grid,
    .report-layout,
    .entry-intake-grid,
    .purchase-detail-layout {
      grid-template-columns: 1fr;
    }

    .purchase-detail-side {
      width: 100%;
      max-width: 100%;
    }

    .report-metrics {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .todo-list--featured {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .detail-flow-panel {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .detail-flow-step b {
      display: none;
    }

    .quote-supplier-summary {
      grid-template-columns: minmax(220px, .9fr) minmax(240px, 1fr);
    }

    .quote-supplier-summary__price {
      border-right: 0;
    }

    .quote-supplier-summary__evidence {
      grid-column: 1 / -1;
      border-top: 1px solid rgba(223, 230, 238, .9);
    }
  }
}
</style>

<style lang="scss">
.el-message.procurement-top-message,
.el-message {
  z-index: 10080 !important;
}

.approval-flow-dialog {
  .el-dialog__body {
    max-height: 72vh;
    overflow-y: auto;
    padding: 14px 18px 8px;
  }

  .el-dialog__footer {
    padding: 10px 18px 16px;
  }

  .approval-business-panel {
    margin-bottom: 14px;
    padding: 12px;
    border: 1px solid #dbe5f0;
    border-radius: 6px;
    background: #f8fafc;
  }

  .approval-business-title {
    margin-bottom: 8px;
    font-weight: 600;
    color: #303133;
  }

  .approval-business-title--decision {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    div {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    em {
      color: #909399;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
    }
  }

  .approval-business-panel p {
    margin: 0 0 10px;
    color: #606266;
    line-height: 1.6;
  }

  .approval-quote-group {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #e3e9f0;
  }

  .approval-quote-group__title {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
    color: #606266;

    div {
      display: grid;
      gap: 3px;
    }

    span {
      color: #909399;
      font-size: 12px;
    }
  }

  .approval-quote-group__toggle {
    cursor: pointer;
  }

  .approval-quote-matrix {
    margin-top: 4px;
    overflow-x: auto;
  }

  .approval-item-offer-list {
    display: grid;
    gap: 8px;
  }

  .approval-item-offer {
    display: grid;
    grid-template-columns: 18px minmax(0, 1fr) 130px;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #dfe5ed;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    transition: border-color .18s ease, background-color .18s ease;

    &.selected {
      border-color: #4b82e8;
      background: #f3f7ff;
    }
  }

  .approval-item-offer__radio {
    width: 16px;
    height: 16px;
    border: 1px solid #b8c2cf;
    border-radius: 50%;
    box-sizing: border-box;
  }

  .approval-item-offer.selected .approval-item-offer__radio {
    border: 5px solid #4b82e8;
  }

  .approval-item-offer__main,
  .approval-item-offer__price {
    display: grid;
    min-width: 0;
    gap: 3px;
  }

  .approval-item-offer__supplier {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .approval-item-offer__meta,
  .approval-item-offer__reason {
    color: #7c8796;
    font-size: 12px;
    line-height: 18px;
  }

  .approval-item-offer__files {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;

    .el-button {
      max-width: 220px;
      margin: 0;
      padding: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .approval-item-offer__price {
    justify-items: end;

    strong {
      color: #e26a19;
      font-size: 16px;
    }

    small {
      color: #909399;
    }
  }
}

.ai-recognition-dialog {
  width: min(1120px, calc(100vw - 64px)) !important;

  .el-dialog__body {
    padding: 14px 18px 8px;
  }

  .el-dialog__footer {
    padding: 10px 18px 16px;
  }

  .dialog-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;

    .el-button {
      margin-left: 0;
    }
  }

  .ai-dialog-grid {
    display: grid;
    grid-template-columns: minmax(360px, .9fr) minmax(420px, 1.1fr);
    gap: 14px;
    align-items: stretch;
  }

  .ai-dialog-source,
  .ai-result-panel {
    min-width: 0;
    padding: 14px;
    border: 1px solid #dfe5eb;
    border-radius: 8px;
    background: #fff;
  }

  .dialog-section-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }

    span {
      color: #6f7f8b;
      font-size: 12px;
      line-height: 18px;
    }
  }

  .ai-processing-panel--dialog {
    min-height: 316px;
    overflow: hidden;
    border: 1px solid #dfe5eb;
    border-radius: 8px;
    background:
      linear-gradient(90deg, rgba(20, 51, 59, .03) 1px, transparent 1px),
      linear-gradient(180deg, rgba(20, 51, 59, .03) 1px, transparent 1px),
      #fff;
    background-size: 18px 18px, 18px 18px, auto;

    .ai-processing-panel__top {
      display: grid;
      grid-template-columns: 92px minmax(0, 1fr) auto;
      gap: 12px;
      align-items: center;
    }

    .ai-processing-panel__top strong,
    .ai-processing-panel__top span,
    .ai-processing-panel__top em {
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ai-processing-panel__top strong {
      color: #1f2d3d;
      font-size: 17px;
      font-weight: 600;
      line-height: 24px;
    }

    .ai-processing-panel__top span {
      margin-top: 3px;
      color: #5f6f7a;
      font-size: 13px;
      line-height: 20px;
    }

    .ai-processing-panel__top em {
      margin-top: 2px;
      color: #b07721;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
    }

    .ai-visualizer {
      position: relative;
      width: 84px;
      height: 84px;
      overflow: hidden;
      border: 1px solid #cbd8de;
      border-radius: 8px;
      background:
        radial-gradient(circle at 50% 50%, rgba(158, 224, 214, .28), transparent 30px),
        linear-gradient(145deg, #102831 0%, #183744 55%, #12282e 100%);
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .05), 0 12px 26px rgba(19, 45, 53, .18);
    }

    .ai-visualizer::before {
      content: "";
      position: absolute;
      inset: -32px;
      background: conic-gradient(from 30deg, transparent 0 48deg, rgba(240, 185, 91, .42) 68deg, transparent 88deg 360deg);
      opacity: .62;
      animation: procurement-ai-orbit-sweep 5.2s linear infinite;
    }

    .ai-visualizer::after {
      content: "";
      position: absolute;
      inset: 0;
      background:
        linear-gradient(rgba(255, 255, 255, .07) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, .07) 1px, transparent 1px);
      background-size: 12px 12px;
      opacity: .28;
      animation: procurement-ai-grid-drift 4.8s linear infinite;
    }

    .ai-ring {
      position: absolute;
      border: 1px solid rgba(121, 205, 193, .42);
      border-radius: 50%;
      z-index: 2;
    }

    .ai-ring--outer {
      inset: 10px;
      border-top-color: #f0b95b;
      animation: procurement-ai-ring-rotate 4s linear infinite;
    }

    .ai-ring--middle {
      inset: 21px;
      border-right-color: #9ee0d6;
      animation: procurement-ai-ring-rotate-reverse 3.2s linear infinite;
    }

    .ai-core {
      position: absolute;
      inset: 32px;
      display: grid;
      place-items: center;
      border-radius: 8px;
      background: #ecf5ff;
      color: #1f4e79;
      font-size: 14px;
      box-shadow: 0 0 0 1px rgba(158, 224, 214, .54), 0 0 18px rgba(158, 224, 214, .34);
      z-index: 4;
      animation: procurement-ai-core-idle 2.4s ease-in-out infinite;
    }

    .ai-scan-line {
      position: absolute;
      left: 10px;
      right: 10px;
      top: 14px;
      height: 2px;
      background: #f0b95b;
      box-shadow: 0 0 14px rgba(240, 185, 91, .7);
      opacity: .75;
      z-index: 3;
      animation: procurement-ai-scan 2.4s ease-in-out infinite;
    }

    .ai-dot {
      position: absolute;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #9ee0d6;
      opacity: .75;
      z-index: 3;
    }

    .ai-dot--one {
      top: 15px;
      left: 18px;
      animation: procurement-ai-dot-travel-one 2.8s linear infinite;
    }

    .ai-dot--two {
      right: 18px;
      bottom: 16px;
      animation: procurement-ai-dot-travel-two 3.1s linear infinite;
    }

    .ai-dot--three {
      left: 22px;
      bottom: 20px;
      background: #f0b95b;
      animation: procurement-ai-dot-pulse 1.6s ease-in-out infinite;
    }

    .ai-visualizer.active .ai-core {
      animation: procurement-ai-core-pulse 1.15s ease-in-out infinite;
    }

    .ai-visualizer.active::before {
      opacity: .9;
      animation-duration: 2.4s;
    }

    .ai-visualizer.done {
      background: #18392e;
    }

    .ai-visualizer.done .ai-core {
      color: #2f6f45;
      background: #e7f7ed;
    }

    .ai-visualizer.error {
      background: #3a2020;
    }

    .ai-visualizer.error .ai-core {
      color: #b2554f;
      background: #fff0ed;
    }

    .ai-visualizer.error .ai-scan-line {
      background: #dd6b62;
      box-shadow: 0 0 12px rgba(221, 107, 98, .65);
    }

    .ai-progress-bar {
      position: relative;
      height: 8px;
      margin: 14px 0 12px;
      overflow: hidden;
      border-radius: 999px;
      background: #e4eaef;
    }

    .ai-progress-bar span {
      position: relative;
      display: block;
      height: 100%;
      min-width: 4px;
      border-radius: inherit;
      background: linear-gradient(90deg, #1f4e79 0%, #409eff 55%, #d9a441 100%);
      transition: width .28s ease;
    }

    .ai-progress-bar span::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      width: 42px;
      background: rgba(255, 255, 255, .38);
      transform: skewX(-18deg);
      animation: procurement-ai-progress-sheen 1.6s linear infinite;
    }

    .ai-step-track {
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 6px;
    }

    .ai-step-track div {
      position: relative;
      display: grid;
      justify-items: center;
      gap: 6px;
      min-width: 0;
      color: #8a94a2;
      font-size: 12px;
      line-height: 16px;
    }

    .ai-step-track i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border: 1px solid #dfe5eb;
      border-radius: 7px;
      background: #fff;
      color: #8a94a2;
      font-size: 13px;
      transition: all .2s ease;
    }

    .ai-step-track span {
      max-width: 64px;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ai-step-track div.active {
      color: #1f4e79;
      font-weight: 600;
    }

    .ai-step-track div.active i {
      border-color: #409eff;
      background: #ecf5ff;
      color: #409eff;
      box-shadow: 0 0 0 4px rgba(64, 158, 255, .12);
    }

    .ai-step-track div.done {
      color: #3f8f63;
    }

    .ai-step-track div.done i {
      border-color: #bfe3ca;
      background: #e7f7ed;
      color: #3f8f63;
    }

    .ai-model-substeps {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 8px;
      margin-top: 10px;
    }

    .ai-model-substeps span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      min-width: 0;
      min-height: 30px;
      padding: 5px 7px;
      border: 1px solid #e5ebf2;
      border-radius: 6px;
      background: rgba(255, 255, 255, .82);
      color: #9aa5b1;
      font-size: 12px;
      line-height: 18px;
      white-space: nowrap;
    }

    .ai-model-substeps span.active {
      border-color: #409eff;
      background: #ecf5ff;
      color: #1f78d1;
      box-shadow: 0 6px 14px rgba(64, 158, 255, .12);
    }

    .ai-model-substeps span.done {
      border-color: #b7ebc6;
      background: #f0fbf3;
      color: #1f8d50;
    }

    .ai-summary-strip {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 8px;
      margin-top: 12px;
    }

    .ai-summary-strip span {
      min-width: 0;
      padding: 8px;
      border: 1px solid #edf0f5;
      border-radius: 6px;
      background: #fbfcfd;
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
    }

    .ai-summary-strip strong {
      display: block;
      min-width: 0;
      overflow: hidden;
      color: #1f2d3d;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ai-review-list {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: 10px;
    }

    .ai-review-list span {
      display: inline-flex;
      align-items: center;
      min-height: 26px;
      padding: 4px 8px;
      border: 1px solid #f3d19e;
      border-radius: 6px;
      background: #fdf6ec;
      color: #a65f00;
      font-size: 12px;
      line-height: 18px;
    }

    .ai-review-list.is-ok span {
      border-color: #c2e7b0;
      background: #f0f9eb;
      color: #2f7d32;
    }
  }

  .ai-result-panel {
    margin-top: 14px;
    overflow: hidden;
  }

  .ai-result-panel__head {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: 12px;
    margin-bottom: 12px;

    strong,
    span {
      display: block;
    }

    strong {
      color: #1f2d3d;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }

    span {
      margin-top: 2px;
      color: #718094;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .ai-result-panel__controls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px;

    .el-checkbox {
      margin-right: 8px;
    }

    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }

    .ai-fill-scope-group .el-checkbox {
      margin: 0;
    }
  }

  .ai-result-tabs {
    .el-tabs__header {
      margin-bottom: 10px;
    }
  }
}

@keyframes procurement-ai-ring-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes procurement-ai-ring-rotate-reverse {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}

@keyframes procurement-ai-orbit-sweep {
  from {
    transform: rotate(0deg) scale(1);
  }
  to {
    transform: rotate(360deg) scale(1);
  }
}

@keyframes procurement-ai-grid-drift {
  0% {
    background-position: 0 0, 0 0;
  }
  100% {
    background-position: 12px 12px, 12px 12px;
  }
}

@keyframes procurement-ai-core-idle {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 1px rgba(158, 224, 214, .54), 0 0 16px rgba(158, 224, 214, .28);
  }
  50% {
    transform: scale(1.04);
    box-shadow: 0 0 0 1px rgba(240, 185, 91, .54), 0 0 24px rgba(240, 185, 91, .36);
  }
}

@keyframes procurement-ai-scan {
  0% {
    opacity: .24;
    transform: translateY(0);
  }
  48% {
    opacity: 1;
    transform: translateY(54px);
  }
  100% {
    opacity: .24;
    transform: translateY(0);
  }
}

@keyframes procurement-ai-core-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(240, 185, 91, .36);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(240, 185, 91, 0);
    transform: scale(1.05);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(240, 185, 91, 0);
    transform: scale(1);
  }
}

@keyframes procurement-ai-dot-travel-one {
  0% {
    transform: translate(0, 0);
  }
  35% {
    transform: translate(38px, 14px);
  }
  70% {
    transform: translate(18px, 47px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes procurement-ai-dot-travel-two {
  0% {
    transform: translate(0, 0);
  }
  40% {
    transform: translate(-42px, -12px);
  }
  72% {
    transform: translate(-18px, -48px);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes procurement-ai-dot-pulse {
  0%,
  100% {
    opacity: .35;
    transform: scale(.7);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}

@keyframes procurement-ai-progress-sheen {
  0% {
    left: -48px;
  }
  100% {
    left: calc(100% + 48px);
  }
}

@media (max-width: 900px) {
  .ai-recognition-dialog {
    width: calc(100vw - 24px) !important;

    .ai-dialog-grid,
    .ai-result-panel__head {
      grid-template-columns: 1fr;
    }

    .ai-dialog-grid {
      display: grid;
    }

    .ai-result-panel__head,
    .dialog-section-heading {
      flex-direction: column;
    }
  }
}

.material-reference-popper,
.spec-reference-popper,
.supplier-reference-popper,
.party-reference-popper {
  width: min(620px, calc(100vw - 40px)) !important;

  li {
    height: auto;
    line-height: normal;
    padding: 0 12px;
  }

  .reference-option {
    display: flex;
    flex-direction: column;
    gap: 7px;
    padding: 10px 0;

    .reference-option__title {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
    }

    strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      white-space: normal;
      word-break: break-word;
    }

    em {
      flex: none;
      max-width: 220px;
      padding: 1px 6px;
      border-radius: 4px;
      background: #edf4ff;
      color: #3f7ee8;
      font-size: 12px;
      font-style: normal;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .reference-option__details {
      display: flex;
      flex-wrap: wrap;
      gap: 5px 8px;
    }

    .reference-option__details span {
      max-width: 100%;
      padding: 2px 6px;
      border-radius: 4px;
      background: #f5f7fa;
      color: #8a94a2;
      font-size: 12px;
      line-height: 18px;
      white-space: normal;
      word-break: break-word;
    }
  }

  .reference-option--material-name {
    gap: 0;
    padding: 9px 0;

    strong {
      line-height: 20px;
    }
  }

  .spec-reference-option {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 0;
    line-height: normal;

    strong {
      color: #1f2d3d;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      white-space: normal;
      word-break: break-word;
    }

    span {
      color: #8a94a2;
      font-size: 12px;
      line-height: 17px;
      white-space: normal;
      word-break: break-word;
    }
  }
}

.quote-editor-dialog {
  .el-dialog__body {
    padding: 16px 20px 8px;
  }

  .quote-mode-hint {
    margin-left: 12px;
    color: #909399;
    font-size: 12px;
  }

  .quote-import-group-switcher {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 34px;
    margin-bottom: 12px;
    border-bottom: 1px solid #dfe6f1;

    &__status {
      display: inline-flex;
      flex: none;
      align-items: center;
      gap: 6px;
      height: 30px;
      margin-bottom: 1px;
      color: #409eff;
      font-size: 13px;

      .el-icon-circle-check {
        color: #67c23a;
      }
    }

    &__tabs {
      display: flex;
      flex: 1;
      align-items: center;
      gap: 4px;
      min-width: 0;
      overflow-x: auto;
      overflow-y: hidden;
      padding: 0 1px;
      scrollbar-width: thin;
    }

    &__tab {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      max-width: 190px;
      height: 34px;
      margin: 0 0 -1px;
      padding: 0 12px;
      border: 1px solid #dfe6f1;
      border-bottom-color: #dfe6f1;
      border-radius: 4px 4px 0 0;
      background: #f8fafc;
      color: #606266;
      cursor: pointer;
      font-size: 13px;
      line-height: 32px;
      transition: color .15s ease, background .15s ease, border-color .15s ease;

      &:hover:not(:disabled) {
        color: #409eff;
        background: #fff;
      }

      &.is-active {
        border-color: #b9d6ff #dfe6f1 #fff;
        border-top: 2px solid #409eff;
        background: #fff;
        color: #2475df;
        font-weight: 600;
        line-height: 31px;
      }

      &.is-ecommerce {
        border-top-color: #e6a23c;
        background: #fffaf2;
        color: #9a5b00;

        &:hover:not(:disabled) {
          color: #b66d00;
          background: #fff;
        }
      }

      &.is-ecommerce.is-active {
        border-color: #f3cf9b #dfe6f1 #fff;
        border-top-color: #e6a23c;
        background: #fff;
        color: #b66d00;
      }

      &.is-saved {
        color: #a8abb2;
        cursor: not-allowed;
      }
    }

    &__tab-index {
      flex: none;
      margin-right: 6px;
      color: inherit;
    }

    &__tab-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__tab-mode {
      flex: none;
      margin-left: 6px;
      padding: 0 5px;
      border-radius: 2px;
      background: #fff0d8;
      color: #b66d00;
      font-size: 12px;
      line-height: 18px;
    }

    &__tab-count {
      flex: none;
      margin-left: 6px;
      color: #909399;
      font-size: 12px;
      font-weight: 400;
    }

    &__tab-saved {
      flex: none;
      margin-left: 6px;
      color: #909399;
      font-size: 12px;
      font-style: normal;
    }
  }

  .quote-import-subgroup-switcher {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: -4px 0 12px;
    padding: 7px 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;

    &__label {
      flex: none;
      color: #606266;
      font-size: 12px;
    }

    &__tabs {
      display: flex;
      flex: 1;
      gap: 6px;
      min-width: 0;
      overflow-x: auto;
      scrollbar-width: thin;
    }

    &__tab {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      max-width: 220px;
      height: 28px;
      padding: 0 10px;
      overflow: hidden;
      border: 1px solid #dcdfe6;
      border-radius: 3px;
      background: #fff;
      color: #606266;
      cursor: pointer;
      font-size: 12px;
      line-height: 26px;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover:not(:disabled) {
        border-color: #409eff;
        color: #409eff;
      }

      &.is-active {
        border-color: #409eff;
        background: #ecf5ff;
        color: #2475df;
        font-weight: 600;
      }

      &.is-saved {
        color: #a8abb2;
        cursor: not-allowed;
      }

      .quote-import-subgroup-switcher__tab-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      em {
        flex: none;
        margin-left: 6px;
        color: #909399;
        font-size: 12px;
        font-style: normal;
      }
    }
  }

  .quote-supplier-card-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .quote-supplier-compact-card {
    min-width: 0;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: 1px solid #dfe6ef;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(31, 45, 61, .04);
    transition: border-color .18s ease, box-shadow .18s ease;

    &.is-recommended {
      border-color: #70a1f5;
      box-shadow: 0 3px 12px rgba(75, 130, 232, .12);
    }

    .quote-offer-editor__head {
      margin: 0;
      padding: 9px 12px;
      border-bottom: 1px solid #edf0f5;
      background: #f8fafc;
    }
  }

  .quote-supplier-card__identity {
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;

    > span {
      display: inline-flex;
      flex: none;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 7px;
      background: #eaf2ff;
      color: #3f7ee8;
      font-size: 13px;
      font-weight: 600;
    }

    > div {
      display: grid;
      min-width: 0;
      gap: 1px;
    }

    strong,
    small {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 14px;
      line-height: 19px;
    }

    small {
      color: #9099a6;
      font-size: 11px;
      line-height: 16px;
    }
  }

  .quote-supplier-card__actions {
    display: flex;
    flex: none;
    align-items: center;
    gap: 8px;

    .el-radio {
      margin-right: 0;
    }

    .el-button {
      margin: 0;
      padding: 3px 0;
    }
  }

  .quote-supplier-card__form {
    padding: 10px 12px 8px;

    .el-form-item {
      margin-bottom: 9px;
    }
  }

  .quote-supplier-card__primary {
    margin-bottom: 7px !important;
  }

  .quote-supplier-link-state {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: -2px 0 9px 70px;
    padding: 7px 9px;
    border-radius: 6px;
    font-size: 12px;
    line-height: 18px;

    i {
      flex: none;
      margin-top: 2px;
    }

    span {
      flex: 1;
      min-width: 0;
      word-break: break-word;
    }

    .el-button {
      flex: none;
      margin: 0;
      padding: 1px 0;
      font-size: 12px;
    }

    &.is-linked,
    &.is-ready {
      background: #f0f9eb;
      color: #3b8f2f;
    }

    &.is-unlinked,
    &.is-ambiguous {
      background: #fdf6ec;
      color: #a76800;
    }
  }

  .quote-history-price-field {
    display: grid;
    gap: 4px;

    small {
      color: #909399;
      font-size: 11px;
      line-height: 15px;
      white-space: normal;
      word-break: break-word;
    }
  }

  .quote-supplier-card__total {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    align-items: center;
    gap: 6px 12px;
    margin: 2px 0 9px 70px;
    padding: 9px 10px;
    border: 1px solid #dce9fb;
    border-radius: 7px;
    background: #f6f9fe;

    > small,
    > .quote-supplier-card__discount,
    > .quote-supplier-card__increase {
      grid-column: 1 / -1;
      font-size: 11px;
      line-height: 16px;
    }

    > small {
      color: #909399;
    }
  }

  .quote-form-amount-summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px 16px;
    margin: 0 0 12px 96px;
    padding: 8px 12px;
    border: 1px solid #e3e8ef;
    border-radius: 6px;
    background: #f8fafc;
    color: #606266;
    font-size: 12px;

    strong {
      color: #303133;
      font-size: 13px;
    }

    em {
      color: #909399;
      font-style: normal;
    }
  }

  .quote-editor-layout-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 10px 96px;
    color: #606266;
    font-size: 12px;
  }

  .quote-supplier-card__detail-total,
  .quote-supplier-card__freight-total,
  .quote-supplier-card__final-total {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    > span {
      flex: none;
      color: #606266;
      font-size: 12px;
    }
  }

  .quote-supplier-card__detail-total strong {
    color: #303133;
    font-size: 15px;
  }

  .quote-supplier-card__final-total {
    .el-input-number {
      width: 180px;
    }

    .el-input__inner {
      padding-left: 10px;
      padding-right: 10px;
      text-align: right;
      color: #d46b08;
      font-weight: 600;
    }

    .el-button {
      flex: none;
      margin: 0;
      padding: 3px 0;
      font-size: 12px;
    }
  }

  .quote-supplier-card__freight-total {
    .el-input-number {
      width: 150px;
    }

    .el-input__inner {
      padding-left: 10px;
      padding-right: 10px;
      text-align: right;
    }
  }

  .quote-supplier-card__discount {
    color: #21a366;
  }

  .quote-supplier-card__increase {
    color: #e6a23c;
  }

  .quote-supplier-card__recommendation {
    margin: 9px 0 !important;
    padding: 9px 10px 1px;
    border: 1px solid #f3d19e;
    border-radius: 6px;
    background: #fdf6ec;
  }

  .quote-supplier-card__optional-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-height: 24px;
    padding-top: 2px;
    border-top: 1px dashed #e4e9f0;
  }

  .quote-supplier-card__summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 6px;
    min-width: 0;
    font-size: 12px;
  }

  .quote-supplier-card__toggle {
    flex: none;
    margin: 0;
    padding: 3px 0;
  }

  .quote-supplier-card__optional {
    margin-top: 8px;
    padding: 10px 10px 0;
    border: 1px solid #e8edf3;
    border-radius: 6px;
    background: #f8fafc;
  }

  .quote-duplicate-alert {
    margin-bottom: 10px;
  }

  .quote-editor-duplicate-row > td {
    background: #fffaf0;
  }

  .quote-editor-item-name {
    display: grid;
    gap: 4px;

    > span {
      color: #e6a23c;
      font-size: 11px;
      line-height: 14px;

      i {
        margin-right: 3px;
      }
    }
  }

  .quote-editor-supplier-column-header {
    display: grid;
    gap: 2px;
    min-width: 0;
    line-height: 1.25;

    strong {
      overflow: hidden;
      color: #303133;
      font-size: 13px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span {
      color: #909399;
      font-size: 11px;
      font-weight: 400;
    }
  }

  .quote-editor-price-field {
    display: grid;
    gap: 3px;

    .el-input-number .el-input__inner {
      padding-left: 8px;
      padding-right: 8px;
    }

    > span {
      color: #168653;
      font-size: 11px;
      line-height: 14px;
      text-align: right;
    }

    &.is-lowest .el-input__inner {
      border-color: #67c23a;
      background: #f0f9eb;
      color: #168653;
      font-weight: 600;
    }
  }

  .quote-item-flat-list {
    display: grid;
    gap: 6px;
    max-height: 580px;
    overflow: auto;
    padding-right: 2px;
  }

  .quote-item-flat-card {
    border: 1px solid #dfe6ef;
    border-radius: 4px;
    background: #fff;
    min-width: 1260px;

    &.is-duplicate {
      border-color: #f3d19e;
      background: #fffaf0;
    }
  }

  .quote-item-flat-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 32px;
    padding: 5px 8px;
    border-bottom: 1px solid #edf0f5;
    background: #f8fafc;

    > div:first-child {
      display: grid;
      min-width: 0;
      gap: 2px;
    }

    strong,
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    strong {
      color: #1f2d3d;
      font-size: 13px;
      line-height: 18px;
    }

    span {
      color: #909399;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .quote-item-flat-card__actions {
    display: inline-flex;
    flex: none;
    align-items: center;
    gap: 8px;

    .el-button {
      margin: 0;
      padding: 3px 0;
    }
  }

  .quote-item-flat-card__form {
    display: grid;
    grid-template-columns: minmax(170px, 1.45fr) minmax(150px, 1.2fr) minmax(120px, .9fr) minmax(120px, .9fr) 78px 78px 78px 62px 150px;
    align-items: center;
    gap: 6px 8px;
    padding: 6px 8px;

    .quote-item-flat-field {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr);
      align-items: center;
      gap: 5px;
      min-width: 0;
      margin: 0;
    }

    .quote-item-flat-field > span {
      color: #606266;
      font-size: 12px;
      font-weight: 600;
      line-height: 26px;
      white-space: nowrap;
    }

    .quote-item-flat-field--qty,
    .quote-item-flat-field--unit {
      grid-template-columns: auto minmax(34px, 1fr);
    }

    .el-input,
    .el-input-number {
      width: 100%;
      min-width: 0;
    }

    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .el-input__inner {
      padding-left: 8px;
      padding-right: 8px;
    }

    .quote-history-price-field {
      display: block;

      small {
        display: none;
      }
    }
  }

  .quote-item-offer-list {
    padding: 0 8px 8px;
  }

  .quote-item-offer-list__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 0 4px;
    color: #606266;
    font-size: 12px;
  }

  .quote-item-offer-row {
    display: grid;
    grid-template-columns: 28px minmax(220px, 1.25fr) minmax(170px, .9fr) 150px 108px 66px minmax(180px, .9fr) 42px 42px;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    padding: 4px 0;
    border-top: 1px dashed #edf0f5;

    &.has-platform {
      grid-template-columns: 28px 112px minmax(220px, 1.25fr) minmax(170px, .9fr) 150px 108px 66px minmax(180px, .9fr) 42px 42px;
    }

    &.is-recommended {
      background: #fffaf0;
    }

    .el-button {
      margin: 0;
      padding: 3px 0;
    }

    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }

  .quote-item-offer-row__index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 5px;
    background: #eef2f7;
    color: #606266;
    font-size: 12px;
  }

  .quote-item-offer-row__supplier {
    min-width: 0;
  }

  .quote-item-offer-row__platform,
  .quote-item-offer-row__supplier,
  .quote-item-offer-row__price {
    width: 100%;
  }

  .quote-item-offer-row__maintain {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 6px;

    .el-button {
      flex: none;
      font-size: 12px;
    }
  }

  .quote-item-offer-row__link-state {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 4px;
    color: #909399;
    font-size: 12px;
    line-height: 18px;

    i {
      flex: none;
    }

    span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &.is-linked,
    &.is-ready {
      color: #67c23a;
    }

    &.is-ambiguous {
      color: #e6a23c;
    }

    &.is-unlinked {
      color: #f56c6c;
    }
  }

  .quote-item-offer-row__price .el-input__inner {
    padding-left: 8px;
    padding-right: 8px;
    text-align: right;
  }

  .quote-item-offer-row__amount {
    color: #606266;
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
  }

  .quote-item-offer-row__recommend {
    margin-right: 0;
    white-space: nowrap;
  }

  .quote-item-offer-row__reason {
    min-width: 0;
    width: 100%;
  }

  .quote-item-offer-row__remove {
    grid-column: -1;
    justify-self: end;
  }

  .quote-item-offer-row__cancel {
    justify-self: end;
  }

  .el-dialog__footer {
    padding: 10px 20px 16px;
  }
}

.direct-order-dialog {
  .el-dialog__body {
    padding: 14px 20px 8px;
  }

  .el-alert {
    margin-bottom: 16px;
  }

  .direct-order-total {
    color: #303133;
    font-size: 16px;
  }

  .direct-order-item-table .el-input-number {
    max-width: 100%;

    .el-input__inner {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .el-dialog__footer {
    padding: 10px 20px 16px;
  }
}

.price-lookup-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;

  strong {
    color: #1f2d3d;
    font-size: 13px;
    line-height: 18px;
  }

  span {
    color: #8a94a2;
    font-size: 12px;
    line-height: 17px;
  }
}

.detail-dialog-files {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;

  strong {
    display: block;
    margin-bottom: 8px;
    color: #1f2d3d;
    font-size: 13px;
    line-height: 20px;
  }
}

.quote-editor-context {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 14px;

  div {
    min-width: 0;
    padding: 9px 10px;
    border: 1px solid #e0e8f2;
    border-radius: 4px;
    background: #f8fbff;
  }

  span,
  strong {
    display: block;
  }

  span {
    color: #8a94a2;
    font-size: 12px;
    line-height: 18px;
  }

  strong {
    margin-top: 2px;
    overflow: hidden;
    color: #1f2d3d;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.quote-dialog-form {
  .el-form-item {
    margin-bottom: 14px;
  }
}

.purchaser-decision-entry {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  padding: 16px 18px;
  border: 1px solid #b9d7ff;
  border-radius: 10px;
  background: linear-gradient(135deg, #f2f8ff 0%, #ffffff 72%);
}

.final-decision-card__header,
.final-decision-supplier__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.final-decision-tab__header {
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid #d9ecff;
  border-radius: 8px;
  background: #f5faff;
}

.final-decision-card__header > div:first-child,
.final-decision-supplier__head > div {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.final-decision-card__header span,
.final-decision-supplier__head span {
  color: #8492a6;
  font-size: 12px;
}

.final-decision-card__total {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.final-decision-card__total strong,
.final-decision-supplier__head > strong {
  color: #f56c6c;
  font-size: 18px;
}

.final-decision-supplier + .final-decision-supplier {
  margin-top: 16px;
}

.final-decision-supplier__head {
  padding: 10px 12px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-bottom: 0;
}

.purchaser-decision-entry__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border-radius: 10px;
  color: #fff;
  font-size: 21px;
  background: #3478d4;
}

.purchaser-decision-entry__main {
  min-width: 0;
  flex: 1;
}

.purchaser-decision-entry__title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.purchaser-decision-entry__title strong {
  color: #173b68;
  font-size: 17px;
}

.purchaser-decision-entry__main p {
  margin: 6px 0 0;
  color: #55708f;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.purchaser-decision-entry__actions {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.purchaser-decision-preview {
  margin-top: 20px;
  padding: 18px;
  border: 1px solid #d7e6f8;
  border-radius: 10px;
  background: #f8fbff;
}

.purchaser-decision-preview__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;

  strong,
  p,
  span {
    display: block;
  }

  strong {
    margin-top: 3px;
    color: #1f3652;
    font-size: 18px;
    line-height: 26px;
  }

  p {
    margin: 4px 0 0;
    color: #718096;
    font-size: 13px;
    line-height: 20px;
  }
}

.purchaser-decision-preview__eyebrow {
  color: #3478c9;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
}

.purchaser-decision-preview__summary {
  padding: 14px 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(31, 76, 128, 0.06);

  span {
    color: #3478c9;
    font-size: 12px;
    font-weight: 700;
  }

  p {
    margin: 7px 0 5px;
    color: #223a57;
    font-size: 14px;
    line-height: 23px;
    white-space: pre-wrap;
  }

  em {
    color: #9aa6b5;
    font-size: 12px;
    font-style: normal;
  }
}

.purchaser-decision-preview__plans {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;

  article {
    min-width: 0;
    padding: 14px;
    border: 1px solid #e4ebf3;
    border-radius: 8px;
    background: #fff;

    > p {
      margin: 9px 0;
      color: #536579;
      font-size: 13px;
      line-height: 20px;
    }

    ul {
      margin: 7px 0 0;
      padding-left: 18px;
    }

    li {
      font-size: 12px;
      line-height: 19px;
    }
  }
}

.purchaser-decision-preview__plan-title {
  display: flex;
  align-items: center;
  gap: 9px;

  > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 24px;
    height: 24px;
    color: #3478c9;
    font-size: 12px;
    font-weight: 700;
    border-radius: 7px;
    background: #eaf3ff;
  }

  strong,
  em {
    display: block;
  }

  strong {
    color: #223a57;
    font-size: 14px;
    line-height: 20px;
  }

  em {
    margin-top: 2px;
    color: #3478c9;
    font-size: 12px;
    font-style: normal;
  }
}

.purchaser-decision-preview__item-plans {
  display: grid;
  gap: 6px;
  margin-top: 10px;

  > div {
    display: grid;
    grid-template-columns: minmax(100px, .7fr) minmax(150px, 1fr);
    gap: 4px 10px;
    padding: 7px 9px;
    border: 1px solid #e8edf3;
    border-radius: 6px;
    background: #f8fafc;
  }

  span,
  strong,
  em {
    min-width: 0;
    font-size: 12px;
    line-height: 18px;
  }

  span {
    color: #52657a;
  }

  strong {
    color: #2f6fac;
  }

  em {
    grid-column: 1 / -1;
    color: #7b8795;
    font-style: normal;
  }
}

.purchaser-decision-preview__reason-list {
  color: #47705a;
}

.purchaser-decision-preview__risk-list {
  color: #b36b2e;
}

.purchaser-decision-preview__followup {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;

  > div {
    padding: 12px 14px;
    border-radius: 8px;
    background: #fff;
  }

  strong {
    color: #334b68;
    font-size: 13px;
  }

  p {
    margin: 6px 0 0;
    color: #66778b;
    font-size: 12px;
    line-height: 19px;
  }
}

.requirement-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 16px;
  padding: 10px 22px 0;
  background: #f8fafc;

  .el-form-item {
    margin-bottom: 12px;
  }

  .requirement-detail-grid__wide {
    grid-column: 1 / -1;
  }
}

::v-deep .requirement-workbook-dialog {
  .el-dialog__body {
    padding-top: 12px;
  }

  .requirement-preview-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 24px;
    margin: 12px 0;
    color: #45566c;
    font-size: 13px;
  }

  .requirement-preview-table {
    margin-top: 12px;
  }

  .requirement-preview-tabs {
    margin-top: 12px;
  }

  .requirement-ai-preview {
    max-height: 58vh;
    overflow: auto;
    padding-right: 4px;
  }

  .requirement-category {
    & + .requirement-category {
      margin-top: 18px;
    }
  }

  .requirement-category__title {
    display: grid;
    grid-template-columns: 76px minmax(240px, 1fr) 64px;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    color: #0f3f63;
    background: linear-gradient(90deg, #e7f4ff 0%, #f3f9ff 100%);
    border: 1px solid #9bc8e8;
    border-bottom: 0;
    border-radius: 6px 6px 0 0;

    span {
      font-weight: 700;
    }

    em {
      color: #5d7184;
      font-size: 12px;
      font-style: normal;
      text-align: right;
    }

    .el-input__inner {
      height: 32px;
      color: #0f3f63;
      font-weight: 700;
      background: rgba(255, 255, 255, 0.72);
      border-color: #b8d8ef;
    }
  }

  .requirement-category__title + .requirement-preview-table {
    margin-top: 0;
  }

  .requirement-source-sheet {
    & + .requirement-source-sheet {
      margin-top: 18px;
    }
  }

  .requirement-source-sheet__name {
    padding: 8px 12px;
    color: #24384d;
    font-weight: 700;
    background: #f3f6f9;
    border: 1px solid #d9e2ec;
    border-bottom: 0;
  }

  .requirement-source-sheet__scroll {
    max-height: 56vh;
    overflow: auto;
    border: 1px solid #d9e2ec;
    background: #f6f7f9;

    table {
      table-layout: fixed;
      border-spacing: 0;
      border-collapse: collapse;
      background: #fff;
    }

    td {
      box-sizing: border-box;
      min-width: 36px;
      padding: 4px 6px;
      line-height: 1.4;
      word-break: break-word;
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

}

.contract-seal-package {
  margin: 14px 0 18px;
  padding: 16px;
  border: 1px solid #cfe0f3;
  border-radius: 8px;
  background: linear-gradient(135deg, #f8fbff 0%, #f3f8fd 100%);
}

.contract-seal-package__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;

  strong {
    color: #1f3f63;
    font-size: 16px;
  }

  p {
    margin: 6px 0 0;
    color: #64778c;
    font-size: 13px;
  }
}

.contract-seal-package__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.contract-seal-package__table {
  margin-top: 12px;
}

.contract-seal-files,
.contract-seal-dialog-files {
  margin-top: 14px;
  padding: 14px;
  border: 1px solid #dce7f3;
  border-radius: 8px;
  background: #fff;
}

.contract-seal-dialog-files {
  margin-bottom: 18px;
  background: #f8fbff;
}

.contract-seal-files__header,
.contract-seal-files__supplier {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.contract-seal-files__header {
  margin-bottom: 12px;

  div {
    display: flex;
    align-items: baseline;
    gap: 10px;
  }

  strong {
    color: #243c59;
    font-size: 15px;
  }

  span {
    color: #8492a6;
    font-size: 12px;
  }
}

.contract-seal-files__group + .contract-seal-files__group {
  margin-top: 12px;
}

.contract-seal-files__supplier {
  padding: 7px 10px;
  border-radius: 5px;
  background: #edf5ff;

  strong {
    color: #345678;
    font-size: 13px;
  }

  span {
    color: #7b8da1;
    font-size: 12px;
  }
}

.contract-seal-files__list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.contract-seal-file-card {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #e6ebf1;
  border-radius: 6px;
  background: #fff;

  > i {
    flex: none;
    color: #409eff;
    font-size: 22px;
  }

  > div {
    flex: 1;
    min-width: 0;
  }

  strong,
  span {
    display: block;
  }

  strong {
    overflow: hidden;
    color: #303d4f;
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    margin-top: 2px;
    color: #9aa5b1;
    font-size: 11px;
  }

  .el-button + .el-button {
    margin-left: 2px;
  }
}

.contract-batch-upload-zone {
  margin: 14px 0;
  padding: 12px;
  border: 1px dashed #9fc1e6;
  border-radius: 8px;
  background: #f8fbff;
}

.contract-batch-remark {
  margin-top: 16px;
}

.contract-batch-footer-tip {
  margin-right: auto;
  color: #66778b;
  font-size: 13px;
}

@media (max-width: 768px) {
  .contract-seal-package__header {
    flex-direction: column;
  }

  .contract-seal-package__actions {
    justify-content: flex-start;
  }

  .contract-seal-files__list {
    grid-template-columns: 1fr;
  }

  .purchaser-decision-preview__plans,
  .purchaser-decision-preview__followup {
    grid-template-columns: 1fr;
  }

  .quote-editor-dialog .quote-supplier-card-grid {
    grid-template-columns: 1fr;
  }

  .detail-dialog-files {
    grid-template-columns: 1fr;
  }

  .requirement-detail-grid {
    grid-template-columns: 1fr;

    .requirement-detail-grid__wide {
      grid-column: auto;
    }
  }
}
</style>
